//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, o) => (o = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule || !a.call(n, "default") ? t(o, "default", {
	value: n,
	enumerable: !0
}) : o, n)), d = (e) => a.call(e, "module.exports") ? e["module.exports"] : l(t({}, "__esModule", { value: !0 }), e);
//#endregion
//#region node_modules/preact/dist/preact.module.js
function f(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function p(e) {
	e && e.parentNode && e.parentNode.removeChild(e);
}
function m(e, t, n) {
	var r, i, a, o = {};
	for (a in t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : o[a] = t[a];
	if (arguments.length > 2 && (o.children = arguments.length > 3 ? be.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (a in e.defaultProps) o[a] === void 0 && (o[a] = e.defaultProps[a]);
	return h(e, o, r, i, null);
}
function h(e, t, n, r, i) {
	var a = {
		type: e,
		props: t,
		key: n,
		ref: r,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: i ?? ++xe,
		__i: -1,
		__u: 0
	};
	return i == null && w.vnode != null && w.vnode(a), a;
}
function g() {
	return { current: null };
}
function _(e) {
	return e.children;
}
function v(e, t) {
	this.props = e, this.context = t;
}
function y(e, t) {
	if (t == null) return e.__ ? y(e.__, e.__i + 1) : null;
	for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
	return typeof e.type == "function" ? y(e) : null;
}
function b(e) {
	if (e.__P && e.__d) {
		var t = e.__v, n = t.__e, r = [], i = [], a = f({}, t);
		a.__v = t.__v + 1, w.vnode && w.vnode(a), ce(e.__P, a, t, e.__n, e.__P.namespaceURI, 32 & t.__u ? [n] : null, r, n ?? y(t), !!(32 & t.__u), i), a.__v = t.__v, a.__.__k[a.__i] = a, ue(r, a, i), t.__e = t.__ = null, a.__e != n && ee(a);
	}
}
function ee(e) {
	if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
		if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
	}), ee(e);
}
function x(e) {
	(!e.__d && (e.__d = !0) && Se.push(e) && !S.__r++ || Ce != w.debounceRendering) && ((Ce = w.debounceRendering) || we)(S);
}
function S() {
	try {
		for (var e, t = 1; Se.length;) Se.length > t && Se.sort(Te), e = Se.shift(), t = Se.length, b(e);
	} finally {
		Se.length = S.__r = 0;
	}
}
function te(e, t, n, r, i, a, o, s, c, l, u) {
	var d, f, p, m, h, g, _ = r && r.__k || Pe, v = t.length;
	for (c = ne(n, t, _, c, v), d = 0; d < v; d++) (p = n.__k[d]) != null && (f = p.__i != -1 && _[p.__i] || Ne, p.__i = d, g = ce(e, p, f, i, a, o, s, c, l, u), m = p.__e, p.ref && f.ref != p.ref && (f.ref && pe(f.ref, null, p), u.push(p.ref, p.__c || m, p)), h == null && m != null && (h = m), 4 & p.__u ? (c = re(p, c, e), f.__e && (f.__e = null)) : typeof p.type == "function" && g !== void 0 ? c = g : m && (c = m.nextSibling), p.__u &= -7);
	return n.__e = h, c;
}
function ne(e, t, n, r, i) {
	var a, o, s, c, l, u = n.length, d = u, f = 0;
	for (e.__k = Array(i), a = 0; a < i; a++) (o = t[a]) != null && typeof o != "boolean" && typeof o != "function" ? (typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? o = e.__k[a] = h(null, o, null, null, null) : Ie(o) ? o = e.__k[a] = h(_, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? o = e.__k[a] = h(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : e.__k[a] = o, c = a + f, o.__ = e, o.__b = e.__b + 1, s = null, (l = o.__i = ie(o, n, c, d)) != -1 && (d--, (s = n[l]) && (s.__u |= 2)), s == null || s.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof o.type != "function" && (o.__u |= 4)) : l != c && (l == c - 1 ? f-- : l == c + 1 ? f++ : (l > c ? f-- : f++, o.__u |= 4))) : e.__k[a] = null;
	if (d) for (a = 0; a < u; a++) (s = n[a]) != null && !(2 & s.__u) && (s.__e == r && (r = y(s)), me(s, s));
	return r;
}
function re(e, t, n) {
	var r, i;
	if (typeof e.type == "function") {
		for (r = e.__k, i = 0; r && i < r.length; i++) r[i] && (r[i].__ = e, t = re(r[i], t, n));
		return t;
	}
	e.__e != t && (t && e.type && !t.parentNode && (t = y(e)), t = n.insertBefore(e.__e, t || null));
	do
		t &&= t.nextSibling;
	while (t != null && t.nodeType == 8);
	return t;
}
function C(e, t) {
	return t ||= [], e == null || typeof e == "boolean" || (Ie(e) ? e.some(function(e) {
		C(e, t);
	}) : t.push(e)), t;
}
function ie(e, t, n, r) {
	var i, a, o, s = e.key, c = e.type, l = t[n], u = l != null && !(2 & l.__u);
	if (l === null && s == null || u && s == l.key && c == l.type) return n;
	if (r > +!!u) {
		for (i = n - 1, a = n + 1; i >= 0 || a < t.length;) if ((l = t[o = i >= 0 ? i-- : a++]) != null && !(2 & l.__u) && s == l.key && c == l.type) return o;
	}
	return -1;
}
function ae(e, t, n) {
	t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || Fe.test(t) ? n : n + "px";
}
function oe(e, t, n, r, i) {
	var a, o;
	n: if (t == "style") {
		if (typeof n == "string") e.style.cssText = n;
		else {
			if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || ae(e.style, t, "");
			if (n) for (t in n) r && n[t] == r[t] || ae(e.style, t, n[t]);
		}
	} else if (t[0] == "o" && t[1] == "n") a = t != (t = t.replace(Oe, "$1")), o = t.toLowerCase(), t = o in e || t == "onFocusOut" || t == "onFocusIn" ? o.slice(2) : t.slice(2), e.l ||= {}, e.l[t + a] = n, n ? r ? n[De] = r[De] : (n[De] = ke, e.addEventListener(t, a ? je : Ae, a)) : e.removeEventListener(t, a ? je : Ae, a);
	else {
		if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
		else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
			e[t] = n ?? "";
			break n;
		} catch {}
		typeof n == "function" || (n == null || !1 === n && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
	}
}
function se(e) {
	return function(t) {
		if (this.l) {
			var n = this.l[t.type + e];
			if (t[Ee] == null) t[Ee] = ke++;
			else if (t[Ee] < n[De]) return;
			return n(w.event ? w.event(t) : t);
		}
	};
}
function ce(e, t, n, r, i, a, o, s, c, l) {
	var u, d, m, h, g, b, ee, x, S, ne, re, C, ie, ae, oe, se, ce = t.type;
	if (t.constructor !== void 0) return null;
	128 & n.__u && (c = !!(32 & n.__u), a = [s = t.__e = n.__e]), (u = w.__b) && u(t);
	n: if (typeof ce == "function") {
		d = o.length;
		try {
			if (S = t.props, ne = ce.prototype && ce.prototype.render, re = (u = ce.contextType) && r[u.__c], C = u ? re ? re.props.value : u.__ : r, n.__c ? x = (m = t.__c = n.__c).__ = m.__E : (ne ? t.__c = m = new ce(S, C) : (t.__c = m = new v(S, C), m.constructor = ce, m.render = he), re && re.sub(m), m.state || (m.state = {}), m.__n = r, h = m.__d = !0, m.__h = [], m._sb = []), ne && m.__s == null && (m.__s = m.state), ne && ce.getDerivedStateFromProps != null && (m.__s == m.state && (m.__s = f({}, m.__s)), f(m.__s, ce.getDerivedStateFromProps(S, m.__s))), g = m.props, b = m.state, m.__v = t, h) ne && ce.getDerivedStateFromProps == null && m.componentWillMount != null && m.componentWillMount(), ne && m.componentDidMount != null && m.__h.push(m.componentDidMount);
			else {
				if (ne && ce.getDerivedStateFromProps == null && S !== g && m.componentWillReceiveProps != null && m.componentWillReceiveProps(S, C), t.__v == n.__v || !m.__e && m.shouldComponentUpdate != null && !1 === m.shouldComponentUpdate(S, m.__s, C)) {
					t.__v != n.__v && (m.props = S, m.state = m.__s, m.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.some(function(e) {
						e && (e.__ = t);
					}), Pe.push.apply(m.__h, m._sb), m._sb = [], m.__h.length && o.push(m), s = y(n);
					break n;
				}
				m.componentWillUpdate != null && m.componentWillUpdate(S, m.__s, C), ne && m.componentDidUpdate != null && m.__h.push(function() {
					m.componentDidUpdate(g, b, ee);
				});
			}
			if (m.context = C, m.props = S, m.__P = e, m.__e = !1, ie = w.__r, ae = 0, ne) m.state = m.__s, m.__d = !1, ie && ie(t), u = m.render(m.props, m.state, m.context), Pe.push.apply(m.__h, m._sb), m._sb = [];
			else do
				m.__d = !1, ie && ie(t), u = m.render(m.props, m.state, m.context), m.state = m.__s;
			while (m.__d && ++ae < 25);
			m.state = m.__s, m.getChildContext != null && (r = f(f({}, r), m.getChildContext())), ne && !h && m.getSnapshotBeforeUpdate != null && (ee = m.getSnapshotBeforeUpdate(g, b)), oe = u != null && u.type === _ && u.key == null ? de(u.props.children) : u, s = te(e, Ie(oe) ? oe : [oe], t, n, r, i, a, o, s, c, l), m.base = t.__e, t.__u &= -161, m.__h.length && o.push(m), x && (m.__E = m.__ = null);
		} catch (e) {
			if (o.length = d, t.__v = null, c || a != null) {
				if (e.then) {
					for (t.__u |= c ? 160 : 128; s && s.nodeType == 8 && s.nextSibling;) s = s.nextSibling;
					a != null && (a[a.indexOf(s)] = null), t.__e = s;
				} else if (a != null) for (se = a.length; se--;) p(a[se]);
			} else t.__e = n.__e;
			t.__k ??= n.__k || [], e.then || le(t), w.__e(e, t, n);
		}
	} else a == null && t.__v == n.__v ? (t.__k = n.__k, t.__e = n.__e) : s = t.__e = fe(n.__e, t, n, r, i, a, o, c, l);
	return (u = w.diffed) && u(t), 128 & t.__u ? void 0 : s;
}
function le(e) {
	e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(le));
}
function ue(e, t, n) {
	for (var r = 0; r < n.length; r++) pe(n[r], n[++r], n[++r]);
	w.__c && w.__c(t, e), e.some(function(t) {
		try {
			e = t.__h, t.__h = [], e.some(function(e) {
				e.call(t);
			});
		} catch (e) {
			w.__e(e, t.__v);
		}
	});
}
function de(e) {
	return typeof e != "object" || !e || e.__b > 0 ? e : Ie(e) ? e.map(de) : e.constructor === void 0 ? f({}, e) : null;
}
function fe(e, t, n, r, i, a, o, s, c) {
	var l, u, d, f, m, h, g, _ = n.props || Ne, v = t.props, b = t.type;
	if (b == "svg" ? i = "http://www.w3.org/2000/svg" : b == "math" ? i = "http://www.w3.org/1998/Math/MathML" : i ||= "http://www.w3.org/1999/xhtml", a != null) {
		for (l = 0; l < a.length; l++) if ((m = a[l]) && "setAttribute" in m == !!b && (b ? m.localName == b : m.nodeType == 3)) {
			e = m, a[l] = null;
			break;
		}
	}
	if (e == null) {
		if (b == null) return document.createTextNode(v);
		e = document.createElementNS(i, b, v.is && v), s &&= (w.__m && w.__m(t, a), !1), a = null;
	}
	if (b == null) _ === v || s && e.data == v || (e.data = v);
	else {
		if (a = b == "textarea" && v.defaultValue != null ? null : a && be.call(e.childNodes), !s && a != null) for (_ = {}, l = 0; l < e.attributes.length; l++) _[(m = e.attributes[l]).name] = m.value;
		for (l in _) m = _[l], l == "dangerouslySetInnerHTML" ? d = m : l == "children" || l in v || l == "value" && "defaultValue" in v || l == "checked" && "defaultChecked" in v || oe(e, l, null, m, i);
		for (l in v) m = v[l], l == "children" ? f = m : l == "dangerouslySetInnerHTML" ? u = m : l == "value" ? h = m : l == "checked" ? g = m : s && typeof m != "function" || _[l] === m || oe(e, l, m, _[l], i);
		if (u) s || d && (u.__html == d.__html || u.__html == e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];
		else if (d && (e.innerHTML = ""), te(t.type == "template" ? e.content : e, Ie(f) ? f : [f], t, n, r, b == "foreignObject" ? "http://www.w3.org/1999/xhtml" : i, a, o, a ? a[0] : n.__k && y(n, 0), s, c), a != null) for (l = a.length; l--;) p(a[l]);
		s && b != "textarea" || (l = "value", b == "progress" && h == null ? e.removeAttribute("value") : h != null && (h !== e[l] || b == "progress" && !h || b == "option" && h != _[l]) && oe(e, l, h, _[l], i), l = "checked", g != null && g != e[l] && oe(e, l, g, _[l], i));
	}
	return e;
}
function pe(e, t, n) {
	try {
		if (typeof e == "function") {
			var r = typeof e.__u == "function";
			r && e.__u(), r && t == null || (e.__u = e(t));
		} else e.current = t;
	} catch (e) {
		w.__e(e, n);
	}
}
function me(e, t, n) {
	var r, i;
	if (w.unmount && w.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || pe(r, null, t)), (r = e.__c) != null) {
		if (r.componentWillUnmount) try {
			r.componentWillUnmount();
		} catch (e) {
			w.__e(e, t);
		}
		r.base = r.__P = r.__n = null;
	}
	if (r = e.__k) for (i = 0; i < r.length; i++) r[i] && me(r[i], t, n || typeof e.type != "function");
	n || p(e.__e), e.__c = e.__ = e.__e = void 0;
}
function he(e, t, n) {
	return this.constructor(e, n);
}
function ge(e, t, n) {
	var r, i, a, o;
	t == document && (t = document.documentElement), w.__ && w.__(e, t), i = (r = typeof n == "function") ? null : n && n.__k || t.__k, a = [], o = [], ce(t, e = (!r && n || t).__k = m(_, null, [e]), i || Ne, Ne, t.namespaceURI, !r && n ? [n] : i ? null : t.firstChild ? be.call(t.childNodes) : null, a, !r && n ? n : i ? i.__e : t.firstChild, r, o), ue(a, e, o), e.props.children = null;
}
function _e(e, t) {
	ge(e, t, _e);
}
function ve(e, t, n) {
	var r, i, a, o, s = f({}, e.props);
	for (a in e.type && e.type.defaultProps && (o = e.type.defaultProps), t) a == "key" ? r = t[a] : a == "ref" ? i = t[a] : s[a] = t[a] === void 0 && o != null ? o[a] : t[a];
	return arguments.length > 2 && (s.children = arguments.length > 3 ? be.call(arguments, 2) : n), h(e.type, s, r || e.key, i || e.ref, null);
}
function ye(e) {
	function t(e) {
		var n, r;
		return this.getChildContext || (n = /* @__PURE__ */ new Set(), (r = {})[t.__c] = this, this.getChildContext = function() {
			return r;
		}, this.componentWillUnmount = function() {
			n = null;
		}, this.shouldComponentUpdate = function(e) {
			this.props.value != e.value && n.forEach(function(e) {
				e.__e = !0, x(e);
			});
		}, this.sub = function(e) {
			n.add(e);
			var t = e.componentWillUnmount;
			e.componentWillUnmount = function() {
				n && n.delete(e), t && t.call(e);
			};
		}), e.children;
	}
	return t.__c = "__cC" + Me++, t.__ = e, t.Provider = t.__l = (t.Consumer = function(e, t) {
		return e.children(t);
	}).contextType = t, t;
}
var be, w, xe, Se, Ce, we, Te, T, Ee, De, Oe, ke, Ae, je, Me, Ne, Pe, Fe, Ie, Le = o((() => {
	Ne = {}, Pe = [], Fe = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Ie = Array.isArray, be = Pe.slice, w = { __e: function(e, t, n, r) {
		for (var i, a, o; t = t.__;) if ((i = t.__c) && !i.__) try {
			if ((a = i.constructor) && a.getDerivedStateFromError != null && (i.setState(a.getDerivedStateFromError(e)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), o = i.__d), o) return i.__E = i;
		} catch (t) {
			e = t;
		}
		throw e;
	} }, xe = 0, v.prototype.setState = function(e, t) {
		var n = this.__s != null && this.__s != this.state ? this.__s : this.__s = f({}, this.state);
		typeof e == "function" && (e = e(f({}, n), this.props)), e && f(n, e), e != null && this.__v && (t && this._sb.push(t), x(this));
	}, v.prototype.forceUpdate = function(e) {
		this.__v && (this.__e = !0, e && this.__h.push(e), x(this));
	}, v.prototype.render = _, Se = [], we = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Te = function(e, t) {
		return e.__v.__b - t.__v.__b;
	}, S.__r = 0, T = Math.random().toString(8), Ee = "__d" + T, De = "__a" + T, Oe = /(PointerCapture)$|Capture$/i, ke = 0, Ae = se(!1), je = se(!0), Me = 0;
}));
//#endregion
//#region node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
function E(e, t, n, r, i, a) {
	t ||= {};
	var o, s, c = t;
	if ("ref" in c) for (s in c = {}, t) s == "ref" ? o = t[s] : c[s] = t[s];
	var l = {
		type: e,
		props: c,
		key: n,
		ref: o,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: --Re,
		__i: -1,
		__u: 0,
		__source: i,
		__self: a
	};
	if (typeof e == "function" && (o = e.defaultProps)) for (s in o) c[s] === void 0 && (c[s] = o[s]);
	return w.vnode && w.vnode(l), l;
}
var Re, ze = o((() => {
	Le(), Re = 0, Array.isArray;
}));
//#endregion
//#region node_modules/preact/hooks/dist/hooks.module.js
function Be(e, t) {
	O.__h && O.__h(D, e, ct || t), ct = 0;
	var n = D.__H || (D.__H = {
		__: [],
		__h: []
	});
	return e >= n.__.length && n.__.push({}), n.__[e];
}
function Ve(e) {
	return ct = 1, He(it, e);
}
function He(e, t, n) {
	var r = Be(at++, 2);
	if (r.t = e, !r.__c && (r.__ = [n ? n(t) : it(void 0, t), function(e) {
		var t = r.__N ? r.__N[0] : r.__[0], n = r.t(t, e);
		t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
	}], r.__c = D, !D.__f)) {
		var i = function(e, t, n) {
			if (!r.__c.__H) return !0;
			var i = !1, o = r.__c.props !== e;
			if (r.__c.__H.__.some(function(e) {
				if (e.__N) {
					i = !0;
					var t = e.__[0];
					e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
				}
			}), a) {
				var s = a.call(this, e, t, n);
				return i ? s || o : s;
			}
			return !i || o;
		};
		D.__f = !0;
		var a = D.shouldComponentUpdate, o = D.componentWillUpdate;
		D.componentWillUpdate = function(e, t, n) {
			if (this.__e) {
				var r = a;
				a = void 0, i(e, t, n), a = r;
			}
			o && o.call(this, e, t, n);
		}, D.shouldComponentUpdate = i;
	}
	return r.__N || r.__;
}
function Ue(e, t) {
	var n = Be(at++, 3);
	!O.__s && rt(n.__H, t) && (n.__ = e, n.u = t, D.__H.__h.push(n));
}
function We(e, t) {
	var n = Be(at++, 4);
	!O.__s && rt(n.__H, t) && (n.__ = e, n.u = t, D.__h.push(n));
}
function Ge(e) {
	return ct = 5, qe(function() {
		return { current: e };
	}, []);
}
function Ke(e, t, n) {
	ct = 6, We(function() {
		if (typeof e == "function") {
			var n = e(t());
			return function() {
				e(null), n && typeof n == "function" && n();
			};
		}
		if (e) return e.current = t(), function() {
			return e.current = null;
		};
	}, n == null ? n : n.concat(e));
}
function qe(e, t) {
	var n = Be(at++, 7);
	return rt(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function Je(e, t) {
	return ct = 8, qe(function() {
		return e;
	}, t);
}
function Ye(e) {
	var t = D.context[e.__c], n = Be(at++, 9);
	return n.c = e, t ? (n.__ ?? (n.__ = !0, t.sub(D)), t.props.value) : e.__;
}
function Xe(e, t) {
	O.useDebugValue && O.useDebugValue(t ? t(e) : e);
}
function Ze(e) {
	var t = Be(at++, 10), n = Ve();
	return t.__ = e, D.componentDidCatch || (D.componentDidCatch = function(e, r) {
		t.__ && t.__(e, r), n[1](e);
	}), [n[0], function() {
		n[1](void 0);
	}];
}
function Qe() {
	var e = Be(at++, 11);
	if (!e.__) {
		for (var t = D.__v; t !== null && !t.__m && t.__ !== null;) t = t.__;
		var n = t.__m || (t.__m = [0, 0]);
		e.__ = "P" + n[0] + "-" + n[1]++;
	}
	return e.__;
}
function $e() {
	for (var e; e = lt.shift();) {
		var t = e.__H;
		if (e.__P && t) try {
			t.__h.some(tt), t.__h.some(nt), t.__h = [];
		} catch (n) {
			t.__h = [], O.__e(n, e.__v);
		}
	}
}
function et(e) {
	var t, n = function() {
		clearTimeout(r), gt && cancelAnimationFrame(t), setTimeout(e);
	}, r = setTimeout(n, 35);
	gt && (t = requestAnimationFrame(n));
}
function tt(e) {
	var t = D, n = e.__c;
	typeof n == "function" && (e.__c = void 0, n()), D = t;
}
function nt(e) {
	var t = D;
	e.__c = e.__(), D = t;
}
function rt(e, t) {
	return !e || e.length !== t.length || t.some(function(t, n) {
		return t !== e[n];
	});
}
function it(e, t) {
	return typeof t == "function" ? t(e) : t;
}
var at, D, ot, st, ct, lt, O, ut, dt, ft, pt, mt, ht, gt, k = o((() => {
	Le(), ct = 0, lt = [], O = w, ut = O.__b, dt = O.__r, ft = O.diffed, pt = O.__c, mt = O.unmount, ht = O.__, O.__b = function(e) {
		D = null, ut && ut(e);
	}, O.__ = function(e, t) {
		e && t.__k && t.__k.__m && (e.__m = t.__k.__m), ht && ht(e, t);
	}, O.__r = function(e) {
		dt && dt(e), at = 0;
		var t = (D = e.__c).__H;
		t && (ot === D ? (t.__h = [], D.__h = [], t.__.some(function(e) {
			e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
		})) : (t.__h.some(tt), t.__h.some(nt), t.__h = [], at = 0)), ot = D;
	}, O.diffed = function(e) {
		ft && ft(e);
		var t = e.__c;
		t && t.__H && (t.__H.__h.length && (lt.push(t) !== 1 && st === O.requestAnimationFrame || ((st = O.requestAnimationFrame) || et)($e)), t.__H.__.some(function(e) {
			e.u &&= (e.__H = e.u, void 0);
		})), ot = D = null;
	}, O.__c = function(e, t) {
		t.some(function(e) {
			try {
				e.__h.some(tt), e.__h = e.__h.filter(function(e) {
					return !e.__ || nt(e);
				});
			} catch (n) {
				t.some(function(e) {
					e.__h &&= [];
				}), t = [], O.__e(n, e.__v);
			}
		}), pt && pt(e, t);
	}, O.unmount = function(e) {
		mt && mt(e);
		var t, n = e.__c;
		n && n.__H && (n.__H.__.some(function(e) {
			try {
				tt(e);
			} catch (e) {
				t = e;
			}
		}), n.__H = void 0, t && O.__e(t, n.__v));
	}, gt = typeof requestAnimationFrame == "function";
})), _t = /* @__PURE__ */ c({
	Children: () => Xt,
	Component: () => v,
	Fragment: () => _,
	PureComponent: () => Tt,
	StrictMode: () => _,
	Suspense: () => At,
	SuspenseList: () => Nt,
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: () => pn,
	cloneElement: () => Ut,
	createContext: () => ye,
	createElement: () => m,
	createFactory: () => zt,
	createPortal: () => It,
	createRef: () => g,
	default: () => vn,
	findDOMNode: () => Gt,
	flushSync: () => gn,
	forwardRef: () => Dt,
	hydrate: () => Rt,
	isElement: () => _n,
	isFragment: () => Vt,
	isMemo: () => Ht,
	isValidElement: () => Bt,
	lazy: () => Mt,
	memo: () => Et,
	render: () => Lt,
	startTransition: () => St,
	unmountComponentAtNode: () => Wt,
	unstable_batchedUpdates: () => hn,
	useCallback: () => Je,
	useContext: () => Ye,
	useDebugValue: () => Xe,
	useDeferredValue: () => Ct,
	useEffect: () => Ue,
	useErrorBoundary: () => Ze,
	useId: () => Qe,
	useImperativeHandle: () => Ke,
	useInsertionEffect: () => Kt,
	useLayoutEffect: () => We,
	useMemo: () => qe,
	useReducer: () => He,
	useRef: () => Ge,
	useState: () => Ve,
	useSyncExternalStore: () => bt,
	useTransition: () => wt,
	version: () => mn
});
function vt(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function yt(e, t) {
	for (var n in e) if (n !== "__source" && !(n in t)) return !0;
	for (var r in t) if (r !== "__source" && e[r] !== t[r]) return !0;
	return !1;
}
function bt(e, t) {
	var n = t(), r = Ve({ t: {
		__: n,
		u: t
	} }), i = r[0].t, a = r[1];
	return We(function() {
		i.__ = n, i.u = t, xt(i) && a({ t: i });
	}, [
		e,
		n,
		t
	]), Ue(function() {
		return xt(i) && a({ t: i }), e(function() {
			xt(i) && a({ t: i });
		});
	}, [e]), n;
}
function xt(e) {
	try {
		return !((t = e.__) === (n = e.u()) && (t !== 0 || 1 / t == 1 / n) || t != t && n != n);
	} catch {
		return !0;
	}
	var t, n;
}
function St(e) {
	e();
}
function Ct(e) {
	return e;
}
function wt() {
	return [!1, St];
}
function Tt(e, t) {
	this.props = e, this.context = t;
}
function Et(e, t) {
	function n(e) {
		var n = this.props.ref;
		return n != e.ref && n && (typeof n == "function" ? n(null) : n.current = null), t ? !t(this.props, e) || n != e.ref : yt(this.props, e);
	}
	function r(t) {
		return this.shouldComponentUpdate = n, m(e, t);
	}
	return r.displayName = "Memo(" + (e.displayName || e.name) + ")", r.__f = r.prototype.isReactComponent = !0, r.type = e, r;
}
function Dt(e) {
	function t(t) {
		var n = vt({}, t);
		return delete n.ref, e(n, t.ref || null);
	}
	return t.$$typeof = Jt, t.render = e, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
}
function Ot(e, t, n) {
	return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function(e) {
		typeof e.__c == "function" && e.__c();
	}), e.__c.__H = null), (e = vt({}, e)).__c != null && (e.__c.__P === n && (e.__c.__P = t), e.__c.__e = !0, e.__c = null), e.__k = e.__k && e.__k.map(function(e) {
		return Ot(e, t, n);
	})), e;
}
function kt(e, t, n) {
	return e && n && (e.__v = null, e.__k = e.__k && e.__k.map(function(e) {
		return kt(e, t, n);
	}), e.__c && e.__c.__P === t && (e.__e && n.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = n)), e;
}
function At() {
	this.__u = 0, this.o = null, this.__b = null;
}
function jt(e) {
	var t = e.__ && e.__.__c;
	return t && t.__a && t.__a(e);
}
function Mt(e) {
	var t, n, r, i = null;
	function a(a) {
		if (t || (t = e()).then(function(e) {
			e && (i = e.default || e), r = !0;
		}, function(e) {
			n = e, r = !0;
		}), n) throw n;
		if (!r) throw t;
		return i ? m(i, a) : null;
	}
	return a.displayName = "Lazy", a.__f = !0, a;
}
function Nt() {
	this.i = null, this.l = null;
}
function Pt(e) {
	return this.getChildContext = function() {
		return e.context;
	}, e.children;
}
function Ft(e) {
	var t = this, n = e.h;
	if (t.componentWillUnmount = function() {
		ge(null, t.v), t.v = null, t.h = null;
	}, t.h && t.h !== n && t.componentWillUnmount(), !t.v) {
		for (var r = t.__v; r !== null && !r.__m && r.__ !== null;) r = r.__;
		t.h = n, t.v = {
			nodeType: 1,
			parentNode: n,
			childNodes: [],
			__k: { __m: r.__m },
			contains: function() {
				return !0;
			},
			namespaceURI: n.namespaceURI,
			insertBefore: function(e, n) {
				this.childNodes.push(e), t.h.insertBefore(e, n);
			},
			removeChild: function(e) {
				this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.h.removeChild(e);
			}
		};
	}
	ge(m(Pt, { context: t.context }, e.__v), t.v);
}
function It(e, t) {
	var n = m(Ft, {
		__v: e,
		h: t
	});
	return n.containerInfo = t, n;
}
function Lt(e, t, n) {
	return t.__k ?? (t.textContent = ""), ge(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function Rt(e, t, n) {
	return _e(e, t), typeof n == "function" && n(), e ? e.__c : null;
}
function zt(e) {
	return m.bind(null, e);
}
function Bt(e) {
	return !!e && e.$$typeof === en;
}
function Vt(e) {
	return Bt(e) && e.type === _;
}
function Ht(e) {
	return !!e && typeof e.displayName == "string" && e.displayName.indexOf("Memo(") == 0;
}
function Ut(e) {
	return Bt(e) ? ve.apply(null, arguments) : e;
}
function Wt(e) {
	return !!e.__k && (ge(null, e), !0);
}
function Gt(e) {
	return e && (e.base || e.nodeType === 1 && e) || null;
}
var Kt, qt, Jt, Yt, Xt, Zt, Qt, $t, en, tn, nn, rn, an, on, sn, cn, ln, un, dn, fn, pn, mn, hn, gn, _n, vn, yn = o((() => {
	Le(), k(), k(), Kt = We, (Tt.prototype = new v()).isPureReactComponent = !0, Tt.prototype.shouldComponentUpdate = function(e, t) {
		return yt(this.props, e) || yt(this.state, t);
	}, qt = w.__b, w.__b = function(e) {
		e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), qt && qt(e);
	}, Jt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911, Yt = function(e, t) {
		return e == null ? null : C(C(e).map(t));
	}, Xt = {
		map: Yt,
		forEach: Yt,
		count: function(e) {
			return e ? C(e).length : 0;
		},
		only: function(e) {
			var t = C(e);
			if (t.length !== 1) throw "Children.only";
			return t[0];
		},
		toArray: C
	}, Zt = w.__e, w.__e = function(e, t, n, r) {
		if (e.then) {
			for (var i, a = t; a = a.__;) if ((i = a.__c) && i.__c) return t.__e ?? (t.__e = n.__e, t.__k = n.__k || []), i.__c(e, t);
		}
		Zt(e, t, n, r);
	}, Qt = w.unmount, w.unmount = function(e) {
		var t = e.__c;
		t && (t.__z = !0), t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), Qt && Qt(e);
	}, (At.prototype = new v()).__c = function(e, t) {
		var n = t.__c, r = this;
		r.o ??= [], r.o.push(n);
		var i = jt(r.__v), a = !1, o = function() {
			a || r.__z || (a = !0, n.__R = null, i ? i(c) : c());
		};
		n.__R = o;
		var s = n.__P;
		n.__P = null;
		var c = function() {
			if (!--r.__u) {
				if (r.state.__a) {
					var e = r.state.__a;
					r.__v.__k[0] = kt(e, e.__c.__P, e.__c.__O);
				}
				var t;
				for (r.setState({ __a: r.__b = null }); t = r.o.pop();) t.__P = s, t.forceUpdate();
			}
		};
		r.__u++ || 32 & t.__u || r.setState({ __a: r.__b = r.__v.__k[0] }), e.then(o, o);
	}, At.prototype.componentWillUnmount = function() {
		this.o = [];
	}, At.prototype.render = function(e, t) {
		if (this.__b) {
			if (this.__v.__k) {
				var n = document.createElement("div"), r = this.__v.__k[0].__c;
				this.__v.__k[0] = Ot(this.__b, n, r.__O = r.__P);
			}
			this.__b = null;
		}
		var i = t.__a && m(_, null, e.fallback);
		return i && (i.__u &= -33), [m(_, null, t.__a ? null : e.children), i];
	}, $t = function(e, t, n) {
		if (++n[1] === n[0] && e.l.delete(t), e.props.revealOrder && (e.props.revealOrder[0] !== "t" || !e.l.size)) for (n = e.i; n;) {
			for (; n.length > 3;) n.pop()();
			if (n[1] < n[0]) break;
			e.i = n = n[2];
		}
	}, (Nt.prototype = new v()).__a = function(e) {
		var t = this, n = jt(t.__v), r = t.l.get(e);
		return r[0]++, function(i) {
			var a = function() {
				t.props.revealOrder ? (r.push(i), $t(t, e, r)) : i();
			};
			n ? n(a) : a();
		};
	}, Nt.prototype.render = function(e) {
		this.i = null, this.l = /* @__PURE__ */ new Map();
		var t = C(e.children);
		e.revealOrder && e.revealOrder[0] === "b" && t.reverse();
		for (var n = t.length; n--;) this.l.set(t[n], this.i = [
			1,
			0,
			this.i
		]);
		return e.children;
	}, Nt.prototype.componentDidUpdate = Nt.prototype.componentDidMount = function() {
		var e = this;
		this.l.forEach(function(t, n) {
			$t(e, n, t);
		});
	}, en = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, tn = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, nn = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, rn = /[A-Z0-9]/g, an = typeof document < "u", on = function(e) {
		return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(e);
	}, v.prototype.isReactComponent = !0, [
		"componentWillMount",
		"componentWillReceiveProps",
		"componentWillUpdate"
	].forEach(function(e) {
		Object.defineProperty(v.prototype, e, {
			configurable: !0,
			get: function() {
				return this["UNSAFE_" + e];
			},
			set: function(t) {
				Object.defineProperty(this, e, {
					configurable: !0,
					writable: !0,
					value: t
				});
			}
		});
	}), sn = w.event, w.event = function(e) {
		return sn && (e = sn(e)), e.persist = function() {}, e.isPropagationStopped = function() {
			return this.cancelBubble;
		}, e.isDefaultPrevented = function() {
			return this.defaultPrevented;
		}, e.nativeEvent = e;
	}, ln = {
		configurable: !0,
		get: function() {
			return this.class;
		}
	}, un = w.vnode, w.vnode = function(e) {
		typeof e.type == "string" && function(e) {
			var t = e.props, n = e.type, r = {}, i = n.indexOf("-") == -1;
			for (var a in t) {
				var o = t[a];
				if (!(a === "value" && "defaultValue" in t && o == null || an && a === "children" && n === "noscript" || a === "class" || a === "className")) {
					var s = a.toLowerCase();
					a === "defaultValue" && "value" in t && t.value == null ? a = "value" : a === "download" && !0 === o ? o = "" : s === "translate" && o === "no" ? o = !1 : s[0] === "o" && s[1] === "n" ? s === "ondoubleclick" ? a = "ondblclick" : s !== "onchange" || n !== "input" && n !== "textarea" || on(t.type) ? s === "onfocus" ? a = "onfocusin" : s === "onblur" ? a = "onfocusout" : nn.test(a) && (a = s) : s = a = "oninput" : i && tn.test(a) ? a = a.replace(rn, "-$&").toLowerCase() : o === null && (o = void 0), s === "oninput" && r[a = s] && (a = "oninputCapture"), r[a] = o;
				}
			}
			n == "select" && (r.multiple && Array.isArray(r.value) && (r.value = C(t.children).forEach(function(e) {
				e.props.selected = r.value.indexOf(e.props.value) != -1;
			})), r.defaultValue != null && (r.value = C(t.children).forEach(function(e) {
				e.props.selected = r.multiple ? r.defaultValue.indexOf(e.props.value) != -1 : r.defaultValue == e.props.value;
			}))), t.class && !t.className ? (r.class = t.class, Object.defineProperty(r, "className", ln)) : t.className && (r.class = r.className = t.className), e.props = r;
		}(e), e.$$typeof = en, un && un(e);
	}, dn = w.__r, w.__r = function(e) {
		dn && dn(e), cn = e.__c;
	}, fn = w.diffed, w.diffed = function(e) {
		fn && fn(e);
		var t = e.props, n = e.__e;
		n != null && e.type === "textarea" && "value" in t && t.value !== n.value && (n.value = t.value == null ? "" : t.value), cn = null;
	}, pn = { ReactCurrentDispatcher: { current: {
		readContext: function(e) {
			return cn.__n[e.__c].props.value;
		},
		useCallback: Je,
		useContext: Ye,
		useDebugValue: Xe,
		useDeferredValue: Ct,
		useEffect: Ue,
		useId: Qe,
		useImperativeHandle: Ke,
		useInsertionEffect: Kt,
		useLayoutEffect: We,
		useMemo: qe,
		useReducer: He,
		useRef: Ge,
		useState: Ve,
		useSyncExternalStore: bt,
		useTransition: wt
	} } }, mn = "18.3.1", hn = function(e, t) {
		return e(t);
	}, gn = function(e, t) {
		var n, r = w.debounceRendering;
		w.debounceRendering = function(e) {
			n = e;
		};
		try {
			var i = e(t);
			return n && n(), i;
		} finally {
			w.debounceRendering = r;
		}
	}, _n = Bt, vn = {
		useState: Ve,
		useId: Qe,
		useReducer: He,
		useEffect: Ue,
		useLayoutEffect: We,
		useInsertionEffect: Kt,
		useTransition: wt,
		useDeferredValue: Ct,
		useSyncExternalStore: bt,
		startTransition: St,
		useRef: Ge,
		useImperativeHandle: Ke,
		useMemo: qe,
		useCallback: Je,
		useContext: Ye,
		useDebugValue: Xe,
		version: "18.3.1",
		Children: Xt,
		render: Lt,
		hydrate: Rt,
		unmountComponentAtNode: Wt,
		createPortal: It,
		createElement: m,
		createContext: ye,
		createFactory: zt,
		cloneElement: Ut,
		createRef: g,
		Fragment: _,
		isValidElement: Bt,
		isElement: _n,
		isFragment: Vt,
		isMemo: Ht,
		findDOMNode: Gt,
		Component: v,
		PureComponent: Tt,
		memo: Et,
		forwardRef: Dt,
		flushSync: gn,
		unstable_batchedUpdates: hn,
		StrictMode: _,
		Suspense: At,
		SuspenseList: Nt,
		lazy: Mt,
		__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: pn
	};
}));
//#endregion
//#region node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
function bn(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function xn(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Sn, Cn = o((() => {
	Sn = /*#__PURE__*/ function() {
		function e(e) {
			var t = this;
			this._insertTag = function(e) {
				var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
				t.container.insertBefore(e, n), t.tags.push(e);
			}, this.isSpeedy = e.speedy === void 0 || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
		}
		var t = e.prototype;
		return t.hydrate = function(e) {
			e.forEach(this._insertTag);
		}, t.insert = function(e) {
			this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(xn(this));
			var t = this.tags[this.tags.length - 1];
			if (this.isSpeedy) {
				var n = bn(t);
				try {
					n.insertRule(e, n.cssRules.length);
				} catch {}
			} else t.appendChild(document.createTextNode(e));
			this.ctr++;
		}, t.flush = function() {
			this.tags.forEach(function(e) {
				return e.parentNode?.removeChild(e);
			}), this.tags = [], this.ctr = 0;
		}, e;
	}();
})), wn, Tn, A, En, Dn, On, kn, An, jn, Mn = o((() => {
	wn = "-ms-", Tn = "-moz-", A = "-webkit-", En = "comm", Dn = "rule", On = "decl", kn = "@import", An = "@keyframes", jn = "@layer";
}));
//#endregion
//#region node_modules/stylis/src/Utility.js
function Nn(e, t) {
	return Ln(e, 0) ^ 45 ? (((t << 2 ^ Ln(e, 0)) << 2 ^ Ln(e, 1)) << 2 ^ Ln(e, 2)) << 2 ^ Ln(e, 3) : 0;
}
function Pn(e) {
	return e.trim();
}
function Fn(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function j(e, t, n) {
	return e.replace(t, n);
}
function In(e, t) {
	return e.indexOf(t);
}
function Ln(e, t) {
	return e.charCodeAt(t) | 0;
}
function Rn(e, t, n) {
	return e.slice(t, n);
}
function zn(e) {
	return e.length;
}
function Bn(e) {
	return e.length;
}
function Vn(e, t) {
	return t.push(e), e;
}
function Hn(e, t) {
	return e.map(t).join("");
}
var Un, Wn, Gn, Kn = o((() => {
	Un = Math.abs, Wn = String.fromCharCode, Gn = Object.assign;
}));
//#endregion
//#region node_modules/stylis/src/Tokenizer.js
function qn(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: ur,
		column: dr,
		length: o,
		return: ""
	};
}
function Jn(e, t) {
	return Gn(qn("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Yn() {
	return M;
}
function Xn() {
	return M = pr > 0 ? Ln(mr, --pr) : 0, dr--, M === 10 && (dr = 1, ur--), M;
}
function Zn() {
	return M = pr < fr ? Ln(mr, pr++) : 0, dr++, M === 10 && (dr = 1, ur++), M;
}
function Qn() {
	return Ln(mr, pr);
}
function $n() {
	return pr;
}
function er(e, t) {
	return Rn(mr, e, t);
}
function tr(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function nr(e) {
	return ur = dr = 1, fr = zn(mr = e), pr = 0, [];
}
function rr(e) {
	return mr = "", e;
}
function ir(e) {
	return Pn(er(pr - 1, sr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ar(e) {
	for (; (M = Qn()) && M < 33;) Zn();
	return tr(e) > 2 || tr(M) > 3 ? "" : " ";
}
function or(e, t) {
	for (; --t && Zn() && !(M < 48 || M > 102 || M > 57 && M < 65 || M > 70 && M < 97););
	return er(e, $n() + (t < 6 && Qn() == 32 && Zn() == 32));
}
function sr(e) {
	for (; Zn();) switch (M) {
		case e: return pr;
		case 34:
		case 39:
			e !== 34 && e !== 39 && sr(M);
			break;
		case 40:
			e === 41 && sr(e);
			break;
		case 92: Zn();
	}
	return pr;
}
function cr(e, t) {
	for (; Zn() && e + M !== 57 && (e + M !== 84 || Qn() !== 47););
	return "/*" + er(t, pr - 1) + "*" + Wn(e === 47 ? e : Zn());
}
function lr(e) {
	for (; !tr(Qn());) Zn();
	return er(e, pr);
}
var ur, dr, fr, pr, M, mr, hr = o((() => {
	Kn(), ur = 1, dr = 1, fr = 0, pr = 0, M = 0, mr = "";
}));
//#endregion
//#region node_modules/stylis/src/Parser.js
function gr(e) {
	return rr(_r("", null, null, null, [""], e = nr(e), 0, [0], e));
}
function _r(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, ee = a, x = r, S = y; g;) switch (m = v, v = Zn()) {
		case 40: if (m != 108 && Ln(S, d - 1) == 58) {
			In(S += j(ir(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			S += ir(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			S += ar(m);
			break;
		case 92:
			S += or($n() - 1, 7);
			continue;
		case 47:
			switch (Qn()) {
				case 42:
				case 47:
					Vn(yr(cr(Zn(), $n()), t, n), c);
					break;
				default: S += "/";
			}
			break;
		case 123 * h: s[l++] = zn(S) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (S = j(S, /\f/g, "")), p > 0 && zn(S) - d && Vn(p > 32 ? br(S + ";", r, n, d - 1) : br(j(S, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: S += ";";
				default: if (Vn(x = vr(S, t, n, l, u, i, s, y, b = [], ee = [], d), a), v === 123) {
					if (u === 0) _r(S, t, x, x, b, a, d, s, ee);
					else switch (f === 99 && Ln(S, 3) === 110 ? 100 : f) {
						case 100:
						case 108:
						case 109:
						case 115:
							_r(e, x, x, r && Vn(vr(e, x, x, 0, 0, i, s, y, i, b = [], d), ee), i, ee, d, s, r ? b : ee);
							break;
						default: _r(S, x, x, x, [""], ee, 0, s, ee);
					}
				}
			}
			l = u = p = 0, h = _ = 1, y = S = "", d = o;
			break;
		case 58: d = 1 + zn(S), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && Xn() == 125) continue;
			}
			switch (S += Wn(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (S += "\f", -1);
					break;
				case 44:
					s[l++] = (zn(S) - 1) * _, _ = 1;
					break;
				case 64:
					Qn() === 45 && (S += ir(Zn())), f = Qn(), u = d = zn(y = S += lr($n())), v++;
					break;
				case 45: m === 45 && zn(S) == 2 && (h = 0);
			}
	}
	return a;
}
function vr(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = Bn(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = Rn(e, d + 1, d = Un(h = o[m])), y = e; _ < p; ++_) (y = Pn(h > 0 ? f[_] + " " + v : j(v, /&\f/g, f[_]))) && (c[g++] = y);
	return qn(e, t, n, i === 0 ? Dn : s, c, l, u);
}
function yr(e, t, n) {
	return qn(e, t, n, En, Wn(Yn()), Rn(e, 2, -2), 0);
}
function br(e, t, n, r) {
	return qn(e, t, n, On, Rn(e, 0, r), Rn(e, r + 1, -1), r);
}
var xr = o((() => {
	Mn(), Kn(), hr();
})), Sr = o((() => {}));
//#endregion
//#region node_modules/stylis/src/Serializer.js
function Cr(e, t) {
	for (var n = "", r = Bn(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function wr(e, t, n, r) {
	switch (e.type) {
		case jn: if (e.children.length) break;
		case kn:
		case On: return e.return = e.return || e.value;
		case En: return "";
		case An: return e.return = e.value + "{" + Cr(e.children, r) + "}";
		case Dn: e.value = e.props.join(",");
	}
	return zn(n = Cr(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
var Tr = o((() => {
	Mn(), Kn();
}));
//#endregion
//#region node_modules/stylis/src/Middleware.js
function Er(e) {
	var t = Bn(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function Dr(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
var Or = o((() => {
	Kn();
})), kr = o((() => {
	Mn(), Kn(), xr(), Sr(), hr(), Tr(), Or();
}));
//#endregion
//#region node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function Ar(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
var jr = o((() => {}));
//#endregion
//#region node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
function Mr(e, t) {
	switch (Nn(e, t)) {
		case 5103: return A + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return A + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return A + e + Tn + e + wn + e + e;
		case 6828:
		case 4268: return A + e + wn + e + e;
		case 6165: return A + e + wn + "flex-" + e + e;
		case 5187: return A + e + j(e, /(\w+).+(:[^]+)/, A + "box-$1$2" + wn + "flex-$1$2") + e;
		case 5443: return A + e + wn + "flex-item-" + j(e, /flex-|-self/, "") + e;
		case 4675: return A + e + wn + "flex-line-pack" + j(e, /align-content|flex-|-self/, "") + e;
		case 5548: return A + e + wn + j(e, "shrink", "negative") + e;
		case 5292: return A + e + wn + j(e, "basis", "preferred-size") + e;
		case 6060: return A + "box-" + j(e, "-grow", "") + A + e + wn + j(e, "grow", "positive") + e;
		case 4554: return A + j(e, /([^-])(transform)/g, "$1" + A + "$2") + e;
		case 6187: return j(j(j(e, /(zoom-|grab)/, A + "$1"), /(image-set)/, A + "$1"), e, "") + e;
		case 5495:
		case 3959: return j(e, /(image-set\([^]*)/, A + "$1$`$1");
		case 4968: return j(j(e, /(.+:)(flex-)?(.*)/, A + "box-pack:$3" + wn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + A + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return j(e, /(.+)-inline(.+)/, A + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (zn(e) - 1 - t > 6) switch (Ln(e, t + 1)) {
				case 109: if (Ln(e, t + 4) !== 45) break;
				case 102: return j(e, /(.+:)(.+)-([^]+)/, "$1" + A + "$2-$3$1" + Tn + (Ln(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~In(e, "stretch") ? Mr(j(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (Ln(e, t + 1) !== 115) break;
		case 6444:
			switch (Ln(e, zn(e) - 3 - (~In(e, "!important") && 10))) {
				case 107: return j(e, ":", ":" + A) + e;
				case 101: return j(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + A + (Ln(e, 14) === 45 ? "inline-" : "") + "box$3$1" + A + "$2$3$1" + wn + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (Ln(e, t + 11)) {
				case 114: return A + e + wn + j(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return A + e + wn + j(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return A + e + wn + j(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return A + e + wn + e + e;
	}
	return e;
}
var Nr, Pr, Fr, Ir, Lr, Rr, zr, Br, Vr = o((() => {
	Cn(), kr(), Nr = function(e, t, n) {
		for (var r = 0, i = 0; r = i, i = Qn(), r === 38 && i === 12 && (t[n] = 1), !tr(i);) Zn();
		return er(e, pr);
	}, Pr = function(e, t) {
		var n = -1, r = 44;
		do
			switch (tr(r)) {
				case 0:
					r === 38 && Qn() === 12 && (t[n] = 1), e[n] += Nr(pr - 1, t, n);
					break;
				case 2:
					e[n] += ir(r);
					break;
				case 4: if (r === 44) {
					e[++n] = Qn() === 58 ? "&\f" : "", t[n] = e[n].length;
					break;
				}
				default: e[n] += Wn(r);
			}
		while (r = Zn());
		return e;
	}, Fr = function(e, t) {
		return rr(Pr(nr(e), t));
	}, Ir = /* #__PURE__ */ new WeakMap(), Lr = function(e) {
		if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
			for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
			if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !Ir.get(n)) && !r) {
				Ir.set(e, !0);
				for (var i = [], a = Fr(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
			}
		}
	}, Rr = function(e) {
		if (e.type === "decl") {
			var t = e.value;
			t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
		}
	}, zr = [function(e, t, n, r) {
		if (e.length > -1 && !e.return) switch (e.type) {
			case On:
				e.return = Mr(e.value, e.length);
				break;
			case An: return Cr([Jn(e, { value: j(e.value, "@", "@" + A) })], r);
			case Dn: if (e.length) return Hn(e.props, function(t) {
				switch (Fn(t, /(::plac\w+|:read-\w+)/)) {
					case ":read-only":
					case ":read-write": return Cr([Jn(e, { props: [j(t, /:(read-\w+)/, ":" + Tn + "$1")] })], r);
					case "::placeholder": return Cr([
						Jn(e, { props: [j(t, /:(plac\w+)/, ":" + A + "input-$1")] }),
						Jn(e, { props: [j(t, /:(plac\w+)/, ":" + Tn + "$1")] }),
						Jn(e, { props: [j(t, /:(plac\w+)/, wn + "input-$1")] })
					], r);
				}
				return "";
			});
		}
	}], Br = function(e) {
		var t = e.key;
		if (t === "css") {
			var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
			Array.prototype.forEach.call(n, function(e) {
				e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
			});
		}
		var r = e.stylisPlugins || zr, i = {}, a, o = [];
		a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
			for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
			o.push(e);
		});
		var s, c = [Lr, Rr], l, u = [wr, Dr(function(e) {
			l.insert(e);
		})], d = Er(c.concat(r, u)), f = function(e) {
			return Cr(gr(e), d);
		};
		s = function(e, t, n, r) {
			l = n, f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
		};
		var p = {
			key: t,
			sheet: new Sn({
				key: t,
				container: a,
				nonce: e.nonce,
				speedy: e.speedy,
				prepend: e.prepend,
				insertionPoint: e.insertionPoint
			}),
			nonce: e.nonce,
			inserted: i,
			registered: {},
			insert: s
		};
		return p.sheet.hydrate(o), p;
	};
})), Hr = /* @__PURE__ */ s(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function ee(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return ee(e) || b(e) === l;
	}, e.isConcurrentMode = ee, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Ur = /* @__PURE__ */ s(((e, t) => {
	t.exports = Hr();
})), Wr = /* @__PURE__ */ s(((e, t) => {
	var n = Ur(), r = {
		childContextTypes: !0,
		contextType: !0,
		contextTypes: !0,
		defaultProps: !0,
		displayName: !0,
		getDefaultProps: !0,
		getDerivedStateFromError: !0,
		getDerivedStateFromProps: !0,
		mixins: !0,
		propTypes: !0,
		type: !0
	}, i = {
		name: !0,
		length: !0,
		prototype: !0,
		caller: !0,
		callee: !0,
		arguments: !0,
		arity: !0
	}, a = {
		$$typeof: !0,
		render: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0
	}, o = {
		$$typeof: !0,
		compare: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0,
		type: !0
	}, s = {};
	s[n.ForwardRef] = a, s[n.Memo] = o;
	function c(e) {
		return n.isMemo(e) ? o : s[e.$$typeof] || r;
	}
	var l = Object.defineProperty, u = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
	function h(e, t, n) {
		if (typeof t != "string") {
			if (m) {
				var r = p(t);
				r && r !== m && h(e, r, n);
			}
			var a = u(t);
			d && (a = a.concat(d(t)));
			for (var o = c(e), s = c(t), g = 0; g < a.length; ++g) {
				var _ = a[g];
				if (!i[_] && !(n && n[_]) && !(s && s[_]) && !(o && o[_])) {
					var v = f(t, _);
					try {
						l(e, _, v);
					} catch {}
				}
			}
		}
		return e;
	}
	t.exports = h;
}));
//#endregion
//#region node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
function Gr(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? n && (r += n + " ") : t.push(e[n] + ";");
	}), r;
}
var Kr, qr, Jr = o((() => {
	Kr = function(e, t, n) {
		var r = e.key + "-" + t.name;
		n === !1 && e.registered[r] === void 0 && (e.registered[r] = t.styles);
	}, qr = function(e, t, n) {
		Kr(e, t, n);
		var r = e.key + "-" + t.name;
		if (e.inserted[t.name] === void 0) {
			var i = t;
			do
				e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
			while (i !== void 0);
		}
	};
}));
//#endregion
//#region node_modules/@emotion/hash/dist/emotion-hash.esm.js
function Yr(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Xr = o((() => {})), Zr, Qr = o((() => {
	Zr = {
		animationIterationCount: 1,
		aspectRatio: 1,
		borderImageOutset: 1,
		borderImageSlice: 1,
		borderImageWidth: 1,
		boxFlex: 1,
		boxFlexGroup: 1,
		boxOrdinalGroup: 1,
		columnCount: 1,
		columns: 1,
		flex: 1,
		flexGrow: 1,
		flexPositive: 1,
		flexShrink: 1,
		flexNegative: 1,
		flexOrder: 1,
		gridRow: 1,
		gridRowEnd: 1,
		gridRowSpan: 1,
		gridRowStart: 1,
		gridColumn: 1,
		gridColumnEnd: 1,
		gridColumnSpan: 1,
		gridColumnStart: 1,
		msGridRow: 1,
		msGridRowSpan: 1,
		msGridColumn: 1,
		msGridColumnSpan: 1,
		fontWeight: 1,
		lineHeight: 1,
		opacity: 1,
		order: 1,
		orphans: 1,
		scale: 1,
		tabSize: 1,
		widows: 1,
		zIndex: 1,
		zoom: 1,
		WebkitLineClamp: 1,
		fillOpacity: 1,
		floodOpacity: 1,
		stopOpacity: 1,
		strokeDasharray: 1,
		strokeDashoffset: 1,
		strokeMiterlimit: 1,
		strokeOpacity: 1,
		strokeWidth: 1
	};
}));
//#endregion
//#region node_modules/@emotion/serialize/dist/emotion-serialize.esm.js
function $r(e, t, n) {
	if (n == null) return "";
	var r = n;
	if (r.__emotion_styles !== void 0) return r;
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			var i = n;
			if (i.anim === 1) return di = {
				name: i.name,
				styles: i.styles,
				next: di
			}, i.name;
			var a = n;
			if (a.styles !== void 0) {
				var o = a.next;
				if (o !== void 0) for (; o !== void 0;) di = {
					name: o.name,
					styles: o.styles,
					next: di
				}, o = o.next;
				return a.styles + ";";
			}
			return ei(e, t, n);
		case "function": if (e !== void 0) {
			var s = di, c = n(e);
			return di = s, $r(e, t, c);
		}
	}
	var l = n;
	if (t == null) return l;
	var u = t[l];
	return u === void 0 ? l : u;
}
function ei(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += $r(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") {
			var s = o;
			t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : oi(s) && (r += si(a) + ":" + ci(a, s) + ";");
		} else {
			if (a === "NO_COMPONENT_SELECTOR" && ni) throw Error(li);
			if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var c = 0; c < o.length; c++) oi(o[c]) && (r += si(a) + ":" + ci(a, o[c]) + ";");
			else {
				var l = $r(e, t, o);
				switch (a) {
					case "animation":
					case "animationName":
						r += si(a) + ":" + l + ";";
						break;
					default: r += a + "{" + l + "}";
				}
			}
		}
	}
	return r;
}
function ti(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	di = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += $r(n, t, a)) : i += a[0];
	for (var o = 1; o < e.length; o++) i += $r(n, t, e[o]), r && (i += a[o]);
	ui.lastIndex = 0;
	for (var s = "", c; (c = ui.exec(i)) !== null;) s += "-" + c[1];
	return {
		name: Yr(i) + s,
		styles: i,
		next: di
	};
}
var ni, ri, ii, ai, oi, si, ci, li, ui, di, fi = o((() => {
	Xr(), Qr(), jr(), ni = !1, ri = /[A-Z]|^ms/g, ii = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ai = function(e) {
		return e.charCodeAt(1) === 45;
	}, oi = function(e) {
		return e != null && typeof e != "boolean";
	}, si = /* #__PURE__ */ Ar(function(e) {
		return ai(e) ? e : e.replace(ri, "-$&").toLowerCase();
	}), ci = function(e, t) {
		switch (e) {
			case "animation":
			case "animationName": if (typeof t == "string") return t.replace(ii, function(e, t, n) {
				return di = {
					name: t,
					styles: n,
					next: di
				}, t;
			});
		}
		return Zr[e] !== 1 && !ai(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
	}, li = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.", ui = /label:\s*([^\s;{]+)\s*(;|$)/g;
})), pi, mi, hi, gi = o((() => {
	yn(), pi = function(e) {
		return e();
	}, mi = Kt || !1, hi = mi || pi;
})), _i, vi, yi, bi, xi, Si, Ci, wi, Ti, Ei, Di = o((() => {
	yn(), Vr(), Jr(), fi(), gi(), _i = /* #__PURE__ */ ye(typeof HTMLElement < "u" ? /* #__PURE__ */ Br({ key: "css" }) : null), vi = _i.Provider, yi = function(e) {
		return /*#__PURE__*/ Dt(function(t, n) {
			return e(t, Ye(_i), n);
		});
	}, bi = /* #__PURE__ */ ye({}), xi = function() {
		return Ye(bi);
	}, Si = {}.hasOwnProperty, Ci = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", wi = function(e, t) {
		var n = {};
		for (var r in t) Si.call(t, r) && (n[r] = t[r]);
		return n[Ci] = e, n;
	}, Ti = function(e) {
		var t = e.cache, n = e.serialized, r = e.isStringTag;
		return Kr(t, n, r), hi(function() {
			return qr(t, n, r);
		}), null;
	}, Ei = /* @__PURE__ */ yi(function(e, t, n) {
		var r = e.css;
		typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
		var i = e[Ci], a = [r], o = "";
		typeof e.className == "string" ? o = Gr(t.registered, a, e.className) : e.className != null && (o = e.className + " ");
		var s = ti(a, void 0, Ye(bi));
		o += t.key + "-" + s.name;
		var c = {};
		for (var l in e) Si.call(e, l) && l !== "css" && l !== Ci && (c[l] = e[l]);
		return c.className = o, n && (c.ref = n), /*#__PURE__*/ m(_, null, /*#__PURE__*/ m(Ti, {
			cache: t,
			serialized: s,
			isStringTag: typeof i == "string"
		}), /*#__PURE__*/ m(i, c));
	});
}));
//#endregion
//#region node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
function N(e, t, n) {
	return Si.call(t, "css") ? E(Ei, wi(e, t), n) : E(e, t, n);
}
function Oi(e, t, n) {
	return Si.call(t, "css") ? E(Ei, wi(e, t), n) : E(e, t, n);
}
var ki, Ai = o((() => {
	ze(), Di(), yn(), Wr(), gi(), ki = _;
})), ji = /* @__PURE__ */ s(((e, t) => {
	var n = function(e) {
		return r(e) && !i(e);
	};
	function r(e) {
		return !!e && typeof e == "object";
	}
	function i(e) {
		var t = Object.prototype.toString.call(e);
		return t === "[object RegExp]" || t === "[object Date]" || o(e);
	}
	var a = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
	function o(e) {
		return e.$$typeof === a;
	}
	function s(e) {
		return Array.isArray(e) ? [] : {};
	}
	function c(e, t) {
		return t.clone !== !1 && t.isMergeableObject(e) ? g(s(e), e, t) : e;
	}
	function l(e, t, n) {
		return e.concat(t).map(function(e) {
			return c(e, n);
		});
	}
	function u(e, t) {
		if (!t.customMerge) return g;
		var n = t.customMerge(e);
		return typeof n == "function" ? n : g;
	}
	function d(e) {
		return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
			return Object.propertyIsEnumerable.call(e, t);
		}) : [];
	}
	function f(e) {
		return Object.keys(e).concat(d(e));
	}
	function p(e, t) {
		try {
			return t in e;
		} catch {
			return !1;
		}
	}
	function m(e, t) {
		return p(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
	}
	function h(e, t, n) {
		var r = {};
		return n.isMergeableObject(e) && f(e).forEach(function(t) {
			r[t] = c(e[t], n);
		}), f(t).forEach(function(i) {
			m(e, i) || (r[i] = p(e, i) && n.isMergeableObject(t[i]) ? u(i, n)(e[i], t[i], n) : c(t[i], n));
		}), r;
	}
	function g(e, t, r) {
		r ||= {}, r.arrayMerge = r.arrayMerge || l, r.isMergeableObject = r.isMergeableObject || n, r.cloneUnlessOtherwiseSpecified = c;
		var i = Array.isArray(t);
		return i === Array.isArray(e) ? i ? r.arrayMerge(e, t, r) : h(e, t, r) : c(t, r);
	}
	g.all = function(e, t) {
		if (!Array.isArray(e)) throw Error("first argument should be an array");
		return e.reduce(function(e, n) {
			return g(e, n, t);
		}, {});
	}, t.exports = g;
}));
//#endregion
//#region node_modules/is-plain-object/dist/is-plain-object.mjs
function Mi(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Ni(e) {
	var t, n;
	return Mi(e) !== !1 && (t = e.constructor, t === void 0 || (n = t.prototype, Mi(n) !== !1 && n.hasOwnProperty("isPrototypeOf") !== !1));
}
var Pi = o((() => {}));
//#endregion
//#region node_modules/mobx/dist/mobx.esm.js
function P(e) {
	var t = [...arguments].slice(1);
	throw Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (t.length ? " " + t.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
function Fi() {
	return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : Us;
}
function Ii() {
	Xs || P("Proxy not available");
}
function Li(e) {
	var t = !1;
	return function() {
		if (!t) return t = !0, e.apply(this, arguments);
	};
}
function Ri(e) {
	return typeof e == "function";
}
function zi(e) {
	switch (typeof e) {
		case "string":
		case "symbol":
		case "number": return !0;
	}
	return !1;
}
function Bi(e) {
	return typeof e == "object" && !!e;
}
function Vi(e) {
	if (!Bi(e)) return !1;
	var t = Object.getPrototypeOf(e);
	if (t == null) return !0;
	var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
	return typeof n == "function" && n.toString() === Zs;
}
function Hi(e) {
	var t = e?.constructor;
	return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function Ui(e, t, n) {
	Ks(e, t, {
		enumerable: !1,
		writable: !0,
		configurable: !0,
		value: n
	});
}
function Wi(e, t, n) {
	Ks(e, t, {
		enumerable: !1,
		writable: !1,
		configurable: !0,
		value: n
	});
}
function Gi(e, t) {
	var n = "isMobX" + e;
	return t.prototype[n] = !0, function(e) {
		return Bi(e) && e[n] === !0;
	};
}
function Ki(e) {
	return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function qi(e) {
	var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t);
	return Object.getPrototypeOf(n) === null;
}
function Ji(e) {
	return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
function Yi(e) {
	var t = Object.keys(e);
	if (!$s) return t;
	var n = Object.getOwnPropertySymbols(e);
	return n.length ? [].concat(t, n.filter(function(t) {
		return qs.propertyIsEnumerable.call(e, t);
	})) : t;
}
function Xi(e) {
	return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Zi(e, t) {
	return qs.hasOwnProperty.call(e, t);
}
function Qi(e, t) {
	return !!(e & t);
}
function $i(e, t, n) {
	return n ? e |= t : e &= ~t, e;
}
function ea(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function ta(e, t, n) {
	if (la()) return Reflect.construct.apply(null, arguments);
	var r = [null];
	r.push.apply(r, t);
	var i = new (e.bind.apply(e, r))();
	return n && ua(i, n.prototype), i;
}
function na(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, fa(r.key), r);
	}
}
function ra(e, t, n) {
	return t && na(e.prototype, t), n && na(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ia(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n) return (n = n.call(e)).next.bind(n);
	if (Array.isArray(e) || (n = pa(e)) || t && e && typeof e.length == "number") {
		n && (e = n);
		var r = 0;
		return function() {
			return r >= e.length ? { done: !0 } : {
				done: !1,
				value: e[r++]
			};
		};
	}
	throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function aa() {
	return aa = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, aa.apply(null, arguments);
}
function oa(e) {
	return oa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
		return e.__proto__ || Object.getPrototypeOf(e);
	}, oa(e);
}
function sa(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ua(e, t);
}
function ca(e) {
	try {
		return Function.toString.call(e).indexOf("[native code]") !== -1;
	} catch {
		return typeof e == "function";
	}
}
function la() {
	try {
		var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch {}
	return (la = function() {
		return !!e;
	})();
}
function ua(e, t) {
	return ua = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, ua(e, t);
}
function da(e, t) {
	if (typeof e != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (typeof r != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function fa(e) {
	var t = da(e, "string");
	return typeof t == "symbol" ? t : t + "";
}
function pa(e, t) {
	if (e) {
		if (typeof e == "string") return ea(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ea(e, t) : void 0;
	}
}
function ma(e) {
	var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
	return ma = function(e) {
		if (e === null || !ca(e)) return e;
		if (typeof e != "function") throw TypeError("Super expression must either be null or a function");
		if (t !== void 0) {
			if (t.has(e)) return t.get(e);
			t.set(e, n);
		}
		function n() {
			return ta(e, arguments, oa(this).constructor);
		}
		return n.prototype = Object.create(e.prototype, { constructor: {
			value: n,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }), ua(n, e);
	}, ma(e);
}
function ha(e) {
	function t(t, n) {
		if (va(n)) return e.decorate_20223_(t, n);
		ga(t, n, e);
	}
	return Object.assign(t, e);
}
function ga(e, t, n) {
	Zi(e, nc) || Ui(e, nc, aa({}, e[nc])), Oa(n) || (e[nc][t] = n);
}
function _a(e) {
	return Zi(e, nc) || Ui(e, nc, aa({}, e[nc])), e[nc];
}
function va(e) {
	return typeof e == "object" && typeof e.kind == "string";
}
function ya(e, t, n) {
	t === void 0 && (t = Qs), n === void 0 && (n = Qs);
	var r = new rc(e);
	return t !== Qs && Ko(r, t), n !== Qs && qo(r, n), r;
}
function ba(e, t) {
	return e === t;
}
function xa(e, t) {
	return Rs(e, t);
}
function Sa(e, t) {
	return Rs(e, t, 1);
}
function Ca(e, t) {
	return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function wa(e, t, n) {
	return rs(e) ? e : Array.isArray(e) ? R.array(e, { name: n }) : Vi(e) ? R.object(e, void 0, { name: n }) : Ki(e) ? R.map(e, { name: n }) : Ji(e) ? R.set(e, { name: n }) : typeof e == "function" && !Vo(e) && !ts(e) ? Hi(e) ? sl(e) : Xc(n, e) : e;
}
function Ta(e, t, n) {
	if (e == null || Ds(e) || xs(e) || bl(e) || Cl(e)) return e;
	if (Array.isArray(e)) return R.array(e, {
		name: n,
		deep: !1
	});
	if (Vi(e)) return R.object(e, void 0, {
		name: n,
		deep: !1
	});
	if (Ki(e)) return R.map(e, {
		name: n,
		deep: !1
	});
	if (Ji(e)) return R.set(e, {
		name: n,
		deep: !1
	});
}
function Ea(e) {
	return e;
}
function Da(e, t) {
	return Rs(e, t) ? t : e;
}
function Oa(e) {
	return e.annotationType_ === oc;
}
function ka(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Aa,
		extend_: ja,
		decorate_20223_: Ma
	};
}
function Aa(e, t, n, r) {
	var i;
	return (i = this.options_) != null && i.bound ? this.extend_(e, t, n, !1) === null ? 0 : 1 : r === e.target_ ? this.extend_(e, t, n, !1) === null ? 0 : 2 : Vo(n.value) ? 1 : (Ks(r, t, Pa(e, this, t, n, !1)), 2);
}
function ja(e, t, n, r) {
	var i = Pa(e, this, t, n);
	return e.defineProperty_(t, i, r);
}
function Ma(e, t) {
	var n = t.kind, r = t.name, i = t.addInitializer, a = this, o = function(e) {
		return oo(a.options_?.name ?? r.toString(), e, a.options_?.autoAction ?? !1);
	};
	if (n == "field") return function(e) {
		var t, n = e;
		return Vo(n) || (n = o(n)), (t = a.options_) != null && t.bound && (n = n.bind(this), n.isMobxAction = !0), n;
	};
	if (n == "method") {
		var s;
		return Vo(e) || (e = o(e)), (s = this.options_) != null && s.bound && i(function() {
			var e = this, t = e[r].bind(e);
			t.isMobxAction = !0, e[r] = t;
		}), e;
	}
	P("Cannot apply '" + a.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + ("\n'" + a.annotationType_ + "' can only be used on properties with a function value."));
}
function Na(e, t, n, r) {
	t.annotationType_, r.value;
}
function Pa(e, t, n, r, i) {
	var a, o;
	i === void 0 && (i = V.safeDescriptors), Na(e, t, n, r);
	var s = r.value;
	return (a = t.options_) != null && a.bound && (s = s.bind(e.proxy_ ?? e.target_)), {
		value: oo(t.options_?.name ?? n.toString(), s, t.options_?.autoAction ?? !1, (o = t.options_) != null && o.bound ? e.proxy_ ?? e.target_ : void 0),
		configurable: !i || e.isPlainObject_,
		enumerable: !1,
		writable: !i
	};
}
function Fa(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Ia,
		extend_: La,
		decorate_20223_: Ra
	};
}
function Ia(e, t, n, r) {
	var i;
	return r === e.target_ ? this.extend_(e, t, n, !1) === null ? 0 : 2 : (i = this.options_) != null && i.bound && (!Zi(e.target_, t) || !ts(e.target_[t])) && this.extend_(e, t, n, !1) === null ? 0 : ts(n.value) ? 1 : (Ks(r, t, Ba(e, this, t, n, !1, !1)), 2);
}
function La(e, t, n, r) {
	var i = Ba(e, this, t, n, this.options_?.bound);
	return e.defineProperty_(t, i, r);
}
function Ra(e, t) {
	var n, r = t.name, i = t.addInitializer;
	return ts(e) || (e = sl(e)), (n = this.options_) != null && n.bound && i(function() {
		var e = this, t = e[r].bind(e);
		t.isMobXFlow = !0, e[r] = t;
	}), e;
}
function za(e, t, n, r) {
	t.annotationType_, r.value;
}
function Ba(e, t, n, r, i, a) {
	a === void 0 && (a = V.safeDescriptors), za(e, t, n, r);
	var o = r.value;
	return ts(o) || (o = sl(o)), i && (o = o.bind(e.proxy_ ?? e.target_), o.isMobXFlow = !0), {
		value: o,
		configurable: !a || e.isPlainObject_,
		enumerable: !1,
		writable: !a
	};
}
function Va(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: Ha,
		extend_: Ua,
		decorate_20223_: Wa
	};
}
function Ha(e, t, n) {
	return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ua(e, t, n, r) {
	return Ga(e, this, t, n), e.defineComputedProperty_(t, aa({}, this.options_, {
		get: n.get,
		set: n.set
	}), r);
}
function Wa(e, t) {
	var n = this, r = t.name, i = t.addInitializer, a;
	function o(t, i) {
		var a = aa({}, n.options_, {
			get: e,
			context: t
		});
		return a.name ||= "ObservableObject." + r.toString(), new kc(a);
	}
	return i(function() {
		var t = Ts(this)[L], n = this, i = t.values_.get(r);
		i instanceof kc && i.derivation !== e && t.values_.delete(r), (t.lazyComputedKeys_ ??= /* @__PURE__ */ new Map()).set(r, function() {
			return o(n, t);
		});
	}), function() {
		var t = this[L], n = t.values_.get(r);
		if (n instanceof kc && n.derivation !== e) {
			var i = a?.get(this);
			return i || (i = o(this, t), (a ??= /* @__PURE__ */ new WeakMap()).set(this, i)), i.get();
		}
		return t.getObservablePropValue_(r);
	};
}
function Ga(e, t, n, r) {
	t.annotationType_, r.get;
}
function Ka(e, t) {
	return {
		annotationType_: e,
		options_: t,
		make_: qa,
		extend_: Ja,
		decorate_20223_: Ya
	};
}
function qa(e, t, n) {
	return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function Ja(e, t, n, r) {
	return Xa(e, this, t, n), e.defineObservableProperty_(t, n.value, this.options_?.enhancer ?? wa, r);
}
function Ya(e, t) {
	var n = this, r = t.kind, i = t.name;
	if (r !== "accessor") return;
	function a(e, t) {
		var r = Ts(e)[L];
		return (r.lazyObservableKeys_ ??= /* @__PURE__ */ new Map()).set(i, function() {
			return new Dc(t, n.options_?.enhancer ?? wa, "ObservableObject." + i.toString(), !1);
		}), r;
	}
	return {
		get: function() {
			return (this[L] ?? a(this, e.get.call(this))).getObservablePropValue_(i);
		},
		set: function(e) {
			return (this[L] ?? a(this, e)).setObservablePropValue_(i, e);
		},
		init: function(e) {
			return a(this, e), e;
		}
	};
}
function Xa(e, t, n, r) {
	t.annotationType_;
}
function Za(e) {
	return {
		annotationType_: sc,
		options_: e,
		make_: Qa,
		extend_: $a,
		decorate_20223_: eo
	};
}
function Qa(e, t, n, r) {
	var i;
	if (n.get) return z.make_(e, t, n, r);
	if (n.set) {
		var a = Vo(n.set) ? n.set : oo(t.toString(), n.set);
		return r === e.target_ ? e.defineProperty_(t, {
			configurable: !V.safeDescriptors || e.isPlainObject_,
			set: a
		}) === null ? 0 : 2 : (Ks(r, t, {
			configurable: !0,
			set: a
		}), 2);
	}
	if (r !== e.target_ && typeof n.value == "function") {
		var o;
		if (Hi(n.value)) {
			var s;
			return ((s = this.options_) != null && s.autoBind ? sl.bound : sl).make_(e, t, n, r);
		}
		return ((o = this.options_) != null && o.autoBind ? Xc.bound : Xc).make_(e, t, n, r);
	}
	var c = this.options_?.deep === !1 ? R.ref : R;
	return typeof n.value == "function" && (i = this.options_) != null && i.autoBind && (n.value = n.value.bind(e.proxy_ ?? e.target_)), c.make_(e, t, n, r);
}
function $a(e, t, n, r) {
	var i;
	return n.get ? z.extend_(e, t, n, r) : n.set ? e.defineProperty_(t, {
		configurable: !V.safeDescriptors || e.isPlainObject_,
		set: oo(t.toString(), n.set)
	}, r) : (typeof n.value == "function" && (i = this.options_) != null && i.autoBind && (n.value = n.value.bind(e.proxy_ ?? e.target_)), (this.options_?.deep === !1 ? R.ref : R).extend_(e, t, n, r));
}
function eo(e, t) {
	P("'" + this.annotationType_ + "' cannot be used as a decorator");
}
function to(e) {
	return e || pc;
}
function no(e) {
	return e.deep === !0 ? wa : e.deep === !1 ? Ea : io(e.defaultDecorator);
}
function ro(e) {
	return e ? e.defaultDecorator ?? Za(e) : void 0;
}
function io(e) {
	return e ? e.options_?.enhancer ?? wa : wa;
}
function ao(e, t, n) {
	if (va(t)) return mc.decorate_20223_(e, t);
	if (zi(t)) {
		ga(e, t, mc);
		return;
	}
	return rs(e) ? e : Vi(e) ? R.object(e, t, n) : Array.isArray(e) ? R.array(e, t) : Ki(e) ? R.map(e, t) : Ji(e) ? R.set(e, t) : typeof e == "object" && e ? e : R.box(e, t);
}
function oo(e, t, n, r) {
	n === void 0 && (n = !1);
	function i() {
		return so(e, n, t, r || this, arguments);
	}
	return i.isMobxAction = !0, i.toString = function() {
		return t.toString();
	}, Tc && (Ec.value = e, Ks(i, "name", Ec)), i;
}
function so(e, t, n, r, i) {
	var a = co(e, t, r, i);
	try {
		return n.apply(r, i);
	} catch (e) {
		throw a.error_ = e, e;
	} finally {
		lo(a);
	}
}
function co(e, t, n, r) {
	var i = !1, a = 0, o = V.trackingDerivation, s = !t || !o;
	ko();
	var c = V.allowStateChanges;
	s && (bo(), c = fo(!0));
	var l = So(!0), u = {
		runAsAction_: s,
		prevDerivation_: o,
		prevAllowStateChanges_: c,
		prevAllowStateReads_: l,
		notifySpy_: i,
		startTime_: a,
		actionId_: wc++,
		parentActionId_: Cc
	};
	return Cc = u.actionId_, u;
}
function lo(e) {
	Cc !== e.actionId_ && P(30), Cc = e.parentActionId_, e.error_ !== void 0 && (V.suppressReactionErrors = !0), po(e.prevAllowStateChanges_), Co(e.prevAllowStateReads_), Ao(), e.runAsAction_ && xo(e.prevDerivation_), V.suppressReactionErrors = !1;
}
function uo(e, t) {
	var n = fo(e);
	try {
		return t();
	} finally {
		po(n);
	}
}
function fo(e) {
	var t = V.allowStateChanges;
	return V.allowStateChanges = e, t;
}
function po(e) {
	V.allowStateChanges = e;
}
function mo(e) {
	return e instanceof Mc;
}
function ho(e) {
	switch (e.dependenciesState_) {
		case B.UP_TO_DATE_: return !1;
		case B.NOT_TRACKING_:
		case B.STALE_: return !0;
		case B.POSSIBLY_STALE_:
			for (var t = So(!0), n = bo(), r = e.observing_, i = r.length, a = 0; a < i; a++) {
				var o = r[a];
				if (Ac(o)) {
					if (V.disableErrorBoundaries) o.get();
					else try {
						o.get();
					} catch {
						return xo(n), Co(t), !0;
					}
					if (e.dependenciesState_ === B.STALE_) return xo(n), Co(t), !0;
				}
			}
			return wo(e), xo(n), Co(t), !1;
	}
}
function go(e, t, n) {
	var r = So(!0);
	wo(e), e.newObserving_ = Array(e.runId_ === 0 ? 100 : e.observing_.length), e.unboundDepsCount_ = 0, e.runId_ = ++V.runId;
	var i = V.trackingDerivation;
	V.trackingDerivation = e, V.inBatch++;
	var a;
	if (V.disableErrorBoundaries === !0) a = t.call(n);
	else try {
		a = t.call(n);
	} catch (e) {
		a = new Mc(e);
	}
	return V.inBatch--, V.trackingDerivation = i, _o(e), Co(r), a;
}
function _o(e) {
	for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = B.UP_TO_DATE_, i = 0, a = e.unboundDepsCount_, o = 0; o < a; o++) {
		var s = n[o];
		s.diffValue === 0 && (s.diffValue = 1, i !== o && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
	}
	for (n.length = i, e.newObserving_ = null, a = t.length; a--;) {
		var c = t[a];
		c.diffValue === 0 && Do(c, e), c.diffValue = 0;
	}
	for (; i--;) {
		var l = n[i];
		l.diffValue === 1 && (l.diffValue = 0, Eo(l, e));
	}
	r !== B.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function vo(e) {
	var t = e.observing_;
	e.observing_ = [];
	for (var n = t.length; n--;) Do(t[n], e);
	e.dependenciesState_ = B.NOT_TRACKING_;
}
function yo(e) {
	var t = bo();
	try {
		return e();
	} finally {
		xo(t);
	}
}
function bo() {
	var e = V.trackingDerivation;
	return V.trackingDerivation = null, e;
}
function xo(e) {
	V.trackingDerivation = e;
}
function So(e) {
	var t = V.allowStateReads;
	return V.allowStateReads = e, t;
}
function Co(e) {
	V.allowStateReads = e;
}
function wo(e) {
	if (e.dependenciesState_ !== B.UP_TO_DATE_) {
		e.dependenciesState_ = B.UP_TO_DATE_;
		for (var t = e.observing_, n = t.length; n--;) t[n].lowestObserverState_ = B.UP_TO_DATE_;
	}
}
function To() {
	if ((V.pendingReactions.length || V.inBatch || V.isRunningReactions) && P(36), Fc = !0, Pc) {
		var e = Fi();
		--e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), V = new Nc();
	}
}
function Eo(e, t) {
	e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function Do(e, t) {
	e.observers_.delete(t), e.observers_.size === 0 && Oo(e);
}
function Oo(e) {
	e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, V.pendingUnobservations.push(e));
}
function ko() {
	V.inBatch++;
}
function Ao() {
	if (--V.inBatch === 0) {
		Fo();
		for (var e = V.pendingUnobservations, t = 0; t < e.length; t++) {
			var n = e[t];
			n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof kc && n.suspend_());
		}
		V.pendingUnobservations = [];
	}
}
function jo(e) {
	var t = V.trackingDerivation;
	return t === null ? (e.observers_.size === 0 && V.inBatch > 0 && Oo(e), !1) : (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && V.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved);
}
function Mo(e) {
	e.lowestObserverState_ !== B.STALE_ && (e.lowestObserverState_ = B.STALE_, e.observers_.forEach(function(e) {
		e.dependenciesState_ === B.UP_TO_DATE_ && e.onBecomeStale_(), e.dependenciesState_ = B.STALE_;
	}));
}
function No(e) {
	e.lowestObserverState_ !== B.STALE_ && (e.lowestObserverState_ = B.STALE_, e.observers_.forEach(function(t) {
		t.dependenciesState_ === B.POSSIBLY_STALE_ ? t.dependenciesState_ = B.STALE_ : t.dependenciesState_ === B.UP_TO_DATE_ && (e.lowestObserverState_ = B.UP_TO_DATE_);
	}));
}
function Po(e) {
	e.lowestObserverState_ === B.UP_TO_DATE_ && (e.lowestObserverState_ = B.POSSIBLY_STALE_, e.observers_.forEach(function(e) {
		e.dependenciesState_ === B.UP_TO_DATE_ && (e.dependenciesState_ = B.POSSIBLY_STALE_, e.onBecomeStale_());
	}));
}
function Fo() {
	V.inBatch > 0 || V.isRunningReactions || Rc(Io);
}
function Io() {
	V.isRunningReactions = !0;
	for (var e = V.pendingReactions, t = 0; e.length > 0;) {
		++t === Lc && (console.error("[mobx] cycle in reaction: " + e[0]), e.splice(0));
		for (var n = e.splice(0), r = 0, i = n.length; r < i; r++) n[r].runReaction_();
	}
	V.isRunningReactions = !1;
}
function Lo(e) {
	var t = Rc;
	Rc = function(n) {
		return e(function() {
			return t(n);
		});
	};
}
function Ro() {
	return !1;
}
function zo(e) {
	return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
}
function Bo(e) {
	return function(t, n) {
		if (Ri(t)) return oo(t.name || Wc, t, e);
		if (Ri(n)) return oo(t, n, e);
		if (va(n)) return (e ? qc : Gc).decorate_20223_(t, n);
		if (zi(n)) return ga(t, n, e ? qc : Gc);
		if (zi(t)) return ha(ka(e ? Hc : Bc, {
			name: t,
			autoAction: e
		}));
	};
}
function Vo(e) {
	return Ri(e) && e.isMobxAction === !0;
}
function Ho(e, t) {
	var n;
	t === void 0 && (t = Ys);
	var r = t?.name ?? "Autorun", i = !t.scheduler && !t.delay, a;
	if (i) a = new Ic(r, function() {
		this.track(c);
	}, t.onError, t.requiresObservable);
	else {
		var o = Uo(t), s = !1;
		a = new Ic(r, function() {
			s || (s = !0, o(function() {
				s = !1, a.isDisposed || a.track(c);
			}));
		}, t.onError, t.requiresObservable);
	}
	function c() {
		e(a);
	}
	return (n = t) != null && (n = n.signal) != null && n.aborted || a.schedule_(), a.getDisposer_(t?.signal);
}
function Uo(e) {
	return e.scheduler ? e.scheduler : e.delay ? function(t) {
		return setTimeout(t, e.delay);
	} : Zc;
}
function Wo(e, t, n) {
	var r;
	n === void 0 && (n = Ys);
	var i = n.name ?? "Reaction", a = Yc(i, n.onError ? Go(n.onError, t) : t), o = !n.scheduler && !n.delay, s = Uo(n), c = !0, l = !1, u, d = n.compareStructural ? ac.structural : n.equals || ac.default, f = new Ic(i, function() {
		c || o ? p() : l || (l = !0, s(p));
	}, n.onError, n.requiresObservable);
	function p() {
		if (l = !1, !f.isDisposed) {
			var t = !1, r = u;
			f.track(function() {
				var n = uo(!1, function() {
					return e(f);
				});
				t = c || !d(u, n), u = n;
			}), (c && n.fireImmediately || !c && t) && a(u, r, f), c = !1;
		}
	}
	return (r = n) != null && (r = r.signal) != null && r.aborted || f.schedule_(), f.getDisposer_(n?.signal);
}
function Go(e, t) {
	return function() {
		try {
			return t.apply(this, arguments);
		} catch (t) {
			e.call(this, t);
		}
	};
}
function Ko(e, t, n) {
	return Jo(Qc, e, t, n);
}
function qo(e, t, n) {
	return Jo($c, e, t, n);
}
function Jo(e, t, n, r) {
	var i = typeof r == "function" ? Ps(t, n) : Ps(t), a = Ri(r) ? r : n, o = e + "L";
	return i[o] ? i[o].add(a) : i[o] = /* @__PURE__ */ new Set([a]), function() {
		var e = i[o];
		e && (e.delete(a), e.size === 0 && delete i[o]);
	};
}
function Yo(e) {
	e.isolateGlobalState === !0 && To();
	var t = e.useProxies, n = e.enforceActions;
	if (t !== void 0 && (V.useProxies = t === tl || t !== el && typeof Proxy < "u"), t === "ifavailable" && (V.verifyProxies = !0), n !== void 0) {
		var r = n === tl ? tl : n === nl;
		V.enforceActions = r, V.allowStateChanges = r !== !0 && r !== tl;
	}
	[
		"computedRequiresReaction",
		"reactionRequiresObservable",
		"observableRequiresReaction",
		"disableErrorBoundaries",
		"safeDescriptors"
	].forEach(function(t) {
		t in e && (V[t] = !!e[t]);
	}), V.allowStateReads = !V.observableRequiresReaction, e.reactionScheduler && Lo(e.reactionScheduler);
}
function Xo(e, t, n, r) {
	var i = tc(t);
	return Ls(function() {
		var t = Ts(e, r)[L];
		ec(i).forEach(function(e) {
			t.extend_(e, i[e], n && e in n ? n[e] : !0);
		});
	}), e;
}
function Zo(e, t) {
	return Qo(Ps(e, t));
}
function Qo(e) {
	var t = { name: e.name_ };
	return e.observing_ && e.observing_.length > 0 && (t.dependencies = $o(e.observing_).map(Qo)), t;
}
function $o(e) {
	return Array.from(new Set(e));
}
function es(e) {
	Ri(e.cancel) && e.cancel();
}
function ts(e) {
	return e?.isMobXFlow === !0;
}
function ns(e, t) {
	if (!e) return !1;
	if (t !== void 0) {
		if (Ds(e)) {
			var n, r, i = e[L];
			return i.values_.has(t) || !!((n = i.lazyComputedKeys_) != null && n.has(t)) || !!((r = i.lazyObservableKeys_) != null && r.has(t));
		}
		return !1;
	}
	return Ds(e) || !!e[L] || ic(e) || zc(e) || Ac(e);
}
function rs(e) {
	return ns(e);
}
function is(e) {
	if (Ds(e)) return e[L].ownKeys_();
	P(38);
}
function as(e, t, n) {
	return e.set(t, n), n;
}
function os(e, t) {
	if (typeof e != "object" || !e || e instanceof Date || !rs(e)) return e;
	if (Oc(e) || Ac(e)) return os(e.get(), t);
	if (t.has(e)) return t.get(e);
	if (xs(e)) {
		var n = as(t, e, Array(e.length));
		return e.forEach(function(e, r) {
			n[r] = os(e, t);
		}), n;
	}
	if (Cl(e)) {
		var r = as(t, e, /* @__PURE__ */ new Set());
		return e.forEach(function(e) {
			r.add(os(e, t));
		}), r;
	}
	if (bl(e)) {
		var i = as(t, e, /* @__PURE__ */ new Map());
		return e.forEach(function(e, n) {
			i.set(n, os(e, t));
		}), i;
	}
	var a = as(t, e, {});
	return is(e).forEach(function(n) {
		qs.propertyIsEnumerable.call(e, n) && (a[n] = os(e[n], t));
	}), a;
}
function ss(e, t) {
	return os(e, /* @__PURE__ */ new Map());
}
function cs(e, t) {
	t === void 0 && (t = void 0), ko();
	try {
		return e.apply(t);
	} finally {
		Ao();
	}
}
function ls(e) {
	return e[L];
}
function us(e, t) {
	var n;
	return Ii(), e = Ts(e, t), (n = e[L]).proxy_ ?? (n.proxy_ = new Proxy(e, cl));
}
function ds(e) {
	return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function fs(e, t) {
	var n = e.interceptors_ ||= [];
	return n.push(t), Li(function() {
		var e = n.indexOf(t);
		e !== -1 && n.splice(e, 1);
	});
}
function ps(e, t) {
	var n = bo();
	try {
		for (var r = [].concat(e.interceptors_ || []), i = 0, a = r.length; i < a && (t = r[i](t), t && !t.type && P(14), t); i++);
		return t;
	} finally {
		xo(n);
	}
}
function ms(e) {
	return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function hs(e, t) {
	var n = e.changeListeners_ ||= [];
	return n.push(t), Li(function() {
		var e = n.indexOf(t);
		e !== -1 && n.splice(e, 1);
	});
}
function gs(e, t) {
	var n = bo(), r = e.changeListeners_;
	if (r) {
		r = r.slice();
		for (var i = 0, a = r.length; i < a; i++) r[i](t);
		xo(n);
	}
}
function F(e, t, n) {
	return Ls(function() {
		var r = Ts(e, n)[L];
		t ??= _a(e), ec(t).forEach(function(e) {
			return r.make_(e, t[e]);
		});
	}), e;
}
function _s(e, t, n, r) {
	return n === void 0 && (n = "ObservableArray"), r === void 0 && (r = !1), Ii(), Ls(function() {
		var i = new pl(n, t, r, !1);
		Wi(i.values_, L, i);
		var a = new Proxy(i.values_, fl);
		return i.proxy_ = a, e && e.length && i.spliceWithArray_(0, 0, e), a;
	});
}
function I(e, t) {
	typeof Array.prototype[e] == "function" && (ml[e] = t(e));
}
function vs(e) {
	return function() {
		var t = this[L];
		t.atom_.reportObserved();
		var n = t.dehanceValues_(t.values_);
		return n[e].apply(n, arguments);
	};
}
function ys(e) {
	return function(t, n) {
		var r = this, i = this[L];
		return i.atom_.reportObserved(), i.dehanceValues_(i.values_)[e](function(e, i) {
			return t.call(n, e, i, r);
		});
	};
}
function bs(e) {
	return function() {
		var t = this, n = this[L];
		n.atom_.reportObserved();
		var r = n.dehanceValues_(n.values_), i = arguments[0];
		return arguments[0] = function(e, n, r) {
			return i(e, n, r, t);
		}, r[e].apply(r, arguments);
	};
}
function xs(e) {
	return Bi(e) && hl(e[L]);
}
function Ss(e) {
	return e[Symbol.toStringTag] = "MapIterator", Vs(e);
}
function Cs(e) {
	if (Ki(e) || bl(e)) return e;
	if (Array.isArray(e)) return new Map(e);
	if (Vi(e)) {
		var t = /* @__PURE__ */ new Map();
		for (var n in e) t.set(n, e[n]);
		return t;
	}
	return P(21, e);
}
function ws(e) {
	return e[Symbol.toStringTag] = "SetIterator", Vs(e);
}
function Ts(e, t) {
	if (Zi(e, L)) return e;
	var n = t?.name ?? "ObservableObject";
	return Ui(e, L, new El(e, /* @__PURE__ */ new Map(), String(n), ro(t))), e;
}
function Es(e) {
	return wl[e] || (wl[e] = {
		get: function() {
			return this[L].getObservablePropValue_(e);
		},
		set: function(t) {
			return this[L].setObservablePropValue_(e, t);
		}
	});
}
function Ds(e) {
	return Bi(e) ? Dl(e[L]) : !1;
}
function Os(e, t, n) {
	var r;
	(r = e.target_[nc]) == null || delete r[n];
}
function ks(e, t) {
	Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ === void 0 ? e.prototype = t : e.prototype.__proto__ = t;
}
function As(e) {
	return {
		enumerable: !1,
		configurable: !0,
		get: function() {
			return this[L].get_(e);
		},
		set: function(t) {
			this[L].set_(e, t);
		}
	};
}
function js(e) {
	Ks(Ml.prototype, "" + e, As(e));
}
function Ms(e) {
	if (e > Al) {
		for (var t = Al; t < e + 100; t++) js(t);
		Al = e;
	}
}
function Ns(e, t, n) {
	return new Ml(e, t, n);
}
function Ps(e, t) {
	if (typeof e == "object" && e) {
		if (xs(e)) return t !== void 0 && P(23), e[L].atom_;
		if (Cl(e)) return e.atom_;
		if (bl(e)) {
			if (t === void 0) return e.keysAtom_;
			var n = e.data_.get(t) || e.hasMap_.get(t);
			return n || P(25, t, Is(e)), n;
		}
		if (Ds(e)) {
			if (!t) return P(26);
			var r = e[L], i = r.values_.get(t) ?? r.materializeLazyComputed_(t) ?? r.materializeLazyObservable_(t);
			return i || P(27, t, Is(e)), i;
		}
		if (ic(e) || Ac(e) || zc(e)) return e;
	} else if (Ri(e) && zc(e[L])) return e[L];
	P(28);
}
function Fs(e, t) {
	if (e || P(29), t !== void 0) return Fs(Ps(e, t));
	if (ic(e) || Ac(e) || zc(e) || bl(e) || Cl(e)) return e;
	if (e[L]) return e[L];
	P(24, e);
}
function Is(e, t) {
	var n;
	if (t !== void 0) n = Ps(e, t);
	else if (Vo(e)) return e.name;
	else n = Ds(e) || bl(e) || Cl(e) ? Fs(e) : Ps(e);
	return n.name_;
}
function Ls(e) {
	var t = bo(), n = fo(!0);
	ko();
	try {
		return e();
	} finally {
		Ao(), po(n), xo(t);
	}
}
function Rs(e, t, n) {
	return n === void 0 && (n = -1), zs(e, t, n);
}
function zs(e, t, n, r, i) {
	if (e === t) return e !== 0 || 1 / e == 1 / t;
	if (e == null || t == null) return !1;
	if (e !== e) return t !== t;
	var a = typeof e;
	if (a !== "function" && a !== "object" && typeof t != "object") return !1;
	var o = Nl.call(e);
	if (o !== Nl.call(t)) return !1;
	switch (o) {
		case "[object RegExp]":
		case "[object String]": return "" + e == "" + t;
		case "[object Number]": return +e == +e ? +e == 0 ? 1 / e == 1 / t : +e == +t : +t != +t;
		case "[object Date]":
		case "[object Boolean]": return +e == +t;
		case "[object Symbol]": return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
		case "[object Map]":
		case "[object Set]": n >= 0 && n++;
	}
	e = Bs(e), t = Bs(t);
	var s = o === "[object Array]";
	if (!s) {
		if (typeof e != "object" || typeof t != "object") return !1;
		var c = e.constructor, l = t.constructor;
		if (c !== l && !(Ri(c) && c instanceof c && Ri(l) && l instanceof l) && "constructor" in e && "constructor" in t) return !1;
	}
	if (n === 0) return !1;
	n < 0 && (n = -1), r ||= [], i ||= [];
	for (var u = r.length; u--;) if (r[u] === e) return i[u] === t;
	if (r.push(e), i.push(t), s) {
		if (u = e.length, u !== t.length) return !1;
		for (; u--;) if (!zs(e[u], t[u], n - 1, r, i)) return !1;
	} else {
		var d = Object.keys(e), f = d.length;
		if (Object.keys(t).length !== f) return !1;
		for (var p = 0; p < f; p++) {
			var m = d[p];
			if (!(Zi(t, m) && zs(e[m], t[m], n - 1, r, i))) return !1;
		}
	}
	return r.pop(), i.pop(), !0;
}
function Bs(e) {
	return xs(e) ? e.slice() : Ki(e) || bl(e) || Ji(e) || Cl(e) ? Array.from(e.entries()) : e;
}
function Vs(e) {
	return e[Symbol.iterator] = Hs, Object.assign(Object.create(Pl), e);
}
function Hs() {
	return this;
}
var Us, Ws, Gs, Ks, qs, Js, Ys, Xs, Zs, Qs, $s, ec, tc, nc, L, rc, ic, ac, oc, sc, cc, lc, uc, dc, fc, pc, mc, hc, gc, _c, vc, R, yc, bc, xc, Sc, z, Cc, wc, Tc, Ec, Dc, Oc, kc, Ac, B, jc, Mc, Nc, Pc, Fc, V, Ic, Lc, Rc, zc, Bc, Vc, Hc, Uc, Wc, Gc, Kc, qc, Jc, Yc, Xc, Zc, Qc, $c, el, tl, nl, rl, il, al, ol, sl, cl, ll, ul, dl, fl, pl, ml, hl, gl, _l, vl, yl, bl, xl, Sl, Cl, wl, Tl, El, Dl, Ol, kl, Al, jl, Ml, Nl, Pl, H = o((() => {
	Us = {}, Ws = Object.assign, Gs = Object.getOwnPropertyDescriptor, Ks = Object.defineProperty, qs = Object.prototype, Js = [], Object.freeze(Js), Ys = {}, Object.freeze(Ys), Xs = typeof Proxy < "u", Zs = /*#__PURE__*/ Object.toString(), Qs = function() {}, $s = Object.getOwnPropertySymbols !== void 0, ec = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : $s ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : /* istanbul ignore next */ Object.getOwnPropertyNames, tc = Object.getOwnPropertyDescriptors || function(e) {
		var t = {};
		return ec(e).forEach(function(n) {
			t[n] = Gs(e, n);
		}), t;
	}, nc = /*#__PURE__*/ Symbol("mobx-stored-annotations"), L = /*#__PURE__*/ Symbol("mobx administration"), rc = /*#__PURE__*/ function() {
		function e(e) {
			e === void 0 && (e = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = B.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e;
		}
		var t = e.prototype;
		return t.onBO = function() {
			this.onBOL && this.onBOL.forEach(function(e) {
				return e();
			});
		}, t.onBUO = function() {
			this.onBUOL && this.onBUOL.forEach(function(e) {
				return e();
			});
		}, t.reportObserved = function() {
			return jo(this);
		}, t.reportChanged = function() {
			ko(), Mo(this), Ao();
		}, t.toString = function() {
			return this.name_;
		}, ra(e, [
			{
				key: "isBeingObserved",
				get: function() {
					return Qi(this.flags_, e.isBeingObservedMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isBeingObservedMask_, t);
				}
			},
			{
				key: "isPendingUnobservation",
				get: function() {
					return Qi(this.flags_, e.isPendingUnobservationMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isPendingUnobservationMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!Qi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), rc.isBeingObservedMask_ = 1, rc.isPendingUnobservationMask_ = 2, rc.diffValueMask_ = 4, ic = /*#__PURE__*/ Gi("Atom", rc), ac = {
		identity: ba,
		structural: xa,
		default: Ca,
		shallow: Sa
	}, oc = "override", sc = "true", cc = /*#__PURE__*/ Za(), lc = "observable", uc = "observable.ref", dc = "observable.shallow", fc = "observable.struct", pc = {
		deep: !0,
		name: void 0,
		defaultDecorator: void 0,
		proxy: !0
	}, Object.freeze(pc), mc = /*#__PURE__*/ Ka(lc), hc = /*#__PURE__*/ Ka(uc, { enhancer: Ea }), gc = /*#__PURE__*/ Ka(dc, { enhancer: Ta }), _c = /*#__PURE__*/ Ka(fc, { enhancer: Da }), vc = /*#__PURE__*/ ha(mc), Ws(ao, vc), R = /*#__PURE__*/ Ws(ao, {
		box: function(e, t) {
			var n = to(t);
			return new Dc(e, no(n), n.name, !0, n.equals);
		},
		array: function(e, t) {
			var n = to(t);
			return (V.useProxies === !1 || n.proxy === !1 ? Ns : _s)(e, no(n), n.name);
		},
		map: function(e, t) {
			var n = to(t);
			return new yl(e, no(n), n.name);
		},
		set: function(e, t) {
			var n = to(t);
			return new Sl(e, no(n), n.name);
		},
		object: function(e, t, n) {
			return Ls(function() {
				return Xo(V.useProxies === !1 || n?.proxy === !1 ? Ts({}, n) : us({}, n), e, t);
			});
		},
		ref: /*#__PURE__*/ ha(hc),
		shallow: /*#__PURE__*/ ha(gc),
		deep: vc,
		struct: /*#__PURE__*/ ha(_c)
	}), yc = "computed", bc = "computed.struct", xc = /*#__PURE__*/ Va(yc), Sc = /*#__PURE__*/ Va(bc, { equals: ac.structural }), z = function(e, t) {
		if (va(t)) return xc.decorate_20223_(e, t);
		if (zi(t)) return ga(e, t, xc);
		if (Vi(e)) return ha(Va(yc, e));
		var n = Vi(t) ? t : {};
		return n.get = e, n.name ||= e.name || "", new kc(n);
	}, Object.assign(z, xc), z.struct = /*#__PURE__*/ ha(Sc), Cc = 0, wc = 1, Tc = (/*#__PURE__*/ Gs(function() {}, "name"))?.configurable ?? !1, Ec = {
		value: "action",
		configurable: !0,
		writable: !1,
		enumerable: !1
	}, Dc = /*#__PURE__*/ function(e) {
		function t(t, n, r, i, a) {
			var o;
			return r === void 0 && (r = "ObservableValue"), i === void 0 && (i = !0), a === void 0 && (a = ac.default), o = e.call(this, r) || this, o.enhancer = void 0, o.name_ = void 0, o.equals = void 0, o.hasUnreportedChange_ = !1, o.interceptors_ = void 0, o.changeListeners_ = void 0, o.value_ = void 0, o.dehancer = void 0, o.enhancer = n, o.name_ = r, o.equals = a, o.value_ = n(t, void 0, r), o;
		}
		sa(t, e);
		var n = t.prototype;
		return n.dehanceValue = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, n.set = function(e) {
			this.value_, e = this.prepareNewValue_(e), e !== V.UNCHANGED && this.setNewValue_(e);
		}, n.prepareNewValue_ = function(e) {
			if (ds(this)) {
				var t = ps(this, {
					object: this,
					type: ul,
					newValue: e
				});
				if (!t) return V.UNCHANGED;
				e = t.newValue;
			}
			return e = this.enhancer(e, this.value_, this.name_), this.equals(this.value_, e) ? V.UNCHANGED : e;
		}, n.setNewValue_ = function(e) {
			var t = this.value_;
			this.value_ = e, this.reportChanged(), ms(this) && gs(this, {
				type: ul,
				object: this,
				newValue: e,
				oldValue: t
			});
		}, n.get = function() {
			return this.reportObserved(), this.dehanceValue(this.value_);
		}, n.intercept_ = function(e) {
			return fs(this, e);
		}, n.observe_ = function(e, t) {
			return t && e({
				observableKind: "value",
				debugObjectName: this.name_,
				object: this,
				type: ul,
				newValue: this.value_,
				oldValue: void 0
			}), hs(this, e);
		}, n.raw = function() {
			return this.value_;
		}, n.toJSON = function() {
			return this.get();
		}, n.toString = function() {
			return this.name_ + "[" + this.value_ + "]";
		}, n.valueOf = function() {
			return Xi(this.get());
		}, n[Symbol.toPrimitive] = function() {
			return this.valueOf();
		}, t;
	}(rc), Oc = /*#__PURE__*/ Gi("ObservableValue", Dc), kc = /*#__PURE__*/ function() {
		function e(e) {
			this.dependenciesState_ = B.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = B.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Mc(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = jc.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e.get || P(31), this.derivation = e.get, this.name_ = e.name || "ComputedValue", e.set && (this.setter_ = oo("ComputedValue-setter", e.set)), this.equals_ = e.equals || (e.compareStructural || e.struct ? ac.structural : ac.default), this.scope_ = e.context, this.requiresReaction_ = e.requiresReaction, this.keepAlive_ = !!e.keepAlive;
		}
		var t = e.prototype;
		return t.onBecomeStale_ = function() {
			Po(this);
		}, t.onBO = function() {
			this.onBOL && this.onBOL.forEach(function(e) {
				return e();
			});
		}, t.onBUO = function() {
			this.onBUOL && this.onBUOL.forEach(function(e) {
				return e();
			});
		}, t.get = function() {
			if (this.isComputing && P(32, this.name_, this.derivation), V.inBatch === 0 && this.observers_.size === 0 && !this.keepAlive_) ho(this) && (this.warnAboutUntrackedRead_(), ko(), this.value_ = this.computeValue_(!1), Ao());
			else if (jo(this), ho(this)) {
				var e = V.trackingContext;
				this.keepAlive_ && !e && (V.trackingContext = this), this.trackAndCompute() && No(this), V.trackingContext = e;
			}
			var t = this.value_;
			if (mo(t)) throw t.cause;
			return t;
		}, t.set = function(e) {
			if (this.setter_) {
				this.isRunningSetter && P(33, this.name_), this.isRunningSetter = !0;
				try {
					this.setter_.call(this.scope_, e);
				} finally {
					this.isRunningSetter = !1;
				}
			} else P(34, this.name_);
		}, t.trackAndCompute = function() {
			var e = this.value_, t = this.dependenciesState_ === B.NOT_TRACKING_, n = this.computeValue_(!0), r = t || mo(e) || mo(n) || !this.equals_(e, n);
			return r && (this.value_ = n), r;
		}, t.computeValue_ = function(e) {
			this.isComputing = !0;
			var t = fo(!1), n;
			if (e) n = go(this, this.derivation, this.scope_);
			else if (V.disableErrorBoundaries === !0) n = this.derivation.call(this.scope_);
			else try {
				n = this.derivation.call(this.scope_);
			} catch (e) {
				n = new Mc(e);
			}
			return po(t), this.isComputing = !1, n;
		}, t.suspend_ = function() {
			this.keepAlive_ || (vo(this), this.value_ = void 0);
		}, t.observe_ = function(e, t) {
			var n = this, r = !0, i = void 0;
			return Ho(function() {
				var a = n.get();
				if (!r || t) {
					var o = bo();
					e({
						observableKind: "computed",
						debugObjectName: n.name_,
						type: ul,
						object: n,
						newValue: a,
						oldValue: i
					}), xo(o);
				}
				r = !1, i = a;
			});
		}, t.warnAboutUntrackedRead_ = function() {}, t.toString = function() {
			return this.name_ + "[" + this.derivation.toString() + "]";
		}, t.valueOf = function() {
			return Xi(this.get());
		}, t[Symbol.toPrimitive] = function() {
			return this.valueOf();
		}, ra(e, [
			{
				key: "isComputing",
				get: function() {
					return Qi(this.flags_, e.isComputingMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isComputingMask_, t);
				}
			},
			{
				key: "isRunningSetter",
				get: function() {
					return Qi(this.flags_, e.isRunningSetterMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isRunningSetterMask_, t);
				}
			},
			{
				key: "isBeingObserved",
				get: function() {
					return Qi(this.flags_, e.isBeingObservedMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isBeingObservedMask_, t);
				}
			},
			{
				key: "isPendingUnobservation",
				get: function() {
					return Qi(this.flags_, e.isPendingUnobservationMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isPendingUnobservationMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!Qi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), kc.isComputingMask_ = 1, kc.isRunningSetterMask_ = 2, kc.isBeingObservedMask_ = 4, kc.isPendingUnobservationMask_ = 8, kc.diffValueMask_ = 16, Ac = /*#__PURE__*/ Gi("ComputedValue", kc), (function(e) {
		e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
	})(B ||= {}), (function(e) {
		e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
	})(jc ||= {}), Mc = function(e) {
		this.cause = void 0, this.cause = e;
	}, Nc = function() {
		this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
	}, Pc = !0, Fc = !1, V = /*#__PURE__*/ function() {
		var e = /*#__PURE__*/ Fi();
		return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Pc = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Nc().version && (Pc = !1), Pc ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /*#__PURE__*/ new Nc()) : (setTimeout(function() {
			Fc || P(35);
		}, 1), new Nc());
	}(), Ic = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			e === void 0 && (e = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = B.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = jc.NONE, this.name_ = e, this.onInvalidate_ = t, this.errorHandler_ = n, this.requiresObservable_ = r;
		}
		var t = e.prototype;
		return t.onBecomeStale_ = function() {
			this.schedule_();
		}, t.schedule_ = function() {
			this.isScheduled || (this.isScheduled = !0, V.pendingReactions.push(this), Fo());
		}, t.runReaction_ = function() {
			if (!this.isDisposed) {
				ko(), this.isScheduled = !1;
				var e = V.trackingContext;
				if (V.trackingContext = this, ho(this)) {
					this.isTrackPending = !0;
					try {
						this.onInvalidate_();
					} catch (e) {
						this.reportExceptionInDerivation_(e);
					}
				}
				V.trackingContext = e, Ao();
			}
		}, t.track = function(e) {
			if (!this.isDisposed) {
				ko(), this.isRunning = !0;
				var t = V.trackingContext;
				V.trackingContext = this;
				var n = go(this, e, void 0);
				V.trackingContext = t, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && vo(this), mo(n) && this.reportExceptionInDerivation_(n.cause), Ao();
			}
		}, t.reportExceptionInDerivation_ = function(e) {
			var t = this;
			if (this.errorHandler_) {
				this.errorHandler_(e, this);
				return;
			}
			if (V.disableErrorBoundaries) throw e;
			var n = "[mobx] uncaught error in '" + this + "'";
			V.suppressReactionErrors || console.error(n, e), V.globalReactionErrorHandlers.forEach(function(n) {
				return n(e, t);
			});
		}, t.dispose = function() {
			this.isDisposed || (this.isDisposed = !0, this.isRunning || (ko(), vo(this), Ao()));
		}, t.getDisposer_ = function(e) {
			var t = this, n = function n() {
				t.dispose(), e == null || e.removeEventListener == null || e.removeEventListener("abort", n);
			};
			return e == null || e.addEventListener == null || e.addEventListener("abort", n), n[L] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (n[Symbol.dispose] = n), n;
		}, t.toString = function() {
			return "Reaction[" + this.name_ + "]";
		}, t.trace = function(e) {
			e === void 0 && (e = !1);
		}, ra(e, [
			{
				key: "isDisposed",
				get: function() {
					return Qi(this.flags_, e.isDisposedMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isDisposedMask_, t);
				}
			},
			{
				key: "isScheduled",
				get: function() {
					return Qi(this.flags_, e.isScheduledMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isScheduledMask_, t);
				}
			},
			{
				key: "isTrackPending",
				get: function() {
					return Qi(this.flags_, e.isTrackPendingMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isTrackPendingMask_, t);
				}
			},
			{
				key: "isRunning",
				get: function() {
					return Qi(this.flags_, e.isRunningMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.isRunningMask_, t);
				}
			},
			{
				key: "diffValue",
				get: function() {
					return +!!Qi(this.flags_, e.diffValueMask_);
				},
				set: function(t) {
					this.flags_ = $i(this.flags_, e.diffValueMask_, t === 1);
				}
			}
		]);
	}(), Ic.isDisposedMask_ = 1, Ic.isScheduledMask_ = 2, Ic.isTrackPendingMask_ = 4, Ic.isRunningMask_ = 8, Ic.diffValueMask_ = 16, Lc = 100, Rc = function(e) {
		return e();
	}, zc = /*#__PURE__*/ Gi("Reaction", Ic), Bc = "action", Vc = "action.bound", Hc = "autoAction", Uc = "autoAction.bound", Wc = "<unnamed action>", Gc = /*#__PURE__*/ ka(Bc), Kc = /*#__PURE__*/ ka(Vc, { bound: !0 }), qc = /*#__PURE__*/ ka(Hc, { autoAction: !0 }), Jc = /*#__PURE__*/ ka(Uc, {
		autoAction: !0,
		bound: !0
	}), Yc = /*#__PURE__*/ Bo(!1), Object.assign(Yc, Gc), Xc = /*#__PURE__*/ Bo(!0), Object.assign(Xc, qc), Yc.bound = /*#__PURE__*/ ha(Kc), Xc.bound = /*#__PURE__*/ ha(Jc), Zc = function(e) {
		return e();
	}, Qc = "onBO", $c = "onBUO", el = "never", tl = "always", nl = "observed", rl = 0, il = /*#__PURE__*/ function(e) {
		function t() {
			var n = e.call(this, "FLOW_CANCELLED") || this;
			return Object.setPrototypeOf(n, (this instanceof t ? this.constructor : void 0).prototype), n.name = "FlowCancellationError", n;
		}
		sa(t, e);
		var n = t.prototype;
		return n.toString = function() {
			return "Error: " + this.message;
		}, t;
	}(/*#__PURE__*/ ma(Error)), al = /*#__PURE__*/ Fa("flow"), ol = /*#__PURE__*/ Fa("flow.bound", { bound: !0 }), sl = /*#__PURE__*/ Object.assign(function(e, t) {
		if (va(t)) return al.decorate_20223_(e, t);
		if (zi(t)) return ga(e, t, al);
		var n = e, r = n.name || "<unnamed flow>", i = function() {
			var e = this, t = arguments, i = ++rl, a = Yc(r + " - runid: " + i + " - init", n).apply(e, t), o, s = void 0, c = new Promise(function(e, t) {
				var n = 0;
				o = t;
				function c(e) {
					s = void 0;
					var o;
					try {
						o = Yc(r + " - runid: " + i + " - yield " + n++, a.next).call(a, e);
					} catch (e) {
						return t(e);
					}
					u(o);
				}
				function l(e) {
					s = void 0;
					var o;
					try {
						o = Yc(r + " - runid: " + i + " - yield " + n++, a.throw).call(a, e);
					} catch (e) {
						return t(e);
					}
					u(o);
				}
				function u(n) {
					if (Ri(n?.then)) {
						n.then(u, t);
						return;
					}
					return n.done ? e(n.value) : (s = Promise.resolve(n.value), s.then(c, l));
				}
				c(void 0);
			});
			return c.cancel = Yc(r + " - runid: " + i + " - cancel", function() {
				try {
					s && es(s);
					var e = a.return(void 0), t = Promise.resolve(e.value);
					t.then(Qs, Qs), es(t), o(new il());
				} catch (e) {
					o(e);
				}
			}), c;
		};
		return i.isMobXFlow = !0, i;
	}, al), sl.bound = /*#__PURE__*/ ha(ol), cl = {
		has: function(e, t) {
			return ls(e).has_(t);
		},
		get: function(e, t) {
			return ls(e).get_(t);
		},
		set: function(e, t, n) {
			return zi(t) ? ls(e).set_(t, n, !0) ?? !0 : !1;
		},
		deleteProperty: function(e, t) {
			return zi(t) ? ls(e).delete_(t, !0) ?? !0 : !1;
		},
		defineProperty: function(e, t, n) {
			return ls(e).defineProperty_(t, n) ?? !0;
		},
		ownKeys: function(e) {
			return ls(e).ownKeys_();
		},
		preventExtensions: function(e) {
			P(13);
		}
	}, ll = "splice", ul = "update", dl = 1e4, fl = {
		get: function(e, t) {
			var n = e[L];
			return t === L ? n : t === "length" ? n.getArrayLength_() : typeof t == "string" && !isNaN(t) ? n.get_(parseInt(t)) : Zi(ml, t) ? ml[t] : e[t];
		},
		set: function(e, t, n) {
			var r = e[L];
			return t === "length" && r.setArrayLength_(n), typeof t == "symbol" || isNaN(t) ? e[t] = n : r.set_(parseInt(t), n), !0;
		},
		preventExtensions: function() {
			P(15);
		}
	}, pl = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			e === void 0 && (e = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = r, this.atom_ = new rc(e), this.enhancer_ = function(e, n) {
				return t(e, n, "ObservableArray[..]");
			};
		}
		var t = e.prototype;
		return t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.dehanceValues_ = function(e) {
			return this.dehancer !== void 0 && e.length > 0 ? e.map(this.dehancer) : e;
		}, t.intercept_ = function(e) {
			return fs(this, e);
		}, t.observe_ = function(e, t) {
			return t === void 0 && (t = !1), t && e({
				observableKind: "array",
				object: this.proxy_,
				debugObjectName: this.atom_.name_,
				type: "splice",
				index: 0,
				added: this.values_.slice(),
				addedCount: this.values_.length,
				removed: [],
				removedCount: 0
			}), hs(this, e);
		}, t.getArrayLength_ = function() {
			return this.atom_.reportObserved(), this.values_.length;
		}, t.setArrayLength_ = function(e) {
			(typeof e != "number" || isNaN(e) || e < 0) && P("Out of range: " + e);
			var t = this.values_.length;
			if (e !== t) {
				if (e > t) {
					for (var n = Array(e - t), r = 0; r < e - t; r++) n[r] = void 0;
					this.spliceWithArray_(t, 0, n);
				} else this.spliceWithArray_(e, t - e);
			}
		}, t.updateArrayLength_ = function(e, t) {
			e !== this.lastKnownLength_ && P(16), this.lastKnownLength_ += t, this.legacyMode_ && t > 0 && Ms(e + t + 1);
		}, t.spliceWithArray_ = function(e, t, n) {
			var r = this;
			this.atom_;
			var i = this.values_.length;
			if (e === void 0 ? e = 0 : e > i ? e = i : e < 0 && (e = Math.max(0, i + e)), t = arguments.length === 1 ? i - e : t == null ? 0 : Math.max(0, Math.min(t, i - e)), n === void 0 && (n = Js), ds(this)) {
				var a = ps(this, {
					object: this.proxy_,
					type: ll,
					index: e,
					removedCount: t,
					added: n
				});
				if (!a) return Js;
				t = a.removedCount, n = a.added;
			}
			if (n = n.length === 0 ? n : n.map(function(e) {
				return r.enhancer_(e, void 0);
			}), this.legacyMode_) {
				var o = n.length - t;
				this.updateArrayLength_(i, o);
			}
			var s = this.spliceItemsIntoValues_(e, t, n);
			return (t !== 0 || n.length !== 0) && this.notifyArraySplice_(e, n, s), this.dehanceValues_(s);
		}, t.spliceItemsIntoValues_ = function(e, t, n) {
			if (n.length < dl) {
				var r;
				return (r = this.values_).splice.apply(r, [e, t].concat(n));
			}
			var i = this.values_.slice(e, e + t), a = this.values_.slice(e + t);
			this.values_.length += n.length - t;
			for (var o = 0; o < n.length; o++) this.values_[e + o] = n[o];
			for (var s = 0; s < a.length; s++) this.values_[e + n.length + s] = a[s];
			return i;
		}, t.notifyArrayChildUpdate_ = function(e, t, n) {
			var r = !this.owned_ && Ro(), i = ms(this), a = i || r ? {
				observableKind: "array",
				object: this.proxy_,
				type: ul,
				debugObjectName: this.atom_.name_,
				index: e,
				newValue: t,
				oldValue: n
			} : null;
			this.atom_.reportChanged(), i && gs(this, a);
		}, t.notifyArraySplice_ = function(e, t, n) {
			var r = !this.owned_ && Ro(), i = ms(this), a = i || r ? {
				observableKind: "array",
				object: this.proxy_,
				debugObjectName: this.atom_.name_,
				type: ll,
				index: e,
				removed: n,
				added: t,
				removedCount: n.length,
				addedCount: t.length
			} : null;
			this.atom_.reportChanged(), i && gs(this, a);
		}, t.get_ = function(e) {
			if (this.legacyMode_ && e >= this.values_.length) {
				console.warn("[mobx] Out of bounds read: " + e);
				return;
			}
			return this.atom_.reportObserved(), this.dehanceValue_(this.values_[e]);
		}, t.set_ = function(e, t) {
			var n = this.values_;
			if (this.legacyMode_ && e > n.length && P(17, e, n.length), e < n.length) {
				this.atom_;
				var r = n[e];
				if (ds(this)) {
					var i = ps(this, {
						type: ul,
						object: this.proxy_,
						index: e,
						newValue: t
					});
					if (!i) return;
					t = i.newValue;
				}
				t = this.enhancer_(t, r), t !== r && (n[e] = t, this.notifyArrayChildUpdate_(e, t, r));
			} else {
				for (var a = Array(e + 1 - n.length), o = 0; o < a.length - 1; o++) a[o] = void 0;
				a[a.length - 1] = t, this.spliceWithArray_(n.length, 0, a);
			}
		}, e;
	}(), ml = {
		clear: function() {
			return this.splice(0);
		},
		replace: function(e) {
			var t = this[L];
			return t.spliceWithArray_(0, t.values_.length, e);
		},
		toJSON: function() {
			return this.slice();
		},
		splice: function(e, t) {
			var n = [...arguments].slice(2), r = this[L];
			switch (arguments.length) {
				case 0: return [];
				case 1: return r.spliceWithArray_(e);
				case 2: return r.spliceWithArray_(e, t);
			}
			return r.spliceWithArray_(e, t, n);
		},
		spliceWithArray: function(e, t, n) {
			return this[L].spliceWithArray_(e, t, n);
		},
		push: function() {
			var e = this[L], t = [...arguments];
			return e.spliceWithArray_(e.values_.length, 0, t), e.values_.length;
		},
		pop: function() {
			return this.splice(Math.max(this[L].values_.length - 1, 0), 1)[0];
		},
		shift: function() {
			return this.splice(0, 1)[0];
		},
		unshift: function() {
			var e = this[L], t = [...arguments];
			return e.spliceWithArray_(0, 0, t), e.values_.length;
		},
		reverse: function() {
			return V.trackingDerivation && P(37, "reverse"), this.replace(this.slice().reverse()), this;
		},
		sort: function() {
			V.trackingDerivation && P(37, "sort");
			var e = this.slice();
			return e.sort.apply(e, arguments), this.replace(e), this;
		},
		remove: function(e) {
			var t = this[L], n = t.dehanceValues_(t.values_).indexOf(e);
			return n > -1 && (this.splice(n, 1), !0);
		}
	}, I("at", vs), I("concat", vs), I("flat", vs), I("includes", vs), I("indexOf", vs), I("join", vs), I("lastIndexOf", vs), I("slice", vs), I("toString", vs), I("toLocaleString", vs), I("toSorted", vs), I("toSpliced", vs), I("with", vs), I("every", ys), I("filter", ys), I("find", ys), I("findIndex", ys), I("findLast", ys), I("findLastIndex", ys), I("flatMap", ys), I("forEach", ys), I("map", ys), I("some", ys), I("toReversed", ys), I("reduce", bs), I("reduceRight", bs), hl = /*#__PURE__*/ Gi("ObservableArrayAdministration", pl), gl = {}, _l = "add", vl = "delete", yl = /*#__PURE__*/ function() {
		function e(e, t, n) {
			var r = this;
			t === void 0 && (t = wa), n === void 0 && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[L] = gl, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = n, Ri(Map) || P(18), Ls(function() {
				r.keysAtom_ = ya("ObservableMap.keys()"), r.data_ = /* @__PURE__ */ new Map(), r.hasMap_ = /* @__PURE__ */ new Map(), e && r.merge(e);
			});
		}
		var t = e.prototype;
		return t.has_ = function(e) {
			return this.data_.has(e);
		}, t.has = function(e) {
			var t = this;
			if (!V.trackingDerivation) return this.has_(e);
			var n = this.hasMap_.get(e);
			if (!n) {
				var r = n = new Dc(this.has_(e), Ea, "ObservableMap.key?", !1);
				this.hasMap_.set(e, r), qo(r, function() {
					return t.hasMap_.delete(e);
				});
			}
			return n.get();
		}, t.set = function(e, t) {
			var n = this.has_(e);
			if (ds(this)) {
				var r = ps(this, {
					type: n ? ul : _l,
					object: this,
					newValue: t,
					name: e
				});
				if (!r) return this;
				t = r.newValue;
			}
			return n ? this.updateValue_(e, t) : this.addValue_(e, t), this;
		}, t.delete = function(e) {
			var t = this;
			if (this.keysAtom_, ds(this) && !ps(this, {
				type: vl,
				object: this,
				name: e
			})) return !1;
			if (this.has_(e)) {
				var n = Ro(), r = ms(this), i = r || n ? {
					observableKind: "map",
					debugObjectName: this.name_,
					type: vl,
					object: this,
					oldValue: this.data_.get(e).value_,
					name: e
				} : null;
				return cs(function() {
					var n;
					t.keysAtom_.reportChanged(), (n = t.hasMap_.get(e)) == null || n.setNewValue_(!1), t.data_.get(e).setNewValue_(void 0), t.data_.delete(e);
				}), r && gs(this, i), !0;
			}
			return !1;
		}, t.updateValue_ = function(e, t) {
			var n = this.data_.get(e);
			if (t = n.prepareNewValue_(t), t !== V.UNCHANGED) {
				var r = Ro(), i = ms(this), a = i || r ? {
					observableKind: "map",
					debugObjectName: this.name_,
					type: ul,
					object: this,
					oldValue: n.value_,
					name: e,
					newValue: t
				} : null;
				n.setNewValue_(t), i && gs(this, a);
			}
		}, t.addValue_ = function(e, t) {
			var n = this;
			this.keysAtom_, cs(function() {
				var r, i = new Dc(t, n.enhancer_, "ObservableMap.key", !1);
				n.data_.set(e, i), t = i.value_, (r = n.hasMap_.get(e)) == null || r.setNewValue_(!0), n.keysAtom_.reportChanged();
			});
			var r = Ro(), i = ms(this), a = i || r ? {
				observableKind: "map",
				debugObjectName: this.name_,
				type: _l,
				object: this,
				name: e,
				newValue: t
			} : null;
			i && gs(this, a);
		}, t.get = function(e) {
			return this.has(e) ? this.dehanceValue_(this.data_.get(e).get()) : this.dehanceValue_(void 0);
		}, t.getOrInsert = function(e, t) {
			return this.has(e) || this.set(e, t), this.get(e);
		}, t.getOrInsertComputed = function(e, t) {
			return this.has(e) || this.set(e, t(e)), this.get(e);
		}, t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.keys = function() {
			return this.keysAtom_.reportObserved(), this.data_.keys();
		}, t.values = function() {
			var e = this, t = this.keys();
			return Ss({ next: function() {
				var n = t.next(), r = n.done, i = n.value;
				return {
					done: r,
					value: r ? void 0 : e.get(i)
				};
			} });
		}, t.entries = function() {
			var e = this, t = this.keys();
			return Ss({ next: function() {
				var n = t.next(), r = n.done, i = n.value;
				return {
					done: r,
					value: r ? void 0 : [i, e.get(i)]
				};
			} });
		}, t[Symbol.iterator] = function() {
			return this.entries();
		}, t.forEach = function(e, t) {
			for (var n = ia(this), r; !(r = n()).done;) {
				var i = r.value, a = i[0], o = i[1];
				e.call(t, o, a, this);
			}
		}, t.merge = function(e) {
			var t = this;
			return bl(e) && (e = new Map(e)), cs(function() {
				Vi(e) ? Yi(e).forEach(function(n) {
					return t.set(n, e[n]);
				}) : Array.isArray(e) ? e.forEach(function(e) {
					var n = e[0], r = e[1];
					return t.set(n, r);
				}) : Ki(e) ? (qi(e) || P(19, e), e.forEach(function(e, n) {
					return t.set(n, e);
				})) : e != null && P(20, e);
			}), this;
		}, t.clear = function() {
			var e = this;
			cs(function() {
				yo(function() {
					for (var t = ia(e.keys()), n; !(n = t()).done;) {
						var r = n.value;
						e.delete(r);
					}
				});
			});
		}, t.replace = function(e) {
			var t = this;
			return cs(function() {
				for (var n = Cs(e), r = /* @__PURE__ */ new Map(), i = !1, a = ia(t.data_.keys()), o; !(o = a()).done;) {
					var s = o.value;
					if (!n.has(s)) {
						if (t.delete(s)) i = !0;
						else {
							var c = t.data_.get(s);
							r.set(s, c);
						}
					}
				}
				for (var l = ia(n.entries()), u; !(u = l()).done;) {
					var d = u.value, f = d[0], p = d[1], m = t.data_.has(f);
					if (t.set(f, p), t.data_.has(f)) {
						var h = t.data_.get(f);
						r.set(f, h), m || (i = !0);
					}
				}
				if (!i) {
					if (t.data_.size !== r.size) t.keysAtom_.reportChanged();
					else for (var g = t.data_.keys(), _ = r.keys(), v = g.next(), y = _.next(); !v.done;) {
						if (v.value !== y.value) {
							t.keysAtom_.reportChanged();
							break;
						}
						v = g.next(), y = _.next();
					}
				}
				t.data_ = r;
			}), this;
		}, t.toString = function() {
			return "[object ObservableMap]";
		}, t.toJSON = function() {
			return Array.from(this);
		}, t.observe_ = function(e, t) {
			return hs(this, e);
		}, t.intercept_ = function(e) {
			return fs(this, e);
		}, ra(e, [{
			key: "size",
			get: function() {
				return this.keysAtom_.reportObserved(), this.data_.size;
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Map";
			}
		}]);
	}(), bl = /*#__PURE__*/ Gi("ObservableMap", yl), xl = {}, Sl = /*#__PURE__*/ function() {
		function e(e, t, n) {
			var r = this;
			t === void 0 && (t = wa), n === void 0 && (n = "ObservableSet"), this.name_ = void 0, this[L] = xl, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, Ri(Set) || P(22), this.enhancer_ = function(e, r) {
				return t(e, r, n);
			}, Ls(function() {
				r.atom_ = ya(r.name_), e && r.replace(e);
			});
		}
		var t = e.prototype;
		return t.dehanceValue_ = function(e) {
			return this.dehancer === void 0 ? e : this.dehancer(e);
		}, t.clear = function() {
			var e = this;
			cs(function() {
				yo(function() {
					for (var t = ia(e.data_.values()), n; !(n = t()).done;) {
						var r = n.value;
						e.delete(r);
					}
				});
			});
		}, t.forEach = function(e, t) {
			for (var n = ia(this), r; !(r = n()).done;) {
				var i = r.value;
				e.call(t, i, i, this);
			}
		}, t.add = function(e) {
			var t = this;
			if (this.atom_, ds(this)) {
				var n = ps(this, {
					type: _l,
					object: this,
					newValue: e
				});
				if (!n) return this;
				e = n.newValue;
			}
			if (!this.has(e)) {
				cs(function() {
					t.data_.add(t.enhancer_(e, void 0)), t.atom_.reportChanged();
				});
				var r = ms(this), i = r ? {
					observableKind: "set",
					debugObjectName: this.name_,
					type: _l,
					object: this,
					newValue: e
				} : null;
				r && gs(this, i);
			}
			return this;
		}, t.delete = function(e) {
			var t = this;
			if (ds(this) && !ps(this, {
				type: vl,
				object: this,
				oldValue: e
			})) return !1;
			if (this.has(e)) {
				var n = ms(this), r = n ? {
					observableKind: "set",
					debugObjectName: this.name_,
					type: vl,
					object: this,
					oldValue: e
				} : null;
				return cs(function() {
					t.atom_.reportChanged(), t.data_.delete(e);
				}), n && gs(this, r), !0;
			}
			return !1;
		}, t.has = function(e) {
			return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(e));
		}, t.entries = function() {
			var e = this.values();
			return ws({ next: function() {
				var t = e.next(), n = t.value, r = t.done;
				return r ? {
					value: void 0,
					done: r
				} : {
					value: [n, n],
					done: r
				};
			} });
		}, t.keys = function() {
			return this.values();
		}, t.values = function() {
			this.atom_.reportObserved();
			var e = this, t = this.data_.values();
			return ws({ next: function() {
				var n = t.next(), r = n.value, i = n.done;
				return i ? {
					value: void 0,
					done: i
				} : {
					value: e.dehanceValue_(r),
					done: i
				};
			} });
		}, t.intersection = function(e) {
			return Ji(e) && !Cl(e) ? e.intersection(this) : new Set(this).intersection(e);
		}, t.union = function(e) {
			return Ji(e) && !Cl(e) ? e.union(this) : new Set(this).union(e);
		}, t.difference = function(e) {
			return new Set(this).difference(e);
		}, t.symmetricDifference = function(e) {
			return Ji(e) && !Cl(e) ? e.symmetricDifference(this) : new Set(this).symmetricDifference(e);
		}, t.isSubsetOf = function(e) {
			return new Set(this).isSubsetOf(e);
		}, t.isSupersetOf = function(e) {
			return new Set(this).isSupersetOf(e);
		}, t.isDisjointFrom = function(e) {
			return Ji(e) && !Cl(e) ? e.isDisjointFrom(this) : new Set(this).isDisjointFrom(e);
		}, t.replace = function(e) {
			var t = this;
			return Cl(e) && (e = new Set(e)), cs(function() {
				Array.isArray(e) || Ji(e) ? (t.clear(), e.forEach(function(e) {
					return t.add(e);
				})) : e != null && P("Cannot initialize set from " + e);
			}), this;
		}, t.observe_ = function(e, t) {
			return hs(this, e);
		}, t.intercept_ = function(e) {
			return fs(this, e);
		}, t.toJSON = function() {
			return Array.from(this);
		}, t.toString = function() {
			return "[object ObservableSet]";
		}, t[Symbol.iterator] = function() {
			return this.values();
		}, ra(e, [{
			key: "size",
			get: function() {
				return this.atom_.reportObserved(), this.data_.size;
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Set";
			}
		}]);
	}(), Cl = /*#__PURE__*/ Gi("ObservableSet", Sl), wl = /*#__PURE__*/ Object.create(null), Tl = "remove", El = /*#__PURE__*/ function() {
		function e(e, t, n, r) {
			t === void 0 && (t = /* @__PURE__ */ new Map()), r === void 0 && (r = cc), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.lazyComputedKeys_ = void 0, this.lazyObservableKeys_ = void 0, this.target_ = e, this.values_ = t, this.name_ = n, this.defaultAnnotation_ = r, this.keysAtom_ = new rc("ObservableObject.keys"), this.isPlainObject_ = Vi(this.target_);
		}
		var t = e.prototype;
		return t.getObservablePropValue_ = function(e) {
			return (this.values_.get(e) ?? this.materializeLazyComputed_(e) ?? this.materializeLazyObservable_(e)).get();
		}, t.materializeLazyComputed_ = function(e) {
			var t = this.lazyComputedKeys_?.get(e);
			if (t) {
				this.lazyComputedKeys_.delete(e), this.lazyComputedKeys_.size === 0 && (this.lazyComputedKeys_ = void 0);
				var n = t();
				return this.values_.set(e, n), n;
			}
		}, t.materializeLazyObservable_ = function(e) {
			var t = this.lazyObservableKeys_?.get(e);
			if (t) {
				this.lazyObservableKeys_.delete(e), this.lazyObservableKeys_.size === 0 && (this.lazyObservableKeys_ = void 0);
				var n = t();
				return this.values_.set(e, n), n;
			}
		}, t.setObservablePropValue_ = function(e, t) {
			var n = this.values_.get(e) ?? this.materializeLazyComputed_(e) ?? this.materializeLazyObservable_(e);
			if (n instanceof kc) return n.set(t), !0;
			if (ds(this)) {
				var r = ps(this, {
					type: ul,
					object: this.proxy_ || this.target_,
					name: e,
					newValue: t
				});
				if (!r) return null;
				t = r.newValue;
			}
			if (t = n.prepareNewValue_(t), t !== V.UNCHANGED) {
				var i = ms(this), a = i ? {
					type: ul,
					observableKind: "object",
					debugObjectName: this.name_,
					object: this.proxy_ || this.target_,
					oldValue: n.value_,
					name: e,
					newValue: t
				} : null;
				n.setNewValue_(t), i && gs(this, a);
			}
			return !0;
		}, t.get_ = function(e) {
			return V.trackingDerivation && !Zi(this.target_, e) && this.has_(e), this.target_[e];
		}, t.set_ = function(e, t, n) {
			return n === void 0 && (n = !1), Zi(this.target_, e) ? this.values_.has(e) ? this.setObservablePropValue_(e, t) : n ? Reflect.set(this.target_, e, t) : (this.target_[e] = t, !0) : this.extend_(e, {
				value: t,
				enumerable: !0,
				writable: !0,
				configurable: !0
			}, this.defaultAnnotation_, n);
		}, t.has_ = function(e) {
			if (!V.trackingDerivation) return e in this.target_;
			this.pendingKeys_ ||= /* @__PURE__ */ new Map();
			var t = this.pendingKeys_.get(e);
			return t || (t = new Dc(e in this.target_, Ea, "ObservableObject.key?", !1), this.pendingKeys_.set(e, t)), t.get();
		}, t.make_ = function(e, t) {
			if (t === !0 && (t = this.defaultAnnotation_), t !== !1) {
				if (!(e in this.target_)) {
					var n;
					if ((n = this.target_[nc]) != null && n[e]) return;
					P(1, t.annotationType_, this.name_ + "." + e.toString());
				}
				for (var r = this.target_; r && r !== qs;) {
					var i = Gs(r, e);
					if (i) {
						var a = t.make_(this, e, i, r);
						if (a === 0) return;
						if (a === 1) break;
					}
					r = Object.getPrototypeOf(r);
				}
				Os(this, t, e);
			}
		}, t.extend_ = function(e, t, n, r) {
			if (r === void 0 && (r = !1), n === !0 && (n = this.defaultAnnotation_), n === !1) return this.defineProperty_(e, t, r);
			var i = n.extend_(this, e, t, r);
			return i && Os(this, n, e), i;
		}, t.defineProperty_ = function(e, t, n) {
			n === void 0 && (n = !1), this.keysAtom_;
			try {
				ko();
				var r = this.delete_(e);
				if (!r) return r;
				if (ds(this)) {
					var i = ps(this, {
						object: this.proxy_ || this.target_,
						name: e,
						type: _l,
						newValue: t.value
					});
					if (!i) return null;
					var a = i.newValue;
					t.value !== a && (t = aa({}, t, { value: a }));
				}
				if (n) {
					if (!Reflect.defineProperty(this.target_, e, t)) return !1;
				} else Ks(this.target_, e, t);
				this.notifyPropertyAddition_(e, t.value);
			} finally {
				Ao();
			}
			return !0;
		}, t.defineObservableProperty_ = function(e, t, n, r) {
			r === void 0 && (r = !1), this.keysAtom_;
			try {
				ko();
				var i = this.delete_(e);
				if (!i) return i;
				if (ds(this)) {
					var a = ps(this, {
						object: this.proxy_ || this.target_,
						name: e,
						type: _l,
						newValue: t
					});
					if (!a) return null;
					t = a.newValue;
				}
				var o = Es(e), s = {
					configurable: !V.safeDescriptors || this.isPlainObject_,
					enumerable: !0,
					get: o.get,
					set: o.set
				};
				if (r) {
					if (!Reflect.defineProperty(this.target_, e, s)) return !1;
				} else Ks(this.target_, e, s);
				var c = new Dc(t, n, "ObservableObject.key", !1);
				this.values_.set(e, c), this.notifyPropertyAddition_(e, c.value_);
			} finally {
				Ao();
			}
			return !0;
		}, t.defineComputedProperty_ = function(e, t, n) {
			n === void 0 && (n = !1), this.keysAtom_;
			try {
				ko();
				var r = this.delete_(e);
				if (!r) return r;
				if (ds(this) && !ps(this, {
					object: this.proxy_ || this.target_,
					name: e,
					type: _l,
					newValue: void 0
				})) return null;
				t.name ||= "ObservableObject.key", t.context = this.proxy_ || this.target_;
				var i = Es(e), a = {
					configurable: !V.safeDescriptors || this.isPlainObject_,
					enumerable: !1,
					get: i.get,
					set: i.set
				};
				if (n) {
					if (!Reflect.defineProperty(this.target_, e, a)) return !1;
				} else Ks(this.target_, e, a);
				this.values_.set(e, new kc(t)), this.notifyPropertyAddition_(e, void 0);
			} finally {
				Ao();
			}
			return !0;
		}, t.delete_ = function(e, t) {
			if (t === void 0 && (t = !1), this.keysAtom_, !Zi(this.target_, e)) return !0;
			if (ds(this) && !ps(this, {
				object: this.proxy_ || this.target_,
				name: e,
				type: Tl
			})) return null;
			try {
				var n;
				ko();
				var r = ms(this), i = this.values_.get(e), a = void 0;
				if (!i && r && (a = Gs(this.target_, e)?.value), t) {
					if (!Reflect.deleteProperty(this.target_, e)) return !1;
				} else delete this.target_[e];
				if (i && (this.values_.delete(e), i instanceof Dc && (a = i.value_), Mo(i)), this.keysAtom_.reportChanged(), (n = this.pendingKeys_) == null || (n = n.get(e)) == null || n.set(e in this.target_), r) {
					var o = {
						type: Tl,
						observableKind: "object",
						object: this.proxy_ || this.target_,
						debugObjectName: this.name_,
						oldValue: a,
						name: e
					};
					r && gs(this, o);
				}
			} finally {
				Ao();
			}
			return !0;
		}, t.observe_ = function(e, t) {
			return hs(this, e);
		}, t.intercept_ = function(e) {
			return fs(this, e);
		}, t.notifyPropertyAddition_ = function(e, t) {
			var n, r = ms(this);
			if (r) {
				var i = r ? {
					type: _l,
					observableKind: "object",
					debugObjectName: this.name_,
					object: this.proxy_ || this.target_,
					name: e,
					newValue: t
				} : null;
				r && gs(this, i);
			}
			(n = this.pendingKeys_) == null || (n = n.get(e)) == null || n.set(!0), this.keysAtom_.reportChanged();
		}, t.ownKeys_ = function() {
			return this.keysAtom_.reportObserved(), ec(this.target_);
		}, t.keys_ = function() {
			return this.keysAtom_.reportObserved(), Object.keys(this.target_);
		}, e;
	}(), Dl = /*#__PURE__*/ Gi("ObservableObjectAdministration", El), Ol = /*#__PURE__*/ As(0), kl = /*#__PURE__*/ function() {
		var e = !1, t = {};
		return Object.defineProperty(t, "0", { set: function() {
			e = !0;
		} }), (/*#__PURE__*/ Object.create(t))[0] = 1, e === !1;
	}(), Al = 0, jl = function() {}, ks(jl, Array.prototype), Ml = /*#__PURE__*/ function(e) {
		function t(t, n, r, i) {
			var a;
			return r === void 0 && (r = "ObservableArray"), i === void 0 && (i = !1), a = e.call(this) || this, Ls(function() {
				var e = new pl(r, n, i, !0);
				e.proxy_ = a, Wi(a, L, e), t && t.length && a.spliceWithArray(0, 0, t), kl && Object.defineProperty(a, "0", Ol);
			}), a;
		}
		sa(t, e);
		var n = t.prototype;
		return n.concat = function() {
			this[L].atom_.reportObserved();
			var e = [...arguments];
			return Array.prototype.concat.apply(this.slice(), e.map(function(e) {
				return xs(e) ? e.slice() : e;
			}));
		}, n[Symbol.iterator] = function() {
			var e = this, t = 0;
			return Vs({ next: function() {
				return t < e.length ? {
					value: e[t++],
					done: !1
				} : {
					done: !0,
					value: void 0
				};
			} });
		}, ra(t, [{
			key: "length",
			get: function() {
				return this[L].getArrayLength_();
			},
			set: function(e) {
				this[L].setArrayLength_(e);
			}
		}, {
			key: Symbol.toStringTag,
			get: function() {
				return "Array";
			}
		}]);
	}(jl), Object.entries(ml).forEach(function(e) {
		var t = e[0], n = e[1];
		t !== "concat" && Ui(Ml.prototype, t, n);
	}), Ms(1e3), Nl = qs.toString, Pl = (/* @__PURE__ */ Fi()).Iterator?.prototype || {}, [
		"Symbol",
		"Map",
		"Set"
	].forEach(function(e) {
		Fi()[e] === void 0 && P("MobX requires global '" + e + "' to be available or polyfilled");
	}), typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
		spy: zo,
		extras: { getDebugName: Is },
		$mobx: L
	});
})), Fl, Il, Ll = o((() => {
	Fl = [], Il = class {
		constructor(e, t, n) {
			this.targets = [], this.styleBlockRefs = {}, this.targetedElems = [], this.unhideTarget = (e) => {
				if (this.styleBlockRefs[e]) try {
					this.document.head.removeChild(this.styleBlockRefs[e]), delete this.styleBlockRefs[e];
				} catch {}
			}, this.hideTarget = (e) => {
				if (this.styleBlockRefs[e]) return;
				let t = `${e} { visibility: hidden !important }`, n = this.document.createElement("style");
				n.setAttribute("type", "text/css"), n.appendChild(this.document.createTextNode(t)), this.document.head.appendChild(n), this.styleBlockRefs[e] = n;
			}, this.document = n || window.document;
			try {
				this.abortController = new (this.document.defaultView || window).AbortController();
			} catch {}
			this.targets = e, this.onTarget = t, this.retarget(), this.targets.forEach((e) => {
				let t = 100, n = () => {
					this.abortController?.signal.aborted || (t < 2e3 ? (t += 200, this.retarget(), setTimeout(n, t)) : e.hideTarget && this.unhideTarget(e.selector));
				};
				if (e.clickRetarget) {
					let r = [];
					typeof e.clickRetarget == "boolean" ? r.push(this.document) : r = Array.from(this.document.querySelectorAll(e.clickRetarget)), r.map((e) => {
						e.addEventListener("click", () => {
							t = 100, setTimeout(n);
						}, {
							capture: !0,
							signal: this.abortController?.signal
						});
					});
				}
				if (e.navigationRetarget) try {
					this.document.defaultView?.navigation?.addEventListener("navigate", () => {
						t = 100, n();
					}, { signal: this.abortController?.signal });
				} catch {}
				e.autoRetarget ? n() : /complete|interactive|loaded/.test(this.document.readyState) ? e.hideTarget && this.unhideTarget(e.selector) : this.document.addEventListener("DOMContentLoaded", () => {
					this.retarget(), e.hideTarget && this.unhideTarget(e.selector);
				}, { signal: this.abortController?.signal });
			});
		}
		getTargets() {
			return this.targets;
		}
		getTargetedElems() {
			return this.targetedElems = this.targetedElems.filter((e) => e.isConnected !== !1), [...this.targetedElems];
		}
		releaseTargets(e) {
			(e || this.targetedElems).forEach((e) => {
				let t = Fl.indexOf(e);
				t !== -1 && Fl.splice(t, 1);
			}), this.targetedElems = e ? this.targetedElems.filter((t) => !e.includes(t)) : [];
		}
		destroy() {
			this.abortController?.abort(), this.releaseTargets(), Object.keys(this.styleBlockRefs).forEach((e) => this.unhideTarget(e));
		}
		retarget() {
			Fl = Fl.filter((e) => e.isConnected !== !1), this.targetedElems = this.targetedElems.filter((e) => e.isConnected !== !1);
			let e = this.targets.flatMap((e) => {
				e.hideTarget && this.hideTarget(e.selector);
				let t = this.domQuery(e.selector).filter((t) => {
					if (!Fl.find((e) => e == t) && !this.targetedElems.find((e) => e == t)) return !0;
					e.hideTarget && this.unhideTarget(e.selector);
				});
				return e.inject?.element || (Fl = Fl.concat(t)), t.map((t) => ({
					target: e,
					elem: t
				}));
			});
			for (let { target: t, elem: n } of e) try {
				if (this.targetedElems = this.targetedElems.concat(n), t.inject) {
					let e = this.inject(n, t), r = this.onTarget(t, e, n, this);
					r && typeof r.then == "function" && r.catch((e) => {
						console.error("DomTargeter onTarget async failure:", e);
					});
				} else {
					if (t.emptyTarget = t.emptyTarget ?? !0, t.emptyTarget) for (; n.firstChild && n.removeChild(n.firstChild););
					let e = this.onTarget(t, n, void 0, this);
					e && typeof e.then == "function" && e.catch((e) => {
						console.error("DomTargeter onTarget async failure:", e);
					});
				}
				t.hideTarget && this.unhideTarget(t.selector), t.unsetTargetMinHeight = t.unsetTargetMinHeight ?? !0, t.unsetTargetMinHeight && n.style.minHeight && (n.style.minHeight = "");
			} catch (e) {
				console.error("DomTargeter retarget failure:", e);
			}
		}
		domQuery(e) {
			return Array.from(this.document.querySelectorAll(e));
		}
		inject(e, t) {
			if (!t || !t.inject) throw Error("DomTargeter::inject: Injected element unspecified");
			let n = t.inject.element instanceof Function ? t.inject.element(t, e) : t.inject.element;
			if (!n) throw Error("DomTargeter::inject: Injected element unspecified");
			if (!e.parentNode) throw Error("DomTargeter::inject: Provided element has no parent element");
			switch (t?.inject?.action) {
				case "before":
					e.parentNode.insertBefore(n, e);
					break;
				case "after":
					e.nextSibling ? e.parentNode.insertBefore(n, e.nextSibling) : e.parentNode.appendChild(n);
					break;
				case "append":
					e.appendChild(n);
					break;
				case "prepend":
					e.firstChild ? e.insertBefore(n, e.firstChild) : e.appendChild(n);
					break;
				case "replace": e.parentNode.replaceChild(n, e);
			}
			return n;
		}
	};
})), Rl = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/featureFlags/featureFlags.js
function zl(e = "") {
	e = (e || (typeof window > "u" ? {} : window?.navigator).userAgent || "").toLowerCase();
	let t = (function() {
		let t;
		return function() {
			if (t === void 0) {
				let n = (e.match(/(msie|trident\/7.0; rv:) ?([0-9]{1,2})\./) || [])[2];
				t = n ? Number(n) : !1;
			}
			return t;
		};
	})();
	return {
		cors: function() {
			return !t() || Number(t()) >= 10;
		},
		cookies: function() {
			return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
		},
		storage: function() {
			let e = "ss-test";
			try {
				return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
			} catch {
				return !1;
			}
		}
	};
}
var Bl, Vl, Hl = o((() => {
	Bl = zl(), Vl = {
		cors: Bl.cors(),
		cookies: Bl.cookies(),
		storage: Bl.storage()
	};
})), Ul, Wl = o((() => {
	Hl(), Ul = {
		set: (e, t, n, r, i) => {
			if (zl().cookies()) {
				n ||= "Lax";
				let a = e + "=" + encodeURIComponent(t) + ";SameSite=" + n + ";path=/;";
				if (window.location.protocol == "https:" && (a += "Secure;"), r) {
					let e = /* @__PURE__ */ new Date();
					e.setTime(e.getTime() + r), a += "expires=" + e.toUTCString() + ";";
				}
				i && (a += "domain=" + i + ";"), window.document.cookie = a;
			}
		},
		get: (e) => {
			if (zl().cookies()) {
				e += "=";
				let t = window.document.cookie.split(";");
				for (let n = 0; n < t.length; n++) {
					let r = t[n];
					for (; r.charAt(0) == " ";) r = r.substring(1);
					if (r.indexOf(e) == 0) return decodeURIComponent(r.substring(e.length, r.length));
				}
			}
			return "";
		},
		unset: (e, t) => {
			if (!zl().cookies()) return;
			let n = e + "=; path=/; Max-Age=-99999999;";
			t && (n += "domain=" + t + ";"), window.document.cookie = n;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/escapeHTML/escapeHTML.js
function Gl(e) {
	if (typeof e != "string") throw Error("parameter must be a string");
	if (window?.document) {
		let t = window.document.createElement("textarea");
		return t.textContent = e, t.innerHTML;
	}
	return e.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/'/g, "&#039;").replace(/"/g, "&quot;");
}
var Kl = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/unescapeHTML/unescapeHTML.js
function ql(e) {
	return e.replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&#0?39;/g, "'").replace(/&apos;/g, "'").replace(/&#0?34;/g, "\"").replace(/&quot;/g, "\"").replace(/&amp;/g, "&");
}
var Jl = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/getContext/getContext.js
function Yl(e = [], t) {
	let n;
	if (!t || typeof t == "string" ? n = Array.from(document.querySelectorAll(t || "script[id^=searchspring], script[id=athos-context], script[src*=\"snapui.searchspring.io\"], script[src*=\"snapui.athoscommerce.io\"]")).sort((e, t) => e.innerHTML.length - t.innerHTML.length).pop() : t && t.tagName === "SCRIPT" && (n = t), !n) throw Error("getContext: did not find a script tag");
	let r = n;
	if (!t && !r.getAttribute("type")?.match(/^searchspring/i) && !r.id?.match(/^searchspring/i) && !r.id?.match(/athos-context/) && !r.src?.match(/\/\/snapui.searchspring.io/i) && !r.src?.match(/\/\/snapui.athoscommerce.io/i)) throw Error("getContext: did not find a script from Snap CDN or with attribute (type, id) starting with \"athos-context\"");
	if (e && !Array.isArray(e) || e && !e.reduce((e, t) => e && typeof t == "string", !0)) throw Error("getContext: first parameter must be an array of strings");
	let i = "siteId", a = {};
	Object.values(n?.attributes).map((t) => {
		let r = t.nodeName;
		e.includes(r) && (a[r] = n?.getAttribute(r));
	});
	let o = {}, s = n?.innerHTML, c = s.replace(/`(?:\\[\s\S]|[^`\\])*`|'(?:\\[\s\S]|[^'\\])*'|"(?:\\[\s\S]|[^"\\])*"/g, "").match(/([a-zA-Z_$][a-zA-Z_$0-9]*)\s*=/g)?.map((e) => e.replace(/[\s=]/g, "")), l = e.concat(c || []), u = l.filter((e, t) => {
		let n = Zl.has(e);
		return n && console.error(`getContext: JavaScript keyword found: '${e}'! Please use a different variable name.`), l.indexOf(e) === t && !n;
	});
	e?.forEach((e) => {
		try {
			let t = Function(`
				var ${u.join(", ")};
				${s}
				return ${e};
			`);
			o[e] = t();
		} catch (t) {
			Zl.has(e) || (console.error(`getContext: error evaluating '${e}'`), console.error(t)), o[e] = void 0;
		}
	});
	let d = {
		...Xl(a),
		...Xl(o)
	};
	if (e.includes(i) && !d[i]) {
		let e = n.getAttribute("src")?.match(/.*snapui.(?:searchspring|athoscommerce).io\/([a-zA-Z0-9]{6})\//);
		e && e.length > 1 && (d.siteId = e[1]);
	}
	return d;
}
function Xl(e) {
	return Object.keys(e).forEach((t) => {
		e[t] === void 0 && delete e[t];
	}), e;
}
var Zl, Ql = o((() => {
	Zl = /* @__PURE__ */ new Set(/* @__PURE__ */ "break.case.catch.class.const.continue.debugger.default.delete.do.else.export.extends.finally.for.function.if.import.in.instanceof.new.return.super.switch.this.throw.try.typeof.var.void.while.with.yield.let.static.enum.await.implements.package.protected.interface.private.public".split("."));
})), $l = o((() => {})), eu, tu = o((() => {
	eu = (e) => {
		if (!e) return;
		let [t, n] = e.split("#"), [r, i] = t.split("?"), a = {
			query: {},
			hash: n
		};
		return i?.split("&").forEach((e) => {
			let [t, n] = e.split("=");
			a.query[t] = n;
		}), {
			base: r,
			params: a,
			url: () => {
				let e = Object.keys(a.query).map((e) => `${e}=${a.query[e]}`).join("&");
				return `${r}${e ? "?" + e : ""}${a.hash ? "#" + a.hash : ""}`;
			}
		};
	};
})), nu, ru, iu, au, ou, su, cu, lu, uu, du, fu, pu, mu, hu = o((() => {
	nu = "@athoscommerce/snap-toolbox", ru = "1.11.0", iu = "Snap Toolbox", au = "dist/cjs/index.js", ou = "dist/esm/index.js", su = "dist/esm/index.d.ts", cu = "AthosCommerce", lu = {
		type: "git",
		url: "https://github.com/AthosCommerce/snap.git"
	}, uu = { access: "public" }, du = {
		build: "rm -rf ./dist && tsc",
		"build:prod": "rm -rf ./dist && (tsc & p1=$!; tsc -p tsconfig.cjs.json & p2=$!; wait $p1 && wait $p2)",
		"build:docs": "typedoc --out docs src/index.ts",
		dev: "tsc --watch",
		format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
		lint: "eslint 'src/**/*.{js,jsx,ts,tsx}'",
		test: "jest",
		"test:watch": "jest --watch"
	}, fu = ["dist/**/*"], pu = "827b9566f3a8282b3a78fd85b0b2a281fe963df4", mu = {
		name: nu,
		version: ru,
		description: iu,
		main: au,
		module: ou,
		types: su,
		author: cu,
		license: "MIT",
		repository: lu,
		publishConfig: uu,
		scripts: du,
		sideEffects: !1,
		files: fu,
		gitHead: pu
	};
})), gu, _u = o((() => {
	hu(), {version: gu} = mu;
})), vu = o((() => {})), yu, bu, xu, Su = o((() => {
	W(), yu = { cookies: Ul }, bu = class {
		constructor(e) {
			if (this.type = null, this.expiration = 31536e6, this.sameSite = "Lax", this.key = "ss-storage", this.cookieDomain = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, this.state = {}, e) switch (e.key.trim() !== "" && (this.key = e.key.trim()), e?.cookie?.expiration && (this.expiration = e.cookie.expiration), e?.cookie?.sameSite && (this.sameSite = e.cookie.sameSite), e.type) {
				case xu.session:
					this.type = Vl.storage ? e.type : null, this.type && (this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}"), window.sessionStorage.setItem(this.key, JSON.stringify(this.state)));
					break;
				case xu.local:
					this.type = Vl.storage ? e.type : null, this.type && (this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}"), window.localStorage.setItem(this.key, JSON.stringify(this.state)));
					break;
				case xu.cookie:
					if (Vl.cookies) {
						this.type = e.type;
						let t = yu.cookies.get(this.key);
						t && (this.state = JSON.parse(t));
					}
					break;
				default: this.type = xu.memory;
			}
		}
		set(e, t) {
			switch (this.type) {
				case xu.session:
					this.state = JSON.parse(window.sessionStorage.getItem(this.key) || "{}");
					break;
				case xu.local:
					this.state = JSON.parse(window.localStorage.getItem(this.key) || "{}");
					break;
				case xu.cookie: {
					let e = yu.cookies.get(this.key);
					e && (this.state = JSON.parse(e));
					break;
				}
			}
			let n;
			n = typeof e == "string" ? e?.split(".") : e;
			let r = this.state;
			n?.forEach((e, i) => {
				i == n.length - 1 ? r[e] = t : r = r[e] = r[e] || {};
			});
			try {
				switch (this.type) {
					case xu.session:
						window.sessionStorage.setItem(this.key, JSON.stringify(this.state));
						break;
					case xu.local:
						window.localStorage.setItem(this.key, JSON.stringify(this.state));
						break;
					case xu.cookie: yu.cookies.set(this.key, JSON.stringify(this.state), this.sameSite, this.expiration, this.cookieDomain);
				}
			} catch {
				console.warn(`something went wrong setting ${this.key} to ${this.type} storage`);
			}
		}
		get(e) {
			switch (this.type) {
				case xu.session:
					let e = window.sessionStorage.getItem(this.key);
					this.state = e ? JSON.parse(e) : {};
					break;
				case xu.local:
					let t = window.localStorage.getItem(this.key);
					this.state = t ? JSON.parse(t) : {};
					break;
				case xu.cookie:
					let n = yu.cookies.get(this.key);
					n && (this.state = JSON.parse(n) || {});
			}
			let t;
			if (t = typeof e == "string" ? e?.split(".") : e, !t?.length) return;
			let n = this.state;
			for (let e of t) if (n && n[e] !== void 0) n = n[e];
			else {
				n = {};
				return;
			}
			return n;
		}
		clear() {
			switch (this.type) {
				case xu.session:
					window.sessionStorage.removeItem(this.key);
					break;
				case xu.local:
					window.localStorage.removeItem(this.key);
					break;
				case xu.cookie: yu.cookies.unset(this.key, this.cookieDomain);
			}
			this.state = {};
		}
	}, (function(e) {
		e.session = "session", e.local = "local", e.cookie = "cookie", e.memory = "memory";
	})(xu ||= {});
})), U, Cu = o((() => {
	(function(e) {
		e.production = "production", e.development = "development";
	})(U ||= {});
})), wu = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-toolbox/dist/esm/sprintf/sprintf.js
function Tu(e, t) {
	let n = [];
	for (; t > 0; n[--t] = e);
	return n.join("");
}
function Eu(e, ...t) {
	let n = [e, ...t], r = 0, i, a = n[r++], o, s, c, l, u = [];
	for (; a;) {
		if (o = /^[^\x25]+/.exec(a)) u.push(o[0]);
		else if (o = /^\x25{2}/.exec(a)) u.push("%");
		else if (o = /^\x25(?:(\d+)\$)?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-fosuxX])/.exec(a)) {
			if ((i = n[parseInt(o[1]) || r++]) == null || i == null) throw "Too few arguments.";
			if (/[^s]/.test(o[7]) && typeof i != "number") throw "Expecting number but found " + typeof i;
			switch (o[7]) {
				case "b":
					i = i.toString(2);
					break;
				case "c":
					i = String.fromCharCode(i);
					break;
				case "d":
					i = parseInt(i);
					break;
				case "e":
					i = o[6] ? i.toExponential(parseInt(o[6])) : i.toExponential();
					break;
				case "f":
					i = o[6] ? parseFloat(i).toFixed(parseInt(o[6])) : parseFloat(i);
					break;
				case "o":
					i = i.toString(8);
					break;
				case "s":
					i = (i = String(i)) && o[6] ? i.substring(0, parseInt(o[6])) : i;
					break;
				case "u":
					i = Math.abs(i);
					break;
				case "x":
					i = i.toString(16);
					break;
				case "X": i = i.toString(16).toUpperCase();
			}
			i = /[def]/.test(o[7]) && o[2] && i > 0 ? "+" + i : i, c = o[3] ? o[3] == "0" ? "0" : o[3].charAt(1) : " ", l = (o[5] ? parseInt(o[5]) : 0) - String(i).length, s = o[5] ? Tu(c, l) : "", u.push(o[4] ? i + s : s + i);
		} else throw Error("sprintf: Invalid format string encountered");
		a = a.substring(o[0].length);
	}
	return u.join("");
}
var Du = o((() => {})), W = o((() => {
	Ll(), Rl(), Hl(), Wl(), Kl(), Jl(), Ql(), $l(), tu(), _u(), vu(), Su(), Cu(), wu(), Du();
})), Ou, ku = o((() => {
	Ou = (e) => {
		let t = 1, n = 0, r;
		for (; e >= 0;) r = t, t += n, n = r, e--;
		return n;
	};
})), Au, ju, Mu, Nu, Pu = o((() => {
	Au = /* @__PURE__ */ u(ji()), ju = "athos-networkcache", Mu = {
		enabled: !0,
		type: "sessionStorage",
		ttl: 3e5,
		maxSize: 1e3,
		purgeable: !0
	}, Nu = class {
		constructor(e) {
			this.memoryCache = {}, this.config = (0, Au.default)(Mu, e || {}), this.load(), this.config?.entries && Object.keys(this.config.entries).map((e) => {
				this.config.entries && this.config.entries[e] && this.set(e, this.config.entries[e]);
			});
		}
		load() {
			if (typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage") {
				let e = window.sessionStorage.getItem(ju), t = { ...e && JSON.parse(e) };
				this.memoryCache = t || {};
			}
			this.purgeExpired();
		}
		get(e) {
			if (this.config.enabled) {
				this.load();
				try {
					let t = [];
					if (typeof window < "u" && window.performance?.getEntriesByType("navigation")?.[0]?.type === "back_forward" && (t = ["lastViewed", "cart"]), Object.keys(this.memoryCache).length && e) {
						let n = e;
						if (t.length && e.startsWith("/v1/search")) try {
							let r = e.split("{")[0], i = "{" + e.split("{")[1], a = JSON.parse(i), o = Object.keys(this.memoryCache).find((e) => {
								try {
									if (e.split("{")[0] == r) {
										let n = "{" + e.split("{")[1], r = JSON.parse(n), i = Array.from(/* @__PURE__ */ new Set([...Object.keys(a), ...Object.keys(r)]));
										for (let e of i) if (!t.includes(e) && JSON.stringify(a[e]) !== JSON.stringify(r[e])) return !1;
										return !0;
									}
									return !1;
								} catch {
									return !1;
								}
							});
							o && (n = o);
						} catch {}
						if (this.memoryCache[n]) return this.memoryCache[n].value;
					}
				} catch (e) {
					console.warn("something went wrong getting from cache: ", e);
				}
			}
		}
		purgeExpired() {
			Object.keys(this.memoryCache).forEach((e) => {
				Date.now() >= this.memoryCache[e].expires && delete this.memoryCache[e];
			});
			try {
				if (typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage") {
					let e = JSON.stringify(this.memoryCache);
					window.sessionStorage.setItem(ju, e);
				}
			} catch (e) {
				console.warn("failed to store network cache: ", e);
			}
		}
		set(e, t) {
			if (this.config.enabled) {
				this.load();
				try {
					let n = {
						value: t,
						expires: Date.now() + this.config.ttl,
						purgeable: this.config.purgeable
					}, r = new Blob([JSON.stringify({ [e]: n })], { endings: "native" }).size / 1024;
					if (r > this.config.maxSize) {
						console.warn(`Cache object size (${r.toFixed(2)}KB) exceeds maxSize (${this.config.maxSize}KB), skipping cache`);
						return;
					}
					let i = new Blob([JSON.stringify(this.memoryCache)], { endings: "native" }).size / 1024;
					for (; i + r > this.config.maxSize;) {
						let e = Object.keys(this.memoryCache).filter((e) => this.memoryCache[e].purgeable).sort((e, t) => this.memoryCache[e].expires - this.memoryCache[t].expires)[0];
						if (!e) break;
						delete this.memoryCache[e], i = new Blob([JSON.stringify(this.memoryCache)], { endings: "native" }).size / 1024;
					}
					if (i + r > this.config.maxSize) {
						console.warn(`Unable to cache entry for key "${e}" without exceeding maxSize (${this.config.maxSize}KB), skipping cache`);
						return;
					}
					this.memoryCache[e] = n, typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage" && window.sessionStorage.setItem(ju, JSON.stringify(this.memoryCache));
				} catch (e) {
					console.warn("something went wrong setting to cache: ", e);
				}
			}
		}
		clear() {
			try {
				this.memoryCache = {}, typeof window < "u" && window?.sessionStorage && this.config.type === "sessionStorage" && window.sessionStorage.setItem(ju, "");
			} catch (e) {
				console.warn("something went wrong clearing cache: ", e);
			}
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/apis/Abstract.js
function Fu(e, t = "") {
	return Object.keys(e).map((n) => {
		let r = t + (t.length ? `[${n}]` : n), i = e[n];
		if (i instanceof Array) {
			let e = i.map((e) => encodeURIComponent(String(e))).join(`&${encodeURIComponent(r)}=`);
			return `${encodeURIComponent(r)}=${e}`;
		}
		return i instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(i.toISOString())}` : i instanceof Object ? Fu(i, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(i))}`;
	}).filter((e) => e.length > 0).join("&");
}
var Iu, Lu, Ru, zu, Bu = o((() => {
	Iu = /* @__PURE__ */ u(ji()), W(), ku(), Pu(), Lu = (e) => typeof Blob < "u" && e instanceof Blob, Ru = class {
		constructor(e) {
			this.configuration = e, this.retryDelay = 1e3, this.retryCount = 0, this.cache = new Nu(this.configuration.cache);
		}
		get mode() {
			return this.configuration.mode;
		}
		async request(e, t) {
			let { url: n, init: r } = this.createFetchParams(e);
			if (t) {
				let n = this.cache.get(`${e.path}/${t}`) || this.cache.get(`${e.path}/*`);
				if (n) return this.retryCount = 0, this.retryDelay = 1e3, n;
			}
			let i, a;
			try {
				if (i = await this.fetchApi(n, r), a = await i?.json(), i.status >= 200 && i.status < 300) return this.retryCount = 0, this.retryDelay = 1e3, t && this.cache.set(`${e.path}/${t}`, a), a;
				throw i.status == 429 ? this.retryCount < this.configuration.maxRetry ? (await new Promise((e) => setTimeout(e, this.retryDelay)), this.retryDelay = Ou(this.retryCount) * 1e3, this.retryCount++, Error("Rate limited.")) : Error("Retry rate limit exceeded.") : i.status == 404 && a?.message == "Profile is currently paused" ? Error(`${a.message}: ${e.query?.tag}`) : Error("Unexpected Response Status.");
			} catch (a) {
				if (a.message == "Rate limited.") return await this.request(e, t);
				throw {
					err: a,
					fetchDetails: {
						status: i?.status,
						message: i?.statusText || "FAILED",
						url: n,
						...r
					}
				};
			}
		}
		createFetchParams(e) {
			let t = e?.body?.siteId || e?.query?.siteId;
			if (!t) throw Error("Request failed. Missing \"siteId\" parameter.");
			let n = `https://${t}.a${e.subDomain ? `.${e.subDomain}` : ""}.athoscommerce.net`, r = `${(e.origin || this.configuration.origin || n).replace(/\/$/, "")}/${e.path.replace(/^\//, "")}`, i = (0, Iu.default)(e.query || {}, this.configuration.globals);
			Object.keys(i).length !== 0 && (r += "?" + this.configuration.queryParamsStringify(i));
			let a = typeof FormData < "u" && e.body instanceof FormData || e.body instanceof URLSearchParams || Lu(e.body) ? e.body : JSON.stringify(e.body ? (0, Iu.default)(e.body, this.configuration.globals) : e.body), o = {
				...this.configuration.headers,
				...e.headers
			}, s = {
				method: e.method,
				headers: o,
				body: a
			};
			return {
				url: r,
				init: s
			};
		}
		async fetchApi(e, t) {
			return await this.configuration.fetchApi(e, t);
		}
	}, zu = class {
		constructor(e = {}) {
			this.config = e, e.maxRetry || (this.config.maxRetry = 8), this.config.cache = this.config.cache || {}, this.config.mode = this.config.mode || U.production, this.config.mode == U.development && (this.config.cache.enabled = !1);
		}
		get cache() {
			return this.config?.cache || {};
		}
		get maxRetry() {
			return this.config.maxRetry || 8;
		}
		get origin() {
			return this.config.origin || "";
		}
		get initiator() {
			return this.config.initiator || `snap/client/${gu}`;
		}
		get fetchApi() {
			return this.config.fetchApi || (typeof window < "u" ? window.fetch?.bind(window) : fetch);
		}
		get queryParamsStringify() {
			return this.config.queryParamsStringify || Fu;
		}
		get headers() {
			return this.config.headers || {};
		}
		set headers(e) {
			this.config.headers = e;
		}
		get globals() {
			return this.config.globals || {};
		}
		set globals(e) {
			this.config.globals = e;
		}
		get mode() {
			return this.config.mode;
		}
		get paths() {
			return this.config.paths || {};
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/searchResponse.js
function G(e, t) {
	return {
		pagination: G.pagination(e),
		results: G.results(e),
		filters: G.filters(e),
		facets: G.facets(e, t),
		sorting: G.sorting(e),
		merchandising: G.merchandising(e),
		search: G.search(e, t),
		tracking: G.tracking(e)
	};
}
function Vu(e) {
	return Array.isArray(e) ? e.map((e) => typeof e == "string" ? ql(String(e)) : e) : ql(typeof e == "string" ? e : JSON.stringify(e));
}
var Hu, Uu, Wu = o((() => {
	W(), Hu = [
		"uid",
		"sku",
		"available",
		"name",
		"url",
		"addToCartUrl",
		"parentId",
		"parentImageUrl",
		"price",
		"msrp",
		"imageUrl",
		"secureImageUrl",
		"thumbnailImageUrl",
		"secureThumbnailImageUrl",
		"rating",
		"ratingCount",
		"description",
		"stockMessage",
		"brand",
		"popularity",
		"caption"
	], Uu = class {
		constructor(e) {
			Object.assign(this, e);
		}
	}, G.pagination = (e) => {
		let t = e?.pagination;
		return {
			totalResults: t?.totalResults,
			page: t?.currentPage,
			pageSize: t?.perPage,
			totalPages: t?.totalPages
		};
	}, G.results = (e) => (e?.results || []).map((t) => G.result(t, e)), G.result = (e, t) => {
		let n = Hu.reduce((t, n) => e[n] === void 0 ? t : {
			...t,
			[n]: Vu(e[n] || "")
		}, {});
		n.price &&= +n.price, n.msrp &&= +n.msrp, n.available?.toString() === "true" ? n.available = !0 : n.available?.toString() === "false" && (n.available = !1);
		let r = Object.keys(e).filter((e) => Hu.indexOf(e) == -1).filter((t) => !(t == "badges" && Array.isArray(e[t]) && typeof e[t]?.[0] == "object")).filter((e) => e != "variants").reduce((t, n) => ({
			...t,
			[n]: Vu(e[n] || "")
		}), {});
		return new Uu({
			id: e.uid,
			responseId: t.responseId,
			mappings: { core: n },
			attributes: r,
			badges: Array.isArray(e.badges) && typeof e.badges[0] == "object" ? e.badges : [],
			variants: e.variants
		});
	}, G.filters = (e) => (e?.filterSummary || []).map((e) => {
		let t = e.value, n = "value";
		return typeof e.value == "object" && e && e.value && e.value.rangeHigh != null && e.value.rangeLow != null && (n = "range", t = {
			low: +e.value.rangeLow,
			high: +e.value.rangeHigh
		}), {
			type: n,
			field: e.field,
			label: e.filterValue,
			value: t
		};
	}), G.facets = (e, t = {}) => {
		let n = t.filters || [], r = e?.facets || [], i = t?.facets?.limit, a = t?.facets?.valueLimit, o = r.map((e) => {
			let t = {
				field: e.field,
				type: "value",
				filtered: !!e.facet_active
			};
			if (e.step) e.range && (t = {
				...t,
				type: "range",
				step: e.step,
				range: {
					low: e.range[0] == "*" ? void 0 : +e.range[0],
					high: e.range[1] == "*" ? void 0 : +e.range[1]
				}
			}), e.active && typeof e.active != "boolean" && e.active.length > 1 && (t.active = {
				low: e.active[0] == "*" ? void 0 : +e.active[0],
				high: e.active[1] == "*" ? void 0 : +e.active[1]
			});
			else if (e.values instanceof Array) {
				if (e.type == "hierarchy") {
					t.type = "value", t.values = (e.values || []).map((e) => ({
						filtered: !!e.active,
						value: e.value,
						label: e.label,
						count: e.count
					}));
					let r = n.find((t) => t.field == e.field), i = [];
					if (r && !r.background) {
						let t = r.value?.split(e.hierarchyDelimiter || ">");
						if (t) for (let n = t.length - 1; n >= 0; n--) {
							let a = t.slice(0, n + 1), o = a.join(e.hierarchyDelimiter);
							i.unshift({
								value: o,
								filtered: o == r.value,
								label: a[a.length - 1]
							});
						}
						i.unshift({
							value: void 0,
							filtered: !1,
							label: "View All"
						});
					}
					t.values = i.concat(t.values);
				} else e.values[0].type == "value" ? (t.type = "value", t.values = e.values.map((e) => ({
					filtered: e.active,
					value: e.value,
					label: e.label,
					count: e.count
				}))) : e.values[0].type == "range" && (t.type = "range-buckets", t.values = e.values.map((e) => ({
					filtered: e.active,
					low: e.low == "*" || e.low == null ? null : +e.low,
					high: e.high == "*" || e.high == null ? null : +e.high,
					label: e.label,
					count: e.count
				})));
			}
			return t;
		});
		return i && (o = o.slice(0, i)), a && (o = o.map((e) => (e.values &&= e.values.slice(0, a), e))), o;
	}, G.sorting = (e) => (e?.sorting?.options || []).filter((e) => e.active).map((e) => ({
		field: e.field,
		direction: e.direction
	})), G.merchandising = (e) => {
		let t = e?.merchandising;
		return t?.content && Array.isArray(t.content) && !t.content.length && (t.content = {}), {
			redirect: t?.redirect || "",
			content: t?.content || {},
			campaigns: t?.triggeredCampaigns || [],
			personalized: t?.personalized,
			experiments: t?.experiments || []
		};
	}, G.search = (e, t) => {
		let n = {
			query: t?.search?.query?.string,
			didYouMean: e?.didYouMean?.query,
			matchType: e?.query?.matchType,
			subject: e?.query?.subject
		};
		return e?.query?.corrected && e?.query.original && (n.query = e?.query?.corrected, n.originalQuery = e?.query?.original), n;
	}, G.tracking = (e) => ({ responseId: e.responseId });
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/utils/mergeParams.js
function Gu(...e) {
	let t = {};
	return e.reverse().forEach((e) => {
		Object.keys(e).forEach((n) => {
			let r = e[n], i = t[n];
			if (r instanceof Array) {
				let e = i === void 0 ? [] : i instanceof Array ? i : [i];
				t[n] = e.concat(r.filter((t) => e.indexOf(t) === -1));
			} else i instanceof Array ? t[n] = i.indexOf(r) === -1 ? [r].concat(i) : i : t[n] = r;
		});
	}), t;
}
var Ku = o((() => {})), qu = o((() => {
	Ku();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/searchRequest.js
function K(e) {
	return Gu(K.sorts(e), K.search(e), K.filters(e), K.merchandising(e), K.pagination(e), K.siteId(e), K.facets(e), K.tracking(e), K.personalization(e));
}
var Ju = o((() => {
	qu(), K.sorts = (e = {}) => (e.sorts || []).reduce((e, t) => !t.field || !t.direction || t.direction != "asc" && t.direction != "desc" ? e : {
		...e,
		["sort." + t.field]: (e[t.field] || []).concat([t.direction])
	}, {}), K.search = (e = {}) => {
		let t = e.search || {}, n = {};
		return t.query && t.query.string && (n.q = t.query.string), t.subQuery && (n.rq = t.subQuery.trim()), t.originalQuery && (n.originalQuery = t.originalQuery.trim()), t.fallbackQuery && (n.fallbackQuery = t.fallbackQuery.trim()), t.redirectResponse && (n.redirectResponse = t.redirectResponse), t.source && (n.source = t.source), t.input && (n.input = t.input), n;
	}, K.filters = (e = {}) => (e.filters || []).reduce((e, t) => {
		let n = t.background ? "bgfilter" : "filter";
		if (t.type == "value") {
			let r = n + "." + t.field;
			return {
				...e,
				[r]: (e[r] || []).concat([t.value])
			};
		}
		if (t.type == "range") {
			let r = n + "." + t.field + ".low", i = n + "." + t.field + ".high", a = t?.value?.low ?? "*", o = t?.value?.high ?? "*";
			return {
				...e,
				[r]: (e[r] || []).concat([a]),
				[i]: (e[i] || []).concat([o])
			};
		}
		return e;
	}, {}), K.merchandising = (e = {}) => {
		let t = e.merchandising || {}, n = t.disabled ? { disableMerchandising: !0 } : {};
		return t.landingPage && (n["landing-page"] = t.landingPage), t.segments instanceof Array && t.segments.length && (n.tag = t.segments.map((e) => `merch.segment/${e}`)), t.disableInlineBanners && (n.disableInlineBanners = t.disableInlineBanners), n;
	}, K.pagination = (e = {}) => {
		let t = e.pagination || {}, n = {};
		return t.page && (n.page = t.page), (t.pageSize || t.pageSize === 0) && (n.resultsPerPage = t.pageSize), n;
	}, K.siteId = (e = {}) => e.siteId ? { siteId: e.siteId } : {}, K.facets = (e = {}) => {
		let t = e.facets || {}, n = {};
		if (t.include && t.include.length && t.exclude && t.exclude.length) throw "cannot use facet include and exclude at the same time";
		return t.include?.length && (n.includedFacets = t.include), t.exclude?.length && (n.excludedFacets = t.exclude), t.autoDrillDown === !1 && (n.disableFacetDrillDown = !0), n;
	}, K.tracking = (e = {}) => {
		let t = e.tracking || {}, n = {};
		return t.userId && (n.userId = t.userId), t.domain && (n.domain = t.domain), t.sessionId && (n.sessionId = t.sessionId), t.pageLoadId && (n.pageLoadId = t.pageLoadId), n;
	}, K.personalization = (e = {}) => {
		let t = e.personalization || {}, n = {};
		return t.disabled && (n.skipPersonalization = t.disabled), t.cart && (n.cart = t.cart), t.lastViewed && (n.lastViewed = t.lastViewed), t.shopper && (n.shopper = t.shopper), n;
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/transforms/suggestResponse.js
function Yu(e) {
	return {
		query: e?.query,
		correctedQuery: e?.["corrected-query"],
		suggested: Yu.suggested(e),
		alternatives: Yu.alternatives(e)
	};
}
var Xu = o((() => {
	Yu.suggested = (e) => typeof e != "object" || !e.suggested || typeof e.suggested != "object" ? {} : {
		text: e.suggested?.text,
		type: e.suggested?.type,
		source: e.suggested?.source
	}, Yu.alternatives = (e) => (e?.alternatives || []).map((e) => ({ text: e.text }));
})), Zu, Qu = o((() => {
	Zu = (e) => {
		if (!e) return;
		let t = [];
		return e.map((e) => {
			if (e.type == "value") {
				let n = t.findIndex((t) => t.field == e.field);
				if (n > -1) t[n].values.push(e.value);
				else {
					let n = {
						field: e.field,
						type: "=",
						values: [e.value]
					};
					t.push(n);
				}
			} else if (e.type == "range") {
				if (typeof e.value.low == "number") {
					let n = {
						field: e.field,
						type: ">=",
						values: [e.value.low]
					}, r = t.findIndex((t) => t.field == e.field && t.type == ">=");
					r > -1 ? t[r] = n : t.push(n);
				}
				if (typeof e.value.high == "number") {
					let n = {
						field: e.field,
						type: "<=",
						values: [e.value.high]
					}, r = t.findIndex((t) => t.field == e.field && t.type == "<=");
					r > -1 ? t[r] = n : t.push(n);
				}
			}
		}), t;
	};
})), $u = o((() => {
	Ju(), Wu(), Xu(), Qu();
})), ed, td, nd = o((() => {
	pd(), W(), Wu(), $u(), ed = "test", td = class extends Ru {
		async getEndpoint(e, t) {
			let n = K(e);
			n.ajaxCatalog = this.configuration.initiator, n.resultsFormat = "native", this.configuration.mode == U.development && (n[ed] = !0);
			let r = { ...n };
			return delete r.pageLoadId, delete r.domain, delete r.input, delete r.redirectResponse, G(await this.request({
				path: t,
				method: "GET",
				headers: {},
				query: n
			}, JSON.stringify(r)), e);
		}
		async getAutocomplete(e) {
			return this.getEndpoint(e, this.configuration.paths.autocomplete || "/v1/autocomplete");
		}
		async getSearch(e) {
			return this.getEndpoint(e, this.configuration.paths.search || "/v1/search");
		}
		async getCategory(e) {
			return this.getEndpoint(e, this.configuration.paths.category || "/v1/category");
		}
		async getFinder(e) {
			return this.getEndpoint(e, this.configuration.paths.finder || "/v1/finder");
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-client/dist/esm/Client/apis/Recommend.js
function rd(e, t) {
	let n = e.request, r = t.request, i = n.order ?? n.profile?.order, a = r.order ?? r.profile?.order;
	return i == null && a == null ? 0 : i == null && a != null ? 1 : a == null && i != null || i < a ? -1 : +(i > a);
}
function id(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var ad, od, sd, cd = o((() => {
	Bu(), W(), $u(), nd(), ad = class {
		constructor() {
			this.promise = new Promise((e, t) => {
				this.reject = t, this.resolve = e;
			});
		}
	}, od = 150, sd = class extends Ru {
		constructor() {
			super(...arguments), this.batches = {};
		}
		async getProfile(e) {
			return await this.request({
				path: this.configuration.paths.profile || "/v1/profile",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async batchRecommendations(e) {
			let t = e.batchId || 1, n = e.batched ? `${e.profile?.siteId || e.siteId}:${t}` : `${Math.random()}:${t}`, r = this.batches[n] = this.batches[n] || {
				timeout: null,
				request: { profiles: [] },
				entries: []
			}, i = new ad();
			r.entries.push({
				request: e,
				deferred: i
			});
			let a = typeof window < "u" ? window.clearTimeout : clearTimeout, o = typeof window < "u" ? window.setTimeout : setTimeout;
			return a && a(r.timeout), r.timeout = o(async () => {
				delete this.batches[n], r.entries.sort(rd), r.entries.map((e) => {
					if (e.request.product && (Array.isArray(e.request.products) && e.request.products.indexOf(e.request.product) == -1 ? e.request.products = e.request.products.concat(e.request.product) : e.request.products = [e.request.product]), e.request.profile) {
						let { tag: t, profile: { categories: n, brands: i, blockedItems: a, limit: o, query: s, filters: c, dedupe: l } } = e.request, u = {
							tag: t,
							...id({
								categories: n,
								brands: i,
								blockedItems: a,
								limit: o,
								searchTerm: s,
								filters: Zu(c),
								dedupe: l
							})
						};
						r.request.profiles?.push(u);
					} else {
						let { tag: t, categories: n, brands: i, limit: a, query: o, dedupe: s } = e.request, c = {
							tag: t,
							...id({
								categories: n,
								brands: i,
								limit: a,
								searchTerm: o,
								dedupe: s
							})
						};
						r.request.profiles?.push(c);
					}
					let { products: t, blockedItems: n, filters: i, test: a, cart: o, lastViewed: s, shopper: c, withRecInfo: l } = e.request, u = Array.from(new Set((r.request.products || []).concat(t || []))), d = Array.from(new Set((r.request.blockedItems || []).concat(n || []))), f = Array.from(new Set((r.request.filters || []).concat(Zu(i) || []).map((e) => JSON.stringify(e)))).map((e) => JSON.parse(e)), p = r.request.withRecInfo || l || void 0;
					r.request = {
						...r.request,
						...id({
							siteId: e.request.profile?.siteId || e.request.siteId,
							products: u.length ? u : void 0,
							blockedItems: d.length ? d : void 0,
							filters: f.length ? f : void 0,
							test: a,
							cart: o,
							lastViewed: s,
							shopper: c,
							withRecInfo: p
						})
					}, this.configuration.mode == U.development && (r.request[ed] = !0);
				});
				try {
					this.configuration.mode == U.development && (r.request.test = !0);
					let e = await this.postRecommendations(r.request);
					r.entries?.forEach((t, n) => {
						t.deferred.resolve(e[n]);
					});
				} catch (e) {
					r.entries?.forEach((t) => {
						t.deferred.reject(e);
					});
				}
			}, od), i.promise;
		}
		async postRecommendations(e) {
			let t = {};
			return t["Content-Type"] = "text/plain", await this.request({
				path: this.configuration.paths.recommend || "/v1/recommend",
				method: "POST",
				headers: t,
				body: e,
				subDomain: "p13n"
			}, JSON.stringify(e));
		}
	};
})), ld, ud = o((() => {
	Bu(), ld = class extends Ru {
		async getSuggest(e) {
			return await this.request({
				path: this.configuration.paths.suggest || "/v1/suggest",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async postSuggest(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.suggest || "/v1/suggest",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
		async getTrending(e) {
			return await this.request({
				path: this.configuration.paths.trending || "/v1/trending",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
		async postTrending(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.trending || "/v1/trending",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
	};
})), dd, fd = o((() => {
	pd(), dd = class extends Ru {
		async postMeta(e) {
			let t = {};
			return t["Content-Type"] = "application/json", await this.request({
				path: this.configuration.paths.meta || "/v1/meta",
				method: "POST",
				headers: t,
				body: e
			}, JSON.stringify(e));
		}
		async getMeta(e) {
			return await this.request({
				path: this.configuration.paths.meta || "/v1/meta",
				method: "GET",
				headers: {},
				query: e
			}, JSON.stringify(e));
		}
	};
})), pd = o((() => {
	Bu(), nd(), cd(), ud(), fd();
})), md, hd, gd, _d = o((() => {
	W(), pd(), md = /* @__PURE__ */ u(ji()), $u(), hd = {
		mode: U.production,
		meta: { cache: { purgeable: !1 } }
	}, gd = class {
		constructor(e, t = {}) {
			if (this.mode = U.production, !e?.siteId) throw "no siteId specified!";
			this.globals = e, this.config = (0, md.default)(hd, t), Object.values(U).includes(this.config.mode) && (this.mode = this.config.mode), this.requesters = {
				meta: new dd(new zu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.meta?.origin,
					headers: this.config.meta?.headers,
					cache: this.config.meta?.cache,
					globals: this.config.meta?.globals,
					paths: this.config.meta?.paths
				})),
				recommend: new sd(new zu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.recommend?.origin,
					headers: this.config.recommend?.headers,
					cache: this.config.recommend?.cache,
					globals: this.config.recommend?.globals,
					paths: this.config.recommend?.paths
				})),
				search: new td(new zu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.search?.origin,
					headers: this.config.search?.headers,
					cache: this.config.search?.cache,
					globals: this.config.search?.globals,
					paths: this.config.search?.paths
				})),
				suggest: new ld(new zu({
					fetchApi: this.config.fetchApi,
					initiator: this.config.initiator,
					mode: this.mode,
					origin: this.config.suggest?.origin,
					headers: this.config.suggest?.headers,
					cache: this.config.suggest?.cache,
					globals: this.config.suggest?.globals,
					paths: this.config.suggest?.paths
				}))
			};
		}
		async meta(e) {
			let t = { siteId: this.globals.siteId };
			return e = (0, md.default)(t, e || {}), this.requesters.meta.getMeta(e);
		}
		async autocomplete(e = {}) {
			if (!e.search?.query?.string) throw "query string parameter is required";
			e = (0, md.default)(this.globals, e);
			let t = this.meta({ siteId: e.siteId || "" }), n = {
				siteId: e.siteId || "",
				language: "en",
				query: e.search?.query?.string || "",
				suggestionCount: (e.suggestions || {}).count || 5
			};
			e.search?.query?.spellCorrection === !1 && (n.disableSpellCorrect = !0);
			let r = Yu(await this.requesters.suggest.getSuggest(n)), i = (r.suggested || {}).text || r.query || r.correctedQuery;
			e.search = e.search || {}, e.search.redirectResponse = "full", i && e.search?.query?.string && (e.search.query.string = i);
			let a = {
				...await this.requesters.search.getAutocomplete(e),
				autocomplete: r
			}, [o, s] = await Promise.all([t, a]);
			return {
				meta: o,
				search: s
			};
		}
		async search(e = {}) {
			e = (0, md.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getSearch(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async category(e = {}) {
			e = (0, md.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getCategory(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async finder(e = {}) {
			e = (0, md.default)(this.globals, e);
			let [t, n] = await Promise.all([this.meta({ siteId: e.siteId || "" }), this.requesters.search.getFinder(e)]);
			return {
				meta: t,
				search: n
			};
		}
		async trending(e) {
			return e = (0, md.default)({ siteId: this.globals.siteId }, e || {}), this.requesters.suggest.getTrending(e);
		}
		async recommend(e) {
			let { tag: t, ...n } = e;
			if (!t) throw "tag parameter is required";
			let r = {
				tag: t,
				siteId: e.siteId || this.globals.siteId
			};
			n.branch && (r.branch = n.branch, delete n.branch);
			let i = {
				tag: t,
				...n,
				siteId: e.siteId || this.globals.siteId
			}, [a, o, s] = await Promise.all([
				this.meta(e.siteId ? { siteId: e.siteId } : void 0),
				this.requesters.recommend.getProfile(r),
				this.requesters.recommend.batchRecommendations(i)
			]);
			return {
				...o,
				meta: a,
				results: s && s.results,
				responseId: s ? s.responseId : ""
			};
		}
	};
})), vd = o((() => {
	_d();
})), yd, bd = o((() => {
	yd = {
		blue: "#3379c1",
		bluelight: "#688BA3",
		bluedark: "#1B3141",
		bluegreen: "#318495",
		grey: "#61717B",
		green: "#507B43",
		greendark: "#63715F",
		greenblue: "#46927D",
		indigo: "#4c3ce2",
		orange: "#ecaa15",
		orangelight: "#ff6600",
		orangedark: "#c59600",
		red: "#cc1212",
		redlight: "#f30707",
		reddark: "#8E111C",
		yellow: "#d1d432"
	};
})), xd, Sd = o((() => {
	xd = {
		bang: String.fromCodePoint(8252),
		bright: String.fromCodePoint(128262),
		check: String.fromCodePoint(10004),
		clock: String.fromCodePoint(128342),
		cloud: String.fromCodePoint(9729),
		dim: String.fromCodePoint(128261),
		gear: String.fromCodePoint(9881),
		interobang: String.fromCodePoint(8265),
		lightning: String.fromCodePoint(9889),
		magic: String.fromCodePoint(10024),
		rocket: String.fromCodePoint(128640),
		search: String.fromCodePoint(128269),
		snap: String.fromCodePoint(128165),
		ufo: String.fromCodePoint(128760),
		vortex: String.fromCodePoint(127744),
		warning: String.fromCodePoint(9888)
	};
})), Cd, wd = o((() => {
	W(), bd(), Sd(), Cd = class {
		constructor(e) {
			this.mode = U.production, this.emoji = xd, this.colors = yd, this.prefix = "", this.prefix = e?.prefix || "", this.mode = e?.mode || U.production;
		}
		setNamespace(e) {
			this.prefix = ` [${e}] :: `;
		}
		error(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), console.log(`%c ${xd.bang} %c${this.prefix}${t}`, `color: ${yd.red}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${yd.red}; font-weight: bold;`, ...n);
		}
		warn(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), console.log(`%c ${xd.warning} %c${this.prefix}%c${t}`, `color: ${yd.yellow}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${yd.yellow}; font-weight: normal;`, `color: ${yd.yellow}; font-weight: bold;`, ...n);
		}
		image({ url: e, width: t, height: n }, ...r) {
			let i = {
				size: `font-size: 1px; padding: ${n || t} ${t || n};`,
				background: `background: url("${e}") no-repeat; background-size: contain;`
			};
			this.dev("%c...", `${i.size} ${i.background}`, ...r);
		}
		imageText({ url: e, text: t = "", style: n }, ...r) {
			let i = {
				background: `margin-left: 6px; background: url("${e}") no-repeat; background-size: contain;`,
				custom: n
			}, a = t, o = r;
			!a && r?.length && ([a, ...o] = r), this.dev(`%c ${"  " + this.prefix}${a}`, `${i.background} ${i.custom}`, ...o);
		}
		debug(...e) {
			let t = "", n = e;
			e.length && typeof e[0] == "string" && ([t, ...n] = e), this.dev(`%c ${xd.interobang} %c${this.prefix}${t}`, `color: ${yd.orangelight}; font-weight: bold; font-size: 14px; line-height: 12px;`, `color: ${yd.orangelight}; font-weight: bold;`, ...n);
		}
		profile(e, ...t) {
			this.dev(`%c ${xd.gear} %c${this.prefix}%c${e.type}  %c~  ${e.name}  ::  %c${e.status.toUpperCase()}${e.status == "finished" ? "  ::  %c" + e.time.run + "ms" : ""}`, `color: ${yd.orange}; font-size: 14px; line-height: 12px;`, `color: ${yd.orange};`, `color: ${yd.orange}; font-style: italic;`, `color: ${yd.orange};`, `color: ${yd.orange}; font-weight: bold;`, `color: ${yd.grey};`, ...t);
		}
		dev(...e) {
			this.mode === U.development && console.log(...e);
		}
	};
})), Td = o((() => {
	wd(), bd(), Sd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AttributionInner.js
function Ed(e) {
	return Dd(e, !1);
}
function Dd(e, t = !1) {
	return e == null ? e : {
		type: e.type,
		id: e.id
	};
}
var Od = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Currency.js
function kd(e) {
	return Ad(e, !1);
}
function Ad(e, t = !1) {
	return e == null ? e : { code: e.code };
}
var jd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Context.js
function q(e) {
	return Md(e, !1);
}
function Md(e, t = !1) {
	return e == null ? e : {
		initiator: e.initiator,
		pageLoadId: e.pageLoadId,
		pageUrl: e.pageUrl,
		sessionId: e.sessionId,
		timestamp: e.timestamp,
		userId: e.userId,
		attribution: e.attribution == null ? void 0 : e.attribution.map(Ed),
		currency: kd(e.currency),
		dev: e.dev,
		IP: e.iP,
		shopperId: e.shopperId,
		userAgent: e.userAgent
	};
}
var J = o((() => {
	Od(), jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/Product.js
function Nd(e) {
	return Pd(e, !1);
}
function Pd(e, t = !1) {
	return e == null ? e : {
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku,
		qty: e.qty,
		price: e.price
	};
}
var Fd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AddtocartSchemaData.js
function Id(e) {
	return Ld(e, !1);
}
function Ld(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(Nd)
	};
}
var Rd = o((() => {
	Fd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/AddtocartSchema.js
function zd(e) {
	return Bd(e, !1);
}
function Bd(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Id(e.data)
	};
}
var Vd = o((() => {
	J(), Rd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BannersInner.js
function Hd(e) {
	return Ud(e, !1);
}
function Ud(e, t = !1) {
	return e == null ? e : { uid: e.uid };
}
var Wd = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesAddtocartSchemaData.js
function Gd(e) {
	return Kd(e, !1);
}
function Kd(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		tag: e.tag,
		results: e.results.map(Nd)
	};
}
var qd = o((() => {
	Fd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesAddtocartSchema.js
function Jd(e) {
	return Yd(e, !1);
}
function Yd(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Gd(e.data)
	};
}
var Xd = o((() => {
	J(), qd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersInner.js
function Zd(e) {
	return Qd(e, !1);
}
function Qd(e, t = !1) {
	return e == null ? e : { uid: e.uid };
}
var $d = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersSchema1.js
function ef(e) {
	return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function tf(e) {
	return nf(e, !1);
}
function nf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		banners: e.banners.map(Zd)
	};
}
var rf = o((() => {
	$d();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultProductType.js
function af(e) {
	return e;
}
var of = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultProduct.js
function sf(e) {
	return !(!("type" in e) || e.type === void 0 || !("parentId" in e) || e.parentId === void 0 || !("uid" in e) || e.uid === void 0);
}
function cf(e) {
	return lf(e, !1);
}
function lf(e, t = !1) {
	return e == null ? e : {
		type: af(e.type),
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var uf = o((() => {
	of();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultResultBanner.js
function df(e) {
	return !(!("type" in e) || e.type === void 0 || !("uid" in e) || e.uid === void 0);
}
function ff(e) {
	return pf(e, !1);
}
function pf(e, t = !1) {
	return e == null ? e : {
		type: af(e.type),
		uid: e.uid
	};
}
var mf = o((() => {
	of();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsInner.js
function hf(e) {
	return gf(e, !1);
}
function gf(e, t = !1) {
	return typeof e != "object" || !e ? e : sf(e) ? cf(e) : df(e) ? ff(e) : {};
}
var _f = o((() => {
	uf(), mf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsSchema1.js
function vf(e) {
	return !(!("tag" in e) || e.tag === void 0 || !("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function yf(e) {
	return bf(e, !1);
}
function bf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results.map(hf)
	};
}
var xf = o((() => {
	_f();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesClickthroughSchemaData.js
function Sf(e) {
	return Cf(e, !1);
}
function Cf(e, t = !1) {
	return typeof e != "object" || !e ? e : ef(e) ? tf(e) : vf(e) ? yf(e) : {};
}
var wf = o((() => {
	rf(), xf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesClickthroughSchema.js
function Tf(e) {
	return Ef(e, !1);
}
function Ef(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Sf(e.data)
	};
}
var Df = o((() => {
	J(), wf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ResultsInner.js
function Of(e) {
	return kf(e, !1);
}
function kf(e, t = !1) {
	return typeof e != "object" || !e ? e : sf(e) ? cf(e) : df(e) ? ff(e) : {};
}
var Af = o((() => {
	uf(), mf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesImpressionSchemaData.js
function jf(e) {
	return Mf(e, !1);
}
function Mf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results == null ? void 0 : e.results.map(Of),
		banners: e.banners.map(Hd)
	};
}
var Nf = o((() => {
	Wd(), Af();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesImpressionSchema.js
function Pf(e) {
	return Ff(e, !1);
}
function Ff(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: jf(e.data)
	};
}
var If = o((() => {
	J(), Nf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesRenderSchemaData.js
function Lf(e) {
	return Rf(e, !1);
}
function Rf(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId
	};
}
var zf = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/BundlesRenderSchema.js
function Bf(e) {
	return Vf(e, !1);
}
function Vf(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Lf(e.data)
	};
}
var Hf = o((() => {
	J(), zf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/CartSchemaData.js
function Uf(e) {
	return Wf(e, !1);
}
function Wf(e, t = !1) {
	return e == null ? e : {
		results: e.results.map(Nd),
		cart: e.cart.map(Nd)
	};
}
var Gf = o((() => {
	Fd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/CartSchema.js
function Kf(e) {
	return qf(e, !1);
}
function qf(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Uf(e.data)
	};
}
var Jf = o((() => {
	Gf(), J();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatAddtocartSchemaData.js
function Yf(e) {
	return Xf(e, !1);
}
function Xf(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(Nd)
	};
}
var Zf = o((() => {
	Fd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatAddtocartSchema.js
function Qf(e) {
	return $f(e, !1);
}
function $f(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Yf(e.data)
	};
}
var ep = o((() => {
	J(), Zf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatResultProductType.js
function tp(e) {
	return e;
}
var np = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatResultProduct.js
function rp(e) {
	return ip(e, !1);
}
function ip(e, t = !1) {
	return e == null ? e : {
		type: tp(e.type),
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var ap = o((() => {
	np();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatClickthroughSchemaData.js
function op(e) {
	return sp(e, !1);
}
function sp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(rp)
	};
}
var cp = o((() => {
	ap();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatClickthroughSchema.js
function lp(e) {
	return up(e, !1);
}
function up(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: op(e.data)
	};
}
var dp = o((() => {
	J(), cp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatFeedbackSchemaData.js
function fp(e) {
	return pp(e, !1);
}
function pp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		feedback: e.feedback
	};
}
var mp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatFeedbackSchema.js
function hp(e) {
	return gp(e, !1);
}
function gp(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: fp(e.data)
	};
}
var _p = o((() => {
	mp(), J();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatImpressionSchemaData.js
function vp(e) {
	return yp(e, !1);
}
function yp(e, t = !1) {
	return e == null ? e : {
		chatSessionId: e.chatSessionId,
		responseId: e.responseId,
		results: e.results.map(rp)
	};
}
var bp = o((() => {
	ap();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ChatImpressionSchema.js
function xp(e) {
	return Sp(e, !1);
}
function Sp(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: vp(e.data)
	};
}
var Cp = o((() => {
	J(), bp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughBannersSchema.js
function wp(e) {
	return !(!("responseId" in e) || e.responseId === void 0 || !("banners" in e) || e.banners === void 0);
}
function Tp(e) {
	return Ep(e, !1);
}
function Ep(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		banners: e.banners.map(Zd)
	};
}
var Dp = o((() => {
	$d();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughResultsSchema.js
function Op(e) {
	return !(!("responseId" in e) || e.responseId === void 0 || !("results" in e) || e.results === void 0);
}
function kp(e) {
	return Ap(e, !1);
}
function Ap(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(hf)
	};
}
var jp = o((() => {
	_f();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughSchemaData.js
function Mp(e) {
	return Np(e, !1);
}
function Np(e, t = !1) {
	return typeof e != "object" || !e ? e : wp(e) ? Tp(e) : Op(e) ? kp(e) : {};
}
var Pp = o((() => {
	Dp(), jp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ClickthroughSchema.js
function Fp(e) {
	return Ip(e, !1);
}
function Ip(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Mp(e.data)
	};
}
var Lp = o((() => {
	J(), Pp();
})), Rp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ImpressionSchemaData.js
function zp(e) {
	return Bp(e, !1);
}
function Bp(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		results: e.results.map(Of),
		banners: e.banners.map(Hd)
	};
}
var Vp = o((() => {
	Wd(), Af();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ImpressionSchema.js
function Hp(e) {
	return Up(e, !1);
}
function Up(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: zp(e.data)
	};
}
var Wp = o((() => {
	J(), Vp();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/InlineObject.js
function Y(e) {
	return Gp(e, !1);
}
function Gp(e, t) {
	return e == null ? e : { success: e.success == null ? void 0 : e.success };
}
var Kp = o((() => {})), qp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/LogSchemaData.js
function Jp(e) {
	return Yp(e, !1);
}
function Yp(e, t = !1) {
	return e == null ? e : {
		message: e.message,
		stack: e.stack,
		details: e.details
	};
}
var Xp = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/LogSchema.js
function Zp(e) {
	return Qp(e, !1);
}
function Qp(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Jp(e.data)
	};
}
var $p = o((() => {
	J(), Xp();
})), em = o((() => {})), tm = o((() => {})), nm = o((() => {
	em(), tm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/OrderTransactionSchemaData.js
function rm(e) {
	return im(e, !1);
}
function im(e, t = !1) {
	return e == null ? e : {
		orderId: e.orderId,
		transactionTotal: e.transactionTotal,
		total: e.total,
		vat: e.vat,
		city: e.city,
		state: e.state,
		country: e.country,
		results: e.results.map(Nd)
	};
}
var am = o((() => {
	Fd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/OrderTransactionSchema.js
function om(e) {
	return sm(e, !1);
}
function sm(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: rm(e.data)
	};
}
var cm = o((() => {
	J(), am();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogContext.js
function lm(e) {
	return um(e, !1);
}
function um(e, t = !1) {
	return e == null ? e : {
		timestamp: e.timestamp,
		dev: e.dev
	};
}
var dm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogSchemaData.js
function fm(e) {
	return pm(e, !1);
}
function pm(e, t = !1) {
	return e == null ? e : {
		message: e.message,
		stack: e.stack,
		details: e.details
	};
}
var mm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/PersonalizationLogSchema.js
function hm(e) {
	return gm(e, !1);
}
function gm(e, t = !1) {
	return e == null ? e : {
		context: lm(e.context),
		data: fm(e.data)
	};
}
var _m = o((() => {
	mm(), dm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchemaDataResult.js
function vm(e) {
	return ym(e, !1);
}
function ym(e, t = !1) {
	return e == null ? e : {
		parentId: e.parentId,
		uid: e.uid,
		sku: e.sku
	};
}
var bm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchemaData.js
function xm(e) {
	return Sm(e, !1);
}
function Sm(e, t = !1) {
	return e == null ? e : { result: vm(e.result) };
}
var Cm = o((() => {
	bm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ProductPageviewSchema.js
function wm(e) {
	return Tm(e, !1);
}
function Tm(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: xm(e.data)
	};
}
var Em = o((() => {
	J(), Cm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsAddtocartSchemaData.js
function Dm(e) {
	return Om(e, !1);
}
function Om(e, t = !1) {
	return e == null ? e : {
		responseId: e.responseId,
		tag: e.tag,
		results: e.results.map(Nd)
	};
}
var km = o((() => {
	Fd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsAddtocartSchema.js
function Am(e) {
	return jm(e, !1);
}
function jm(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Dm(e.data)
	};
}
var Mm = o((() => {
	J(), km();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsClickthroughSchemaData.js
function Nm(e) {
	return Pm(e, !1);
}
function Pm(e, t = !1) {
	return typeof e != "object" || !e ? e : ef(e) ? tf(e) : vf(e) ? yf(e) : {};
}
var Fm = o((() => {
	rf(), xf();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsClickthroughSchema.js
function Im(e) {
	return Lm(e, !1);
}
function Lm(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Nm(e.data)
	};
}
var Rm = o((() => {
	J(), Fm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsImpressionSchemaData.js
function zm(e) {
	return Bm(e, !1);
}
function Bm(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId,
		results: e.results == null ? void 0 : e.results.map(Of),
		banners: e.banners.map(Hd)
	};
}
var Vm = o((() => {
	Wd(), Af();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsImpressionSchema.js
function Hm(e) {
	return Um(e, !1);
}
function Um(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: zm(e.data)
	};
}
var Wm = o((() => {
	J(), Vm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsRenderSchemaData.js
function Gm(e) {
	return Km(e, !1);
}
function Km(e, t = !1) {
	return e == null ? e : {
		tag: e.tag,
		responseId: e.responseId
	};
}
var qm = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RecommendationsRenderSchema.js
function Jm(e) {
	return Ym(e, !1);
}
function Ym(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Gm(e.data)
	};
}
var Xm = o((() => {
	J(), qm();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RedirectSchemaData.js
function Zm(e) {
	return Qm(e, !1);
}
function Qm(e, t = !1) {
	return e == null ? e : {
		redirect: e.redirect,
		responseId: e.responseId
	};
}
var $m = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RedirectSchema.js
function eh(e) {
	return th(e, !1);
}
function th(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: Zm(e.data)
	};
}
var nh = o((() => {
	J(), $m();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RenderSchemaData.js
function rh(e) {
	return ih(e, !1);
}
function ih(e, t = !1) {
	return e == null ? e : { responseId: e.responseId };
}
var ah = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/RenderSchema.js
function oh(e) {
	return sh(e, !1);
}
function sh(e, t = !1) {
	return e == null ? e : {
		context: q(e.context),
		data: rh(e.data)
	};
}
var ch = o((() => {
	J(), ah();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ShopperContext.js
function lh(e) {
	return uh(e, !1);
}
function uh(e, t = !1) {
	return e == null ? e : {
		initiator: e.initiator,
		pageLoadId: e.pageLoadId,
		pageUrl: e.pageUrl,
		sessionId: e.sessionId,
		shopperId: e.shopperId,
		timestamp: e.timestamp,
		userId: e.userId,
		attribution: e.attribution == null ? void 0 : e.attribution.map(Ed),
		currency: kd(e.currency),
		dev: e.dev,
		IP: e.iP,
		userAgent: e.userAgent
	};
}
var dh = o((() => {
	Od(), jd();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/models/ShopperLoginSchema.js
function fh(e) {
	return ph(e, !1);
}
function ph(e, t = !1) {
	return e == null ? e : { context: lh(e.context) };
}
var mh = o((() => {
	dh();
})), hh = o((() => {})), gh = o((() => {
	Vd(), Rd(), Od(), Wd(), Xd(), qd(), Df(), wf(), If(), Nf(), Hf(), zf(), Jf(), Gf(), ep(), Zf(), dp(), cp(), _p(), mp(), Cp(), bp(), ap(), np(), $d(), Dp(), rf(), _f(), jp(), xf(), Lp(), Pp(), J(), jd(), Rp(), Wp(), Vp(), Kp(), qp(), $p(), Xp(), nm(), em(), tm(), cm(), am(), dm(), _m(), mm(), Fd(), Em(), Cm(), bm(), Mm(), km(), Rm(), Fm(), Wm(), Vm(), Xm(), qm(), nh(), $m(), ch(), ah(), uf(), of(), mf(), Af(), dh(), mh(), hh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/client/runtime.js
function _h(e) {
	return typeof Blob < "u" && e instanceof Blob;
}
function vh(e) {
	return typeof FormData < "u" && e instanceof FormData;
}
function yh(e, t = "") {
	return Object.keys(e).map((n) => bh(n, e[n], t)).filter((e) => e.length > 0).join("&");
}
function bh(e, t, n = "") {
	let r = n + (n.length ? `[${e}]` : e);
	if (t instanceof Array) {
		let e = t.map((e) => encodeURIComponent(String(e))).join(`&${encodeURIComponent(r)}=`);
		return `${encodeURIComponent(r)}=${e}`;
	}
	return t instanceof Set ? bh(e, Array.from(t), n) : t instanceof Date ? `${encodeURIComponent(r)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? yh(t, r) : `${encodeURIComponent(r)}=${encodeURIComponent(String(t))}`;
}
var xh, Sh, Ch, wh, Th, Eh, X, Z, Dh = o((() => {
	xh = "https://analytics.athoscommerce.net/beacon/v2".replace(/\/+$/, ""), Sh = class {
		constructor(e = {}) {
			this.configuration = e;
		}
		set config(e) {
			this.configuration = e;
		}
		get basePath() {
			return this.configuration.basePath == null ? xh : this.configuration.basePath;
		}
		get fetchApi() {
			return this.configuration.fetchApi;
		}
		get middleware() {
			return this.configuration.middleware || [];
		}
		get queryParamsStringify() {
			return this.configuration.queryParamsStringify || yh;
		}
		get username() {
			return this.configuration.username;
		}
		get password() {
			return this.configuration.password;
		}
		get apiKey() {
			let e = this.configuration.apiKey;
			if (e) return typeof e == "function" ? e : () => e;
		}
		get accessToken() {
			let e = this.configuration.accessToken;
			if (e) return typeof e == "function" ? e : async () => e;
		}
		get headers() {
			return this.configuration.headers;
		}
		get credentials() {
			return this.configuration.credentials;
		}
	}, Ch = new Sh(), wh = class e {
		constructor(e = Ch) {
			this.configuration = e, this.fetchApi = async (e, t) => {
				let n = {
					url: e,
					init: t
				};
				for (let e of this.middleware) e.pre && (n = await e.pre({
					fetch: this.fetchApi,
					...n
				}) || n);
				let r;
				try {
					r = await (this.configuration.fetchApi || fetch)(n.url, n.init);
				} catch (e) {
					for (let t of this.middleware) t.onError && (r = await t.onError({
						fetch: this.fetchApi,
						url: n.url,
						init: n.init,
						error: e,
						response: r ? r.clone() : void 0
					}) || r);
					if (r === void 0) throw e instanceof Error ? new Eh(e, "The request failed and the interceptors did not return an alternative response") : e;
				}
				for (let e of this.middleware) e.post && (r = await e.post({
					fetch: this.fetchApi,
					url: n.url,
					init: n.init,
					response: r.clone()
				}) || r);
				return r;
			}, this.middleware = e.middleware;
		}
		withMiddleware(...e) {
			let t = this.clone();
			return t.middleware = t.middleware.concat(...e), t;
		}
		withPreMiddleware(...e) {
			let t = e.map((e) => ({ pre: e }));
			return this.withMiddleware(...t);
		}
		withPostMiddleware(...e) {
			let t = e.map((e) => ({ post: e }));
			return this.withMiddleware(...t);
		}
		isJsonMime(t) {
			return t ? e.jsonRegex.test(t) : !1;
		}
		async request(e, t) {
			let { url: n, init: r } = await this.createFetchParams(e, t), i = await this.fetchApi(n, r);
			if (i && i.status >= 200 && i.status < 300) return i;
			throw new Th(i, "Response returned an error code");
		}
		async createFetchParams(e, t) {
			let n = this.configuration.basePath + e.path;
			e.query !== void 0 && Object.keys(e.query).length !== 0 && (n += "?" + this.configuration.queryParamsStringify(e.query));
			let r = Object.assign({}, this.configuration.headers, e.headers);
			Object.keys(r).forEach((e) => r[e] === void 0 ? delete r[e] : {});
			let i = typeof t == "function" ? t : async () => t, a = {
				method: e.method,
				headers: r,
				body: e.body,
				credentials: this.configuration.credentials
			}, o = {
				...a,
				...await i({
					init: a,
					context: e
				})
			}, s;
			s = vh(o.body) || o.body instanceof URLSearchParams || _h(o.body) ? o.body : this.isJsonMime(r["Content-Type"]) ? JSON.stringify(o.body) : o.body;
			let c = {
				...o,
				body: s
			};
			return {
				url: n,
				init: c
			};
		}
		clone() {
			let e = this.constructor, t = new e(this.configuration);
			return t.middleware = this.middleware.slice(), t;
		}
	}, wh.jsonRegex = /* @__PURE__ */ RegExp("^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$", "i"), Th = class extends Error {
		constructor(e, t) {
			super(t), this.response = e, this.name = "ResponseError";
		}
	}, Eh = class extends Error {
		constructor(e, t) {
			super(t), this.cause = e, this.name = "FetchError";
		}
	}, X = class extends Error {
		constructor(e, t) {
			super(t), this.field = e, this.name = "RequiredError";
		}
	}, Z = class {
		constructor(e, t = (e) => e) {
			this.raw = e, this.transformer = t;
		}
		async value() {
			return this.transformer(await this.raw.json());
		}
	};
})), Oh, kh = o((() => {
	Dh(), gh(), Oh = class extends wh {
		async autocompleteAddtocartRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteAddtocart().");
			if (e.addtocartSchema == null) throw new X("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling autocompleteAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: zd(e.addtocartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async autocompleteAddtocart(e, t) {
			return await (await this.autocompleteAddtocartRaw(e, t)).value();
		}
		async autocompleteClickthroughRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteClickthrough().");
			if (e.clickthroughSchema == null) throw new X("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling autocompleteClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Fp(e.clickthroughSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async autocompleteClickthrough(e, t) {
			return await (await this.autocompleteClickthroughRaw(e, t)).value();
		}
		async autocompleteImpressionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteImpression().");
			if (e.impressionSchema == null) throw new X("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling autocompleteImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Hp(e.impressionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async autocompleteImpression(e, t) {
			return await (await this.autocompleteImpressionRaw(e, t)).value();
		}
		async autocompleteRedirectRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteRedirect().");
			if (e.redirectSchema == null) throw new X("redirectSchema", "Required parameter \"redirectSchema\" was null or undefined when calling autocompleteRedirect().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/redirect";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: eh(e.redirectSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async autocompleteRedirect(e, t) {
			return await (await this.autocompleteRedirectRaw(e, t)).value();
		}
		async autocompleteRenderRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling autocompleteRender().");
			if (e.renderSchema == null) throw new X("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling autocompleteRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/autocomplete/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: oh(e.renderSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async autocompleteRender(e, t) {
			return await (await this.autocompleteRenderRaw(e, t)).value();
		}
	};
})), Ah, jh = o((() => {
	Dh(), gh(), Ah = class extends wh {
		async bundlesAddtocartRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesAddtocart().");
			if (e.bundlesAddtocartSchema == null) throw new X("bundlesAddtocartSchema", "Required parameter \"bundlesAddtocartSchema\" was null or undefined when calling bundlesAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Jd(e.bundlesAddtocartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async bundlesAddtocart(e, t) {
			return await (await this.bundlesAddtocartRaw(e, t)).value();
		}
		async bundlesClickthroughRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesClickthrough().");
			if (e.bundlesClickthroughSchema == null) throw new X("bundlesClickthroughSchema", "Required parameter \"bundlesClickthroughSchema\" was null or undefined when calling bundlesClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Tf(e.bundlesClickthroughSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async bundlesClickthrough(e, t) {
			return await (await this.bundlesClickthroughRaw(e, t)).value();
		}
		async bundlesImpressionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesImpression().");
			if (e.bundlesImpressionSchema == null) throw new X("bundlesImpressionSchema", "Required parameter \"bundlesImpressionSchema\" was null or undefined when calling bundlesImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Pf(e.bundlesImpressionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async bundlesImpression(e, t) {
			return await (await this.bundlesImpressionRaw(e, t)).value();
		}
		async bundlesRenderRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling bundlesRender().");
			if (e.bundlesRenderSchema == null) throw new X("bundlesRenderSchema", "Required parameter \"bundlesRenderSchema\" was null or undefined when calling bundlesRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/bundles/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Bf(e.bundlesRenderSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async bundlesRender(e, t) {
			return await (await this.bundlesRenderRaw(e, t)).value();
		}
	};
})), Mh, Nh = o((() => {
	Dh(), gh(), Mh = class extends wh {
		async cartAddRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling cartAdd().");
			if (e.cartSchema == null) throw new X("cartSchema", "Required parameter \"cartSchema\" was null or undefined when calling cartAdd().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/cart/add";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Kf(e.cartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async cartAdd(e, t) {
			return await (await this.cartAddRaw(e, t)).value();
		}
		async cartRemoveRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling cartRemove().");
			if (e.cartSchema == null) throw new X("cartSchema", "Required parameter \"cartSchema\" was null or undefined when calling cartRemove().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/cart/remove";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Kf(e.cartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async cartRemove(e, t) {
			return await (await this.cartRemoveRaw(e, t)).value();
		}
	};
})), Ph, Fh = o((() => {
	Dh(), gh(), Ph = class extends wh {
		async categoryAddtocartRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryAddtocart().");
			if (e.addtocartSchema == null) throw new X("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling categoryAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: zd(e.addtocartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async categoryAddtocart(e, t) {
			return await (await this.categoryAddtocartRaw(e, t)).value();
		}
		async categoryClickthroughRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryClickthrough().");
			if (e.clickthroughSchema == null) throw new X("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling categoryClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Fp(e.clickthroughSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async categoryClickthrough(e, t) {
			return await (await this.categoryClickthroughRaw(e, t)).value();
		}
		async categoryImpressionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryImpression().");
			if (e.impressionSchema == null) throw new X("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling categoryImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Hp(e.impressionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async categoryImpression(e, t) {
			return await (await this.categoryImpressionRaw(e, t)).value();
		}
		async categoryRenderRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling categoryRender().");
			if (e.renderSchema == null) throw new X("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling categoryRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/category/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: oh(e.renderSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async categoryRender(e, t) {
			return await (await this.categoryRenderRaw(e, t)).value();
		}
	};
})), Ih, Lh = o((() => {
	Dh(), gh(), Ih = class extends wh {
		async chatAddtocartRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling chatAddtocart().");
			if (e.chatAddtocartSchema == null) throw new X("chatAddtocartSchema", "Required parameter \"chatAddtocartSchema\" was null or undefined when calling chatAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Qf(e.chatAddtocartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async chatAddtocart(e, t) {
			return await (await this.chatAddtocartRaw(e, t)).value();
		}
		async chatClickthroughRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling chatClickthrough().");
			if (e.chatClickthroughSchema == null) throw new X("chatClickthroughSchema", "Required parameter \"chatClickthroughSchema\" was null or undefined when calling chatClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: lp(e.chatClickthroughSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async chatClickthrough(e, t) {
			return await (await this.chatClickthroughRaw(e, t)).value();
		}
		async chatFeedbackRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling chatFeedback().");
			if (e.chatFeedbackSchema == null) throw new X("chatFeedbackSchema", "Required parameter \"chatFeedbackSchema\" was null or undefined when calling chatFeedback().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/feedback";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: hp(e.chatFeedbackSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async chatFeedback(e, t) {
			return await (await this.chatFeedbackRaw(e, t)).value();
		}
		async chatImpressionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling chatImpression().");
			if (e.chatImpressionSchema == null) throw new X("chatImpressionSchema", "Required parameter \"chatImpressionSchema\" was null or undefined when calling chatImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/chat/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: xp(e.chatImpressionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async chatImpression(e, t) {
			return await (await this.chatImpressionRaw(e, t)).value();
		}
	};
})), Rh, zh = o((() => {
	Dh(), gh(), Rh = class extends wh {
		async logPersonalizationRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling logPersonalization().");
			if (e.personalizationLogSchema == null) throw new X("personalizationLogSchema", "Required parameter \"personalizationLogSchema\" was null or undefined when calling logPersonalization().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/personalization";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: hm(e.personalizationLogSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async logPersonalization(e, t) {
			return await (await this.logPersonalizationRaw(e, t)).value();
		}
		async logShopifypixelRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling logShopifypixel().");
			if (e.logSchema == null) throw new X("logSchema", "Required parameter \"logSchema\" was null or undefined when calling logShopifypixel().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/shopifypixel";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Zp(e.logSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async logShopifypixel(e, t) {
			return await (await this.logShopifypixelRaw(e, t)).value();
		}
		async logSnapRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling logSnap().");
			if (e.logSchema == null) throw new X("logSchema", "Required parameter \"logSchema\" was null or undefined when calling logSnap().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/log/snap";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Zp(e.logSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async logSnap(e, t) {
			return await (await this.logSnapRaw(e, t)).value();
		}
	};
})), Bh = o((() => {
	Dh(), gh();
})), Vh, Hh = o((() => {
	Dh(), gh(), Vh = class extends wh {
		async orderTransactionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling orderTransaction().");
			if (e.orderTransactionSchema == null) throw new X("orderTransactionSchema", "Required parameter \"orderTransactionSchema\" was null or undefined when calling orderTransaction().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/order/transaction";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: om(e.orderTransactionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async orderTransaction(e, t) {
			return await (await this.orderTransactionRaw(e, t)).value();
		}
	};
})), Uh, Wh = o((() => {
	Dh(), gh(), Uh = class extends wh {
		async productPageviewRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling productPageview().");
			if (e.productPageviewSchema == null) throw new X("productPageviewSchema", "Required parameter \"productPageviewSchema\" was null or undefined when calling productPageview().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/product/pageview";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: wm(e.productPageviewSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async productPageview(e, t) {
			return await (await this.productPageviewRaw(e, t)).value();
		}
	};
})), Gh, Kh = o((() => {
	Dh(), gh(), Gh = class extends wh {
		async recommendationsAddtocartRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsAddtocart().");
			if (e.recommendationsAddtocartSchema == null) throw new X("recommendationsAddtocartSchema", "Required parameter \"recommendationsAddtocartSchema\" was null or undefined when calling recommendationsAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Am(e.recommendationsAddtocartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async recommendationsAddtocart(e, t) {
			return await (await this.recommendationsAddtocartRaw(e, t)).value();
		}
		async recommendationsClickthroughRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsClickthrough().");
			if (e.recommendationsClickthroughSchema == null) throw new X("recommendationsClickthroughSchema", "Required parameter \"recommendationsClickthroughSchema\" was null or undefined when calling recommendationsClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Im(e.recommendationsClickthroughSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async recommendationsClickthrough(e, t) {
			return await (await this.recommendationsClickthroughRaw(e, t)).value();
		}
		async recommendationsImpressionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsImpression().");
			if (e.recommendationsImpressionSchema == null) throw new X("recommendationsImpressionSchema", "Required parameter \"recommendationsImpressionSchema\" was null or undefined when calling recommendationsImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Hm(e.recommendationsImpressionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async recommendationsImpression(e, t) {
			return await (await this.recommendationsImpressionRaw(e, t)).value();
		}
		async recommendationsRenderRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling recommendationsRender().");
			if (e.recommendationsRenderSchema == null) throw new X("recommendationsRenderSchema", "Required parameter \"recommendationsRenderSchema\" was null or undefined when calling recommendationsRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/recommendations/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Jm(e.recommendationsRenderSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async recommendationsRender(e, t) {
			return await (await this.recommendationsRenderRaw(e, t)).value();
		}
	};
})), qh, Jh = o((() => {
	Dh(), gh(), qh = class extends wh {
		async searchAddtocartRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling searchAddtocart().");
			if (e.addtocartSchema == null) throw new X("addtocartSchema", "Required parameter \"addtocartSchema\" was null or undefined when calling searchAddtocart().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/addtocart";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: zd(e.addtocartSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async searchAddtocart(e, t) {
			return await (await this.searchAddtocartRaw(e, t)).value();
		}
		async searchClickthroughRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling searchClickthrough().");
			if (e.clickthroughSchema == null) throw new X("clickthroughSchema", "Required parameter \"clickthroughSchema\" was null or undefined when calling searchClickthrough().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/clickthrough";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Fp(e.clickthroughSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async searchClickthrough(e, t) {
			return await (await this.searchClickthroughRaw(e, t)).value();
		}
		async searchImpressionRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling searchImpression().");
			if (e.impressionSchema == null) throw new X("impressionSchema", "Required parameter \"impressionSchema\" was null or undefined when calling searchImpression().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/impression";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: Hp(e.impressionSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async searchImpression(e, t) {
			return await (await this.searchImpressionRaw(e, t)).value();
		}
		async searchRedirectRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling searchRedirect().");
			if (e.redirectSchema == null) throw new X("redirectSchema", "Required parameter \"redirectSchema\" was null or undefined when calling searchRedirect().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/redirect";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: eh(e.redirectSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async searchRedirect(e, t) {
			return await (await this.searchRedirectRaw(e, t)).value();
		}
		async searchRenderRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling searchRender().");
			if (e.renderSchema == null) throw new X("renderSchema", "Required parameter \"renderSchema\" was null or undefined when calling searchRender().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/search/render";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: oh(e.renderSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async searchRender(e, t) {
			return await (await this.searchRenderRaw(e, t)).value();
		}
	};
})), Yh, Xh = o((() => {
	Dh(), gh(), Yh = class extends wh {
		async loginRaw(e, t) {
			if (e.siteId == null) throw new X("siteId", "Required parameter \"siteId\" was null or undefined when calling login().");
			if (e.shopperLoginSchema == null) throw new X("shopperLoginSchema", "Required parameter \"shopperLoginSchema\" was null or undefined when calling login().");
			let n = {}, r = {};
			r["Content-Type"] = "text/plain";
			let i = "/{siteId}/shopper/login";
			i = i.replace("{siteId}", encodeURIComponent(String(e.siteId)));
			let a = await this.request({
				path: i,
				method: "POST",
				headers: r,
				query: n,
				body: fh(e.shopperLoginSchema)
			}, t);
			return new Z(a, (e) => Y(e));
		}
		async login(e, t) {
			return await (await this.loginRaw(e, t)).value();
		}
	};
})), Zh = o((() => {
	kh(), jh(), Nh(), Fh(), Lh(), zh(), Bh(), Hh(), Wh(), Kh(), Jh(), Xh();
})), Qh, $h, eg, tg, ng, rg, ig, ag, og, sg, cg, lg, ug, dg, fg = o((() => {
	Qh = "@athoscommerce/beacon", $h = "1.2.0", eg = "athoscommerce", tg = "Javascript library for utilizing Athos Commerce beacon tracking.", ng = "dist/cjs/src/index.js", rg = "dist/esm/src/index.js", ig = {
		type: "git",
		url: "https://github.com/AthosCommerce/beacon.js.git"
	}, ag = "@searchspring/prettier", og = {
		build: "rm -rf ./dist && npm run generate && tsc && tsc -p tsconfig.cjs.json && npm run build:cdn",
		"build:cdn": "webpack --config webpack.prod.js",
		dev: "tsc --watch & webpack serve --config webpack.dev.js",
		commit: "cz",
		test: "jest",
		"test:watch": "jest --watch",
		generate: "rm -fr ./src/client && openapi-generator-cli generate -i ./beacon.v2.snap.types.oas.yaml -g typescript-fetch -o ./src/client && npm run format",
		format: "prettier --write 'src/**/*.{js,jsx,ts,tsx}'",
		lint: "eslint src --ext .ts,.tsx",
		prepare: "husky",
		version: "standard-version -a",
		postpublish: "git push && git push --tags"
	}, sg = { uuid: "9.0.1" }, cg = {
		"@babel/core": "^7.21.4",
		"@babel/preset-env": "^7.21.4",
		"@babel/runtime": "^7.21.0",
		"@openapitools/openapi-generator-cli": "^2.25.2",
		"@searchspring/browserslist-config-snap": "^1.0.7",
		"@searchspring/prettier": "1.0.2",
		"@types/jest": "^29.5.14",
		"@types/uuid": "^10.0.0",
		"babel-loader": "^9.1.2",
		"cz-conventional-changelog": "3.3.0",
		eslint: "9.23.0",
		"eslint-config-prettier": "10.1.1",
		husky: "9.1.7",
		jest: "29.7.0",
		"jest-environment-jsdom": "^29.7.0",
		jsdom: "26.0.0",
		"lint-staged": "15.5.0",
		prettier: "3.5.3",
		"standard-version": "9.5.0",
		"ts-jest": "^29.3.0",
		"ts-loader": "9.4.2",
		typedoc: "0.28.1",
		typescript: "5.8.2",
		"typescript-eslint": "^8.55.0",
		webpack: "^5.77.0",
		"webpack-cli": "^5.0.1",
		"webpack-dev-server": "^4.13.2",
		"webpack-merge": "^5.8.0",
		"whatwg-fetch": "^3.6.20"
	}, lg = { commitizen: { path: "./node_modules/cz-conventional-changelog" } }, ug = { universal: "extends @searchspring/browserslist-config-snap/universal" }, dg = {
		name: Qh,
		version: $h,
		author: eg,
		license: "MIT",
		description: tg,
		main: ng,
		module: rg,
		repository: ig,
		prettier: ag,
		scripts: og,
		dependencies: sg,
		devDependencies: cg,
		"lint-staged": { "*.{js,ts,tsx}": ["prettier --write", "eslint"] },
		config: lg,
		browserslist: ug
	};
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/utils/featureFlags.js
function pg() {
	return {
		cookies: function() {
			return typeof window > "u" ? !1 : window?.navigator?.cookieEnabled;
		},
		storage: function() {
			let e = "ss-test";
			if (typeof window > "u") return !1;
			try {
				return window?.localStorage.setItem(e, e), window?.localStorage.removeItem(e), !0;
			} catch {
				return !1;
			}
		}
	};
}
var mg, hg, gg = o((() => {
	mg = pg(), hg = {
		cookies: mg.cookies(),
		storage: mg.storage()
	};
})), _g, vg = o((() => {
	_g = (e, t, n, r, i) => {
		let a = window.location.protocol == "https:" ? "Secure;" : "", o = "SameSite=" + (n || "Lax") + ";", s = "";
		if (r) {
			let e = /* @__PURE__ */ new Date();
			e.setTime(e.getTime() + r), s = "expires=" + e.toUTCString() + ";";
		}
		let c = encodeURIComponent(t) + ";";
		if (i) return e + "=" + c + s + o + a + "path=/; domain=" + i;
		let l = window?.location?.hostname;
		if (!l || l.split(".").length === 1) return e + "=" + c + s + o + a + "path=/";
		let u = l.split(".");
		return u.shift(), i = "." + u.join("."), e + "=" + c + s + o + a + "path=/; domain=" + i;
	};
})), yg = o((() => {
	gg(), vg();
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/rng.js
function bg() {
	if (!xg && (xg = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !xg)) throw Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
	return xg(Sg);
}
var xg, Sg, Cg = o((() => {
	Sg = /* @__PURE__ */ new Uint8Array(16);
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/stringify.js
function wg(e, t = 0) {
	return Q[e[t + 0]] + Q[e[t + 1]] + Q[e[t + 2]] + Q[e[t + 3]] + "-" + Q[e[t + 4]] + Q[e[t + 5]] + "-" + Q[e[t + 6]] + Q[e[t + 7]] + "-" + Q[e[t + 8]] + Q[e[t + 9]] + "-" + Q[e[t + 10]] + Q[e[t + 11]] + Q[e[t + 12]] + Q[e[t + 13]] + Q[e[t + 14]] + Q[e[t + 15]];
}
var Q, Tg = o((() => {
	Q = [];
	for (let e = 0; e < 256; ++e) Q.push((e + 256).toString(16).slice(1));
})), Eg, Dg, Og = o((() => {
	Eg = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Dg = { randomUUID: Eg };
}));
//#endregion
//#region node_modules/uuid/dist/esm-browser/v4.js
function kg(e, t, n) {
	if (Dg.randomUUID && !t && !e) return Dg.randomUUID();
	e ||= {};
	let r = e.random || (e.rng || bg)();
	if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
		n ||= 0;
		for (let e = 0; e < 16; ++e) t[n + e] = r[e];
		return t;
	}
	return wg(r);
}
var Ag = o((() => {
	Og(), Cg(), Tg();
})), jg = o((() => {
	Cg(), Tg(), Ag();
})), Mg = o((() => {
	Dh(), Zh(), gh();
}));
//#endregion
//#region node_modules/@athoscommerce/beacon/dist/esm/src/Beacon.js
function Ng(e, t, n, r) {
	if (!e.batches[t]) e.batches[t] = JSON.parse(JSON.stringify(r));
	else {
		let i = e.batches[t].payload, a = r.payload, o = i[n], s = a[n];
		if (s?.data?.results) {
			let e = o.data.results || [], t = s.data.results, n = [...e, ...t];
			o.data.results = n;
		}
		if (s?.data?.banners) {
			let e = o?.data?.banners || [], t = s.data.banners, n = [...e, ...t];
			o.data.banners = n;
		}
	}
}
function Pg(e, t) {
	let n = "";
	return n += `||${t.context.pageLoadId}`, n += `||${t.context.sessionId}`, t.data?.chatSessionId ? n += `||chatSessionId=${t.data.chatSessionId}||responseId=${t.data.responseId}` : t.data?.responseId ? n += `||responseId=${t.data.responseId}` : e === "shopper" && t.context.shopperId && (n += `||shopperId=${t.context.shopperId}`), (e === "recommendation" || e === "bundle") && (n += `||tag=${t.data.tag}`), n;
}
function Fg(e) {
	if (typeof window < "u" && hg.cookies) {
		let t = e + "=", n = window.document.cookie.split(";");
		for (let e = 0; e < n.length; e++) {
			let r = n[e];
			for (; r.charAt(0) == " ";) r = r.substring(1);
			if (r.indexOf(t) == 0) return decodeURIComponent(r.substring(t.length, r.length));
		}
		return "";
	}
	return "";
}
function Ig(e, t) {
	let n = $g[e];
	return t.trim().toLowerCase().startsWith("at") ? [n.primary, n.legacy] : [n.legacy, n.primary];
}
function Lg(e, t) {
	let n = $g[e];
	return t.trim().toLowerCase().startsWith("at") ? [n.primary] : [n.legacy];
}
function Rg(e) {
	let t = $g[e];
	typeof window < "u" && (window.localStorage?.removeItem(t.primary), window.localStorage?.removeItem(t.legacy));
}
function zg(e, t, n, r) {
	if (e instanceof Error && e.name === "QuotaExceededError") {
		let e = $g[n];
		t.events.error.snap({ data: {
			message: "QuotaExceededError",
			details: {
				key: e.legacy,
				keyPrimary: e.primary,
				value: r
			}
		} });
	}
}
var Bg, Vg, Hg, Ug, Wg, Gg, Kg, qg, Jg, Yg, Xg, Zg, Qg, $g, e_, t_ = o((() => {
	fg(), yg(), jg(), Mg(), Zh(), {version: Bg} = dg, Vg = 47304e6, Hg = 18e5, Ug = 20, Wg = -1, Gg = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0, Kg = "userId", qg = "pageLoadId", Jg = "sessionId", Yg = "shopperId", Xg = "cartProducts", Zg = "viewedProducts", Qg = "attribution", $g = {
		[Kg]: {
			primary: "athosUserId",
			legacy: "ssUserId"
		},
		[qg]: {
			primary: "athosPageLoadId",
			legacy: "ssPageLoadId"
		},
		[Jg]: {
			primary: "athosSessionId",
			legacy: "ssSessionId"
		},
		[Yg]: {
			primary: "athosShopperId",
			legacy: "ssShopperId"
		},
		[Xg]: {
			primary: "athosCartProducts",
			legacy: "ssCartProducts"
		},
		[Zg]: {
			primary: "athosViewedProducts",
			legacy: "ssViewedProducts"
		},
		[Qg]: {
			primary: "athosAttribution",
			legacy: "ssAttribution"
		}
	}, e_ = class {
		constructor(e, t) {
			if (this.mode = "production", this.pageLoadId = "", this.userId = "", this.sessionId = "", this.shopperId = "", this.currency = { code: "" }, this.initiator = "", this.batchIntervalTimeout = 0, this.preflightTimeout = 0, this.requests = [], this.storage = {
				cart: {
					get: () => {
						let e = this.getLocalStorageItem(Xg);
						if (e) try {
							if (Array.isArray(e)) return e;
						} catch {
							Rg(Xg), this.setCookie(Xg, "", "Lax", 0, Gg);
						}
						else return this.getCookie(Xg).split(",").filter((e) => e).map((e) => ({
							parentId: e,
							uid: e,
							sku: e,
							qty: 1,
							price: 0
						}));
						return [];
					},
					set: (e) => {
						let t = this.storage.cart.get(), n = JSON.stringify(e);
						try {
							this.setLocalStorageItem(Xg, e);
						} catch (e) {
							zg(e, this, Xg, n);
						}
						let r = e.map((e) => this.getProductId(e)).join(",");
						this.setCookie(Xg, r, "Lax", 0, Gg), JSON.stringify(t) !== n && this._sendPreflight();
					},
					add: (e) => {
						if (e.length) {
							let t = [...this.storage.cart.get()];
							e.filter((e) => typeof e == "object" && e.uid).reverse().forEach((e) => {
								let n = t.find((t) => t.uid === e.uid);
								n ? (n.qty += e.qty, n.price = e.price || n.price, (e.parentId !== n.parentId || e.sku !== n.sku) && (n.parentId = e.parentId, n.sku = e.sku)) : t.unshift(e);
							}), this.storage.cart.set(t);
						}
					},
					remove: (e) => {
						if (e.length) {
							let t = [...this.storage.cart.get()];
							e.forEach((e) => {
								let n = t.find((t) => t.uid === e.uid);
								n && n.qty > 0 && (n.qty -= e.qty || 1, (e.parentId !== n.parentId || e.sku !== n.sku) && (n.parentId = e.parentId, n.sku = e.sku));
							});
							let n = t.filter((e) => e.qty > 0);
							this.storage.cart.set(n);
						}
					},
					clear: () => {
						this.storage.cart.set([]);
					}
				},
				viewed: {
					get: () => {
						let e = this.getLocalStorageItem(Zg);
						if (e) try {
							if (Array.isArray(e)) return e;
						} catch {
							Rg(Zg), this.setCookie(Zg, "", "Lax", Vg, Gg);
						}
						else return this.getCookie(Zg).split(",").filter((e) => e).map((e) => ({
							parentId: e,
							uid: e,
							sku: e
						}));
						return [];
					},
					set: (e) => {
						let t = this.storage.viewed.get(), n = e.map((e) => ({
							sku: e.sku,
							parentId: e.parentId,
							uid: e.uid
						})).slice(0, Ug), r = JSON.stringify(n);
						try {
							this.setLocalStorageItem(Zg, n);
						} catch (e) {
							zg(e, this, Zg, r);
						}
						let i = n.map((e) => this.getProductId(e)).join(",");
						this.setCookie(Zg, i, "Lax", Vg, Gg), JSON.stringify(t) !== r && this._sendPreflight();
					},
					add: (e) => {
						if (e.length) {
							let t = this.storage.viewed.get();
							e.forEach((e) => {
								let n = {
									sku: e.sku,
									parentId: e.parentId,
									uid: e.uid
								}, r = t.find((e) => e.uid === n.uid);
								if (r) {
									let e = t.indexOf(r);
									t.splice(e, 1);
								}
								t.unshift(n);
							}), this.storage.viewed.set(t);
						}
					}
				}
			}, this.events = {
				shopper: { login: (e) => {
					let t = this.getContext();
					if (!t.shopperId || t.shopperId !== e.data.id) {
						this.setShopperId(e.data.id);
						return;
					}
					if (t.shopperId = e.data?.id, e.data?.id) {
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							shopperLoginSchema: { context: t }
						}, r = this.createRequest("shopper", "login", n);
						this.queueRequest(r);
					}
				} },
				autocomplete: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteClickthrough", t);
						this.sendRequests([n]);
					},
					redirect: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							redirectSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("autocomplete", "autocompleteRedirect", t);
						this.sendRequests([n]);
					}
				},
				search: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchClickthrough", t);
						this.sendRequests([n]);
					},
					redirect: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							redirectSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("search", "searchRedirect", t);
						this.sendRequests([n]);
					}
				},
				category: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							renderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							impressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							addtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							clickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("category", "categoryClickthrough", t);
						this.sendRequests([n]);
					}
				},
				bundles: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesRenderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							bundlesClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("bundles", "bundlesClickthrough", t);
						this.sendRequests([n]);
					}
				},
				chat: {
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatClickthrough", t);
						this.sendRequests([n]);
					},
					feedback: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							chatFeedbackSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("chat", "chatFeedback", t);
						this.sendRequests([n]);
					}
				},
				recommendations: {
					render: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsRenderSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsRender", t);
						this.queueRequest(n);
					},
					impression: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsImpressionSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsImpression", t);
						this.queueRequest(n);
					},
					addToCart: (e) => {
						e.data.results && this.storage.cart.add(e.data.results);
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsAddtocartSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsAddtocart", t);
						this.queueRequest(n);
					},
					clickThrough: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							recommendationsClickthroughSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("recommendations", "recommendationsClickthrough", t);
						this.sendRequests([n]);
					}
				},
				product: { pageView: (e) => {
					let t = {
						siteId: e?.siteId || this.globals.siteId,
						productPageviewSchema: {
							context: this.getContext(),
							data: e.data
						}
					}, n = this.createRequest("product", "productPageview", t);
					this.sendRequests([n]);
					let r = e.data.result;
					this.storage.viewed.add([r]);
				} },
				cart: {
					add: (e) => {
						let t = { ...e.data };
						t.cart ? this.storage.cart.set(t.cart) : (t.results && this.storage.cart.add(t.results), t.cart = this.storage.cart.get());
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							cartSchema: {
								context: this.getContext(),
								data: t
							}
						}, r = this.createRequest("cart", "cartAdd", n);
						this.sendRequests([r]);
					},
					remove: (e) => {
						let t = { ...e.data };
						t.cart ? this.storage.cart.set(t.cart) : (t.results && this.storage.cart.remove(t.results), t.cart = this.storage.cart.get());
						let n = {
							siteId: e?.siteId || this.globals.siteId,
							cartSchema: {
								context: this.getContext(),
								data: t
							}
						}, r = this.createRequest("cart", "cartRemove", n);
						this.sendRequests([r]);
					}
				},
				order: { transaction: (e) => {
					let t = {
						siteId: e?.siteId || this.globals.siteId,
						orderTransactionSchema: {
							context: this.getContext(),
							data: e.data
						}
					}, n = this.createRequest("order", "orderTransaction", t);
					this.sendRequests([n]), this.storage.cart.clear();
				} },
				error: {
					shopifypixel: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							logSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("error", "logShopifypixel", t);
						this.sendRequests([n]);
					},
					snap: (e) => {
						let t = {
							siteId: e?.siteId || this.globals.siteId,
							logSchema: {
								context: this.getContext(),
								data: e.data
							}
						}, n = this.createRequest("error", "logSnap", t);
						this.sendRequests([n]);
					}
				}
			}, typeof e != "object" || typeof e.siteId != "string") throw Error("Invalid config passed to tracker. The \"siteId\" attribute must be provided.");
			this.config = {
				mode: "production",
				...t || {}
			}, this.config.mode && ["production", "development"].includes(this.config.mode) && (this.mode = this.config.mode);
			let n = this.config.apis?.fetch, r = `${e.siteId}`.trim().toLowerCase().startsWith("at") ? "athos" : "searchspring", i = r === "searchspring" ? "https://analytics.searchspring.net/beacon/v2" : void 0, a = new Sh({
				fetchApi: n,
				basePath: this.config.requesters?.beacon?.origin || i,
				headers: { "Content-Type": "text/plain" }
			});
			if (this.apis = {
				shopper: new Yh(a),
				autocomplete: new Oh(a),
				search: new qh(a),
				category: new Ph(a),
				recommendations: new Gh(a),
				bundles: new Ah(a),
				chat: new Ih(a),
				product: new Uh(a),
				cart: new Mh(a),
				order: new Vh(a),
				error: new Rh(a)
			}, this.initiator = this.config.initiator || `${r}/beaconjs/${Bg}`, this.globals = e, this.pageLoadId = this.getPageLoadId(), this.globals?.siteId) this.globals.siteId = `${this.globals.siteId}`.trim().toLowerCase();
			else throw Error("Beacon: No siteId found in globals. Beacon will not initialize.");
		}
		setCookie(e, t, n, r, i) {
			hg.cookies && Lg(e, this.globals.siteId).forEach((e) => {
				try {
					if (window.document.cookie = _g(e, t, n, r, i), Fg(e) == null || Fg(e) != t) {
						let i = "." + window.location.hostname;
						window.document.cookie = _g(e, t, n, r, i);
					}
				} catch (t) {
					console.error(`Failed to set '${e}' cookie:`, t);
				}
			});
		}
		getLocalStorageItem(e) {
			let t = Ig(e, this.globals.siteId);
			if (typeof window < "u" && hg.storage) {
				let e = "";
				for (let n of t) {
					let t = window.localStorage.getItem(n);
					if (t) {
						e = t;
						break;
					}
				}
				try {
					let n = JSON.parse(e);
					if (n && n.value) return n.value;
					t.forEach((e) => {
						window.localStorage.removeItem(e);
					});
				} catch {}
			}
		}
		setLocalStorageItem(e, t) {
			let n = Lg(e, this.globals.siteId);
			if (typeof window < "u" && hg.storage) try {
				let e = JSON.stringify({ value: t });
				n.forEach((t) => {
					window.localStorage.setItem(t, e);
				});
			} catch (t) {
				throw console.warn(`Something went wrong setting local storage item '${e}':`, t), t;
			}
		}
		getCookie(e) {
			let t = Ig(e, this.globals.siteId);
			for (let e of t) {
				let t = Fg(e);
				if (t) return t;
			}
			return "";
		}
		queueRequest(e) {
			this.requests.push(e), clearTimeout(this.batchIntervalTimeout), this.batchIntervalTimeout = setTimeout(() => {
				this.processRequests();
			}, 300);
		}
		updateContext(e, t) {
			if (t !== void 0) switch (e) {
				case Kg:
				case Jg:
				case Yg:
				case qg:
				case Qg:
					this[e] = t;
					break;
				case "pageUrl":
					this.config.href = t;
					break;
				case "userAgent":
					this.config.userAgent = t;
					break;
				case "dev": ["production", "development"].includes(t) && (this.mode = t);
			}
		}
		getContext() {
			let e = {
				userAgent: this.config.userAgent,
				timestamp: this.getTimestamp(),
				pageUrl: this.config.href || typeof window < "u" && window.location.href || "",
				userId: this.userId || this.getUserId(),
				sessionId: this.sessionId || this.getSessionId(),
				pageLoadId: this.pageLoadId,
				shopperId: this.shopperId || this.getShopperId(),
				initiator: this.initiator,
				dev: this.mode === "development" || void 0,
				attribution: this.attribution || this.getAttribution()
			};
			return this.currency.code && (e.currency = { ...this.currency }), e;
		}
		getStoredId(e, t) {
			let n = "", r = "";
			try {
				r = this.getCookie(e);
				let i = this.getLocalStorageItem(e);
				i.timestamp && new Date(i.timestamp).getTime() < Date.now() - t ? (n = this.generateId(), this.attribution = void 0) : n = i.value;
			} catch {}
			let i = {
				value: r || n || this.generateId(),
				timestamp: this.getTimestamp()
			};
			e === "userId" && (this.userId = i.value), e === Jg && (this.sessionId = i.value), this.setCookie(e, i.value, "Lax", Wg, Gg), this.setCookie(e, i.value, "Lax", t);
			try {
				this.setLocalStorageItem(e, i);
			} catch (t) {
				zg(t, this, e, i.value);
			}
			return i.value;
		}
		getPageLoadId() {
			if (this.pageLoadId) return this.pageLoadId;
			let e = this.generateId(), t = this.getLocalStorageItem(qg), n = this.config.href || typeof window < "u" && window.location.href || "";
			if (t) {
				let { href: r, value: i, timestamp: a } = t;
				r === n && i && a && new Date(a).getTime() > Date.now() - 1e4 && (e = i);
			}
			this.pageLoadId = e;
			try {
				this.setLocalStorageItem(qg, {
					href: n,
					value: e,
					timestamp: this.getTimestamp()
				});
			} catch (t) {
				zg(t, this, qg, e);
			}
			return e;
		}
		getUserId() {
			return this.userId || this.getStoredId("userId", Vg);
		}
		getSessionId() {
			return this.sessionId || this.getStoredId(Jg, Hg);
		}
		getShopperId() {
			try {
				let e = this.getCookie(Yg), t = this.getLocalStorageItem(Yg), n = e || (t ? "" + t : void 0);
				n && (this.shopperId = n);
			} catch {}
			return this.shopperId || "";
		}
		setShopperId(e) {
			if (!e) return;
			let t = this.getShopperId();
			this.shopperId = "" + e, this.setCookie(Yg, this.shopperId, "Lax", Vg, Gg);
			try {
				this.setLocalStorageItem(Yg, this.shopperId);
			} catch (e) {
				zg(e, this, Yg, this.shopperId);
			}
			t !== e && (this.events.shopper.login({ data: { id: this.shopperId } }), this._sendPreflight());
		}
		getAttribution() {
			let e = [], t = null;
			try {
				let e = new URL(this.config.href || typeof window < "u" && window.location.href || "");
				t = e.searchParams.get("athos_attribution") || e.searchParams.get("ss_attribution");
			} catch {}
			let n = this.getCookie(Qg) || this.getLocalStorageItem(Qg);
			if (n) try {
				typeof n == "string" ? e = JSON.parse(n) : Array.isArray(n) && (e = n);
			} catch {}
			if (t) try {
				let [n, r] = decodeURIComponent(t).split(":");
				n && r && !e.find((e) => e.type === n && e.id === r) && e.unshift({
					type: n,
					id: r
				});
			} catch {}
			if (e.length) {
				let t = JSON.stringify(e);
				this.setCookie(Qg, t, "Lax", Hg, Gg);
				try {
					this.setLocalStorageItem(Qg, e);
				} catch (e) {
					zg(e, this, Qg, t);
				}
				return this.attribution = e, [...e];
			}
		}
		generateId() {
			return kg();
		}
		getTimestamp() {
			return (/* @__PURE__ */ new Date()).toISOString();
		}
		setCurrency(e) {
			e && e.code && this.currency?.code !== e.code && (this.currency = e);
		}
		pageLoad() {
			return this.pageLoadId = this.generateId(), this.pageLoadId;
		}
		createRequest(e, t, n) {
			return {
				apiType: e,
				endpoint: t,
				payload: n
			};
		}
		getApiClient(e) {
			return this.apis[e];
		}
		sendRequests(e) {
			for (let t of e) this.getApiClient(t.apiType)[t.endpoint](t.payload, async ({ init: e }) => {
				let t = {
					...e.headers,
					...this.config.requesters?.beacon?.headers || {}
				}, n = t && "Content-Type" in t && t["Content-Type"] === "application/json";
				return {
					keepalive: this.mode === "production" || void 0,
					body: n ? e.body : JSON.stringify(e.body),
					headers: t
				};
			}).catch((e) => {
				this.mode === "development" && console.debug(e);
			});
		}
		processRequests() {
			let e = this.requests.reduce((e, t) => {
				let n = `${t.payload.siteId}||${t.endpoint}`;
				switch (t.endpoint) {
					case "recommendationsAddtocart": {
						let r = t.payload.recommendationsAddtocartSchema;
						n += Pg("recommendation", r), Ng(e, n, "recommendationsAddtocartSchema", t);
						break;
					}
					case "recommendationsImpression": {
						let r = t.payload.recommendationsImpressionSchema;
						n += Pg("recommendation", r), Ng(e, n, "recommendationsImpressionSchema", t);
						break;
					}
					case "bundlesAddtocart": {
						let r = t.payload.bundlesAddtocartSchema;
						n += Pg("bundle", r), Ng(e, n, "bundlesAddtocartSchema", t);
						break;
					}
					case "bundlesImpression": {
						let r = t.payload.bundlesImpressionSchema;
						n += Pg("bundle", r), Ng(e, n, "bundlesImpressionSchema", t);
						break;
					}
					case "chatAddtocart": {
						let r = t.payload.chatAddtocartSchema;
						n += Pg("chat", r), Ng(e, n, "chatAddtocartSchema", t);
						break;
					}
					case "chatImpression": {
						let r = t.payload.chatImpressionSchema;
						n += Pg("chat", r), Ng(e, n, "chatImpressionSchema", t);
						break;
					}
					case "searchAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Pg("search", r), Ng(e, n, "addtocartSchema", t);
						break;
					}
					case "searchImpression": {
						let r = t.payload.impressionSchema;
						n += Pg("search", r), Ng(e, n, "impressionSchema", t);
						break;
					}
					case "autocompleteAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Pg("autocomplete", r), Ng(e, n, "addtocartSchema", t);
						break;
					}
					case "autocompleteImpression": {
						let r = t.payload.impressionSchema;
						n += Pg("autocomplete", r), Ng(e, n, "impressionSchema", t);
						break;
					}
					case "categoryAddtocart": {
						let r = t.payload.addtocartSchema;
						n += Pg("category", r), Ng(e, n, "addtocartSchema", t);
						break;
					}
					case "categoryImpression": {
						let r = t.payload.impressionSchema;
						n += Pg("category", r), Ng(e, n, "impressionSchema", t);
						break;
					}
					case "login": {
						let r = t.payload.shopperLoginSchema;
						n += Pg("shopper", r), Ng(e, n, "shopperLoginSchema", t);
						break;
					}
					default: e.nonBatched.push(t);
				}
				return e;
			}, {
				nonBatched: [],
				batches: {}
			});
			this.requests = [];
			let t = Object.values(e.batches).reduce((e, t) => (e.push(t), e), e.nonBatched);
			this.sendRequests(t);
		}
		_sendPreflight() {
			clearTimeout(this.preflightTimeout), this.preflightTimeout = setTimeout(() => {
				this.sendPreflight();
			}, 300);
		}
		sendPreflight(e) {
			let t = e?.userId || this.getUserId(), n = e?.siteId || this.globals.siteId, r = e?.shopper || this.getShopperId(), i = e?.cart || this.storage.cart.get(), a = e?.lastViewed || this.storage.viewed.get();
			if (t && typeof t == "string" && n) {
				let e = {
					userId: t,
					siteId: n
				};
				r && (e.shopper = r), i.length && (e.cart = i.map((e) => this.getProductId(e))), a.length && (e.lastViewed = a.map((e) => this.getProductId(e)));
				let o = `${n}`.toLowerCase().startsWith("at") ? "athoscommerce.net" : "searchspring.io", s = `${this.config.requesters?.personalization?.origin || `https://${n}.a.${o}`}/v1/preflight`;
				(this.config.apis?.fetch || typeof fetch < "u") && (this.config.apis?.fetch || fetch)(s, {
					method: "POST",
					headers: {
						"Content-Type": "text/plain",
						...this.config.requesters?.personalization?.headers || {}
					},
					body: JSON.stringify(e),
					keepalive: !0
				});
			}
		}
		getProductId(e) {
			return `${e.sku || e.uid || ""}`.trim();
		}
	};
})), n_ = o((() => {
	gh(), Zh(), Dh(), t_();
})), r_, i_, a_, o_ = o((() => {
	r_ = /* @__PURE__ */ u(ji()), W(), n_(), i_ = {
		id: "track",
		framework: "snap",
		mode: U.production
	}, a_ = class extends e_ {
		constructor(e, t) {
			if (t = (0, r_.default)(i_, t || {}), t.initiator || (t.initiator = `athos/${t.framework}/${gu}`), typeof e != "object" || typeof e.siteId != "string") throw Error("Invalid config passed to tracker. The \"siteId\" attribute must be provided.");
			super(e, t), this.targeters = [], this.track = {
				error: (e, t) => {
					if (this.doNotTrack?.includes("error") || this.mode === U.development || !e?.stack && !e?.message) return;
					let { stack: n, message: r, ...i } = e, { pageUrl: a } = this.getContext();
					r?.includes("Profile is currently paused") || a.includes("//localhost") || a.includes("//snapui.searchspring.io/") || a.includes("//snapui.athoscommerce.io/") || this.events.error.snap({
						data: {
							message: r || "unknown",
							stack: n,
							details: i
						},
						siteId: t
					});
				},
				shopper: { login: (e, t) => {
					this.doNotTrack?.includes("shopper.login") || this.events.shopper.login({
						data: { id: e.id },
						siteId: t
					});
				} },
				product: {
					view: (e, t) => {
						if (this.doNotTrack?.includes("product.view")) return;
						let n = { result: {
							parentId: e.parentId || e.uid || "",
							uid: e.uid || e.parentId || e.sku || "",
							sku: e.sku
						} };
						(e.childSku || e.childUid) && (n = { result: {
							parentId: e.parentId || e.uid || e.childUid || "",
							uid: e.childUid || e.uid || "",
							sku: e.childSku || e.sku
						} }), this.events.product.pageView({
							data: n,
							siteId: t
						});
					},
					click: () => {
						console.warn("tracker.track.product.click() is deprecated and is no longer functional. Use tracker.events['search' | 'category'].clickThrough() instead"), this.events.error.snap({ data: { message: "tracker.track.product.click was called" } });
					}
				},
				cart: { view: () => {
					console.warn("tracker.cart.view is deprecated and no longer functional. Use tracker.events.cart.add() and tracker.events.cart.remove() instead"), this.events.error.snap({ data: { message: "tracker.track.cart.view was called" } });
				} },
				order: { transaction: (e, t) => {
					if (this.doNotTrack?.includes("order.transaction")) return;
					let n = e.order, r = e.items, i = {
						orderId: `${n?.id || ""}`,
						transactionTotal: Number(n?.transactionTotal || 0),
						total: Number(n?.total || 0),
						city: n?.city,
						state: n?.state,
						country: n?.country,
						results: r.map((e) => ({
							parentId: e.parentId || e.uid || "",
							uid: e.uid || e.parentId || e.sku || "",
							sku: e.sku,
							qty: Number(e.qty),
							price: Number(e.price)
						}))
					};
					this.events.order.transaction({
						data: i,
						siteId: t
					});
				} }
			}, this.cookies = {
				cart: {
					get: () => this.storage.cart.get().map((e) => this.getProductId(e)),
					set: (e) => {
						let t = e.map((e) => `${e}`.trim()), n = Array.from(new Set(t)).map((e) => ({
							parentId: e,
							uid: e,
							sku: e,
							price: 0,
							qty: 1
						}));
						this.storage.cart.set(n);
					},
					add: (e) => {
						if (e.length) {
							let t = e.map((e) => `${e}`.trim()).map((e) => ({
								parentId: e,
								uid: e,
								sku: e,
								price: 0,
								qty: 1
							}));
							this.storage.cart.add(t);
						}
					},
					remove: (e) => {
						if (e.length) {
							let t = e.map((e) => `${e}`.trim()).map((e) => ({
								parentId: e,
								uid: e,
								sku: e,
								price: 0,
								qty: 1
							}));
							this.storage.cart.remove(t);
						}
					},
					clear: () => {
						this.storage.cart.clear();
					}
				},
				viewed: { get: () => this.storage.viewed.get().map((e) => this.getProductId(e)) }
			}, this.config = t, this.doNotTrack = this.config.doNotTrack || [], Object.values(U).includes(this.config.mode) && (this.mode = this.config.mode), this.localStorage = new bu({
				type: "local",
				key: `athos-${this.config.id}`
			}), this.localStorage.set("siteId", this.globals.siteId);
			let n = this.globals?.currency;
			n && this.setCurrency(n), window.athos?.tracker || (window.athos = window.athos || {}, window.athos.tracker = this, window.athos.version = gu), setTimeout(() => {
				this.targeters.push(new Il([{
					selector: "script[type^=\"athos/track/\"], script[type^=\"searchspring/track/\"]",
					emptyTarget: !1
				}], (e, t) => {
					let { item: n, items: r, siteId: i, shopper: a, order: o, type: s, currency: c } = Yl([
						"item",
						"items",
						"siteId",
						"shopper",
						"order",
						"type",
						"currency"
					], t);
					switch (this.setCurrency(c), s) {
						case "searchspring/track/shopper/login":
						case "athos/track/shopper/login":
							this.track.shopper.login(a, i);
							break;
						case "searchspring/track/product/view":
						case "athos/track/product/view":
							this.track.product.view(n, i);
							break;
						case "searchspring/track/cart/view":
						case "athos/track/cart/view":
							this.track.cart.view();
							break;
						case "searchspring/track/order/transaction":
						case "athos/track/order/transaction":
							this.track.order.transaction({
								order: o,
								items: r
							}, i);
							break;
						default: console.error(`event '${s}' is not supported`);
					}
				}));
			});
			let r = this.globals.cart;
			if (Array.isArray(r)) {
				if (r.length === 0) {
					let e = this.storage.cart.get();
					e.length && this.events.cart.remove({ data: {
						results: e,
						cart: []
					} }), this.storage.cart.clear();
				} else if (r.length) {
					let e = r.filter((e) => typeof e == "object" && (e.parentId || e.uid || e.sku) && e.qty !== void 0 && e.price !== void 0).map((e) => ({
						parentId: e.parentId || e.uid,
						uid: e.uid,
						sku: e.sku,
						price: e.price,
						qty: e.qty
					}));
					e.length || this.events.error.snap({ data: {
						message: "cart globals missing properties",
						details: { cart: r }
					} });
					let t = this.storage.cart.get(), n = [], i = [];
					!t?.length && e.length ? n.push(...e) : e.length && (e.forEach((e) => {
						let r = t.find((t) => t.parentId === e.parentId && t.uid === e.uid && t.sku === e.sku);
						if (!r) n.push(e);
						else if (r) {
							e.qty > r.qty ? n.push({
								...e,
								qty: e.qty - r.qty
							}) : e.qty < r.qty && i.push({
								...r,
								qty: r.qty - e.qty
							});
							let a = t.indexOf(r);
							a !== -1 && t.splice(a, 1);
						}
					}), t.length && i.push(...t)), n.length && this.events.cart.add({ data: {
						results: n,
						cart: e
					} }), i.length && this.events.cart.remove({ data: {
						results: i,
						cart: e
					} });
				}
			}
		}
		getGlobals() {
			return JSON.parse(JSON.stringify(this.globals));
		}
		retarget() {
			this.targeters.forEach((e) => {
				e.retarget();
			});
		}
	};
})), s_ = o((() => {})), c_ = o((() => {
	o_(), s_();
})), l_, u_ = o((() => {
	H(), l_ = class {
		constructor(e) {
			this.custom = {}, this.loading = !1, this.loaded = !1, this.config = e, F(this, {
				custom: R,
				loading: R,
				loaded: R,
				config: R
			});
		}
		setConfig(e) {
			this.config = e;
		}
		toJSON(e = this) {
			return ss(e);
		}
	};
})), d_, f_, p_, m_ = o((() => {
	(function(e) {
		e.HEADER = "header", e.BANNER = "banner", e.FOOTER = "footer", e.LEFT = "left", e.INLINE = "inline";
	})(d_ ||= {}), f_ = class {
		constructor(e) {
			this.redirect = "", this.responseId = "", this.content = {}, this.campaigns = [], this.personalized = !1, this.experiments = [];
			let { merchandising: t } = e?.data?.search || {};
			t && (this.redirect = t.redirect || "", this.responseId = e?.data?.search?.tracking?.responseId || e?.data?.tracking?.responseId || "", t.content && Object.values(d_).forEach((e) => {
				if (t.content && t.content[e]) {
					let n = t.content[e]?.[0] || "", r = typeof n == "string" && n.match(/data-banner-id="(\d+)"/), i = r ? r[1] : "";
					this.content[e] = new p_([{
						value: t.content[e],
						uid: i,
						responseId: this.responseId
					}]);
				}
			}), t.campaigns && (this.campaigns = t.campaigns, t.campaigns.forEach((e) => {
				e.type == "landing-page" && (this.landingPage = e);
			})), t.experiments && (this.experiments = t.experiments), this.personalized = !!t.personalized);
		}
	}, p_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			super(...e);
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Search/Stores/SearchFacetStore.js
function h_(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var g_, __, v_, y_, b_, x_, S_, C_, w_ = o((() => {
	g_ = /* @__PURE__ */ u(ji()), H(), __ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = e?.config || {}, { services: n, stores: r, data: i } = e || {}, { search: a, meta: o } = i || {}, { facets: s, merchandising: c, pagination: l } = a || {}, { storage: u } = r || {}, d = s?.filter((e) => {
				let n = e.field && o.facets && o.facets[e.field];
				if (!n || n.display == "slider" && e.type !== "range" || e.type == "range" && n.display !== "slider") return !1;
				let r = t.settings?.facets?.fields && e.field && t.settings?.facets?.fields[e.field];
				if (typeof r?.trim == "boolean" ? r?.trim : t.settings?.facets?.trim) {
					if (e.type === "range" && e?.range?.low == e?.range?.high || e.values?.length == 0) return !1;
					if (!e.filtered && e.values?.length == 1) return c?.content?.inline ? e.values[0].count + c.content?.inline.length != l.totalResults : e.values[0].count != l.totalResults;
				}
				return !0;
			}).map((e) => {
				let r = e.field && o.facets && o.facets[e.field], i = (0, g_.default)({
					...t.settings?.facets,
					fields: void 0
				}, t.settings?.facets?.fields && e.field && t.settings?.facets?.fields[e.field] || {});
				switch (delete i.fields, e.type) {
					case "range": return new y_(n, u, e, r || {}, i);
					default: return new b_(n, u, e, r || {}, i);
				}
			}) || [];
			super(...d);
		}
	}, v_ = class {
		constructor(e, t, n, r, i) {
			this.filtered = !1, this.custom = {}, this.collapsed = !1, this.display = "", this.label = "", this.services = e, this.storage = t, Object.assign(this, r, n), F(this, {
				type: R,
				field: R,
				filtered: R,
				custom: R,
				collapsed: R,
				display: R,
				label: R,
				clear: z,
				toggleCollapse: Yc
			});
			let a = this.storage.get(`facets.${this.field}.collapsed`);
			this.collapsed = a ?? this.collapsed, this.filtered && this.collapsed && a === void 0 && i.autoOpenActive && this.toggleCollapse();
		}
		get clear() {
			return { url: this.services.urlManager.remove("page").remove(`filter.${this.field}`) };
		}
		toggleCollapse() {
			this.collapsed = !this.collapsed, this.storage.set(`facets.${this.field}.collapsed`, this.collapsed);
		}
	}, y_ = class extends v_ {
		constructor(e, t, n, r, i) {
			super(e, t, n, r, i), this.range = {
				low: 0,
				high: 0
			}, this.active = {
				low: 0,
				high: 0
			}, this.step = n?.step;
			let a = i.storeRange && this.storage.get(`facets.${this.field}.range`);
			a && n.filtered && (n.range?.low > a.low || n.range?.high < a.high) ? this.range = this.storage.get(`facets.${this.field}.range`) : (this.storage.set(`facets.${this.field}.range`, n.range), this.range = n.range), this.active = n.active || n.range, this.formatSeparator = r?.formatSeparator || "-", this.formatValue = r?.formatValue || "%01.2f", F(this, {
				step: R,
				range: R,
				active: R,
				formatSeparator: R,
				formatValue: R
			});
		}
		get filteredCount() {
			return Number(this.filtered);
		}
	}, b_ = class extends v_ {
		constructor(e, t, n, r, i) {
			super(e, t, n, r, i), this.values = [], this.search = { input: "" }, this.overflow = {
				enabled: !1,
				limited: !0,
				limit: 0,
				remaining: void 0,
				setLimit: function(e) {
					e != this.limit && (this.enabled = !0, this.limit = e, this.calculate());
				},
				toggle: (e) => {
					e === void 0 ? this.overflow.limited = !this.overflow.limited : this.overflow.limited = e, this.storage.set(`facets.${this.field}.overflow.limited`, this.overflow.limited), this.overflow.calculate();
				},
				calculate: () => {
					if (this.overflow.limit > 0) {
						let e = this.values.length - this.overflow.limit;
						e > 0 && !this.search.input ? (this.overflow.enabled = !0, this.overflow.limited ? this.overflow.remaining = e : this.overflow.remaining = 0) : this.overflow.enabled = !1;
					}
				}
			}, this.multiple = this.multiple, this.values = n.values && n.values.map((t) => {
				switch (n.type) {
					case "value":
						if (r.display === "hierarchy") {
							let r = n?.values?.filter((e) => e.filtered) || [];
							return new S_(e, this, t, r);
						}
						return t.value = t?.value?.toString(), new x_(e, this, t);
					case "range-buckets": return new C_(e, this, t);
				}
			}) || [], i.pinFiltered && r.display !== "hierarchy" && this.values.sort((e, t) => Number(t.filtered) - Number(e.filtered));
			let a = this.storage.get(`facets.${this.field}.overflow.limited`);
			a !== void 0 && this.overflow.toggle(a), F(this, {
				values: R,
				search: R,
				multiple: R,
				overflow: R,
				refinedValues: z
			}), Wo(() => this.search.input, () => {
				this.overflow.calculate();
			});
		}
		get filteredCount() {
			return this.values.filter((e) => e?.filtered).length;
		}
		get refinedValues() {
			let e = this.values || [];
			if (this.search.input) {
				let t = new RegExp(h_(this.search.input), "i");
				e = this.values.filter((e) => String(e?.label || "").match(t));
			}
			return this.overflow.enabled && this.overflow.limited && (e = e.slice(0, this.overflow.limit)), e;
		}
	}, x_ = class {
		constructor(e, t, n) {
			if (Object.assign(this, n), this.filtered) this.url = e.urlManager.remove("page").remove(`filter.${t.field}`, n.value);
			else {
				let r = e.urlManager.remove("page");
				t.multiple == "single" && (r = r?.remove(`filter.${t.field}`)), this.url = r?.merge(`filter.${t.field}`, n.value);
			}
		}
	}, S_ = class extends x_ {
		constructor(e, t, n, r) {
			if (super(e, t, n), this.level = 0, this.history = !1, n.value && t.hierarchyDelimiter && (this.level = n.value.split(t.hierarchyDelimiter).length), t.filtered && r?.length) {
				let e = t?.hierarchyDelimiter && r[0].value?.split(t.hierarchyDelimiter).length;
				e && this.level <= e && (this.history = !0);
			}
			this.url = n.value ? e.urlManager.remove("page").set(`filter.${t.field}`, n.value) : e.urlManager.remove("page").remove(`filter.${t.field}`);
		}
	}, C_ = class {
		constructor(e, t, n) {
			if (Object.assign(this, n), this.filtered) this.url = e.urlManager.remove("page").remove(`filter.${t.field}`, [{
				low: this.low,
				high: this.high
			}]);
			else {
				let n = e.urlManager.remove("page");
				t.multiple == "single" && (n = n?.remove(`filter.${t.field}`)), this.url = n?.merge(`filter.${t.field}`, [{
					low: this.low,
					high: this.high
				}]);
			}
		}
	};
})), T_, E_, D_, O_ = o((() => {
	H(), W(), T_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { services: t, data: n, config: r } = e || {}, { search: i, meta: a } = n || {}, { filters: o } = i || {}, s = o?.map((e) => {
				let n = e.field, i = a.facets && a.facets[n];
				switch (e.type) {
					case "range":
						let n = e, a = r?.settings?.filters?.fields?.[e.field]?.rangeFormatValue || r?.settings?.filters?.rangeFormatValue;
						return a && (n.label = Eu(a, n.value?.low, n.value?.high)), new D_(t, n, i);
					default: return new E_(t, e, i);
				}
			}) || [];
			super(...s);
		}
	}, E_ = class {
		constructor(e, t, n) {
			this.facet = {
				field: t.field,
				label: n?.label || t.field
			}, this.value = {
				value: t.value,
				label: t.label
			}, this.label = `${this.facet.label}: ${this.value.label}`, this.url = e?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, this.value.value), F(this, {
				facet: R,
				value: R,
				label: R
			});
		}
	}, D_ = class {
		constructor(e, t, n) {
			this.facet = {
				field: t.field,
				label: n?.label || t.field
			}, this.value = {
				low: t?.value?.low,
				high: t?.value?.high,
				label: t.label || `${t?.value?.low} - ${t?.value?.high}`
			}, this.label = `${this.facet.label}: ${this.value.label}`, this.url = e?.urlManager?.remove("page").remove(`filter.${this.facet.field}`, {
				low: this.value.low,
				high: this.value.high
			}), F(this, {
				facet: R,
				value: R,
				label: R
			});
		}
	};
})), k_, A_, j_, M_ = o((() => {
	H(), k_ = class {
		constructor(e) {
			let { services: t, data: n, config: r } = e || {}, { search: i, meta: a } = n || {}, { pagination: o } = i || {}, s = r?.settings?.pagination;
			this.services = t, this.controllerConfig = r, this.page = o?.page, this.pageSize = o?.pageSize, this.totalResults = o?.totalResults, this.defaultPageSize = a?.pagination?.defaultPageSize, this.totalPages = o?.totalPages;
			let c = s?.pageSizeOptions || [
				{
					label: `Show ${this.defaultPageSize}`,
					value: this.defaultPageSize
				},
				{
					label: `Show ${this.defaultPageSize * 2}`,
					value: this.defaultPageSize * 2
				},
				{
					label: `Show ${this.defaultPageSize * 3}`,
					value: this.defaultPageSize * 3
				}
			];
			this.pageSizeOptions = c.filter((e) => e.value <= 100).map((e) => new A_(this.services, this.pageSize, {
				label: e.label,
				value: e.value
			})), this.pageSizeOption = this.pageSizeOptions.find((e) => e.active), F(this, {
				page: R,
				pageSize: R,
				totalResults: R,
				totalPages: R,
				begin: z,
				end: z,
				multiplePages: z,
				current: z,
				first: z,
				last: z,
				next: z,
				previous: z,
				getPages: Yc,
				setPageSize: Yc
			});
		}
		get begin() {
			return this.controllerConfig?.settings?.infinite?.enabled ? 1 : this.pageSize * (this.page - 1) + 1;
		}
		get end() {
			return this.pageSize * this.page > this.totalResults ? this.totalResults : this.pageSize * this.page;
		}
		get multiplePages() {
			return this.pageSize < this.totalResults;
		}
		get current() {
			return new j_(this.services, {
				number: this.page,
				active: !0
			});
		}
		get first() {
			return new j_(this.services, {
				number: 1,
				active: this.page == 1
			});
		}
		get last() {
			return new j_(this.services, {
				number: this.totalPages,
				active: this.totalPages == this.page
			});
		}
		get next() {
			if (this.page < this.totalPages) return new j_(this.services, { number: this.page + 1 });
		}
		get previous() {
			if (this.page > 1) return new j_(this.services, { number: this.page - 1 });
		}
		getPages(e = 5, t) {
			if (!Number.isInteger(e)) return [];
			if (t === void 0 || !Number.isInteger(t)) {
				let n = e - 1, r = this.page, i = this.page, a = i - r;
				do {
					if (a = i - r, i < this.totalPages && i++, i - r >= n) break;
					r > 1 && r--;
				} while (a != i - r && i - r < n);
				e = r - this.page, t = i - this.page;
			} else e = -Math.abs(e), t = Math.abs(t);
			let n = [];
			for (let r = this.page + e; r <= this.page + t; r++) r > 0 && r <= this.totalPages && n.push(new j_(this.services, {
				number: r,
				active: r == this.page
			}));
			return n;
		}
		setPageSize(e) {
			e !== void 0 && this.services.urlManager.remove("page").set("pageSize", e).go();
		}
	}, A_ = class {
		constructor(e, t, n) {
			this.services = e, this.value = n.value, this.label = n.label, this.url = this.services?.urlManager.remove("page").set("pageSize", n.value), this.active = t == n.value;
		}
	}, j_ = class {
		constructor(e, t) {
			this.services = e, this.number = t.number, this.active = t.active || !1, this.url = this.services?.urlManager?.set("page", this.number), this.key = this.url.href;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Search/Stores/SearchResultStore.js
function N_(e, t, n, r) {
	let i = [...t], a = r.pageSize * (r.page - 1) + 1, o = r.pageSize * r.page;
	e?.settings?.infinite?.enabled && (a = 1), r.pageSize * r.page > r.totalResults && (o = r.totalResults);
	let s = n.filter((e) => !i.some((t) => t.id == e.id)), c = s.filter((e) => {
		let t = e.config.position.index;
		return t >= a - 1 && t <= o - 1;
	}), l = s.filter((e) => e.config.position.index >= r.totalResults);
	return c.forEach((e) => {
		let t = e.config.position.index - (a - 1);
		i.splice(t, 0, e);
	}), l.forEach((e, t) => {
		let n = r.totalResults - (l.length - t);
		n >= a - 1 && n <= o - 1 && i.splice(n, 0, e);
	}), e?.settings?.infinite && i.forEach((e, t) => {
		if (e.type === "banner") {
			let n = r.pageSize, a = (Math.floor(t / n) + 1 - 1) * n, o = a + n - 1;
			for (let t = a; t < o; t++) if (i[t].type === "product") {
				e.responseId = i[t].responseId;
				break;
			}
		}
	}), i;
}
function P_(e, t, n) {
	let r = {}, i = e.getAttribute(L_);
	if (i) {
		let [a, o] = i.split(":");
		!a || !o ? console.error("Error!: realtime variant is missing option or value (option:value)!", e, i) : (r[a.toLowerCase()] = [o.toLowerCase()], F_(t, r, n));
	}
}
function F_(e, t, n) {
	let r = n;
	e.realtime?.filters?.forEach((e) => {
		e == "first" && (r = [r[0]]), e == "unaltered" && (r = r.filter((e) => !e.variants?.selections.some((e) => e.previouslySelected)));
	}), r.forEach((e) => {
		e.type == "product" && e.variants?.makeSelections(t);
	});
}
var I_, L_, R_, z_, B_, V_, H_, U_, W_, G_, K_, q_ = o((() => {
	H(), I_ = /* @__PURE__ */ u(ji()), Pi(), L_ = "ss-variant-option", R_ = "ss-variant-option-selected", z_ = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { config: t, data: n, state: r, stores: i } = e || {}, { search: a, meta: o, previousSearch: s } = n || {}, { results: c, merchandising: l, pagination: u } = a || {}, { previousResults: d } = i || {}, { loaded: f } = r || {}, p = (c || []).map((n, r) => new V_({
				config: t,
				data: {
					result: n,
					meta: o
				},
				position: r + 1,
				responseId: e.data.search?.tracking?.responseId || ""
			})), m = t?.settings?.variants;
			if (m?.realtime?.enabled) {
				if (!f && p?.length) {
					let e = /* @__PURE__ */ new Set();
					document.querySelectorAll(`[${L_}]`).forEach((t) => {
						if (t.tagName == "OPTION") {
							let n = t.closest("select");
							n ? e.has(n) || (e.add(n), n.addEventListener("change", (e) => {
								let t = e.target?.value, r = Array.from(n.querySelectorAll(`[${L_}]`)).filter((e) => e.value == t);
								r.length > 0 && P_(r[0], m, p);
							})) : console.warn("Warning: unable to add realtime variant event listener for element - ", t);
						} else t.addEventListener("click", () => {
							P_(t, m, p);
						});
					});
				}
				if (p.length) {
					let e = {};
					document.querySelectorAll(`[${R_}]`).forEach((t) => {
						let n = t.getAttribute(L_);
						if (n) {
							let [t, r] = n.split(":");
							t && r && (e[t.toLowerCase()] = [r.toLowerCase()]);
						}
					}), F_(m, e, p);
				}
			}
			if (t?.settings?.infinite?.enabled && d && u?.page && s?.pagination?.page && u.page == s.pagination.page + 1 && (p = (d || []).concat(p)), u && l?.content?.inline) {
				let n = l.content.inline.sort(function(e, t) {
					return e.config.position.index - t.config.position.index;
				}).map((t) => new B_({ data: {
					banner: t,
					responseId: e.data.search?.tracking?.responseId || ""
				} }));
				n && u.totalResults && (p = N_(t, p, n, u));
			}
			super(...p);
		}
	}, B_ = class {
		constructor(e) {
			this.type = "banner", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {};
			let { banner: t, responseId: n } = e?.data || {}, r = t.value, i = typeof r == "string" && r.match(/data-banner-id="(\d+)"/), a = i ? i[1] : "ss-ib-" + t.config.position.index;
			this.id = a, this.responseId = n, this.config = t.config, this.value = t.value, F(this, {
				id: R,
				mappings: R,
				attributes: R,
				custom: R,
				state: R
			});
		}
	}, V_ = class {
		constructor(e) {
			this.type = "product", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {}, this.quantity = 1, this.mask = new U_();
			let { config: t } = e || {}, { result: n, meta: r } = e?.data || {};
			this.id = n.id, this.attributes = n.attributes, this.mappings = n.mappings, this.position = e.position, this.badges = new H_({ data: {
				meta: r,
				result: n
			} }), this.responseId = n.responseId || e.responseId, n.bundleSeed && (this.bundleSeed = !!n.bundleSeed), n.variants && n.variants.data && (this.variants = new W_({
				data: {
					mask: this.mask,
					variants: n.variants.data,
					optionConfig: n.variants.optionConfig,
					preferences: n.variants?.preferences,
					meta: r
				},
				config: t?.settings?.variants
			})), F(this, {
				id: R,
				display: z,
				mappings: R,
				attributes: R,
				custom: R,
				state: R,
				quantity: R
			});
		}
		get display() {
			return (0, I_.default)({
				id: this.id,
				mappings: this.mappings,
				attributes: this.attributes,
				badges: this.badges
			}, this.mask.data, { isMergeableObject: Ni });
		}
	}, H_ = class {
		constructor(e) {
			this.all = [];
			let { data: t } = e || {}, { meta: n, result: r } = t || {};
			this.all = (r.badges || []).filter((e) => !!(e?.tag && n.badges?.tags && n.badges?.tags[e.tag] && n.badges?.tags[e.tag].enabled)).map((e) => {
				let t = n.badges?.tags?.[e.tag];
				return {
					...e,
					...t
				};
			}).sort((e, t) => e.priority - t.priority), F(this, {
				all: R,
				tags: z,
				locations: z
			});
		}
		atLocation(e) {
			let t = Array.isArray(e) ? e : [e];
			return this.all.filter((e) => t.some((t) => e.location.startsWith(`${t}/`) || e.location == t));
		}
		get tags() {
			return this.all.reduce((e, t) => (e[t.tag] = t, e), {});
		}
		get locations() {
			return this.all.reduce((e, t) => {
				let [n, r] = t.location.split("/");
				return e[n] = e[n] || {}, e[n][r] = (e[n][r] || []).concat(t), e;
			}, {});
		}
	}, U_ = class {
		constructor() {
			this.data = {}, F(this, { data: R });
		}
		merge(e) {
			JSON.stringify((0, I_.default)(this.data, e)) != JSON.stringify(this.data) && (this.data = (0, I_.default)(this.data, e));
		}
		set(e) {
			JSON.stringify(e) != JSON.stringify(this.data) && (this.data = e);
		}
		reset() {
			this.data = {};
		}
	}, W_ = class {
		constructor(e) {
			this.data = [], this.selections = [];
			let { config: t, data: n } = e || {}, { variants: r, mask: i, meta: a } = n || {}, o = e?.data?.preferences || {};
			this.setActive = (e) => {
				this.active = e;
				let t = new H_({ data: {
					meta: a,
					result: e
				} });
				i.set({
					mappings: this.active.mappings,
					attributes: this.active.attributes,
					badges: t,
					state: this.active.state,
					custom: this.active.custom
				});
			}, t && (this.config = t), n.optionConfig && (this.optionConfig = n.optionConfig), this.update(r, t, o);
		}
		update(e, t = this.config, n) {
			try {
				let r = [];
				this.data = e.filter((e) => this.config?.showDisabledSelectionValues || e.mappings.core?.available !== !1).map((e) => (e.mappings.core?.price && (e.mappings.core.price = Number(e.mappings.core?.price)), e.mappings.core?.msrp && (e.mappings.core.msrp = Number(e.mappings.core?.msrp)), e)).map((e) => (e.options && Object.keys(e.options).forEach((e) => {
					r.includes(e) || r.push(e);
				}), new K_({ data: { variant: e } }))), this.selections = [], r.map((e) => {
					let t = this.config?.options && this.config.options[e];
					this.selections.push(new G_({
						config: t,
						optionConfig: this.optionConfig?.[e],
						data: {
							variants: this,
							selectorField: e
						}
					}));
				});
				let i = {};
				n && Object.keys(n).forEach((e) => {
					i[e] = n[e];
				}), t?.options && Object.keys(t?.options).forEach((e) => {
					t.options[e].preSelected && (i[e] = t.options[e].preSelected);
				}), t?.autoSelect && this.makeSelections(i);
			} catch (e) {
				console.error(e, "Failed to update variants!");
			}
		}
		makeSelections(e) {
			!e || !Object.keys(e).length ? this.selections.forEach((e) => {
				let t = e.values.find((e) => e.available);
				t && e.select(t.value, !0);
			}) : this.selections.forEach((t, n) => {
				let r = t.values.filter((e) => n == 0 || e.available), i = e[t.field.toLowerCase()], a = t.selected || r[0];
				if (i) {
					let e = (e) => {
						let t = r.find((t) => t.value.toString().toLowerCase() == e?.toString().toLowerCase());
						t && (a = t);
					};
					Array.isArray(i) ? i.forEach((t) => {
						e(t);
					}) : e(i);
				}
				a && t.select(a.value, !0);
			});
		}
		refineSelections(e) {
			let t = [...this.selections];
			t.sort((t) => t.field == e.field ? 1 : -1), t.forEach((e) => e.refineValues(this));
			let n = this.selections.filter((e) => e.selected?.value?.length);
			if (n.length) {
				let e = this.data;
				for (let t of n) e = e.filter((e) => t.selected?.value == e.options[t.field]?.value && e.available);
				if (e.length == 1) {
					let t = e[0];
					this.selections.filter((e) => !e.selected).forEach((e) => {
						let n = e.field, r = t.options[n].value;
						e.select(r);
					}), this.setActive(t);
				}
			}
		}
	}, G_ = class {
		constructor(e) {
			this.selected = void 0, this.previouslySelected = void 0, this.values = [];
			let { data: t, config: n, optionConfig: r } = e || {}, { variants: i, selectorField: a } = t || {};
			this.field = a, this.type = r?.type, this.count = r?.count, this.label = n?.label || a, this.config = n || {}, this.variantsUpdate = () => i.refineSelections(this), this.refineValues(i), F(this, {
				selected: R,
				values: R
			});
		}
		refineValues(e) {
			let t = e.selections.filter((e) => e.field != this.field && e.selected), n = e.data.filter((e) => e.available);
			for (let e of t) n = n.filter((t) => e.selected?.value == t.options?.[e.field]?.value && t.available);
			let r = e.data.filter((e) => e.options[this.field]).reduce((t, r) => {
				if (!t.some((e) => r.options[this.field].value == e.value)) {
					let i = r.options[this.field].value, a = r.mappings.core?.thumbnailImageUrl, o = !e.data.filter((e) => e.available).some((e) => e.options[this.field].value === i), s = {
						value: i,
						label: i,
						thumbnailImageUrl: a,
						available: !!n.some((e) => e.options[this.field].value == r.options[this.field].value),
						disabled: o
					};
					if (this.config.thumbnailBackgroundImages ? s.backgroundImageUrl = a : r.options[this.field].backgroundImageUrl && (s.backgroundImageUrl = r.options[this.field].backgroundImageUrl), r.options[this.field].background && (s.background = r.options[this.field].background), this.config.mappings && this.config.mappings && this.config.mappings[i.toString().toLowerCase()]) {
						let e = this.config.mappings[i.toString().toLowerCase()];
						e.label && (s.label = e.label), e.background && (s.background = e.background), e.backgroundImageUrl && (s.backgroundImageUrl = e.backgroundImageUrl);
					}
					t.push(s);
				}
				return t;
			}, []);
			if (this.selected && !r.some((e) => e.value == this.selected?.value && e.available)) {
				if (this.selected !== this.previouslySelected && this.previouslySelected && r.some((e) => e.value == this.previouslySelected?.value && e.available)) this.select(this.previouslySelected.value, !0);
				else {
					let e = r.filter((e) => e.available);
					if (r.length && e.length) {
						let t = e[0].value;
						this.selected.value !== t && this.select(t, !0);
					}
				}
			}
			this.values = r;
		}
		reset() {
			this.selected = void 0, this.values.forEach((e) => e.available = !1);
		}
		select(e, t = !1) {
			let n = this.values.find((t) => t.value == e);
			n && (t || (this.previouslySelected = this.selected), this.selected = n, this.variantsUpdate());
		}
	}, K_ = class {
		constructor(e) {
			this.type = "variant", this.attributes = {}, this.mappings = { core: {} }, this.custom = {}, this.state = {};
			let { data: t } = e || {}, { variant: n } = t || {};
			this.attributes = n.attributes || {}, this.mappings = n.mappings, this.options = n.options, this.badges = n.badges || [], this.available = this.mappings.core?.available ?? !0, F(this, {
				attributes: R,
				mappings: R,
				custom: R,
				state: R,
				available: R
			});
		}
	};
})), J_, Y_, X_ = o((() => {
	H(), J_ = class {
		constructor(e) {
			this.options = [];
			let { services: t, data: n } = e || {}, { meta: r } = n || {}, { sorting: i, search: a } = n?.search || {};
			if (t && r.sortOptions) {
				let e = i?.length && i[0], n = (r.sortOptions || []).filter((e) => a?.query ? e : e.type == "field").map((n, r) => (n.active = !1, (e && e.field == n.field && String(e.direction) == String(n.direction) || !e && r === 0) && (n.active = !0), n.default = !1, r === 0 && (n.default = !0), new Y_(t, n, r)));
				this.options = n, F(this, {
					options: R,
					current: z
				});
			}
		}
		get current() {
			return this.options.filter((e) => e.active).pop();
		}
	}, Y_ = class {
		constructor(e, t, n) {
			this.active = t.active, this.default = t.default, this.field = t.field, this.label = t.label, this.direction = t.direction, this.type = t.type, this.value = `${t.label}:${t.field}:${t.direction}:${n}`, this.url = this.default ? e.urlManager.remove("page").remove("sort") : e.urlManager.remove("page").set("sort", [{
				field: this.field,
				direction: this.direction
			}]), F(this, {
				field: R,
				label: R,
				direction: R,
				type: R,
				value: R
			});
		}
	};
})), Z_, Q_, $_ = o((() => {
	H(), W(), Z_ = class {
		constructor(e) {
			let { services: t, data: n } = e || {}, { search: r } = n.search || {}, i = {};
			r?.query && (this.query = new Q_(t, r.query), i.query = R), r?.didYouMean && (this.didYouMean = new Q_(t, r.didYouMean), i.didYouMean = R), r?.originalQuery && (this.originalQuery = new Q_(t, r.originalQuery), i.originalQuery = R), r?.subject && (this.subject = new Q_(t, r.subject), i.subject = R), this.matchType = r?.matchType, i.matchType = R, F(this, i);
		}
	}, Q_ = class {
		constructor(e, t) {
			this.string = Gl(t), this.url = e?.urlManager?.remove("page").remove("filter").set("query", this.string), F(this, { string: R });
		}
	};
})), ev, tv = o((() => {
	W(), $_(), ev = class {
		constructor(e) {
			let { services: t, config: n } = e || {};
			this.config = n, this.services = t, this.max = this.config.settings?.history?.max ?? 25, this.config.settings?.history?.url && (this.services.urlManager = this.services.urlManager.withConfig((e) => ({
				...e,
				urlRoot: this.config.settings?.history?.url
			}))), this.storage = new bu({
				type: "local",
				key: `athos-history${this.config.globals?.siteId ? `-${this.config.globals?.siteId}` : ""}`
			}), this.max === 0 && this.reset(), this.queries.length > this.max && this.getStoredData().forEach((e, t) => {
				t > this.max - 1 && this.remove(e);
			});
		}
		get queries() {
			return this.getStoredData().map((e) => new Q_(this.services, e));
		}
		save(e) {
			if (this.max) {
				let t = this.getStoredData(), n = t.indexOf(e);
				n != -1 && t.splice(n, 1), t.unshift(e), t.length > this.max && t.pop(), this.storage.set("history", JSON.stringify(t));
			}
		}
		remove(e) {
			let t = this.getStoredData(), n = t.indexOf(e);
			n != -1 && (t.splice(n, 1), this.storage.set("history", JSON.stringify(t)));
		}
		reset() {
			this.storage.clear();
		}
		getStoredData(e) {
			let t = this.storage.get("history");
			if (t) try {
				let n = JSON.parse(t);
				if (Array.isArray(n)) return e && Number.isInteger(e) ? n.slice(0, e) : n;
			} catch {
				this.reset();
			}
			return [];
		}
	};
})), nv = o((() => {
	m_(), w_(), O_(), M_(), q_(), X_(), $_(), tv();
})), rv, iv = o((() => {
	nv(), rv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { services: t, state: n } = e || {}, r = new __({
				...e,
				services: {
					...t,
					urlManager: t.urlManager.remove("filter")
				}
			});
			r.forEach((e) => {
				e.values?.forEach((t) => {
					t.preview = () => {
						r.map((e) => {
							e.filtered = !1, e.values?.map((e) => {
								e.filtered = !1;
							});
						}), e.filtered = !0, t.filtered = !0, n?.autocomplete.locks.facets.lock(), t.url.go();
					};
				});
			}), super(...r);
		}
	};
})), av, ov, sv = o((() => {
	H(), av = class {
		constructor(e) {
			let { services: t, data: n } = e || {}, { search: r, autocomplete: i } = n?.autocomplete || {}, a = {};
			r?.query && (this.query = new ov(t.urlManager, r.query), a.query = R), i?.correctedQuery && (this.correctedQuery = new ov(t.urlManager, i.correctedQuery), a.correctedQuery = R), r?.subject && (this.subject = new ov(t.urlManager, r.subject), a.subject = R), this.matchType = r?.matchType, a.matchType = R, F(this, a);
		}
	}, ov = class {
		constructor(e, t) {
			this.string = t, this.url = e.set({ query: this.string }), F(this, { string: R });
		}
	};
})), cv, lv, uv = o((() => {
	H(), cv = class {
		constructor(e) {
			this.focusedInput = void 0, this.input = void 0, this.source = "input";
			let { services: t } = e || {};
			this.locks = {
				terms: new lv(!1),
				facets: new lv(!1)
			}, this.url = t.urlManager, F(this, {
				focusedInput: R,
				locks: R,
				input: R,
				reset: Yc
			});
		}
		reset() {
			this.input = void 0, this.locks.terms.reset(), this.locks.facets.reset();
		}
	}, lv = class {
		constructor(e = !1) {
			this.state = this.startState = e;
		}
		reset() {
			this.state = this.startState;
		}
		get locked() {
			return this.state;
		}
		lock() {
			this.state = !0;
		}
		unlock() {
			this.state = !1;
		}
	};
})), dv, fv, pv = o((() => {
	H(), dv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { data: t } = e || {}, { autocomplete: n, search: r } = t?.autocomplete || {}, i = [...(n?.alternatives ? n.alternatives : []).map((e) => e.text)];
			n?.correctedQuery && r?.query && n.correctedQuery.toLowerCase() != r.query.toLowerCase() && i.unshift(n.correctedQuery), r?.query && i.unshift(r.query);
			let a = [];
			i.map((t, n) => a.push(new fv({
				...e,
				data: {
					term: {
						active: n === 0,
						value: t
					},
					terms: a
				},
				functions: e.functions,
				state: e.state,
				type: "suggested"
			}))), super(...a);
		}
	}, fv = class {
		constructor(e) {
			let { services: t, functions: n, state: r, data: i, type: a } = e || {}, { term: o, terms: s } = i || {};
			this.active = o?.active, this.value = o?.value, this.type = a, this.url = t?.urlManager?.set({ query: this.value }), this.preview = () => {
				n.resetTerms(), s.map((e) => {
					e.active = !1;
				}), r.rootState.source = a, this.active = !0, r.rootState.locks.terms.lock(), r.rootState.locks.facets.unlock(), this.url?.set({ query: this.value }).go();
			}, F(this, {
				active: R,
				value: R
			});
		}
	};
})), mv, hv = o((() => {
	pv(), mv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = [], { data: n } = e || {}, { trending: r } = n?.trending || {};
			r?.queries?.map((n) => {
				t.push(new fv({
					...e,
					data: {
						term: {
							active: !1,
							value: n.searchQuery
						},
						terms: t
					},
					functions: e.functions,
					state: e.state,
					type: "popular"
				}));
			}), super(...t);
		}
	};
})), gv, _v = o((() => {
	pv(), gv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let { data: t } = e || {}, { queries: n } = t || {}, r = [];
			n?.map((t) => {
				r.push(new fv({
					...e,
					data: {
						term: {
							active: !1,
							value: t
						},
						terms: r
					},
					functions: e.functions,
					state: e.state,
					type: "historical"
				}));
			}), super(...r);
		}
	};
})), vv = o((() => {
	iv(), sv(), uv(), pv(), hv(), _v();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Meta/MetaStore.js
function yv(e, t) {
	return t ? yv(t, e % t) : e;
}
function bv(e, t) {
	let n = yv(e, t);
	return e * t / n;
}
var xv, Sv, Cv = o((() => {
	xv = class {
		constructor(e) {
			let { meta: t } = e?.data || {};
			this.data = t ?? {}, this.badges = new Sv(this.data);
		}
	}, Sv = class {
		constructor(e) {
			this.groups = {};
			let t = { overlay: { sections: ["left", "right"] } };
			Object.keys(t).map((n) => {
				let r = t[n], i = r.sections.map((t) => ({
					areas: e?.badges?.locations?.[t]?.map((e) => e.tag) || [],
					grid: []
				})), a = i.map((e) => e.areas.length).reduce(bv);
				i.forEach((e) => {
					e.grid = Array.from({ length: a }).map((t, n) => e.areas[Math.floor(n / (a / e.areas.length))]);
				});
				let o = Array.from({ length: a }).map((e, t) => i.map((e) => e.grid[t]));
				this.groups[n] = {
					sections: r.sections,
					grid: o
				};
			});
		}
	};
})), wv, Tv = o((() => {
	H(), W(), u_(), nv(), vv(), Cv(), wv = class extends l_ {
		constructor(e, t) {
			if (super(e), typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, this.state = new cv({ services: this.services }), this.storage = new bu(), this.trending = [], this.history = [], this.initHistory(), this.reset(), F(this, {
				state: R,
				search: R,
				terms: R,
				facets: R,
				filters: R,
				merchandising: R,
				results: R,
				pagination: R,
				sorting: R,
				history: R,
				trending: R
			});
		}
		get hasQuery() {
			return !!(this.state.input && this.loaded || this.search.query?.string);
		}
		reset() {
			this.state.reset(), this.update(), this.resetTerms();
		}
		initHistory() {
			let e = this.config.settings?.history?.limit;
			if (e && this.config.settings?.history?.enabled !== !1) {
				let t = new ev({
					services: this.services,
					config: {
						id: this.config.id,
						globals: this.config.globals
					}
				});
				this.history = new gv({
					services: this.services,
					functions: { resetTerms: () => {
						this.resetTerms();
					} },
					state: { rootState: this.state },
					data: { queries: t.getStoredData(e) }
				});
			} else this.history = [];
		}
		resetTerms() {
			this.resetSuggestions(), this.resetTrending(), this.resetHistory();
		}
		resetSuggestions() {
			this.terms?.forEach((e) => e.active = !1);
		}
		resetTrending() {
			this.trending?.forEach((e) => e.active = !1);
		}
		resetHistory() {
			this.history?.forEach((e) => e.active = !1);
		}
		setService(e, t) {
			this.services[e] && t && (this.services[e] = t, e === "urlManager" && (this.state.url = t, this.history?.forEach((e) => {
				e.url = t.set({ query: e.value });
			})));
		}
		updateTrendingTerms(e) {
			this.trending = new mv({
				services: this.services,
				functions: { resetTerms: () => {
					this.resetTerms();
				} },
				state: { rootState: this.state },
				data: { trending: e }
			});
		}
		update(e) {
			let { meta: t, search: n } = e || {};
			this.meta = new xv({ data: { meta: t } }), n?.search && (this.state.url = this.services.urlManager = this.services.urlManager.set("query", n.search.query)), this.state.locks.terms.locked || (this.terms = new dv({
				config: this.config,
				services: this.services,
				functions: { resetTerms: () => {
					this.resetTerms();
				} },
				state: { rootState: this.state },
				data: { autocomplete: n }
			}), n?.autocomplete && this.state.locks.terms.lock()), this.merchandising = new f_({ data: { search: n } }), this.search = new av({
				config: this.config,
				services: this.services,
				data: { autocomplete: n }
			}), this.state.locks.facets.locked || (this.facets = new rv({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				state: { autocomplete: this.state },
				data: {
					search: n,
					meta: this.meta.data
				}
			})), this.filters = new T_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.results = new z_({
				config: this.config,
				state: { loaded: this.loaded },
				data: {
					search: n,
					meta: this.meta.data
				}
			}), (this.results.length === 0 && !this.trending.filter((e) => e.active).length || this.terms?.filter((e) => e.active).length) && this.resetTrending(), this.pagination = new k_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.sorting = new J_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.error = void 0, this.loaded = !!n?.pagination;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-store-mobx/dist/esm/Finder/Stores/FinderSelectionStore.js
function Ev(e, t) {
	return `ss-finder-${e}.${t}`;
}
var Dv, Ov, kv, Av, jv = o((() => {
	Dv = class extends Array {
		static get [Symbol.species]() {
			return Array;
		}
		constructor(e) {
			let t = e.config, { services: n, data: r, stores: i, state: a } = e || {}, { storage: o } = i || {}, { search: s, meta: c, selections: l } = r || {}, { facets: u } = s || {}, d = [];
			l?.length ? t.fields.forEach((e) => {
				let r = l.find((t) => t.facet.field === e.field);
				if (r) {
					let { facet: s, selected: c } = r || {};
					if (s?.hierarchyDelimiter) l.forEach((r, c) => {
						let l = e?.levels || s?.values[s?.values.length - 1]?.value.split(s.hierarchyDelimiter), u = {
							index: c,
							label: e.levels ? l[c] : "",
							key: `ss-${c}`
						}, f = Ev(t.id, s.field);
						o.set(`${f}.${u.key}.values`, r.data), o.set(`${f}.${u.key}.selected`, r.selected);
						let p = new Av({
							config: u,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: s
							}
						});
						t.persist?.lockSelections && (p.disabled = !0), r.selected && (n.urlManager = n.urlManager.set(`filter.${r.facet.field}`, r.selected)), d.push(p);
					});
					else {
						let r = new kv({
							config: e,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: s
							}
						});
						r.selected = c, r.storage.set("selected", c), r.data = s.values, c && (n.urlManager = n.urlManager.set(`filter.${s.field}`, c)), t.persist?.lockSelections && (r.disabled = !0), d.push(r);
					}
				}
			}) : u && c && (t?.fields && u.sort((e, n) => {
				let r = t.fields.map((e) => e.field);
				return r.indexOf(e.field) - r.indexOf(n.field);
			}), t?.fields?.forEach((e) => {
				let r = u.filter((t) => t.field == e.field).pop();
				if (r = {
					...c?.facets && c.facets[e.field] || {},
					...r
				}, r?.display === "hierarchy") {
					let o = r.values?.filter((e) => e.filtered).pop();
					if (o) {
						let e = o.value?.split(r?.hierarchyDelimiter).length;
						r.values = r.values?.filter((t, n) => t.value && t.value.split(r?.hierarchyDelimiter).length > e || n == r.values?.length - 1);
					}
					(e?.levels || r?.values && r?.values[r?.values?.length - 1].value?.split(r.hierarchyDelimiter))?.map((o, s) => {
						let c = {
							index: s,
							label: e.levels ? o : "",
							key: `ss-${s}`
						};
						d.push(new Av({
							config: c,
							services: n,
							stores: i,
							state: a,
							data: {
								id: t.id,
								facet: r
							}
						}));
					});
				} else d.push(new kv({
					config: e,
					services: n,
					stores: i,
					state: a,
					data: {
						id: t.id,
						facet: r
					}
				}));
			})), super(...d);
		}
	}, Ov = class {
		constructor(e) {
			this.filtered = !1, this.collapsed = !1, this.display = "", this.disabled = !1, this.selected = "", this.custom = {};
			let { config: t, services: n, stores: r, state: i, data: a } = e || {}, { storage: o } = r || {}, { id: s, facet: c } = a || {}, { persisted: l } = i;
			this.services = n, this.persisted = l, this.id = s, this.config = t, this.facet = c, this.type = c.type, this.field = c.field, this.filtered = c.filtered, this.collapsed = c.collapsed, this.display = c.display, this.label = c.label, this.multiple = c.multiple, this.storage = {
				key: Ev(this.id, this.field),
				get: function(e) {
					let t = this.key + (e ? `.${e}` : "");
					return o.get(t);
				},
				set: function(e, t) {
					let n = this.key + (e ? `.${e}` : "");
					return o.set(n, t);
				}
			};
		}
		get values() {
			let e = [...this.data || []];
			return e.unshift({
				filtered: !1,
				value: "",
				label: this.config.label || this.label
			}), e;
		}
	}, kv = class extends Ov {
		constructor(e) {
			super(e);
			let { data: t } = e || {}, { facet: n } = t || {};
			this.storage.set("values", n.values);
			let r = this.storage.get();
			this.data = r.values || [], this.disabled = !this.values.length, this.selected = this.disabled ? "" : r.selected || "";
		}
		select(e = "") {
			this.selected = e, this.storage.set("selected", e), this.persisted = !1, e ? this.services.urlManager.set(`filter.${this.field}`, e).go() : this.services.urlManager.remove(`filter.${this.field}`).go();
		}
	}, Av = class extends Ov {
		constructor(e) {
			super(e);
			let { data: t } = e || {}, { facet: n } = t || {};
			this.hierarchyDelimiter = n.hierarchyDelimiter;
			let r = this.storage.get();
			if (!r) this.storage.set(`${this.config.key}.values`, n.values), r = this.storage.get();
			else if (r[this.config.key]?.values) this.selected = r[this.config.key]?.selected || "";
			else {
				let e = this.storage.get(), t = Object.keys(e).map((e, t) => `ss-${t}`);
				!t.includes(this.config.key) && t.push(this.config.key);
				let r = Object.keys(e).filter((t) => e[t].selected), i = r[r.length - 1], a = t.indexOf(this.config.key), o = t.indexOf(i);
				o != -1 && a == o + 1 ? this.storage.set(`${this.config.key}.values`, n.values) : this.disabled = !0;
			}
			this.data = r[this.config.key]?.values || [];
		}
		select(e = "") {
			this.selected = e, this.persisted = !1;
			let t = this.config.index, n = this.storage.get(), r = Object.keys(n).slice(t);
			Object.keys(n).reverse().forEach((t) => {
				t == this.config.key ? this.storage.set(`${t}.selected`, e) : r.includes(t) && this.storage.set(`${t}`, {}), e ||= this.storage.get(`${t}.selected`);
			}), e ? this.services.urlManager.set(`filter.${this.field}`, e).go() : this.services.urlManager.remove(`filter.${this.field}`).go();
		}
	};
})), Mv = o((() => {
	jv();
})), Nv, Pv = o((() => {
	H(), W(), u_(), nv(), Mv(), Cv(), Nv = class extends l_ {
		constructor(e, t) {
			if (super(e), this.persisted = !1, this.save = () => {}, this.reset = () => {
				this.config.persist?.enabled && (this.persistedStorage?.clear(), this.persisted = !1), this.services.urlManager.state.filter && (this.storage.clear(), this.selections = [], this.loaded = !1);
			}, typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, this.config.persist?.enabled && (this.persistedStorage = new bu({
				type: "local",
				key: `athos-${this.config.id}-persisted`
			})), this.storage = new bu(), this.update(), F(this, {
				selections: R,
				pagination: R
			});
		}
		setService(e, t) {
			this.services[e] && t && (this.services[e] = t);
		}
		loadPersisted() {
			if (this.config.persist?.enabled && this.persistedStorage) {
				let e = this.persistedStorage.get("date"), t = this.persistedStorage.get("data"), n = this.persistedStorage.get("config"), r = this.persistedStorage.get("selections"), i = this.config.persist.expiration && Date.now() - e > this.config.persist.expiration;
				t && r.filter((e) => e.selected).length && (JSON.stringify({
					...n,
					plugins: [],
					middleware: {}
				}) === JSON.stringify({
					...this.config,
					plugins: [],
					middleware: {}
				}) && !i ? (this.update(t, r), this.persisted = !0, this.services.urlManager.go()) : this.reset());
			}
		}
		update(e, t) {
			let { meta: n, search: r } = e || {};
			this.error = void 0, this.loaded = !!r?.pagination, this.meta = new xv({ data: { meta: n || {} } }), this.pagination = new k_({
				config: this.config,
				services: this.services,
				data: {
					search: r,
					meta: this.meta.data
				}
			}), this.selections = new Dv({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				state: { persisted: this.persisted },
				data: {
					search: r,
					meta: this.meta.data,
					selections: t || []
				}
			}), this.save = () => {
				this.config.persist?.enabled && this.persistedStorage && this?.selections?.filter((e) => e.selected).length && (this.persistedStorage.set("config", this.config), this.persistedStorage.set("data", e), this.persistedStorage.set("date", Date.now()), this.persistedStorage.set("selections", this.selections.map((e) => ({
					selected: e.selected,
					data: e.data,
					facet: e.facet
				}))));
			}, this.error = void 0, this.loaded = !!r?.pagination;
		}
	};
})), Fv, Iv = o((() => {
	H(), W(), nv(), u_(), Cv(), Fv = class extends l_ {
		constructor(e, t) {
			if (super(e), typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to SearchStore. Missing \"subscribe\" function.");
			this.services = t, this.storage = new bu(), this.history = new ev({
				services: this.services,
				config: this.config
			}), this.update(), F(this, {
				search: R,
				merchandising: R,
				facets: R,
				filters: R,
				results: R,
				pagination: R,
				sorting: R
			});
		}
		reset() {
			this.update();
		}
		update(e) {
			let { meta: t, search: n } = e || {};
			this.meta = new xv({ data: { meta: t } }), this.merchandising = new f_({ data: { search: n } }), this.search = new Z_({
				services: this.services,
				data: { search: n }
			}), this.facets = new __({
				config: this.config,
				services: this.services,
				stores: { storage: this.storage },
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.filters = new T_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.results = new z_({
				config: this.config,
				state: { loaded: this.loaded },
				stores: {},
				data: {
					previousSearch: this.previousSearch,
					search: n,
					meta: this.meta.data
				}
			}), this.pagination = new k_({
				config: this.config,
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.sorting = new J_({
				services: this.services,
				data: {
					search: n,
					meta: this.meta.data
				}
			}), this.error = void 0, this.loaded = !!n?.pagination, this.previousSearch = n;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-event-manager/dist/esm/MiddlewareManager.js
async function Lv(e, t) {
	let n = !1;
	return await Rv(e, t, (e) => {
		e === !1 && (n = !0);
	}), n;
}
async function Rv(e, t, n) {
	if (!t.length) return;
	let r = t[0];
	n(await r(e, async () => {
		await Rv(e, t.slice(1), n);
	}));
}
var zv, Bv = o((() => {
	zv = class {
		constructor() {
			this.functions = [];
		}
		use(...e) {
			this.functions.push(...e);
		}
		remove(e) {
			let t = e.toString();
			this.functions = this.functions.filter((n) => e.name !== n.name || n.toString() != t);
		}
		clear() {
			this.functions = [];
		}
		async dispatch(e) {
			if (await Lv(e || {}, this.functions) == 1) throw Error("cancelled");
		}
	};
})), Vv, Hv = o((() => {
	Bv(), Vv = class {
		constructor() {
			this.events = {};
		}
		async fire(e, t) {
			return this.events[e] && await this.events[e].dispatch(t), Promise.resolve();
		}
		on(e, ...t) {
			this.events[e] || (this.events[e] = new zv()), this.events[e].use(...t);
		}
	};
})), Uv = o((() => {})), Wv = o((() => {
	Hv(), Uv();
})), Gv, Kv = o((() => {
	H(), Wv(), Gv = class {
		constructor() {
			this.items = [], F(this, {
				items: R,
				price: z,
				count: z,
				msrp: z
			}), this.eventManager = new Vv();
		}
		on(e, ...t) {
			this.eventManager.on(e, ...t);
		}
		get count() {
			let e = 0;
			return this.items.forEach((t) => {
				e += t.quantity;
			}), e;
		}
		get price() {
			let e = 0;
			return this.items.forEach((t) => {
				e = (e * 100 + +(+((t.display.mappings.core?.price || 0) * 100) * t.quantity)) / 100 || 0;
			}), e;
		}
		get msrp() {
			let e = 0;
			return this.items.forEach((t) => {
				e = (e * 100 + +((+((t.display.mappings.core?.msrp || 0) * 100) || +((t.display.mappings.core?.price || 0) * 100) || 0) * t.quantity)) / 100 || 0;
			}), e;
		}
		addItems(e) {
			e.forEach((e) => {
				this.items.findIndex((t) => t.id == e.id) == -1 && this.items.push(e);
			}), this.eventManager.fire("addItems", {
				cart: this,
				items: e
			});
		}
		removeItems(e) {
			let t = [...this.items];
			e.forEach((e) => {
				let n = t.findIndex((t) => t.id == e.id);
				n > -1 && (t.splice(n, 1), t.length == 0 && this.eventManager.fire("emptied", { cart: this }));
			}), this.items = t, this.eventManager.fire("removeItems", {
				cart: this,
				items: e
			});
		}
		reset() {
			this.items = [], this.eventManager.fire("reset", { cart: this });
		}
	};
})), qv, Jv = o((() => {
	H(), qv = class {
		constructor(e) {
			this.display = {}, this.type = "default";
			let { data: t } = e || {}, { profile: n } = t?.profile || {};
			if (n?.tag) {
				if (!n.display.template) throw Error(`Recommendation Profile Store found a profile without a set template: ${n.tag}`);
				this.tag = n.tag, this.placement = n.placement, this.display = n.display, this.type = n.isBundle ? "bundle" : "default", F(this, {
					tag: R,
					placement: R,
					display: R,
					type: R
				});
			}
		}
	};
})), Yv = o((() => {
	Jv();
})), Xv, Zv, Qv = o((() => {
	H(), Xv = /* @__PURE__ */ u(ji()), u_(), nv(), Kv(), Yv(), Cv(), Zv = class extends l_ {
		constructor(e, t) {
			if (super(e), this.loaded = !1, this.profile = {}, this.results = [], typeof t != "object" || typeof t.urlManager?.subscribe != "function") throw Error("Invalid service 'urlManager' passed to AutocompleteStore. Missing \"subscribe\" function.");
			this.services = t, F(this, {
				profile: R,
				results: R
			});
		}
		reset() {
			this.error = void 0, this.loaded = !1, this.profile = {}, this.results = [];
		}
		update(e) {
			let { meta: t, profile: n, results: r } = e || {};
			this.error = void 0, this.meta = new xv({ data: { meta: t } }), this.profile = new qv({ data: { profile: { profile: n } } }), this.profile.type == "bundle" && (this.config.settings = (0, Xv.default)(this.config.settings || {}, { variants: { autoSelect: !0 } }), this.cart = new Gv()), this.results = new z_({
				config: this.config,
				state: { loaded: this.loaded },
				data: {
					search: {
						results: r,
						tracking: { responseId: e.responseId }
					},
					meta: this.meta.data
				}
			}), this.loaded = !!n;
		}
	};
})), $v, ey = o((() => {
	(function(e) {
		e.WARNING = "warning", e.INFO = "info", e.ERROR = "error";
	})($v ||= {});
})), ty = o((() => {
	u_(), Tv(), Pv(), Iv(), nv(), vv(), Qv(), Kv(), W(), Cv(), ey();
})), ny, ry = o((() => {
	W(), ny = class {
		get initialized() {
			return this._initialized;
		}
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c = {}) {
			if (this.type = "abstract", this.targeters = {}, this._initialized = !1, this.handleError = (e, t) => {
				let n;
				if (e instanceof ErrorEvent) n = e;
				else if (e instanceof Error) n = new ErrorEvent("error", {
					error: e,
					message: e.message
				});
				else if (typeof e == "string" || typeof e == "number") n = new ErrorEvent("error", { error: Error(e.toString()) });
				else if (typeof e == "object" && Object.keys(e).length) try {
					n = new ErrorEvent("error", { error: Error(JSON.stringify(e)) });
				} catch {}
				if (n) {
					let { filename: r, colno: i, lineno: a, error: { stack: o }, message: s, timeStamp: c } = n, l = {
						filename: r,
						stack: o,
						message: s,
						colno: i,
						lineno: a,
						errortimestamp: c,
						details: t,
						context: { controller: {
							id: this.id,
							type: this.type
						} }
					};
					this.tracker.track.error(l), this.eventManager.fire("error", {
						controller: this,
						error: e
					});
				}
			}, typeof e != "object" || typeof e.id != "string" || !e.id.match(/^[a-zA-Z0-9_-]*$/)) throw Error("Invalid config passed to controller. The \"id\" attribute must be an alphanumeric string.");
			if (typeof t != "object" || typeof t.search != "function") throw Error("Invalid service 'client' passed to controller. Missing \"search\" function.");
			if (typeof n != "object" || typeof n.update != "function") throw Error("Invalid service 'store' passed to controller. Missing \"update\" function.");
			if (typeof r != "object" || typeof r.subscribe != "function") throw Error("Invalid service 'urlManager' passed to controller. Missing \"subscribe\" function.");
			if (typeof i != "object" || typeof i.on != "function") throw Error("Invalid service 'eventManager' passed to controller. Missing \"on\" function.");
			if (typeof i != "object" || typeof i.fire != "function") throw Error("Invalid service 'eventManager' passed to controller. Missing \"fire\" function.");
			if (typeof a != "object" || typeof a.setNamespace != "function") throw Error("Invalid service 'profiler' passed to controller. Missing \"setNamespace\" function.");
			if (typeof a != "object" || typeof a.create != "function") throw Error("Invalid service 'profiler' passed to controller. Missing \"create\" function.");
			if (typeof o != "object" || typeof o.dev != "function") throw Error("Invalid service 'logger' passed to controller. Missing \"dev\" function.");
			if (typeof s != "object" || typeof s.track != "object") throw Error("Invalid service 'tracker' passed to controller. Missing \"track\" object.");
			this.id = e.id, this.config = e, this.client = t, this.store = n, this.urlManager = r, this.eventManager = i, this.profiler = a, this.log = o, this.tracker = s, this.context = c, this.log.setNamespace(this.config.id), this.profiler.setNamespace(this.config.id);
		}
		createTargeter(e, t, n) {
			return this.addTargeter(new Il([e], t, n));
		}
		addTargeter(e) {
			let t = e.getTargets()[0], n = t?.name ?? t?.selector;
			if (n && !this.targeters[n]) return this.targeters[n] = e, e;
		}
		async init() {
			this._initialized && this.log.warn("'init' middleware recalled");
			let e = this.profiler.create({
				type: "event",
				name: "init",
				context: this.config
			}).start();
			try {
				try {
					await this.eventManager.fire("init", { controller: this });
				} catch (e) {
					if (e?.message == "cancelled") this.log.warn("'init' middleware cancelled");
					else throw this.log.error("error in 'init' middleware"), e;
				}
			} catch (e) {
				e && (console.error(e), this.handleError(e));
			}
			this._initialized ||= (this.urlManager.subscribe((e, t) => {
				try {
					JSON.stringify(e) !== JSON.stringify(t) && this.search();
				} catch (e) {
					this.log.error("URL state is invalid", e);
				}
			}), !0), e.stop(), this.log.profile(e);
		}
		retarget() {
			Object.keys(this.targeters).forEach((e) => {
				this.targeters[e].retarget();
			});
		}
		async plugin(e, ...t) {
			await e(this, ...t);
		}
		on(e, ...t) {
			this.eventManager.on(e, ...t);
		}
		use(e) {
			if (e?.plugins) try {
				if (!Array.isArray(e?.plugins)) throw "invalid format";
				e?.plugins.forEach((e) => {
					if (!Array.isArray(e)) throw "invalid format";
					let [t, ...n] = e;
					this.plugin(t, ...n);
				});
			} catch {
				this.log.warn("plugins not attached - use format [func, ...args?][]");
			}
			e?.middleware && Object.keys(e.middleware).forEach((t) => {
				let n = e.middleware[t], r;
				r = Array.isArray(n) ? n : [n], r.forEach((e) => {
					this.on(t, e);
				});
			});
		}
		setConfig(e) {
			this.config = e, this.store.setConfig(e);
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/utils/getParams.js
function iy(e) {
	let t = {};
	if (e.tag && (t.merchandising = t.merchandising || {}, t.merchandising.landingPage = e.tag), e.query && (t.search = t.search || {}, t.search.query = t.search.query || {}, t.search.query.string = e.query), e.rq && (t.search = t.search || {}, t.search.subQuery = e.rq), e.fallbackQuery && (t.search = t.search || {}, t.search.fallbackQuery = e.fallbackQuery), e.page && (t.pagination = t.pagination || {}, t.pagination.page = e.page), e.pageSize && (t.pagination = t.pagination || {}, t.pagination.pageSize = e.pageSize), e.sort) {
		t.sorts = t.sorts || [];
		let n = (Array.isArray(e.sort) ? e.sort : [e.sort])[0];
		n && n.field && n.direction && t.sorts.push({
			field: n.field,
			direction: n.direction
		});
	}
	return e.filter && (t.filters = t.filters || [], Object.keys(e.filter).forEach((n) => {
		if (typeof n != "string") return;
		let r = e.filter[n];
		(Array.isArray(r) ? r : [r]).forEach((e) => {
			typeof e == "object" ? e.low !== void 0 && e.high !== void 0 && t.filters.push({
				type: "range",
				field: n,
				value: e
			}) : t.filters.push({
				type: "value",
				field: n,
				value: e
			});
		});
	})), t;
}
var ay = o((() => {})), oy, sy = o((() => {
	(function(e) {
		e.search = "search", e.autocomplete = "autocomplete", e.finder = "finder", e.recommendation = "recommendation";
	})(oy ||= {});
})), cy, ly, uy, dy = o((() => {
	cy = /* @__PURE__ */ u(ji()), ty(), ry(), ay(), sy(), ly = {
		id: "finder",
		beacon: { enabled: !0 },
		globals: { pagination: { pageSize: 0 } },
		fields: [],
		persist: {
			enabled: !1,
			lockSelections: !0,
			expiration: 0
		}
	}, uy = class extends ny {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = oy.finder, this.find = async () => {
				await this.store.save();
				try {
					await this.eventManager.fire("beforeFind", { controller: this }), window.location.href = this.urlManager.href;
				} catch (e) {
					e?.message == "cancelled" ? this.log.warn("'beforeFind' middleware cancelled") : (this.log.error("error in 'beforeFind' middleware"), this.log.error(e));
				}
			}, this.reset = () => {
				this.store.reset(), this.urlManager.remove("filter").go(), this.store.setService("urlManager", this.urlManager);
			}, this.search = async () => {
				try {
					if (this.initialized || await this.init(), this.store.persisted) return;
					let e = this.params;
					this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, search: r } = await this.client.finder(e);
					t.stop(), this.log.profile(t);
					let i = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), i.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					i.stop(), this.log.profile(i), this.store.update({
						meta: n,
						search: r
					});
					let a = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), a.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					a.stop(), this.log.profile(a);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: $v.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: $v.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: $v.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: $v.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.config = (0, cy.default)(ly, this.config), this.store.setConfig(this.config), this.config.url && (this.urlManager = this.urlManager.withConfig((e) => ({
				...e,
				urlRoot: this.config.url
			}))), this.use(this.config), this.store.loadPersisted();
		}
		get params() {
			let e = this.urlManager.state, { userId: t, sessionId: n, pageLoadId: r } = this.tracker.getContext(), i = {};
			t && (i.userId = t), n && (i.sessionId = n), r && (i.pageLoadId = r), i.domain = window.location.href;
			let a = {
				facets: {
					include: this.config.fields.map((e) => e.field),
					autoDrillDown: !1
				},
				tracking: i
			};
			return (0, cy.default)({ ...iy(e) }, (0, cy.default)(a, this.config.globals));
		}
	};
})), fy = /* @__PURE__ */ s(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = r(n) : typeof define == "function" && define.amd ? define([], r.bind(n, n)) : r(n);
	})(typeof global < "u" ? global : e, function(e) {
		if (e.CSS && e.CSS.escape) return e.CSS.escape;
		var t = function(e) {
			if (arguments.length == 0) throw TypeError("`CSS.escape` requires an argument.");
			for (var t = String(e), n = t.length, r = -1, i, a = "", o = t.charCodeAt(0); ++r < n;) {
				if (i = t.charCodeAt(r), i == 0) {
					a += "�";
					continue;
				}
				if (i >= 1 && i <= 31 || i == 127 || r == 0 && i >= 48 && i <= 57 || r == 1 && i >= 48 && i <= 57 && o == 45) {
					a += "\\" + i.toString(16) + " ";
					continue;
				}
				if (r == 0 && n == 1 && i == 45) {
					a += "\\" + t.charAt(r);
					continue;
				}
				if (i >= 128 || i == 45 || i == 95 || i >= 48 && i <= 57 || i >= 65 && i <= 90 || i >= 97 && i <= 122) {
					a += t.charAt(r);
					continue;
				}
				a += "\\" + t.charAt(r);
			}
			return a;
		};
		return e.CSS ||= {}, e.CSS.escape = t, t;
	});
})), py, my, hy = o((() => {
	py = 1e3, my = (e, t) => {
		let n = t?.display?.mappings.core?.url || "", r = t?.mappings.core?.url || "", i = (e.composedPath ? e.composedPath() : [e.target]).slice(0, 12);
		for (let e of i) if (e instanceof Element) {
			let t = e.getAttribute("href");
			if (t && (r && t.includes(r) || n && t.includes(n))) return !0;
		}
		return !1;
	};
})), gy, _y, vy = o((() => {
	hy(), gy = "sstracking", _y = (e) => {
		let t = e.target, n = null, r = 0;
		for (; t && (r < 12 || !t.getAttribute(gy));) {
			n = t.getAttribute("href");
			let e = t.tagName.toLowerCase() === "a";
			if (n && e) return !0;
			t = t.parentElement, r++;
		}
		return !1;
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/Search/SearchController.js
function yy(e) {
	return {
		siteId: e.siteId,
		sorts: e.sorts,
		search: {
			query: { string: e?.search?.query?.string || "" },
			subQuery: e?.search?.subQuery || ""
		},
		filters: e.filters,
		pagination: e.pagination,
		facets: e.facets,
		merchandising: { landingPage: e.merchandising?.landingPage || "" }
	};
}
function by(e, t, n = 7) {
	let r = 0, i = e;
	for (; i && r <= n;) {
		let e = null;
		try {
			e = i.querySelector(`[href*="${t}"]`);
		} catch {
			try {
				e = i.querySelector((0, Sy.default)(`[href*="${t}"]`));
			} catch {}
		}
		if (e) {
			let n = "", r = e;
			for (; r && r != i.parentElement;) {
				let e = r.classList.value.trim().split(" ").reduce((e, t) => t.trim() ? `${e}.${(0, Sy.default)(t.trim())}` : e, "");
				n = `${r.tagName}${e}${n ? ` ${n}` : ""}`, r = r.parentElement;
			}
			return `${n}[href*="${t}"]`;
		}
		i = i.parentElement, r++;
	}
}
var xy, Sy, Cy, wy, Ty, Ey, Dy = o((() => {
	xy = /* @__PURE__ */ u(ji()), Sy = /* @__PURE__ */ u(fy()), ry(), ty(), W(), ay(), sy(), hy(), vy(), Cy = [
		"collection",
		"category",
		"categories",
		"hierarchy",
		"brand",
		"manufacturer"
	], wy = [
		1,
		0,
		"1",
		"0",
		"true",
		"false",
		!0,
		!1
	], Ty = {
		id: "search",
		globals: {},
		beacon: { enabled: !0 },
		settings: {
			redirects: {
				merchandising: !0,
				singleResult: !0
			},
			facets: {
				trim: !0,
				pinFiltered: !0,
				storeRange: !0,
				autoOpenActive: !0
			}
		}
	}, Ey = class extends ny {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = oy.search, this.previousResults = [], this.page = { type: "search" }, this.events = {}, this.track = {
				banner: {
					impression: ({ uid: e, responseId: t }) => {
						if (!e) {
							this.log.warn("No banner provided to track.banner.impression");
							return;
						}
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events[t]?.banner[e]?.impression) return;
						let n = {
							responseId: t,
							banners: [{ uid: e }],
							results: []
						};
						this.eventManager.fire("track.banner.impression", {
							controller: this,
							product: { uid: e },
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].impression({
							data: n,
							siteId: this.config.globals?.siteId
						}), this.events[t].banner[e] = this.events[t].banner[e] || {}, this.events[t].banner[e].impression = !0;
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.click");
							return;
						}
						let { responseId: n, uid: r } = t;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (_y(e)) {
							if (this.events?.[n]?.banner[r]?.clickThrough) return;
							this.track.banner.clickThrough(e, t), this.events[n].banner[r] = this.events[n].banner[r] || {}, this.events[n].banner[r].clickThrough = !0, setTimeout(() => {
								this.events[n].banner[r].clickThrough = !1;
							}, py);
						}
					},
					clickThrough: (e, { uid: t, responseId: n }) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.clickThrough");
							return;
						}
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = {
							responseId: n,
							banners: [{ uid: t }]
						};
						this.eventManager.fire("track.banner.clickThrough", {
							controller: this,
							event: e,
							product: { uid: t },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].clickThrough({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[n].banner[t] = this.events[n].banner[t] || {}, this.events[n].banner[t].clickThrough = !0, setTimeout(() => {
							this.events[n].banner[t].clickThrough = !1;
						}, py);
					}
				},
				product: {
					clickThrough: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.clickThrough");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = e.target, i = t.display?.mappings.core?.url || t.mappings.core?.url || "", a = r?.getAttribute("href"), o = a?.indexOf(i) == -1 && a || i, s = {}, c = by(r, o), l = c ? document?.querySelector(c)?.getBoundingClientRect() : void 0;
						if (c || o || l) try {
							let e = this.storage.get("lastStringyParams");
							if (e) {
								let t = yy(JSON.parse(e)), n = JSON.stringify(t);
								s[n] = {
									domRect: l,
									href: o,
									selector: c
								};
							}
						} catch (e) {
							this.log.warn("Failed to save srcollMap!", e);
						}
						this.storage.set("scrollMap", s);
						let u = ["product", "banner"].includes(t.type) ? t.type : "product", d = {
							responseId: n,
							results: [{
								type: u,
								uid: t.id ? "" + t.id : "",
								...u === "product" ? {
									parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
									sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
								} : {}
							}]
						};
						this.eventManager.fire("track.product.clickThrough", {
							controller: this,
							event: e,
							product: t,
							trackEvent: d
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].clickThrough({
							data: d,
							siteId: this.config.globals?.siteId
						});
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.click");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (t.type === "banner" && _y(e)) {
							if (this.events?.[n]?.product[t.id]?.inlineBannerClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].inlineBannerClickThrough = !1;
							}, py);
						} else if (my(e, t)) {
							if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].productClickThrough = !1;
							}, py);
						}
					},
					impression: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.impression");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events[t]?.product[e.id]?.impression) return;
						let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
							responseId: t,
							results: [{
								type: n,
								uid: e.id ? "" + e.id : "",
								...n === "product" ? {
									parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
									sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
								} : {}
							}],
							banners: []
						};
						this.eventManager.fire("track.product.impression", {
							controller: this,
							product: e,
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
					},
					addToCart: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.addToCart");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let n = {
							responseId: t,
							results: [{
								parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
								uid: e.display.mappings.core?.uid || e.display.id,
								sku: e.display.mappings.core?.sku,
								qty: e.quantity || 1,
								price: Number(e.display.mappings.core?.price) || 0
							}]
						};
						this.eventManager.fire("track.product.addToCart", {
							controller: this,
							product: e,
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events[this.page.type].addToCart({
							data: n,
							siteId: this.config.globals?.siteId
						});
					}
				},
				redirect: ({ redirectURL: e, responseId: t }) => {
					if (!e) {
						this.log.warn("No redirectURL provided to track.redirect");
						return;
					}
					let n = {
						responseId: t,
						redirect: e
					};
					this.eventManager.fire("track.redirect", {
						controller: this,
						redirectURL: e,
						trackEvent: n
					}), this.config.beacon?.enabled && this.tracker.events.search.redirect({
						data: n,
						siteId: this.config.globals?.siteId
					});
				}
			}, this.search = async () => {
				try {
					this.initialized || await this.init();
					let e = this.params;
					e.search?.query?.string && e.search?.query?.string.length && this.store.history.save(e.search.query.string), this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = JSON.stringify(yy(e)), n = this.storage.get("lastStringyParams");
					if (this.store.loaded && t === n) return;
					let r = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), i = {}, a;
					if (this.config.settings?.infinite?.enabled && e.pagination?.page && e.pagination.page > 1) {
						let t = this.config.settings.infinite?.backfill && !this.store.results.length && e.pagination.page > this.config.settings.infinite.backfill, n = !this.config.settings.infinite?.backfill && !this.store.results.length;
						if (t || n) {
							this.storage.set("scrollMap", {}), this.urlManager.set("page", 1).go();
							return;
						}
						if (this.config.settings?.infinite.backfill && !this.store.loaded) {
							let t = [], n = Array(e.pagination.page).fill("backfill").map((n, r) => {
								let i = (0, xy.default)({ ...e }, {
									pagination: { page: r + 1 },
									search: { redirectResponse: "full" }
								});
								return r + 1 == 1 && (delete i?.pagination?.page, this.config.settings?.redirects?.merchandising && delete i?.search?.redirectResponse), t.push(i), this.client[this.page.type](i);
							}), r = await Promise.all(n);
							i = r[0].meta, a = r[0].search;
							let o = r.reduce((e, t) => {
								let n = t.search.tracking.responseId;
								return this.events[n] = this.events[n] || {
									product: {},
									banner: {}
								}, e.concat(...t.search.results);
							}, []);
							a.pagination.totalPages = Math.ceil(a.pagination.totalResults / a.pagination.pageSize), a.pagination.page = e.pagination?.page, a.results = o;
						} else {
							let t = await this.client[this.page.type](e);
							i = t.meta, a = t.search;
							let n = a.tracking.responseId;
							this.events[n] = this.events[n] || {
								product: {},
								banner: {}
							}, a.results = [...this.previousResults, ...a.results || []];
						}
					} else {
						this.previousResults = [];
						let t = await this.client[this.page.type](e);
						i = t.meta, a = t.search;
						let n = a.tracking.responseId;
						this.events[n] = {
							product: {},
							banner: {}
						};
					}
					let o = {
						meta: i,
						search: a
					};
					r.stop(), this.log.profile(r);
					let s = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: o
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), s.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					s.stop(), this.log.profile(s), this.previousResults = JSON.parse(JSON.stringify(o.search.results)), this.store.update(o);
					let c = { responseId: o.search.tracking.responseId };
					this.config.beacon?.enabled && this.tracker.events[this.page.type].render({
						data: c,
						siteId: this.config.globals?.siteId
					});
					let l = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: o
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), l.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					l.stop(), this.log.profile(l);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: $v.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: $v.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: $v.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: $v.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to search controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, this.config = (0, xy.default)(Ty, this.config), this.config.settings?.infinite && typeof this.config.settings?.infinite == "object" && (Object.keys(this.config.settings?.infinite).length == 0 || this.config.settings?.infinite?.backfill !== void 0) && (this.config.settings = {
				...this.config.settings,
				infinite: {
					enabled: !0,
					...this.config.settings.infinite
				}
			}), this.config.settings?.infinite?.enabled && this.config.settings.restorePosition === void 0 && (this.config.settings.restorePosition = { enabled: !0 }), this.store.setConfig(this.config), this.storage = new bu({
				type: "session",
				key: `athos-controller-${this.config.id}`
			}), typeof this.context?.page == "object" && ["search", "category"].includes(this.context.page.type) && (this.page = (0, xy.default)(this.page, this.context.page)), this.eventManager.on("beforeSearch", async ({ request: e }, t) => {
				await t();
				let n = e;
				n.search?.query || n.filters?.filter((e) => e.background).filter((e) => Cy.find((t) => e.field?.toLowerCase().includes(t))).filter((e) => wy.every((t) => {
					switch (e.type) {
						case "range": return e.value !== t;
						default: return e.value !== t;
					}
				}))?.length && (this.page = (0, xy.default)(this.page, { type: "category" }));
			}), this.eventManager.on("afterSearch", async (e, t) => {
				let n = e.controller.config, r = e.response?.search?.merchandising?.redirect, i = e.controller.store;
				if (r && n?.settings?.redirects?.merchandising && !e?.response?.search?.filters?.length && !i.loaded) return i.loaded = !0, this.track.redirect({
					redirectURL: r,
					responseId: e.response.search.tracking.responseId
				}), window.location.replace(r), !1;
				await t();
			}), this.eventManager.on("afterStore", async (e, t) => {
				await t();
				let n = yy(e.request), r = JSON.stringify(n);
				this.storage.set("lastStringyParams", r);
				let i = (this.storage.get("scrollMap") || {})[r];
				i || this.storage.set("scrollMap", {}), this.eventManager.fire("restorePosition", {
					controller: this,
					element: i
				});
			}), this.eventManager.on("afterSearch", async (e, t) => {
				await t();
				let n = e.response.search.facets;
				n && n.forEach((t) => {
					if (e.response.meta?.facets && t.field) {
						let n = t.field || "", r = e.response.meta.facets[n], i = r?.hierarchyDelimiter || " / ", a = this.config?.settings?.filters?.fields ? this.config?.settings?.filters?.fields[n] : this.config?.settings?.filters, o = a?.hierarchy?.displayDelimiter ?? " / ", s = a?.hierarchy?.showFullPath ?? !1;
						if (a?.hierarchy?.enabled && r && r.display === "hierarchy" && t.filtered && t.values?.length > 0) {
							let n = t.values?.filter((e) => e?.filtered === !0);
							if (n && n.length) {
								let r = {
									field: t.field,
									label: s ? (n[0].value ?? n[0].label ?? "").replace(new RegExp(i.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"), o) : n[0].label,
									type: "value"
								};
								e.response.search.filters ? e.response.search.filters.push(r) : e.response.search.filters = [r];
							}
						}
					}
				});
			}), this.eventManager.on("afterStore", async (e, t) => {
				await t();
				let n = e.controller, r = e.response.search;
				if (n.store.loaded && !n.store.error) {
					let t = e.controller.config, n = e?.request?.filters?.filter((e) => !e.background), i = r?.results?.length && r?.results[0].mappings?.core?.url;
					if (t?.settings?.redirects?.singleResult && r.search?.query && r.pagination?.totalResults === 1 && !n?.length && i) return window.location.replace(i), !1;
				}
			}), this.config.settings?.restorePosition?.enabled && (this.eventManager.on("restorePosition", async ({ controller: e, element: t }, n) => {
				if (!t?.selector) {
					let e = this.storage.get("lastStringyParams");
					if (e) {
						let n = yy(JSON.parse(e)), r = JSON.stringify(n);
						t = (this.storage.get("scrollMap") || {})[r];
					}
				}
				t && await new Promise(async (n) => {
					let r = 0, i = 0, a, o = () => {
						let e = t?.domRect?.top || 0, n = document.querySelector(t?.selector);
						for (; n && !n.getBoundingClientRect().height;) n = n.parentElement, e = 0;
						if (n) {
							let { y: t } = n.getBoundingClientRect();
							r++, t > e + 1 || t < e - 1 ? window.scrollBy(0, t - e) : a = n;
						} else i++;
						return !0;
					};
					for (; o() && r <= 10 && i <= 12;) await new Promise((e) => setTimeout(e, 60));
					a ? e.log.debug("restored position to: ", a) : e.log.debug("attempted to scroll back to element with selector: ", t?.selector), n();
				}), await n();
			}), this.config.settings?.restorePosition?.onPageShow && window.addEventListener("pageshow", (e) => {
				e.persisted && this.store.loaded && this.eventManager.fire("restorePosition", {
					controller: this,
					element: {}
				});
			})), this.use(this.config);
		}
		get params() {
			let e = (0, xy.default)({ ...iy(this.urlManager.state) }, this.config.globals || {});
			(!this.config.settings?.redirects?.merchandising || this.store.loaded) && (e.search = e.search || {}, e.search.redirectResponse = "full"), e.tracking = e.tracking || {}, e.tracking.domain = window.location.href;
			let { userId: t, sessionId: n, pageLoadId: r, shopperId: i } = this.tracker.getContext();
			if (t && (e.tracking.userId = t), n && (e.tracking.sessionId = n), r && (e.tracking.pageLoadId = r), !this.config.globals?.personalization?.disabled) {
				let t = this.tracker.cookies.cart.get();
				t.length && (e.personalization = e.personalization || {}, e.personalization.cart = t.join(","));
				let n = this.tracker.cookies.viewed.get();
				n.length && (e.personalization = e.personalization || {}, e.personalization.lastViewed = n.join(",")), i && (e.personalization = e.personalization || {}, e.personalization.shopper = i);
			}
			return e;
		}
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-controller/dist/esm/Autocomplete/AutocompleteController.js
function Oy(e, t, n) {
	let r = document.createElement("input");
	r.type = "hidden", r.name = t, r.value = n, e.querySelector(`[type="hidden"][name="${t}"]`)?.remove(), e.append(r);
}
async function ky(e) {
	return new Promise((t) => {
		window.setTimeout(t, e);
	});
}
function Ay(e, t) {
	let n = {};
	if (typeof e == "object" && e.nodeName == "FORM") for (let r = e.elements.length - 1; r >= 0; r--) {
		let i = e.elements[r];
		typeof t == "function" && !t(i) || i.name && !By.includes(i.type) && (i.type != "checkbox" && i.type != "radio" || i.checked) && (n[i.name] = i.value);
	}
	return n;
}
function jy(e, t, n) {
	if (typeof e == "object" && e.nodeName == "FORM") for (let r = e.elements.length - 1; r >= 0; r--) {
		let i = e.elements[r];
		typeof n == "function" && !n(i) || i.name && !By.includes(i.type) && i.addEventListener("change", t);
	}
}
function My(e, t) {
	if (typeof e == "object" && e.nodeName == "FORM") for (let n = e.elements.length - 1; n >= 0; n--) {
		let r = e.elements[n];
		r.name && !By.includes(r.type) && r.removeEventListener("change", t);
	}
}
var Ny, Py, Fy, Iy, Ly, Ry, zy, By, Vy = o((() => {
	Ny = /* @__PURE__ */ u(ji()), ty(), W(), ry(), ay(), sy(), hy(), vy(), Py = "ss-autocomplete-input", Fy = 13, Iy = 27, Ly = "fallbackQuery", Ry = {
		id: "autocomplete",
		selector: "",
		action: "",
		globals: {},
		beacon: { enabled: !0 },
		settings: {
			initializeFromUrl: !0,
			syncInputs: !0,
			serializeForm: !1,
			facets: {
				trim: !0,
				pinFiltered: !0
			},
			redirects: {
				merchandising: !0,
				singleResult: !1
			},
			bind: {
				input: !0,
				submit: !0
			}
		}
	}, zy = class extends ny {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = oy.autocomplete, this.events = {}, this.track = {
				banner: {
					impression: (e) => {
						if (!e) {
							this.log.warn("No banner provided to track.banner.impression");
							return;
						}
						let { responseId: t, uid: n } = e;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events?.[t]?.banner?.[n]?.impression) return;
						let r = {
							responseId: t,
							banners: [{ uid: n }],
							results: []
						};
						this.eventManager.fire("track.banner.impression", {
							controller: this,
							product: { uid: n },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].banner[n] = this.events[t].banner[n] || {}, this.events[t].banner[n].impression = !0;
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No banner provided to track.banner.click");
							return;
						}
						let { responseId: n, uid: r } = t;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (_y(e)) {
							if (this.events?.[n]?.banner[r]?.clickThrough) return;
							this.track.banner.clickThrough(e, t), this.events[n].banner[r] = this.events[n].banner[r] || {}, this.events[n].banner[r].clickThrough = !0, setTimeout(() => {
								this.events[n].banner[r].clickThrough = !1;
							}, py);
						}
					},
					clickThrough: (e, { uid: t, responseId: n }) => {
						if (!t) {
							this.log.warn("No banner uid provided to track.banner.clickThrough");
							return;
						}
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = {
							responseId: n,
							banners: [{ uid: t }]
						};
						this.eventManager.fire("track.banner.clickThrough", {
							controller: this,
							event: e,
							product: { uid: t },
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.clickThrough({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[n].banner[t] = this.events[n].banner[t] || {}, this.events[n].banner[t].clickThrough = !0, setTimeout(() => {
							this.events[n].banner[t].clickThrough = !1;
						}, py);
					}
				},
				product: {
					clickThrough: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.clickThrough");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let r = ["product", "banner"].includes(t.type) ? t.type : "product", i = {
							responseId: n,
							results: [{
								type: r,
								uid: t.id ? "" + t.id : "",
								...r === "product" ? {
									parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
									sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
								} : {}
							}]
						};
						this.eventManager.fire("track.product.clickThrough", {
							controller: this,
							event: e,
							product: t,
							trackEvent: i
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.clickThrough({
							data: i,
							siteId: this.config.globals?.siteId
						});
					},
					click: (e, t) => {
						if (!t) {
							this.log.warn("No result provided to track.product.click");
							return;
						}
						let n = t.responseId;
						if (!this.events[n]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (t.type === "banner" && _y(e)) {
							if (this.events?.[n]?.product[t.id]?.inlineBannerClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].inlineBannerClickThrough = !1;
							}, py);
						} else if (my(e, t)) {
							if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
							this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
								this.events[n].product[t.id].productClickThrough = !1;
							}, py);
						}
					},
					impression: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.impression");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						if (this.events?.[t]?.product[e.id]?.impression) return;
						let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
							responseId: t,
							results: [{
								type: n,
								uid: e.id ? "" + e.id : "",
								...n === "product" ? {
									parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
									sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
								} : {}
							}],
							banners: []
						};
						this.eventManager.fire("track.product.impression", {
							controller: this,
							product: e,
							trackEvent: r
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.impression({
							data: r,
							siteId: this.config.globals?.siteId
						}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
					},
					addToCart: (e) => {
						if (!e) {
							this.log.warn("No result provided to track.product.addToCart");
							return;
						}
						let t = e.responseId;
						if (!this.events[t]) {
							this.log.warn("No responseId found in controller, ensure correct controller is used");
							return;
						}
						let n = {
							responseId: t,
							results: [{
								parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
								uid: e.display.mappings.core?.uid || e.display.id,
								sku: e.display.mappings.core?.sku,
								qty: e.quantity || 1,
								price: Number(e.display.mappings.core?.price) || 0
							}]
						};
						this.eventManager.fire("track.product.addToCart", {
							controller: this,
							product: e,
							trackEvent: n
						}), this.config.beacon?.enabled && this.tracker.events.autocomplete.addToCart({
							data: n,
							siteId: this.config.globals?.siteId
						});
					}
				},
				redirect: ({ redirectURL: e, responseId: t }) => {
					if (!e) {
						this.log.warn("No redirectURL provided to track.redirect");
						return;
					}
					let n = {
						responseId: t,
						redirect: e
					};
					this.eventManager.fire("track.redirect", {
						controller: this,
						redirectURL: e,
						trackEvent: n
					}), this.config.beacon?.enabled && this.tracker.events.autocomplete.redirect({
						data: n,
						siteId: this.config.globals?.siteId
					});
				}
			}, this.handlers = {
				input: {
					enterKey: async (e) => {
						if (e.keyCode == Fy) {
							let t = e.target, n = this.store.services.urlManager;
							for (e.preventDefault(); this.store.loading;) await ky(200);
							this.store.search.correctedQuery && (n = n?.set(Ly, this.store.search.correctedQuery.string)), n = n?.set("query", t.value), await ky(201);
							try {
								await this.eventManager.fire("beforeSubmit", {
									controller: this,
									input: t
								});
							} catch (e) {
								if (e?.message == "cancelled") {
									this.log.warn("'beforeSubmit' middleware cancelled");
									return;
								}
								this.log.error("error in 'beforeSubmit' middleware"), console.error(e);
							}
							window.location.href = n?.href || "";
						}
					},
					escKey: (e) => {
						e.keyCode == Iy && (e.target.blur(), this.setFocused());
					},
					focus: (e) => {
						e.stopPropagation(), setTimeout(() => {
							this.setFocused(e.target);
						});
					},
					formSubmit: async (e) => {
						let t = e.target, n = t.querySelector(`input[${Py}]`);
						for (e.preventDefault(); this.store.loading;) await ky(200);
						this.store.search.correctedQuery && Oy(t, Ly, this.store.search.correctedQuery.string), await ky(201);
						try {
							await this.eventManager.fire("beforeSubmit", {
								controller: this,
								input: n
							});
						} catch (e) {
							if (e?.message == "cancelled") {
								this.log.warn("'beforeSubmit' middleware cancelled");
								return;
							}
							this.log.error("error in 'beforeSubmit' middleware"), console.error(e);
						}
						t.submit();
					},
					formElementChange: (e) => {
						let t = e.target?.form, n = t?.querySelector(`input[${Py}]`);
						if (t && n && this.config.settings?.serializeForm) {
							let e = Ay(t, function(e) {
								return e != n;
							});
							this.store.setService("urlManager", this.store.services.urlManager.reset().withGlobals(e)), this.store.reset(), this.config.settings?.trending?.enabled && this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && this.searchTrending();
						}
					},
					input: (e) => {
						e.isTrusted && this.store.state.focusedInput !== e.target && this.setFocused(e.target);
						let t = e.target.value;
						if ((!this.store.state.input && !t || this.store.state.input == t) && this.store.loaded) return;
						this.store.state.source = "input", this.store.state.input = t, this.store.merchandising.redirect = "", this.config?.settings?.syncInputs && document.querySelectorAll(this.config.selector).forEach((e) => {
							e.value = t;
						}), clearTimeout(this.handlers.input.timeoutDelay);
						let n = this.store.trending?.length && this.config.settings?.trending?.enabled && this.config.settings?.trending?.showResults, r = this.store.history?.length && this.config.settings?.history?.enabled && this.config.settings?.history?.showResults;
						this.handlers.input.timeoutDelay = setTimeout(() => {
							t ? (this.store.state.locks.terms.unlock(), this.store.state.locks.facets.unlock(), this.urlManager.set({ query: this.store.state.input }).go()) : (this.store.reset(), n ? this.store.trending[0].preview() : r ? this.store.history[0].preview() : this.urlManager.reset().go());
						}, 200);
					},
					timeoutDelay: void 0
				},
				document: { click: (e) => {
					let t = document.querySelectorAll(this.config.selector);
					Array.from(t).includes(e.target) || e.target?.nodeName == "FORM" && e.target.querySelectorAll(this.config.selector).length ? e.stopPropagation() : this.setFocused();
				} }
			}, this.searchTrending = async (e) => {
				let t, n = this.storage.get("terms");
				if (n && !e?.limit) t = JSON.parse(n);
				else {
					let n = { limit: e?.limit || this.config.settings?.trending?.limit || 5 }, r = this.profiler.create({
						type: "event",
						name: "trending",
						context: n
					}).start();
					t = await this.client.trending(n), r.stop(), this.log.profile(r), t?.trending.queries?.length && this.storage.set("terms", JSON.stringify(t));
				}
				this.store.updateTrendingTerms(t);
			}, this.search = async () => {
				try {
					if (this.initialized || await this.init(), !this.urlManager.state.query) return;
					let e = this.params;
					if (!e?.search?.query?.string) return;
					this.store.loading = !0, this.store.merchandising.redirect = "";
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, search: r } = await this.client.autocomplete(e);
					t.stop(), this.log.profile(t);
					let i = r.tracking.responseId;
					this.events[i] = this.events[i] || {
						product: {},
						banner: {}
					};
					let a = this.store.results[0]?.responseId, o = a && a === i;
					if (o) {
						let e = Object.keys(this.events[i].product || {}).filter((e) => this.events[i].product?.[e]?.impression);
						this.events[i] = {
							product: e.reduce((e, t) => (e[t] = { impression: !0 }, e), {}),
							banner: this.events[i].banner
						};
					} else this.events[i] = {
						product: {},
						banner: {}
					};
					let s = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), s.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					if (s.stop(), this.log.profile(s), this.store.update({
						meta: n,
						search: r
					}), !o) {
						let e = { responseId: i };
						this.config.beacon?.enabled && this.tracker.events.autocomplete.render({
							data: e,
							siteId: this.config.globals?.siteId
						});
					}
					let c = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								search: r
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), c.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					c.stop(), this.log.profile(c);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: $v.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: $v.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: $v.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: $v.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to autocomplete controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, this.config = (0, Ny.default)(Ry, this.config), this.config.settings?.trending?.limit && this.config.settings?.trending?.enabled === void 0 && (this.config.settings = {
				...this.config.settings,
				trending: {
					enabled: !0,
					...this.config.settings.trending
				}
			}), this.config.settings?.history?.limit && this.config.settings?.history?.enabled === void 0 && (this.config.settings = {
				...this.config.settings,
				history: {
					enabled: !0,
					...this.config.settings.history
				}
			}), this.store.setConfig(this.config), this.config.settings.initializeFromUrl && (this.store.state.input = this.urlManager.state.query, this.urlManager.reset().go()), this.storage = new bu({
				type: "session",
				key: `athos-controller-${this.config.id}`
			}), this.eventManager.on("afterSearch", async (e, t) => {
				if (await t(), e.response.search.autocomplete?.query != e.controller.urlManager.state.query) return !1;
			}), this.eventManager.on("beforeSubmit", async (e, t) => {
				if (await t(), e.controller.store.loading) return;
				let n = e.controller.store.state.input, r = e.controller.store.merchandising?.redirect;
				if (this.config?.settings?.redirects?.merchandising && n && r) return this.track.redirect({
					redirectURL: r,
					responseId: e.controller.store.merchandising?.responseId
				}), window.location.href = r, !1;
				if (this.config?.settings?.redirects?.singleResult) {
					let { results: t } = e.controller.store, n = t.filter((e) => e.type == "product"), r = n.length === 1 && n[0].mappings.core?.url;
					if (r) return window.location.href = r, !1;
				}
			}), this.use(this.config);
		}
		get params() {
			let e = this.urlManager.state, t = (0, Ny.default)({ ...iy(e) }, this.config.globals || {}), { userId: n, sessionId: r, pageLoadId: i, shopperId: a } = this.tracker.getContext();
			if (t.tracking = t.tracking || {}, t.tracking.domain = window.location.href, n && (t.tracking.userId = n), r && (t.tracking.sessionId = r), i && (t.tracking.pageLoadId = i), this.store.state.input && (t.search = t.search || {}, t.search.input = this.store.state.input), this.store.state.source && (t.search = t.search || {}, t.search.source = this.store.state.source), !this.config.globals?.personalization?.disabled) {
				let e = this.tracker.cookies.cart.get();
				e.length && (t.personalization = t.personalization || {}, t.personalization.cart = e.join(","));
				let n = this.tracker.cookies.viewed.get();
				n.length && (t.personalization = t.personalization || {}, t.personalization.lastViewed = n.join(",")), a && (t.personalization = t.personalization || {}, t.personalization.shopper = a);
			}
			return t;
		}
		async setFocused(e) {
			if (this.store.state.focusedInput !== e) {
				this.store.state.focusedInput = e;
				try {
					try {
						await this.eventManager.fire("focusChange", { controller: this });
					} catch (e) {
						if (e?.message == "cancelled") this.log.warn("'focusChange' middleware cancelled");
						else throw this.log.error("error in 'focusChange' middleware"), e;
					}
				} catch (e) {
					e && console.error(e);
				}
			}
			e?.dispatchEvent(new Event("input"));
		}
		reset() {
			document.querySelectorAll(this.config.selector).forEach((e) => {
				e.value = "";
			}), this.store.reset();
		}
		unbind() {
			document.querySelectorAll(`input[${Py}]`)?.forEach((e) => {
				e.removeEventListener("input", this.handlers.input.input), e.removeEventListener("keydown", this.handlers.input.enterKey), e.removeEventListener("keydown", this.handlers.input.escKey), e.removeEventListener("focus", this.handlers.input.focus), e.form && (e.form.removeEventListener("submit", this.handlers.input.formSubmit), My(e.form, this.handlers.input.formElementChange));
			}), document.removeEventListener("click", this.handlers.document.click);
		}
		async bind() {
			this.initialized || await this.init(), this.unbind(), document.querySelectorAll(this.config.selector).forEach((e) => {
				e.setAttribute("spellcheck", "false"), e.setAttribute("autocomplete", "off"), e.setAttribute("autocorrect", "off"), e.setAttribute("autocapitalize", "none"), e.setAttribute(Py, ""), this.config.settings?.bind?.input && e.addEventListener("input", this.handlers.input.input), this.config?.settings?.initializeFromUrl && !e.value && this.store.state.input && (e.value = this.store.state.input), e.addEventListener("focus", this.handlers.input.focus), e.addEventListener("keydown", this.handlers.input.escKey);
				let t = e.form, n;
				if (this.config.action) this.config.settings?.bind?.submit && e.addEventListener("keydown", this.handlers.input.enterKey), n = this.config.action;
				else if (t) {
					if (this.config.settings?.bind?.submit && t.addEventListener("submit", this.handlers.input.formSubmit), n = t.action || "", this.config.settings?.serializeForm) {
						jy(t, this.handlers.input.formElementChange, function(t) {
							return t != e;
						});
						let n = Ay(t, function(t) {
							return t != e;
						});
						this.store.setService("urlManager", this.urlManager.reset().withGlobals(n));
					}
				} else this.config.settings?.bind?.submit && this.log.warn("Missing form action url! Input element is not inside a <form> and no 'action' URL is configured. Enter key will not submit. Set the 'action' url in the config to enable submission.", e);
				n && this.store.setService("urlManager", this.store.services.urlManager.withConfig((e) => ({
					...e,
					urlRoot: n
				}))), document.activeElement === e && !this.store.loading && this.setFocused(e);
			}), this.config.settings?.trending?.enabled && this.config.settings?.trending?.limit && this.config.settings?.trending?.limit > 0 && !this.store.trending?.length && this.searchTrending(), this.config.settings?.disableClickOutside || document.addEventListener("click", this.handlers.document.click);
		}
	}, By = [
		"file",
		"reset",
		"submit",
		"button",
		"image",
		"password"
	];
})), Hy, Uy, Wy, Gy = o((() => {
	Hy = /* @__PURE__ */ u(ji()), ty(), ry(), sy(), hy(), Uy = {
		id: "recommend",
		beacon: { enabled: !0 },
		tag: "",
		batched: !0,
		realtime: !1,
		globals: {}
	}, Wy = class extends ny {
		constructor(e, { client: t, store: n, urlManager: r, eventManager: i, profiler: a, logger: o, tracker: s }, c) {
			if (super(e, {
				client: t,
				store: n,
				urlManager: r,
				eventManager: i,
				profiler: a,
				logger: o,
				tracker: s
			}, c), this.type = oy.recommendation, this.beaconType = "recommendations", this.events = {}, this.track = { product: {
				clickThrough: (e, t) => {
					if (!t) {
						this.log.warn("No result provided to track.product.clickThrough");
						return;
					}
					let n = t.responseId;
					if (!this.events[n]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (this.events[n]?.product[t.id]?.productClickThrough) return;
					let r = ["product", "banner"].includes(t.type) ? t.type : "product", i = {
						type: r,
						uid: t.id ? "" + t.id : "",
						...r === "product" ? {
							parentId: t.mappings.core?.parentId ? "" + t.mappings.core?.parentId : "",
							sku: t.mappings.core?.sku ? "" + t.mappings.core?.sku : void 0
						} : {}
					}, a = {
						tag: this.store.profile.tag,
						responseId: n,
						results: [i]
					};
					this.eventManager.fire("track.product.clickThrough", {
						controller: this,
						event: e,
						product: t,
						trackEvent: a
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].clickThrough({
						data: a,
						siteId: this.config.globals?.siteId
					}), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0;
				},
				click: (e, t) => {
					if (!t) {
						this.log.warn("No result provided to track.product.click");
						return;
					}
					let n = t.responseId;
					if (!this.events[n]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (t.type === "banner") {
						if (this.events[n]?.product[t.id]?.inlineBannerClickThrough) return;
						this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].inlineBannerClickThrough = !0, setTimeout(() => {
							this.events[n].product[t.id].inlineBannerClickThrough = !1;
						}, py);
					} else if (my(e, t)) {
						if (this.events?.[n]?.product[t.id]?.productClickThrough) return;
						this.track.product.clickThrough(e, t), this.events[n].product[t.id] = this.events[n].product[t.id] || {}, this.events[n].product[t.id].productClickThrough = !0, setTimeout(() => {
							this.events[n].product[t.id].productClickThrough = !1;
						}, py);
					}
				},
				impression: (e) => {
					if (!e) {
						this.log.warn("No result provided to track.product.impression");
						return;
					}
					let t = e.responseId;
					if (!this.events[t]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					if (this.events[t]?.product[e.id]?.impression) return;
					let n = ["product", "banner"].includes(e.type) ? e.type : "product", r = {
						type: n,
						uid: e.id ? "" + e.id : "",
						...n === "product" ? {
							parentId: e.mappings.core?.parentId ? "" + e.mappings.core?.parentId : "",
							sku: e.mappings.core?.sku ? "" + e.mappings.core?.sku : void 0
						} : {}
					}, i = {
						tag: this.store.profile.tag,
						responseId: t,
						results: [r],
						banners: []
					};
					this.eventManager.fire("track.product.impression", {
						controller: this,
						product: e,
						trackEvent: i
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].impression({
						data: i,
						siteId: this.config.globals?.siteId
					}), this.events[t].product[e.id] = this.events[t].product[e.id] || {}, this.events[t].product[e.id].impression = !0;
				},
				addToCart: (e) => {
					if (!e) {
						this.log.warn("No result provided to track.product.addToCart");
						return;
					}
					let t = e.responseId;
					if (!this.events[t]) {
						this.log.warn("No responseId found in controller, ensure correct controller is used");
						return;
					}
					let n = {
						parentId: e.display.mappings.core?.parentId ? "" + e.display.mappings.core?.parentId : "",
						uid: e.display.mappings.core?.uid || e.display.id,
						sku: e.display.mappings.core?.sku,
						qty: e.quantity || 1,
						price: Number(e.display.mappings.core?.price) || 0
					}, r = {
						responseId: t,
						tag: this.store.profile.tag,
						results: [n]
					};
					this.eventManager.fire("track.product.addToCart", {
						controller: this,
						product: e,
						trackEvent: r
					}), this.config.beacon?.enabled && this.tracker.events[this.beaconType].addToCart({
						data: r,
						siteId: this.config.globals?.siteId
					});
				}
			} }, this.search = async () => {
				try {
					this.initialized || await this.init();
					let e = this.params;
					this.store.loading = !0;
					try {
						await this.eventManager.fire("beforeSearch", {
							controller: this,
							request: e
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'beforeSearch' middleware cancelled");
							return;
						}
						throw this.log.error("error in 'beforeSearch' middleware"), e;
					}
					let t = this.profiler.create({
						type: "event",
						name: "search",
						context: e
					}).start(), { meta: n, profile: r, results: i, responseId: a } = await this.client.recommend(e);
					t.stop(), this.log.profile(t), this.events[a] = this.events[a] || { product: {} };
					let o = this.profiler.create({
						type: "event",
						name: "afterSearch",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterSearch", {
							controller: this,
							request: e,
							response: {
								meta: n,
								profile: r,
								results: i
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterSearch' middleware cancelled"), o.stop();
							return;
						}
						throw this.log.error("error in 'afterSearch' middleware"), e;
					}
					o.stop(), this.log.profile(o), this.store.update({
						meta: n,
						profile: r,
						results: i,
						responseId: a
					}), this.beaconType = this.store.profile.type === "bundle" ? "bundles" : "recommendations";
					let s = {
						responseId: a,
						tag: this.store.profile.tag
					};
					this.config.beacon?.enabled && this.tracker.events[this.beaconType].render({
						data: s,
						siteId: this.config.globals?.siteId
					});
					let c = this.profiler.create({
						type: "event",
						name: "afterStore",
						context: e
					}).start();
					try {
						await this.eventManager.fire("afterStore", {
							controller: this,
							request: e,
							response: {
								meta: n,
								profile: r,
								results: i,
								responseId: a
							}
						});
					} catch (e) {
						if (e?.message == "cancelled") {
							this.log.warn("'afterStore' middleware cancelled"), c.stop();
							return;
						}
						throw this.log.error("error in 'afterStore' middleware"), e;
					}
					c.stop(), this.log.profile(c);
				} catch (e) {
					if (e) {
						if (e.err && e.fetchDetails) {
							switch (e.fetchDetails.status) {
								case 429:
									this.store.error = {
										code: 429,
										type: $v.WARNING,
										message: "Too many requests try again later"
									};
									break;
								case 500:
									this.store.error = {
										code: 500,
										type: $v.ERROR,
										message: "Invalid Search Request or Service Unavailable"
									};
									break;
								default: this.store.error = {
									type: $v.ERROR,
									message: e.err.message
								};
							}
							this.log.error(this.store.error), this.handleError(e.err, e.fetchDetails);
						} else this.store.error = {
							type: $v.ERROR,
							message: `Something went wrong... - ${e}`
						}, this.log.error(e), this.handleError(e);
					}
				} finally {
					this.store.loading = !1;
				}
			}, this.addToCart = async (e) => {
				let t = typeof e?.slice == "function" ? e.slice() : [e];
				if (!e || t.length === 0) {
					this.log.warn("No products provided to recommendation controller.addToCart");
					return;
				}
				t.forEach((e) => {
					this.track.product.addToCart(e);
				}), t.length > 0 && await this.eventManager.fire("addToCart", {
					controller: this,
					products: t
				});
			}, !e.tag) throw Error("Invalid config passed to RecommendationController. The \"tag\" attribute is required.");
			e.settings?.searchOnPageShow !== !1 && window.addEventListener("pageshow", (e) => {
				e.persisted && !this.store.error && this.store.loaded && !this.store.loading && this.search();
			}), this.config = (0, Hy.default)(Uy, this.config), this.store.setConfig(this.config), this.use(this.config);
		}
		get params() {
			let e = {
				tag: this.config.tag,
				batched: this.config.batched,
				branch: this.config.branch || "production",
				batchId: this.config.batchId,
				...this.config.globals
			}, { shopperId: t } = this.tracker.getContext();
			if (t && (e.shopper = t), !e.siteId || e.siteId == this.tracker.getGlobals().siteId) {
				let t = this.tracker.cookies.cart.get(), n = this.tracker.cookies.viewed.get();
				t?.length && (e.cart = t), n?.length && (e.lastViewed = n);
			}
			return e;
		}
	};
})), Ky = o((() => {
	dy(), Dy(), Vy(), Gy(), ry(), sy();
})), qy = ["merge", "set"], Jy = [
	"query",
	"tag",
	"fallbackQuery"
], Yy = (e, t) => {
	let { parameters: n } = e, r = e.settings?.useDefaultIgnoreParameters ?? !0, i = e?.settings?.ignoreParameters || [];
	i = r ? i.concat(Jy) : i;
	let a = t, o = t.merge({});
	return Object.keys(n).forEach((e) => {
		let t = n[e].action || "merge", { state: r } = n[e], s = n[e].ignoreParameters || [], c = n[e].useGlobalIgnoreParameters ?? !0 ? i.concat(s) : s, l = Object.keys(a.state).filter((e) => !c.includes(e)).length == 0;
		r && l && qy.includes(t) && (o = o[t](e, r));
	}), o;
}, Xy = /* @__PURE__ */ s(((e, t) => {
	(function() {
		function n(e) {
			var t = typeof Symbol == "function" && Symbol.for && Symbol.for("react.element"), r = 60103, i = { use_static: !1 };
			a(e) && e.use_static !== void 0 && (i.use_static = !!e.use_static);
			function a(e) {
				return typeof e == "object" && !Array.isArray(e) && e !== null;
			}
			function o(e) {
				var t = Object.getPrototypeOf(e);
				return t ? Object.create(t) : {};
			}
			function s(e, t, n) {
				Object.defineProperty(e, t, {
					enumerable: !1,
					configurable: !1,
					writable: !1,
					value: n
				});
			}
			function c(e, t) {
				s(e, t, function() {
					throw new y("The " + t + " method cannot be invoked on an Immutable data structure.");
				});
			}
			var l = "__immutable_invariants_hold";
			function u(e) {
				s(e, l, !0);
			}
			function d(e) {
				return typeof e != "object" || !e || !!Object.getOwnPropertyDescriptor(e, l);
			}
			function f(e, t) {
				return e === t || e !== e && t !== t;
			}
			function p(e) {
				return typeof e == "object" && !!e && !Array.isArray(e) && !(e instanceof Date);
			}
			var m = ["setPrototypeOf"], h = ["keys"], g = m.concat([
				"push",
				"pop",
				"sort",
				"splice",
				"shift",
				"unshift",
				"reverse"
			]), _ = h.concat([
				"map",
				"filter",
				"slice",
				"concat",
				"reduce",
				"reduceRight"
			]), v = m.concat([
				"setDate",
				"setFullYear",
				"setHours",
				"setMilliseconds",
				"setMinutes",
				"setMonth",
				"setSeconds",
				"setTime",
				"setUTCDate",
				"setUTCFullYear",
				"setUTCHours",
				"setUTCMilliseconds",
				"setUTCMinutes",
				"setUTCMonth",
				"setUTCSeconds",
				"setYear"
			]);
			function y(e) {
				this.name = "MyError", this.message = e, this.stack = (/* @__PURE__ */ Error()).stack;
			}
			y.prototype = /* @__PURE__ */ Error(), y.prototype.constructor = Error;
			function b(e, t) {
				for (var n in u(e), t) t.hasOwnProperty(n) && c(e, t[n]);
				return Object.freeze(e), e;
			}
			function ee(e, t) {
				var n = e[t];
				s(e, t, function() {
					return T(n.apply(e, arguments));
				});
			}
			function x(e, t, n) {
				var r = n && n.deep;
				if (e in this && (r && this[e] !== t && p(t) && p(this[e]) && (t = T.merge(this[e], t, {
					deep: !0,
					mode: "replace"
				})), f(this[e], t))) return this;
				var i = oe.call(this);
				return i[e] = T(t), ne(i);
			}
			var S = T([]);
			function te(e, t, n) {
				var r = e[0];
				if (e.length === 1) return x.call(this, r, t, n);
				var i = e.slice(1), a = this[r], o;
				if (typeof a == "object" && a) o = T.setIn(a, i, t);
				else {
					var s = i[0];
					o = s !== "" && isFinite(s) ? te.call(S, i, t) : pe.call(fe, i, t);
				}
				if (r in this && a === o) return this;
				var c = oe.call(this);
				return c[r] = o, ne(c);
			}
			function ne(e) {
				for (var t in _) if (_.hasOwnProperty(t)) {
					var n = _[t];
					ee(e, n);
				}
				i.use_static || (s(e, "flatMap", ie), s(e, "asObject", se), s(e, "asMutable", oe), s(e, "set", x), s(e, "setIn", te), s(e, "update", he), s(e, "updateIn", _e), s(e, "getIn", ve));
				for (var r = 0, a = e.length; r < a; r++) e[r] = T(e[r]);
				return b(e, g);
			}
			function re(e) {
				return i.use_static || s(e, "asMutable", C), b(e, v);
			}
			function C() {
				return new Date(this.getTime());
			}
			function ie(e) {
				if (arguments.length === 0) return this;
				var t = [], n = this.length, r;
				for (r = 0; r < n; r++) {
					var i = e(this[r], r, this);
					Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
				}
				return ne(t);
			}
			function ae(e) {
				if (e === void 0 && arguments.length === 0) return this;
				if (typeof e != "function") {
					var t = Array.isArray(e) ? e.slice() : Array.prototype.slice.call(arguments);
					t.forEach(function(e, t, n) {
						typeof e == "number" && (n[t] = e.toString());
					}), e = function(e, n) {
						return t.indexOf(n) !== -1;
					};
				}
				var n = o(this);
				for (var r in this) this.hasOwnProperty(r) && e(this[r], r) === !1 && (n[r] = this[r]);
				return w(n);
			}
			function oe(e) {
				var t = [], n, r;
				if (e && e.deep) for (n = 0, r = this.length; n < r; n++) t.push(ce(this[n]));
				else for (n = 0, r = this.length; n < r; n++) t.push(this[n]);
				return t;
			}
			function se(e) {
				typeof e != "function" && (e = function(e) {
					return e;
				});
				var t = {}, n = this.length, r;
				for (r = 0; r < n; r++) {
					var i = e(this[r], r, this), a = i[0];
					t[a] = i[1];
				}
				return w(t);
			}
			function ce(e) {
				return !e || typeof e != "object" || !Object.getOwnPropertyDescriptor(e, l) || e instanceof Date ? e : T.asMutable(e, { deep: !0 });
			}
			function le(e, t) {
				for (var n in e) Object.getOwnPropertyDescriptor(e, n) && (t[n] = e[n]);
				return t;
			}
			function ue(e, t) {
				if (arguments.length === 0) return this;
				if (typeof e != "object" || !e) throw TypeError("Immutable#merge can only be invoked with objects or arrays, not " + JSON.stringify(e));
				var n = Array.isArray(e), r = t && t.deep, i = t && t.mode || "merge", a = t && t.merger, s;
				function c(e, n, i) {
					var c = T(n[i]), l = a && a(e[i], c, t), u = e[i];
					if (s !== void 0 || l !== void 0 || !e.hasOwnProperty(i) || !f(c, u)) {
						var d = l === void 0 ? r && p(u) && p(c) ? T.merge(u, c, t) : c : l;
						(!f(u, d) || !e.hasOwnProperty(i)) && (s === void 0 && (s = le(e, o(e))), s[i] = d);
					}
				}
				function l(e, t) {
					for (var n in e) t.hasOwnProperty(n) || (s === void 0 && (s = le(e, o(e))), delete s[n]);
				}
				var u;
				if (n) for (var d = 0, m = e.length; d < m; d++) {
					var h = e[d];
					for (u in h) h.hasOwnProperty(u) && c(s === void 0 ? this : s, h, u);
				}
				else {
					for (u in e) Object.getOwnPropertyDescriptor(e, u) && c(this, e, u);
					i === "replace" && l(this, e);
				}
				return s === void 0 ? this : w(s);
			}
			function de(e, t) {
				var n = t && t.deep;
				if (arguments.length === 0) return this;
				if (typeof e != "object" || !e) throw TypeError("Immutable#replace can only be invoked with objects or arrays, not " + JSON.stringify(e));
				return T.merge(this, e, {
					deep: n,
					mode: "replace"
				});
			}
			var fe = T({});
			function pe(e, t, n) {
				if (!Array.isArray(e) || e.length === 0) throw TypeError("The first argument to Immutable#setIn must be an array containing at least one \"key\" string.");
				var r = e[0];
				if (e.length === 1) return me.call(this, r, t, n);
				var i = e.slice(1), a, s = this[r];
				if (a = this.hasOwnProperty(r) && typeof s == "object" && s ? T.setIn(s, i, t) : pe.call(fe, i, t), this.hasOwnProperty(r) && s === a) return this;
				var c = le(this, o(this));
				return c[r] = a, w(c);
			}
			function me(e, t, n) {
				var r = n && n.deep;
				if (this.hasOwnProperty(e) && (r && this[e] !== t && p(t) && p(this[e]) && (t = T.merge(this[e], t, {
					deep: !0,
					mode: "replace"
				})), f(this[e], t))) return this;
				var i = le(this, o(this));
				return i[e] = T(t), w(i);
			}
			function he(e, t) {
				var n = Array.prototype.slice.call(arguments, 2), r = this[e];
				return T.set(this, e, t.apply(r, [r].concat(n)));
			}
			function ge(e, t) {
				for (var n = 0, r = t.length; e != null && n < r; n++) e = e[t[n]];
				return n && n == r ? e : void 0;
			}
			function _e(e, t) {
				var n = Array.prototype.slice.call(arguments, 2), r = ge(this, e);
				return T.setIn(this, e, t.apply(r, [r].concat(n)));
			}
			function ve(e, t) {
				var n = ge(this, e);
				return n === void 0 ? t : n;
			}
			function ye(e) {
				var t = o(this), n;
				if (e && e.deep) for (n in this) this.hasOwnProperty(n) && (t[n] = ce(this[n]));
				else for (n in this) this.hasOwnProperty(n) && (t[n] = this[n]);
				return t;
			}
			function be() {
				return {};
			}
			function w(e) {
				return i.use_static || (s(e, "merge", ue), s(e, "replace", de), s(e, "without", ae), s(e, "asMutable", ye), s(e, "set", me), s(e, "setIn", pe), s(e, "update", he), s(e, "updateIn", _e), s(e, "getIn", ve)), b(e, m);
			}
			function xe(e) {
				return typeof e == "object" && !!e && (e.$$typeof === r || e.$$typeof === t);
			}
			function Se(e) {
				return typeof File < "u" && e instanceof File;
			}
			function Ce(e) {
				return typeof Blob < "u" && e instanceof Blob;
			}
			function we(e) {
				return typeof e == "object" && typeof e.then == "function";
			}
			function Te(e) {
				return e instanceof Error;
			}
			function T(e, t, n) {
				if (d(e) || xe(e) || Se(e) || Ce(e) || Te(e)) return e;
				if (we(e)) return e.then(T);
				if (Array.isArray(e)) return ne(e.slice());
				if (e instanceof Date) return re(new Date(e.getTime()));
				var r = t && t.prototype, i = (!r || r === Object.prototype ? be : (function() {
					return Object.create(r);
				}))();
				if (n ??= 64, n <= 0) throw new y("Attempt to construct Immutable from a deeply nested object was detected. Have you tried to wrap an object with circular references (e.g. React element)? See https://github.com/rtfeldman/seamless-immutable/wiki/Deeply-nested-object-was-detected for details.");
				for (var a in --n, e) Object.getOwnPropertyDescriptor(e, a) && (i[a] = T(e[a], void 0, n));
				return w(i);
			}
			function Ee(e) {
				function t() {
					var t = [].slice.call(arguments), n = t.shift();
					return e.apply(n, t);
				}
				return t;
			}
			function De(e, t) {
				function n() {
					var n = [].slice.call(arguments), r = n.shift();
					return Array.isArray(r) ? t.apply(r, n) : e.apply(r, n);
				}
				return n;
			}
			function Oe(e, t, n) {
				function r() {
					var r = [].slice.call(arguments), i = r.shift();
					return Array.isArray(i) ? t.apply(i, r) : i instanceof Date ? n.apply(i, r) : e.apply(i, r);
				}
				return r;
			}
			return T.from = T, T.isImmutable = d, T.ImmutableError = y, T.merge = Ee(ue), T.replace = Ee(de), T.without = Ee(ae), T.asMutable = Oe(ye, oe, C), T.set = De(me, x), T.setIn = De(pe, te), T.update = Ee(he), T.updateIn = Ee(_e), T.getIn = Ee(ve), T.flatMap = Ee(ie), T.asObject = Ee(se), i.use_static || (T.static = n({ use_static: !0 })), Object.freeze(T), T;
		}
		var r = n();
		/* istanbul ignore if */
		typeof define == "function" && define.amd ? define(function() {
			return r;
		}) : typeof t == "object" ? t.exports = r : typeof e == "object" ? e.Immutable = r : typeof window == "object" ? window.Immutable = r : typeof global == "object" && (global.Immutable = r);
	})();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/UrlManager/UrlManager.js
function Zy(e) {
	return Array.isArray(e) && e.length ? e.reduce((e, t) => (e.some((e) => $y(e, t)) || e.push(t), e), [e[0]]) : e;
}
function Qy(e, t) {
	if (e instanceof Array && t instanceof Array) return Zy([...e, ...t]);
}
function $y(e, t) {
	if (!e && !t) return !0;
	if (!e && t || e && !t) return !1;
	let n = [
		"string",
		"number",
		"boolean",
		"undefined"
	], r = typeof e;
	if (r !== typeof t) return !1;
	if (n.includes(r)) return e === t;
	let i = Array.isArray(e);
	if (i !== Array.isArray(t)) return !1;
	if (i) {
		if (e.length != t.length) return !1;
		for (let n = 0; n < e.length; n++) if (!$y(e[n], t[n])) return !1;
	} else {
		if (!$y(Object.keys(e).sort(), Object.keys(t).sort())) return !1;
		let n = !0;
		return Object.keys(e).forEach((r) => {
			$y(e[r], t[r]) || (n = !1);
		}), n;
	}
	return !0;
}
var eb, tb, nb, rb = o((() => {
	eb = /* @__PURE__ */ u(Xy()), tb = class {
		constructor() {
			this.callbacks = [];
		}
		subscribe(e) {
			return this.callbacks.push(e), () => this.callbacks = this.callbacks.filter((t) => t != e);
		}
		notify() {
			this.callbacks.forEach((e) => e());
		}
	}, nb = class e {
		constructor(e, t, n, r, i, a = [], o) {
			this.linker = t, this.omissions = a, this.detached = o, this.urlState = (0, eb.default)({}), this.globalState = (0, eb.default)({}), this.localState = (0, eb.default)({}), this.mergedState = (0, eb.default)({}), this.localState = (0, eb.default)(r || {}), this.globalState = (0, eb.default)(n || {}), this.translator = e;
			let s = this.getTranslatorConfig();
			s.urlRoot && s.settings?.serializeUrlRoot && (this.globalState = this.globalState.merge((0, eb.default)(this.translator.deserialize(s.urlRoot)), {
				deep: !0,
				merger: Qy
			})), i ? this.watcherPool = i : (this.watcherPool = new tb(), this.translator.bindExternalEvents instanceof Function && this.translator.bindExternalEvents(() => this.watcherPool.notify())), this.subscribe(() => {
				this.refresh();
			}), this.refresh();
		}
		without(e, t, n) {
			let r = t.slice(0, -1), i = t[t.length - 1];
			if (!r.length) return n?.length ? a(i, e) : e.without(i);
			if (!e.getIn(r)) return e;
			return e.updateIn(r, (e) => a(i, e));
			function a(e, t) {
				return t[i] === void 0 ? t : t[i] instanceof Array ? !n || !n.length ? t.without(i) : t.set(i, t[i].filter((e) => !n.some((t) => $y(e, t)))) : typeof t == "object" ? t.without(i) : t;
			}
		}
		getTranslatorUrl() {
			return this.detached ? this.detached.url : this.translator.getCurrentUrl();
		}
		refresh() {
			this.prevState = this.mergedState, this.urlState = this.omissions.reduce((e, t) => this.without(e, t.path, t.values), (0, eb.default)(this.translator.deserialize(this.getTranslatorUrl()))), this.mergedState = this.globalState.merge(this.urlState, {
				deep: !0,
				merger: Qy
			}), this.mergedState = this.mergedState.merge(this.localState, {
				deep: !0,
				merger: Qy
			});
		}
		get state() {
			return this.mergedState;
		}
		unpackPathAndState(e, t) {
			return {
				path: e instanceof Array ? e : typeof e == "string" ? e.split(".") : [],
				state: !(e instanceof Array) && typeof e == "object" ? e : t === void 0 ? {} : t
			};
		}
		set(...t) {
			let { path: n, state: r } = this.unpackPathAndState(t[0], t[1]), i = n.length ? this.localState.setIn(n, Zy(r)) : Zy(r), a = Zy(this.omissions.concat(n.length ? { path: n } : Object.keys(this.urlState).map((e) => ({ path: [e] }))));
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, a, this.detached);
		}
		merge(...t) {
			let { path: n, state: r } = this.unpackPathAndState(t[0], t[1]), i = n.length ? this.localState.updateIn(n, (e) => {
				if (e instanceof Array) {
					let t = Array.isArray(r) ? r : [r];
					return Zy(e.concat(t));
				}
				if (typeof e == "object") return Array.isArray(r) ? r.length ? Zy([e].concat(r)) : e : e.merge(r, {
					deep: !0,
					merger: Qy
				});
				if (e !== void 0) {
					let t = (Array.isArray(r) ? r : [r]).filter((t) => !$y(t, e));
					return t.length ? Zy([e].concat(t)) : e;
				}
				return e === void 0 && this.urlState.getIn(n) instanceof Array && !Array.isArray(r) ? [r] : r;
			}) : this.localState.merge(r, {
				deep: !0,
				merger: Qy
			});
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, this.omissions, this.detached);
		}
		remove(t, n) {
			let { path: r } = this.unpackPathAndState(t, {});
			n = n === void 0 ? [] : n instanceof Array ? n : [n];
			let i = this.without(this.localState, r, n), a = Zy(this.omissions.concat({
				path: r,
				values: n
			}));
			return new e(this.translator, this.linker, this.globalState, i, this.watcherPool, a, this.detached);
		}
		reset() {
			return this.detached && (this.detached.url = ""), new e(this.translator, this.linker, this.globalState, {}, this.watcherPool, Object.keys(this.urlState).map((e) => ({ path: [e] })), this.detached);
		}
		withConfig(t) {
			return t instanceof Function && (t = t(this.translator.getConfig())), new e(new (Object.getPrototypeOf(this.translator)).constructor(t), this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
		}
		withGlobals(t) {
			return this.globalState = this.globalState.merge((0, eb.default)(t), {
				deep: !0,
				merger: Qy
			}), new e(this.translator, this.linker, this.globalState, this.localState, this.watcherPool, this.omissions, this.detached);
		}
		getTranslatorConfig() {
			return this.translator.getConfig();
		}
		get href() {
			return this.translator.serialize(this.state);
		}
		go(e) {
			this.detached ? this.detached.url = this.href : this.translator.go(this.href, e), this.watcherPool.notify();
		}
		detach(t = !1) {
			return new e(this.translator, this.linker, this.globalState, this.localState, new tb(), this.omissions, { url: t ? "" : this.getTranslatorUrl() });
		}
		get link() {
			return this.linker ? this.linker(this) : {};
		}
		subscribe(e) {
			return this.watcherPool.subscribe(() => {
				let t = this.prevState, n = this.mergedState;
				e(t, n);
			});
		}
	};
})), ib, $, ab = o((() => {
	(function(e) {
		e.LOW = "low", e.HIGH = "high";
	})(ib ||= {}), (function(e) {
		e.hash = "hash", e.query = "query";
	})($ ||= {});
})), ob = o((() => {
	ji(), Xy();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/Translators/Url/UrlTranslator.js
function sb(e) {
	return typeof e == "string" && (e = e.replace(/%2425/g, "$$25"), e = e.replace(/\$25/g, "%"), e = decodeURIComponent(e)), e;
}
function cb(e) {
	return typeof e == "string" && (e = encodeURIComponent(e), e = e.replace(/%/g, "$$25")), e;
}
var lb, ub, db, fb, pb = o((() => {
	lb = /* @__PURE__ */ u(ji()), ab(), ub = {
		urlRoot: "",
		settings: {
			corePrefix: "",
			customType: $.query,
			serializeUrlRoot: !0
		},
		parameters: {
			core: {
				query: {
					name: "q",
					type: $.query
				},
				rq: {
					name: "rq",
					type: $.query
				},
				tag: {
					name: "tag",
					type: $.query
				},
				page: {
					name: "page",
					type: $.query
				},
				pageSize: {
					name: "pageSize",
					type: $.hash
				},
				sort: {
					name: "sort",
					type: $.hash
				},
				filter: {
					name: "filter",
					type: $.hash
				},
				fallbackQuery: {
					name: "fallbackQuery",
					type: $.query
				}
			},
			custom: {}
		}
	}, db = [
		"query",
		"fallbackQuery",
		"rq",
		"tag",
		"page",
		"pageSize",
		"sort",
		"filter"
	], fb = class {
		constructor(e) {
			this.reverseMapping = {}, this.coreNames = {}, this.config = (0, lb.default)(ub, e || {}), Object.keys(this.config.parameters.core).forEach((t) => {
				let n = this.config.parameters.core[t], r = this.config.settings.corePrefixParams, i = (!r || r.includes(t)) && this.config.settings.corePrefix || "";
				this.coreNames[t] = i + n.name;
				let a = this.config.settings?.coreType;
				a && Object.values($).includes(a) && (n.type = e?.parameters?.core && e.parameters?.core[t]?.type ? e.parameters?.core[t]?.type : a), this.reverseMapping[this.coreNames[t]] = t;
			});
			let t = this.config.settings?.customType;
			t && !Object.values($).includes(t) && (this.config.settings.customType = $.hash);
		}
		bindExternalEvents(e) {
			window.addEventListener("popstate", e);
		}
		getCurrentUrl() {
			return window.location.search + window.location.hash;
		}
		getConfig() {
			return (0, lb.default)({}, this.config);
		}
		deserialize(e) {
			let t = this.parseUrlParams(e);
			return this.paramsToState(t);
		}
		parseUrlParams(e) {
			let t = e.includes("?") && (e.split("?").pop() || "").split("#").shift() || "", n = e.includes("#") && e.substring(e.indexOf("#") + 1) || "";
			return [...this.parseHashString(n), ...this.parseQueryString(t)];
		}
		parseQueryString(e) {
			return (e.split("?").pop() || "").split("&").filter((e) => e).map((e) => {
				try {
					let [t, n] = e.split("=").map((e) => decodeURIComponent(e.replace(/\+/g, " ")));
					return {
						key: t.split("."),
						value: n,
						type: $.query
					};
				} catch {
					return console.warn("Snap UrlTranslator: URI malformed - ignoring parameter", e), {
						key: ["ss__delete"],
						value: "ss__delete",
						type: $.query
					};
				}
			}).filter((e) => {
				let t = this.reverseMapping[e.key[0]];
				return e.value === "ss__delete" ? "" : !t || t && e.value;
			});
		}
		parseHashString(e) {
			let t = [];
			return (e.split("#").pop() || "").split("/").filter((e) => e).map((e) => {
				try {
					return e.split(":").map((e) => sb(e));
				} catch {
					return console.warn("Snap UrlTranslator: URI malformed - ignoring parameter", e), [];
				}
			}).filter((e) => {
				let [t, n] = e, r = this.reverseMapping[t];
				return !r || r && n;
			}).forEach((e) => {
				if (e.length == 1) t.push({
					key: [e[0]],
					value: "",
					type: $.hash
				});
				else if (e.length && e.length >= 2) {
					let n = this.reverseMapping[e[0]];
					if (n && n == "filter" && e.length == 4) {
						let [n, r, i, a] = e;
						t.push({
							key: [
								n,
								r,
								"low"
							],
							value: i,
							type: $.hash
						}), t.push({
							key: [
								n,
								r,
								"high"
							],
							value: a,
							type: $.hash
						});
					} else {
						let [n, ...r] = e.reverse();
						t.push({
							key: r.reverse(),
							value: n,
							type: $.hash
						});
					}
				}
			}), t;
		}
		paramsToState(e) {
			let t = [], n = [], r = [], i = [];
			return e?.forEach((e) => {
				let a = this.reverseMapping[e.key[0]], o = this.config.parameters.core[a], s = this.config.parameters.custom[e.key[0]];
				if (a) switch (a) {
					case "filter":
						o.type == e.type && n.push(e);
						break;
					case "sort":
						o.type == e.type && r.push(e);
						break;
					default: o.type == e.type && t.push(e);
				}
				else db.includes(e.key[0]) || (s || (this.config.parameters.custom[e.key[0]] = { type: e.type || this.config.settings.customType }), i.push(e));
			}), {
				...this.parseCoreOther(t),
				...this.parseCoreFilter(n),
				...this.parseCoreSort(r),
				...this.parseOther(i)
			};
		}
		parseCoreOther(e) {
			let t = {}, n = ["page", "pageSize"];
			return e ? (e.forEach((e) => {
				let r = this.reverseMapping[e.key[0]];
				if (n.includes(r)) {
					let n = Number(e.value);
					(r == "page" && n > 1 || r != "page") && (t[r] = n);
				} else t[r] = e.value;
			}), t) : {};
		}
		parseCoreFilter(e) {
			let t = e.filter((e) => e.key.length == 2), n = e.filter((e) => e.key.length == 3), r = t.reduce((e, t) => {
				let n = (e.filter || {})[t.key[1]] || [];
				return { filter: {
					...e.filter,
					[t.key[1]]: [...Array.isArray(n) ? n : [n], t.value]
				} };
			}, {}), i = n.reduce((e, t, r) => {
				let i = e, a = n[r + 1];
				if (r % 2 == 0 && a && a.key[1] == t.key[1] && t.key[2] == ib.LOW && a.key[2] == ib.HIGH) {
					let n = (e.filter || {})[t.key[1]] || [];
					i = { filter: {
						...e.filter,
						[t.key[1]]: [...Array.isArray(n) ? n : [n], {
							[ib.LOW]: isNaN(+t.value) ? null : +t.value,
							[ib.HIGH]: isNaN(+a.value) ? null : +a.value
						}]
					} };
				}
				return i;
			}, {});
			return { ...r.filter || i.filter ? { filter: {
				...r.filter,
				...i.filter
			} } : {} };
		}
		parseCoreSort(e) {
			return e.length ? { sort: e.map((e) => ({
				field: e.key[1],
				direction: e.value
			})) } : {};
		}
		parseOther(e) {
			let t = {};
			return e.forEach((e) => {
				let n = t;
				e.key.forEach((t, r) => {
					r == e.key.length - 1 ? (n[t] = n[t] || [], e.value && n[t].push(e.value)) : (n[t] = n[t] || {}, n = n[t]);
				});
			}), t;
		}
		serialize(e) {
			let t = this.config.urlRoot.includes("?") ? this.config.urlRoot.split("?")[0] : this.config.urlRoot.includes("#") ? this.config.urlRoot.split("#")[0] : this.config.urlRoot || window.location.pathname, n = this.stateToParams(e), r = n.filter((e) => e.type == $.query), i = n.filter((e) => e.type == $.hash);
			return `${t}${r.length ? "?" + r.map((e) => encodeURIComponent(e.key.join(".")) + (e.value ? "=" + encodeURIComponent(e.value) : "")).join("&") : ""}${i.length ? "#/" + i.map((e) => e.key.map((e) => cb(e)).join(":") + (e.value ? ":" + cb(e.value) : "")).join("/") : ""}`;
		}
		stateToParams(e) {
			return [
				...this.encodeOther(e),
				...this.encodeCoreOther(e, ["filter", "sort"]),
				...this.encodeCoreFilters(e),
				...this.encodeCoreSorts(e)
			];
		}
		encodeCoreFilters(e) {
			let t = this.config.parameters.core.filter, n = this.coreNames.filter;
			return !e.filter || !t ? [] : Object.keys(e.filter).flatMap((r) => {
				if (!e.filter || !e.filter[r]) return [];
				let i = e.filter[r];
				return (i instanceof Array ? i : [i]).flatMap((e) => {
					if (typeof e == "string" || typeof e == "number" || typeof e == "boolean") return [{
						key: [n, r],
						value: "" + e,
						type: t.type
					}];
					if (typeof e == "object" && e[ib.LOW] !== void 0 && e[ib.HIGH] !== void 0) {
						if (t.type == $.query) return [{
							key: [
								n,
								r,
								ib.LOW
							],
							value: "" + (e[ib.LOW] ?? "*"),
							type: t.type
						}, {
							key: [
								n,
								r,
								ib.HIGH
							],
							value: "" + (e[ib.HIGH] ?? "*"),
							type: t.type
						}];
						if (t.type == $.hash) return [{
							key: [
								n,
								r,
								"" + (e[ib.LOW] ?? "*")
							],
							value: "" + (e[ib.HIGH] ?? "*"),
							type: t.type
						}];
					}
					return [];
				});
			});
		}
		encodeCoreSorts(e) {
			let t = this.config.parameters.core.sort;
			return !e.sort || !t ? [] : (e.sort instanceof Array ? e.sort : [e.sort]).map((e) => ({
				key: [this.coreNames.sort, e.field],
				value: e.direction,
				type: t.type
			}));
		}
		encodeCoreOther(e, t) {
			let n = [];
			return Object.keys(e).sort(function(e, t) {
				return db.indexOf(e) - db.indexOf(t);
			}).map((r) => {
				if (db.includes(r) && !t.includes(r)) {
					let t = this.config.parameters.core[r];
					r == "page" && e[r] == 1 || n.push({
						key: [this.coreNames[r]],
						value: "" + e[r],
						type: t.type
					});
				}
			}), n;
		}
		encodeOther(e) {
			let t = [], n = (e, r) => {
				Object.keys(e).forEach((i) => {
					if (r.length == 0 && db.includes(i)) return;
					let a = e[i];
					if (a instanceof Array) {
						let e = this.config.parameters.custom[r[0] || i]?.type || this.config.settings.customType;
						t = a.length ? t.concat(a.map((t) => ({
							key: [...r, i],
							value: t,
							type: e
						}))) : t.concat({
							key: [...r, i],
							value: "",
							type: e
						});
					} else if (typeof a == "object" && Object.keys(a || {}).length) n(a, [...r, i]);
					else {
						let e = this.config.parameters.custom[r[0] || i]?.type || this.config.settings.customType, n = typeof a == "object" ? void 0 : a;
						t = t.concat([{
							key: [...r, i],
							value: n,
							type: e
						}]);
					}
				});
			};
			return n(e, []), t;
		}
		go(e, t) {
			e != this.getCurrentUrl() && (t?.history == "replace" ? history.replaceState(null, "", e) : history.pushState(null, "", e));
		}
	};
})), mb = o((() => {})), hb = o((() => {
	ob(), pb(), mb();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-url-manager/dist/esm/linkers/react/react.js
function gb(e) {
	return {
		href: e.href,
		onClick: (t) => {
			e?.detached || t?.preventDefault(), e.go();
		}
	};
}
var _b = o((() => {})), vb = o((() => {
	_b();
})), yb = o((() => {
	rb(), hb(), vb();
})), bb, xb, Sb = o((() => {
	bb = class {
		constructor(e) {
			this.namespace = e || "", this.profiles = [];
		}
		setNamespace(e) {
			this.namespace ||= e;
		}
		create({ type: e, name: t, context: n }) {
			if (!t) throw Error("Profile name is required.");
			let r = new xb(this.namespace, {
				type: e,
				name: t,
				context: n
			});
			return this.profiles.push(r), r;
		}
	}, xb = class {
		constructor(e, { type: t, name: n, context: r }) {
			this.status = "pending", this.time = {
				date: 0,
				begin: 0,
				end: 0,
				run: 0
			}, this.namespace = e, this.type = t, this.name = n, this.context = r;
		}
		start() {
			return this.time.begin || (this.time.date = Date.now(), this.time.begin = window.performance.now(), this.status = "started"), this;
		}
		stop() {
			return !this.time.end && this.time.begin && (this.time.date = Date.now(), this.time.end = window.performance.now(), this.time.run = +(this.time.end - this.time.begin).toFixed(3), this.status = "finished"), this;
		}
	};
})), Cb = o((() => {
	Sb();
})), wb = /* @__PURE__ */ c({ default: () => Tb }), Tb, Eb = o((() => {
	Ky(), vd(), ty(), yb(), Wv(), Cb(), Td(), c_(), Tb = (e, t) => {
		let n = t?.urlManager || new nb(new fb(e.url), gb);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Ey(e.controller, {
			client: t?.client || new gd(e.client.globals, e.client.config),
			store: t?.store || new Fv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new Vv(),
			profiler: t?.profiler || new bb(),
			logger: t?.logger || new Cd({ mode: e.mode }),
			tracker: t?.tracker || new a_(e.client.globals)
		}, e.context);
	};
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/src/utils/configureSnapFeatures/configureSnapFeatures.js
function Db(e) {
	Ob(e);
}
function Ob(e) {
	let t;
	try {
		t = window.sessionStorage?.getItem(kb);
	} catch {}
	if (t) try {
		if (JSON.parse(t)?.enabled) {
			let t = [
				"product.view",
				"cart.view",
				"order.transaction"
			];
			e.tracker = e.tracker || {}, e.tracker.config = e.tracker.config || {}, e.tracker.config.doNotTrack = (e.tracker.config.doNotTrack || []).concat(t);
		}
	} catch {}
}
var kb, Ab = o((() => {
	kb = "ssWebPixel";
})), jb = o((() => {
	Ab();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/src/setupEvents.js
Wv();
var Mb = () => {
	let e = new Vv();
	return e.on("controller/selectVariantOptions", async (e, t) => {
		let { options: n, controllerIds: r } = e;
		Nb(r).map((e) => {
			e.store?.results && e.store?.results.forEach((e) => {
				e.type == "product" && e.variants?.makeSelections(n);
			});
		}), await t();
	}), e.on("controller/recommendation/update", async (e, t) => {
		let { controllerIds: n } = e || {};
		Nb(n).filter((e) => !!(e.type === "recommendation" && e.config?.realtime)).map((e) => {
			e.search();
		}), await t();
	}), e;
}, Nb = (e) => Object.keys(window.athos.controller || {}).reduce((t, n) => {
	let r = window.athos.controller[n];
	return (!e || (Array.isArray(e) && e.forEach((e) => {
		if (e instanceof RegExp) {
			if (n.match(e)?.length) return t.push(r), t;
		} else if (n == e) return t.push(r), t;
	}), typeof e == "string" && e === n)) && t.push(r), t;
}, []), Pb = /* @__PURE__ */ c({ default: () => Fb }), Fb, Ib = o((() => {
	Ky(), vd(), ty(), yb(), Wv(), Cb(), Td(), c_(), Fb = (e, t) => {
		let { globals: n, ...r } = e.url || {}, i = (t?.urlManager || new nb(new fb(r), gb)).detach();
		return n?.length && (i = i.withGlobals(Object.fromEntries(n.map(({ param: e, value: t }) => [e, [t]])))), e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new zy(e.controller, {
			client: t?.client || new gd(e.client.globals, e.client.config),
			store: t?.store || new wv(e.controller, { urlManager: i }),
			urlManager: i,
			eventManager: t?.eventManager || new Vv(),
			profiler: t?.profiler || new bb(),
			logger: t?.logger || new Cd({ mode: e.mode }),
			tracker: t?.tracker || new a_(e.client.globals)
		}, e.context);
	};
})), Lb = /* @__PURE__ */ c({ default: () => Rb }), Rb, zb = o((() => {
	Ky(), vd(), ty(), yb(), Wv(), Cb(), Td(), c_(), Rb = (e, t) => {
		let n = (t?.urlManager || new nb(new fb(e.url), gb)).detach(!0);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new uy(e.controller, {
			client: t?.client || new gd(e.client.globals, e.client.config),
			store: t?.store || new Nv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new Vv(),
			profiler: t?.profiler || new bb(),
			logger: t?.logger || new Cd({ mode: e.mode }),
			tracker: t?.tracker || new a_(e.client.globals)
		}, e.context);
	};
})), Bb = /* @__PURE__ */ c({ default: () => Vb }), Vb, Hb = o((() => {
	Ky(), vd(), ty(), yb(), Wv(), Cb(), Td(), c_(), Vb = (e, t) => {
		let n = (t?.urlManager || new nb(new fb(e.url), gb)).detach(!0);
		return e.mode && e.client && (e.client.config = e.client.config || {}, e.client.config.mode = e.mode), new Wy(e.controller, {
			client: t?.client || new gd(e.client.globals, e.client.config),
			store: t?.store || new Zv(e.controller, { urlManager: n }),
			urlManager: n,
			eventManager: t?.eventManager || new Vv(),
			profiler: t?.profiler || new bb(),
			logger: t?.logger || new Cd({ mode: e.mode }),
			tracker: t?.tracker || new a_(e.client.globals)
		}, e.context);
	};
})), Ub = /* @__PURE__ */ c({ getBundleDetails: () => Wb }), Wb, Gb = o((() => {
	Wb = async (e) => new Promise((t, n) => {
		let r = new XMLHttpRequest();
		r.open("HEAD", e, !0), r.onreadystatechange = () => {
			if (r.readyState === r.DONE) {
				let i = r.status, a = r.getResponseHeader("Last-Modified");
				a && i === 0 || i >= 200 && i < 400 ? t({
					url: e,
					lastModified: a?.split(",")[1]?.trim() || ""
				}) : n({
					message: "Branch not found!",
					description: "Incorrect branch name or branch no longer exists."
				});
			}
		}, r.onerror = () => n({
			message: "Branch load fail!",
			description: "There was an error with the request."
		}), r.send();
	});
}));
//#endregion
//#region node_modules/@emotion/react/dist/emotion-react.browser.esm.js
function Kb() {
	return ti([...arguments]);
}
var qb, Jb = o((() => {
	Di(), yn(), gi(), fi(), Wr(), qb = function(e, t) {
		var n = arguments;
		if (t == null || !Si.call(t, "css")) return m.apply(void 0, n);
		var r = n.length, i = Array(r);
		i[0] = Ei, i[1] = wi(e, t);
		for (var a = 2; a < r; a++) i[a] = n[a];
		return m.apply(null, i);
	};
})), Yb = /* @__PURE__ */ s(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})), Xb = o((() => {
	if (H(), yn(), !Ve) throw Error("mobx-react-lite requires React with Hooks support");
	if (!F) throw Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
})), Zb = o((() => {
	yn();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/utils/observerBatching.js
function Qb(e) {
	e();
}
function $b(e) {
	e ||= Qb, Yo({ reactionScheduler: e });
}
var ex = o((() => {
	H();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/utils/printDebugValue.js
function tx(e) {
	return Zo(e);
}
var nx = o((() => {
	H();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/staticRendering.js
function rx() {
	return ix;
}
var ix, ax = o((() => {
	ix = !1;
})), ox, sx, cx, lx, ux = o((() => {
	ox = 1e4, sx = 1e4, cx = function() {
		function e(e) {
			var t = this;
			Object.defineProperty(this, "finalize", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: e
			}), Object.defineProperty(this, "registrations", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: /* @__PURE__ */ new Map()
			}), Object.defineProperty(this, "sweepTimeout", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: void 0
			}), Object.defineProperty(this, "sweep", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: function(e) {
					e === void 0 && (e = ox), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
					var n = Date.now();
					t.registrations.forEach(function(r, i) {
						n - r.registeredAt >= e && (t.finalize(r.value), t.registrations.delete(i));
					}), t.registrations.size > 0 && t.scheduleSweep();
				}
			}), Object.defineProperty(this, "finalizeAllImmediately", {
				enumerable: !0,
				configurable: !0,
				writable: !0,
				value: function() {
					t.sweep(0);
				}
			});
		}
		return Object.defineProperty(e.prototype, "register", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function(e, t, n) {
				this.registrations.set(n, {
					value: t,
					registeredAt: Date.now()
				}), this.scheduleSweep();
			}
		}), Object.defineProperty(e.prototype, "unregister", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function(e) {
				this.registrations.delete(e);
			}
		}), Object.defineProperty(e.prototype, "scheduleSweep", {
			enumerable: !1,
			configurable: !0,
			writable: !0,
			value: function() {
				this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, sx));
			}
		}), e;
	}(), lx = typeof FinalizationRegistry < "u" ? FinalizationRegistry : cx;
})), dx, fx = o((() => {
	ux(), dx = new lx(function(e) {
		var t;
		(t = e.reaction) == null || t.dispose(), e.reaction = null;
	});
})), px = /* @__PURE__ */ s(((e) => {
	var t = (yn(), d(_t));
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var f = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? f : t.useSyncExternalStore;
})), mx = /* @__PURE__ */ s(((e, t) => {
	t.exports = px();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/useObserver.js
function hx(e) {
	e.reaction = new Ic(`observer${e.name}`, function() {
		var t;
		e.stateVersion = Symbol(), (t = e.onStoreChange) == null || t.call(e);
	});
}
function gx(e, t) {
	if (t === void 0 && (t = "observed"), rx()) return e();
	var n = vn.useRef(null);
	if (!n.current) {
		var r = {
			reaction: null,
			onStoreChange: null,
			stateVersion: Symbol(),
			name: t,
			subscribe: function(e) {
				return dx.unregister(r), r.onStoreChange = e, r.reaction || (hx(r), r.stateVersion = Symbol()), function() {
					var e;
					r.onStoreChange = null, (e = r.reaction) == null || e.dispose(), r.reaction = null;
				};
			},
			getSnapshot: function() {
				return r.stateVersion;
			}
		};
		n.current = r;
	}
	var i = n.current;
	i.reaction || (hx(i), dx.register(n, i, i)), vn.useDebugValue(i.reaction, tx), (0, _x.useSyncExternalStore)(i.subscribe, i.getSnapshot, i.getSnapshot);
	var a, o;
	if (i.reaction.track(function() {
		try {
			a = e();
		} catch (e) {
			o = e;
		}
	}), o) throw o;
	return a;
}
var _x, vx = o((() => {
	H(), yn(), nx(), ax(), fx(), _x = mx();
}));
//#endregion
//#region node_modules/mobx-react-lite/es/observer.js
function yx(e, t) {
	if (wx && e.$$typeof === wx) throw Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
	if (rx()) return e;
	var n = t?.forwardRef ?? !1, r = e, i = e.displayName || e.name;
	if (Cx && e.$$typeof === Cx && (n = !0, r = e.render, typeof r != "function")) throw Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
	var a = function(e, t) {
		return gx(function() {
			return r(e, t);
		}, i);
	};
	return a.displayName = e.displayName, Sx && Object.defineProperty(a, "name", {
		value: e.name,
		writable: !0,
		configurable: !0
	}), e.contextTypes && (a.contextTypes = e.contextTypes), n && (a = Dt(a)), a = Et(a), bx(e, a), a;
}
function bx(e, t) {
	Object.keys(e).forEach(function(n) {
		Tx[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
	});
}
var xx, Sx, Cx, wx, Tx, Ex = o((() => {
	yn(), ax(), vx(), xx = typeof Symbol == "function" && Symbol.for, Sx = Object.getOwnPropertyDescriptor(function() {}, "name")?.configurable ?? !1, Cx = xx ? Symbol.for("react.forward_ref") : typeof Dt == "function" && Dt(function(e) {
		return null;
	}).$$typeof, wx = xx ? Symbol.for("react.memo") : typeof Et == "function" && Et(function(e) {
		return null;
	}).$$typeof, Tx = {
		$$typeof: !0,
		render: !0,
		compare: !0,
		type: !0,
		displayName: !0
	};
})), Dx = o((() => {
	vx();
})), Ox = o((() => {
	yn();
})), kx = o((() => {
	yn();
})), Ax = o((() => {
	yn(), kx();
})), jx = o((() => {
	Xb(), Zb(), ex(), vx(), fx(), ax(), Ex(), Dx(), Ox(), Ax(), kx(), $b(hn), dx.finalizeAllImmediately;
})), Mx, Nx, Px = o((() => {
	Ai(), Jb(), Vr(), Mx = Br({
		key: "ss",
		prepend: !0
	}), Nx = (e) => N(vi, {
		value: e.cache || Mx,
		children: e.children
	});
})), Fx = o((() => {
	Le(), k();
})), Ix = o((() => {
	Le(), k();
})), Lx = o((() => {
	Le(), k(), Jb();
})), Rx = o((() => {
	Le();
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/defined.js
function zx(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var Bx = o((() => {})), Vx = o((() => {})), Hx = o((() => {})), Ux = o((() => {}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/mergeProps.js
function Wx(e, t, n, r) {
	let i = r.theme, a = r?.name || n.name, o = r.treePath || n.treePath || "";
	o += `${o ? " " : ""}${e}`;
	let s = { ...n };
	if (t?.type !== "templates") {
		let n = t?.components && t.components[e];
		n && (s = Gx(n, s)), s = {
			...s,
			...r,
			treePath: o
		};
		let a = i?.components && i.components[e];
		a && (s = Gx(a, s));
	} else {
		s = {
			...s,
			...r
		}, o += a?.match(/^[A-Za-z0-9-]+$/) ? `.${a}` : "";
		let e = qx(t?.components || {}, o).sort(Kx), n = e.filter((e) => e.includes("*")), c = e.filter((e) => !e.includes("*")), l = /* @__PURE__ */ new Set();
		n.forEach((e) => {
			let n = t.components?.[e];
			n && (e.replace(/^\*/, "").replace(/\([MDT]\)$/, "").trim().split(" ").length > 1 && Object.keys(n).forEach((e) => l.add(e)), s = Gx(n, s));
		});
		let u = r.theme?.[Jx];
		if (u instanceof Map && u.size > 0) {
			let e = {}, t = Array.from(u.values());
			for (let n of Object.keys(r)) {
				if (n === "treePath" || n === "theme" || n === "name" || l.has(n)) continue;
				let i = r[n];
				i !== void 0 && t.indexOf(i) !== -1 && (e[n] = i);
			}
			Object.keys(e).length > 0 && (s = {
				...s,
				...e
			});
		}
		c.forEach((e) => {
			let n = t.components?.[e];
			n && (s = Gx(n, s, !0));
		}), qx(i?.components || {}, o).sort(Kx).forEach((e) => {
			let t = i?.components?.[e];
			t && (s = Gx(t, s));
		}), s = {
			...s,
			theme: {
				...s.theme,
				name: t.name,
				...t.activeBreakpoint ? { activeBreakpoint: t.activeBreakpoint } : {}
			},
			treePath: o
		}, r.lang && (s.lang = r.lang), t.variables && s.theme && (s.theme.variables = t.variables);
		let d = s[Jx] || /* @__PURE__ */ new Map();
		if (d.size > 0 && s.theme) {
			let e = new Map(d);
			u instanceof Map && u.forEach((t, n) => {
				e.has(n) || e.set(n, t);
			}), s.theme[Jx] = e;
		}
		o && (o.indexOf("customComponent") > -1 || o.startsWith("storybook") && o.split(" ").length == 2) && (s = {
			...s,
			...r,
			treePath: o
		});
	}
	return s;
}
function Gx(e, t, n = !1) {
	if (e) {
		let r = t[Jx] || /* @__PURE__ */ new Map();
		for (let [t, i] of Object.entries(e)) i != null && typeof i != "function" && (!n || !r.has(t)) && r.set(t, i);
		t = {
			...t,
			...e
		}, t[Jx] = r;
	}
	return t;
}
function Kx(e, t) {
	return e.split(" ").map((e, t) => (t * 2) ** (e.includes(".") ? 2 : 1)).reduce((e, t) => e + t, (e.includes("*") ? 0 : 1e3) + (e.match(/\([MDT]\)/) ? 2e3 : 0)) - t.split(" ").map((e, t) => (t * 2) ** (e.includes(".") ? 2 : 1)).reduce((e, t) => e + t, (t.includes("*") ? 0 : 1e3) + (t.match(/\([MDT]\)/) ? 2e3 : 0));
}
function qx(e, t) {
	let n = Object.keys(e), r = t.split(" "), [i, a] = (r.slice(-1).pop() ?? "").split("."), o = r.map((e) => {
		let [t, n] = e.split(".");
		return {
			type: t,
			name: n,
			path: e
		};
	});
	return n = a ? n.filter((e) => {
		let t = e.split(" "), n = t[t.length - 1].replace(/\*?(\([MDT]\))?/g, "");
		if (n == i || n == `${i}.${a}`) return !0;
	}) : n.filter((e) => e.endsWith(i)), n.filter((e) => {
		let t = e.replace(/\*?(\([MDT]\))?/g, "").split(" ").slice(0, -1);
		if (t.length == 0) return !0;
		for (let e = 0; e < t.length; e++) {
			let n = -1, r = t[e];
			for (let t = n == -1 ? 0 : n; t < o.length; t++) {
				let i = o[t];
				if (r === i.path || r === i.type) {
					n = e;
					break;
				}
			}
			if (n == -1) return !1;
		}
		return !0;
	});
}
var Jx, Yx = o((() => {
	Jx = Symbol.for("__themePropsMap__");
}));
//#endregion
//#region node_modules/@athoscommerce/snap-preact/dist/esm/components/src/utilities/mergeStyles.js
function Xx(e, t) {
	let { name: n, treePath: r, style: i, styleScript: a, themeStyleScript: o, disableStyles: s } = e, c = {
		"ss-name": n,
		"ss-path": r,
		css: []
	};
	return s || c.css.push(t(e)), o && c.css.push(o(e)), a && c.css.push(a(e)), i && c.css.push(i), c.css?.length == 0 && delete c.css, c;
}
var Zx = o((() => {})), Qx = o((() => {})), $x = o((() => {
	k();
})), eS = o((() => {
	k();
})), tS = o((() => {
	k();
})), nS = o((() => {
	k();
})), rS = o((() => {
	k();
})), iS = o((() => {
	k();
})), aS = o((() => {
	k();
})), oS = o((() => {
	k();
})), sS = o((() => {
	k();
})), cS = o((() => {})), lS = o((() => {
	k();
})), uS, dS = o((() => {
	k(), uS = (e, t) => {
		let [n, r] = Ve(void 0), [i, a] = Ve(!1);
		return Ue(() => {
			let n = !0;
			if (!t) return r(void 0), () => {
				n = !1;
			};
			a(!1);
			let i = e[t];
			if (i && typeof i == "function") {
				let e = i();
				e instanceof Promise ? e.then((e) => {
					n && r(() => e);
				}).catch((e) => {
					n && (a(!0), r(void 0), console.warn(`Failed to load component "${t}".`, e));
				}) : n && r(() => e);
			} else r(void 0), console.warn(`Component "${t}" not found in component map.`);
			return () => {
				n = !1;
			};
		}, [e, t]), {
			ComponentOverride: n,
			shouldWaitForNamedOverride: !!(t && typeof e[t] == "function") && !n && !i
		};
	};
})), fS, pS = o((() => {
	Ai(), OS(), dS(), fS = (e, t) => {
		let n = CS()?.templates?.library.import.component?.[e] || {}, { customComponent: r } = t, { ComponentOverride: i, shouldWaitForNamedOverride: a } = uS(n, r), o = r && i ? N(i, {
			...t,
			customComponent: void 0
		}) : null;
		return {
			overrideElement: o,
			shouldRenderDefault: !a && !o,
			shouldWaitForNamedOverride: a
		};
	};
})), mS = o((() => {
	k();
})), hS = o((() => {
	eS(), tS(), nS(), rS(), iS(), oS(), sS(), cS(), aS(), lS(), dS(), pS(), mS();
})), gS = o((() => {})), _S = o((() => {
	k();
})), vS = o((() => {
	Rx(), Bx(), Vx(), Hx(), Ux(), Yx(), Zx(), Qx(), $x(), gS(), _S();
})), yS = o((() => {
	k();
})), bS = o((() => {})), xS = o((() => {})), SS, CS, wS = o((() => {
	Le(), k(), SS = ye(void 0), SS.Provider, CS = () => Ye(SS);
})), TS, ES, DS = o((() => {
	Le(), k(), TS = ye(null), TS.Provider, ES = () => Ye(TS) || void 0;
})), OS = o((() => {
	Px(), Fx(), Ix(), Lx(), yS(), bS(), xS(), wS(), DS();
})), kS, AS, jS = o((() => {
	kS = {
		layoutGrid2: "M25.846 34.461v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM25.846 8.615v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM56 34.461v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308zM56 8.615v12.923c0 2.356-1.952 4.308-4.308 4.308h-17.231c-2.356 0-4.308-1.952-4.308-4.308v-12.923c0-2.356 1.952-4.308 4.308-4.308h17.231c2.356 0 4.308 1.952 4.308 4.308z",
		layoutGrid3: "M16 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM36 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3z"
	}, AS = {
		"angle-up": "M56 39.671c0 0.449-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.786 0.561-1.291 0.561-0.449 0-0.954-0.224-1.291-0.561l-22.052-22.052-22.052 22.052c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z",
		"angle-down": "M56 16.329c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-26.148-26.148c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.786-0.561 1.291-0.561 0.449 0 0.954 0.224 1.291 0.561l22.052 22.052 22.052-22.052c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l2.806 2.806c0.337 0.337 0.561 0.842 0.561 1.291z",
		"angle-left": "M44.329 4.657c0 0.449-0.224 0.954-0.561 1.291l-22.052 22.052 22.052 22.052c0.337 0.337 0.561 0.842 0.561 1.291s-0.224 0.954-0.561 1.291l-2.806 2.806c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-26.148-26.148c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l26.148-26.148c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l2.806 2.806c0.337 0.337 0.561 0.786 0.561 1.291z",
		"angle-right": "M44.329 28c0 0.449-0.224 0.954-0.561 1.291l-26.148 26.148c-0.337 0.337-0.842 0.561-1.291 0.561s-0.954-0.224-1.291-0.561l-2.806-2.806c-0.337-0.337-0.561-0.786-0.561-1.291 0-0.449 0.224-0.954 0.561-1.291l22.052-22.052-22.052-22.052c-0.337-0.337-0.561-0.842-0.561-1.291s0.224-0.954 0.561-1.291l2.806-2.806c0.337-0.337 0.842-0.561 1.291-0.561s0.954 0.224 1.291 0.561l26.148 26.148c0.337 0.337 0.561 0.842 0.561 1.291z",
		bag: "M46.5435 18.6657C46.142 15.4166 43.9379 13.1711 40.4449 13.1711H37.3295C36.8838 5.75827 35.1521 0 28.4228 0C21.5677 0 19.8993 5.75827 19.4922 13.1711H16.1019C12.6083 13.1711 10.3416 15.5058 10.0027 18.6657L6.01336 49.5651L6 49.7409C6 53.1533 8.79407 56 12.1 56H44.4455C47.7521 56 50.5455 53.1407 50.5455 49.729L46.5435 18.6657ZM28.4228 3.29383C32.3475 3.29383 33.6011 6.58138 33.9913 13.1704H22.8164C23.1574 6.58138 24.3442 3.29383 28.4228 3.29383ZM44.4455 52.7055H12.1C10.6488 52.7055 9.372 51.4045 9.32279 49.8448L13.3226 18.7676C13.5301 17.0614 14.8195 16.4643 16.1019 16.4643H19.3833C19.3608 17.2881 19.3601 19.3249 19.3601 20.7598C19.3601 21.6694 20.1032 22.4311 21.02 22.4311C21.9369 22.4311 22.6807 21.6589 22.6807 20.7486C22.6807 19.2391 22.6871 17.2888 22.7096 16.4643H34.1242C34.1544 17.2881 34.1656 19.2635 34.1656 20.7598C34.1656 21.6694 34.9081 22.4311 35.8256 22.4311C36.7418 22.4311 37.4856 21.6589 37.4856 20.7486C37.4856 19.3465 37.4842 18.1119 37.4575 16.4643H40.4449C41.7266 16.4643 42.995 17.0397 43.2235 18.7787L47.2234 49.8218C47.1742 51.3808 45.8981 52.7055 44.4455 52.7055Z",
		ban: "M47.769 27.982c0-3.961-1.163-7.631-3.162-10.72l-27.4 27.364c3.125 2.035 6.832 3.234 10.793 3.234 10.902 0 19.769-8.903 19.769-19.878zM11.465 38.848l27.437-27.4c-3.125-2.108-6.868-3.307-10.902-3.307-10.902 0-19.769 8.903-19.769 19.842 0 4.034 1.199 7.74 3.234 10.866zM55.909 27.982c0 15.481-12.501 28.018-27.909 28.018s-27.909-12.537-27.909-28.018c0-15.445 12.501-27.982 27.909-27.982s27.909 12.537 27.909 27.982z",
		check: "M56 14.921c0 0.903-0.361 1.806-1.012 2.457l-31.071 31.071c-0.65 0.65-1.554 1.012-2.457 1.012s-1.806-0.361-2.457-1.012l-17.992-17.992c-0.65-0.65-1.012-1.554-1.012-2.457s0.361-1.806 1.012-2.457l4.914-4.914c0.65-0.65 1.554-1.012 2.457-1.012s1.806 0.361 2.457 1.012l10.622 10.658 23.701-23.737c0.65-0.65 1.554-1.012 2.457-1.012s1.806 0.361 2.457 1.012l4.914 4.914c0.65 0.65 1.012 1.554 1.012 2.457z",
		"check-thin": "M17.771 40.395l33.749-33.749 4.48 4.48-38.229 38.229-17.771-17.771 4.48-4.48z",
		"chevron-up": "M55.349 39.589l-5.769 5.734c-0.869 0.869-2.259 0.869-3.128 0l-18.452-18.452-18.452 18.452c-0.869 0.869-2.259 0.869-3.128 0l-5.769-5.734c-0.869-0.869-0.869-2.293 0-3.162l25.785-25.75c0.869-0.869 2.259-0.869 3.128 0l25.785 25.75c0.869 0.869 0.869 2.293 0 3.162z",
		"chevron-down": "M55.348 19.573l-25.785 25.75c-0.869 0.869-2.259 0.869-3.128 0l-25.785-25.75c-0.869-0.869-0.869-2.293 0-3.162l5.768-5.734c0.869-0.869 2.259-0.869 3.128 0l18.452 18.452 18.452-18.452c0.869-0.869 2.259-0.869 3.128 0l5.768 5.734c0.869 0.869 0.869 2.293 0 3.162z",
		"chevron-left": "M45.34 9.548l-18.452 18.452 18.452 18.452c0.869 0.869 0.869 2.259 0 3.128l-5.769 5.769c-0.869 0.869-2.259 0.869-3.128 0l-25.785-25.785c-0.869-0.869-0.869-2.259 0-3.128l25.785-25.785c0.869-0.869 2.259-0.869 3.128 0l5.769 5.769c0.869 0.869 0.869 2.259 0 3.128z",
		"chevron-right": "M45.34 29.564l-25.785 25.785c-0.869 0.869-2.259 0.869-3.128 0l-5.768-5.768c-0.869-0.869-0.869-2.259 0-3.128l18.452-18.452-18.452-18.452c-0.869-0.869-0.869-2.259 0-3.128l5.768-5.768c0.869-0.869 2.259-0.869 3.128 0l25.785 25.785c0.869 0.869 0.869 2.259 0 3.128z",
		circle: "M56 28c0 15.458-12.542 28-28 28s-28-12.542-28-28 12.542-28 28-28 28 12.542 28 28z",
		close: "M56 45.064c0 1.178-0.471 2.357-1.32 3.205l-6.411 6.411c-0.849 0.849-2.027 1.32-3.205 1.32s-2.357-0.471-3.205-1.32l-13.859-13.859-13.859 13.859c-0.849 0.849-2.027 1.32-3.205 1.32s-2.357-0.471-3.205-1.32l-6.411-6.411c-0.849-0.849-1.32-2.027-1.32-3.205s0.471-2.357 1.32-3.205l13.859-13.859-13.859-13.859c-0.849-0.849-1.32-2.027-1.32-3.205s0.471-2.357 1.32-3.205l6.411-6.411c0.849-0.849 2.027-1.32 3.205-1.32s2.357 0.471 3.205 1.32l13.859 13.859 13.859-13.859c0.849-0.849 2.027-1.32 3.205-1.32s2.357 0.471 3.205 1.32l6.411 6.411c0.849 0.849 1.32 2.027 1.32 3.205s-0.471 2.357-1.32 3.205l-13.859 13.859 13.859 13.859c0.849 0.849 1.32 2.027 1.32 3.205z",
		"close-thin": "M56 5.638l-22.362 22.362 22.362 22.362-5.638 5.638-22.362-22.362-22.362 22.362-5.638-5.638 22.362-22.362-22.362-22.362 5.638-5.638 22.362 22.362 22.362-22.362z",
		cog: "M37.333 28c0-5.141-4.193-9.333-9.333-9.333s-9.333 4.193-9.333 9.333 4.193 9.333 9.333 9.333 9.333-4.193 9.333-9.333zM56 24.026v8.094c0 0.547-0.438 1.203-1.021 1.312l-6.745 1.021c-0.401 1.167-0.839 2.26-1.422 3.318 1.24 1.786 2.552 3.391 3.901 5.031 0.219 0.255 0.365 0.583 0.365 0.911s-0.109 0.583-0.328 0.839c-0.875 1.167-5.797 6.526-7.036 6.526-0.328 0-0.656-0.146-0.948-0.328l-5.031-3.938c-1.057 0.547-2.188 1.021-3.318 1.385-0.255 2.224-0.474 4.594-1.057 6.781-0.146 0.583-0.656 1.021-1.312 1.021h-8.094c-0.656 0-1.24-0.474-1.312-1.094l-1.021-6.708c-1.13-0.365-2.224-0.802-3.281-1.349l-5.141 3.901c-0.255 0.219-0.583 0.328-0.911 0.328s-0.656-0.146-0.911-0.401c-1.932-1.75-4.484-4.010-6.016-6.125-0.182-0.255-0.255-0.547-0.255-0.839 0-0.328 0.109-0.583 0.292-0.839 1.24-1.677 2.589-3.281 3.828-4.995-0.62-1.167-1.13-2.37-1.495-3.609l-6.672-0.984c-0.62-0.109-1.057-0.693-1.057-1.312v-8.094c0-0.547 0.438-1.203 0.984-1.312l6.781-1.021c0.365-1.167 0.839-2.26 1.422-3.354-1.24-1.75-2.552-3.391-3.901-5.031-0.219-0.255-0.365-0.547-0.365-0.875s0.146-0.583 0.328-0.839c0.875-1.203 5.797-6.526 7.036-6.526 0.328 0 0.656 0.146 0.948 0.365l5.031 3.901c1.057-0.547 2.188-1.021 3.318-1.385 0.255-2.224 0.474-4.594 1.057-6.781 0.146-0.583 0.656-1.021 1.312-1.021h8.094c0.656 0 1.24 0.474 1.312 1.094l1.021 6.708c1.13 0.365 2.224 0.802 3.281 1.349l5.177-3.901c0.219-0.219 0.547-0.328 0.875-0.328s0.656 0.146 0.911 0.365c1.932 1.786 4.484 4.047 6.016 6.198 0.182 0.219 0.255 0.51 0.255 0.802 0 0.328-0.109 0.583-0.292 0.839-1.24 1.677-2.589 3.281-3.828 4.995 0.62 1.167 1.13 2.37 1.495 3.573l6.672 1.021c0.62 0.109 1.057 0.693 1.057 1.312z",
		cogs: "M26.133 27.985c0-4.113-3.354-7.467-7.467-7.467s-7.467 3.354-7.467 7.467 3.354 7.467 7.467 7.467 7.467-3.354 7.467-7.467zM48.533 42.919c0-2.042-1.692-3.733-3.733-3.733s-3.733 1.692-3.733 3.733c0 2.071 1.692 3.733 3.733 3.733 2.071 0 3.733-1.692 3.733-3.733zM48.533 13.052c0-2.042-1.692-3.733-3.733-3.733s-3.733 1.692-3.733 3.733c0 2.071 1.692 3.733 3.733 3.733 2.071 0 3.733-1.692 3.733-3.733zM37.333 25.331v5.396c0 0.379-0.292 0.817-0.671 0.875l-4.521 0.7c-0.233 0.758-0.554 1.487-0.933 2.217 0.817 1.167 1.692 2.246 2.625 3.354 0.117 0.175 0.204 0.35 0.204 0.583 0 0.204-0.058 0.408-0.204 0.554-0.583 0.787-3.85 4.346-4.696 4.346-0.233 0-0.438-0.088-0.613-0.204l-3.354-2.625c-0.729 0.379-1.458 0.671-2.246 0.904-0.146 1.487-0.292 3.092-0.671 4.521-0.117 0.408-0.467 0.7-0.875 0.7h-5.425c-0.408 0-0.817-0.321-0.875-0.729l-0.671-4.462c-0.758-0.233-1.488-0.554-2.188-0.904l-3.442 2.596c-0.146 0.146-0.379 0.204-0.583 0.204-0.233 0-0.438-0.087-0.612-0.233-0.758-0.7-4.2-3.821-4.2-4.667 0-0.204 0.087-0.379 0.204-0.554 0.846-1.108 1.721-2.188 2.567-3.325-0.408-0.788-0.758-1.575-1.021-2.392l-4.433-0.7c-0.408-0.058-0.7-0.438-0.7-0.846v-5.396c0-0.379 0.292-0.817 0.671-0.875l4.521-0.7c0.233-0.758 0.554-1.488 0.933-2.217-0.817-1.167-1.692-2.246-2.625-3.354-0.117-0.175-0.204-0.379-0.204-0.583s0.058-0.408 0.204-0.583c0.583-0.787 3.85-4.317 4.696-4.317 0.233 0 0.438 0.087 0.612 0.204l3.354 2.625c0.729-0.379 1.458-0.671 2.246-0.933 0.146-1.458 0.292-3.063 0.671-4.492 0.117-0.408 0.467-0.7 0.875-0.7h5.425c0.408 0 0.817 0.321 0.875 0.729l0.671 4.463c0.758 0.233 1.488 0.554 2.188 0.904l3.442-2.596c0.175-0.146 0.379-0.204 0.583-0.204 0.233 0 0.438 0.088 0.613 0.233 0.758 0.7 4.2 3.85 4.2 4.667 0 0.204-0.087 0.379-0.204 0.554-0.846 1.138-1.721 2.188-2.537 3.325 0.379 0.787 0.729 1.575 0.992 2.392l4.433 0.671c0.408 0.087 0.7 0.467 0.7 0.875zM56 40.877v4.083c0 0.438-3.762 0.846-4.346 0.904-0.233 0.554-0.525 1.050-0.875 1.517 0.263 0.583 1.488 3.5 1.488 4.025 0 0.087-0.029 0.146-0.117 0.204-0.35 0.204-3.471 2.071-3.617 2.071-0.379 0-2.567-2.917-2.858-3.354-0.292 0.029-0.583 0.058-0.875 0.058s-0.583-0.029-0.875-0.058c-0.292 0.438-2.479 3.354-2.858 3.354-0.146 0-3.267-1.867-3.617-2.071-0.087-0.058-0.117-0.146-0.117-0.204 0-0.496 1.225-3.442 1.488-4.025-0.35-0.467-0.642-0.963-0.875-1.517-0.583-0.058-4.346-0.467-4.346-0.904v-4.083c0-0.438 3.762-0.846 4.346-0.904 0.233-0.525 0.525-1.050 0.875-1.517-0.262-0.583-1.488-3.529-1.488-4.025 0-0.058 0.029-0.146 0.117-0.204 0.35-0.175 3.471-2.042 3.617-2.042 0.379 0 2.567 2.887 2.858 3.325 0.292-0.029 0.583-0.058 0.875-0.058s0.583 0.029 0.875 0.058c0.817-1.137 1.692-2.275 2.683-3.267l0.175-0.058c0.146 0 3.267 1.837 3.617 2.042 0.087 0.058 0.117 0.146 0.117 0.204 0 0.525-1.225 3.442-1.488 4.025 0.35 0.467 0.642 0.992 0.875 1.517 0.583 0.058 4.346 0.467 4.346 0.904zM56 11.010v4.083c0 0.438-3.762 0.846-4.346 0.904-0.233 0.554-0.525 1.050-0.875 1.517 0.263 0.583 1.488 3.5 1.488 4.025 0 0.088-0.029 0.146-0.117 0.204-0.35 0.204-3.471 2.071-3.617 2.071-0.379 0-2.567-2.917-2.858-3.354-0.292 0.029-0.583 0.058-0.875 0.058s-0.583-0.029-0.875-0.058c-0.292 0.438-2.479 3.354-2.858 3.354-0.146 0-3.267-1.867-3.617-2.071-0.087-0.058-0.117-0.146-0.117-0.204 0-0.496 1.225-3.442 1.488-4.025-0.35-0.467-0.642-0.963-0.875-1.517-0.583-0.058-4.346-0.467-4.346-0.904v-4.083c0-0.438 3.762-0.846 4.346-0.904 0.233-0.525 0.525-1.050 0.875-1.517-0.262-0.583-1.488-3.529-1.488-4.025 0-0.058 0.029-0.146 0.117-0.204 0.35-0.175 3.471-2.042 3.617-2.042 0.379 0 2.567 2.888 2.858 3.325 0.292-0.029 0.583-0.058 0.875-0.058s0.583 0.029 0.875 0.058c0.817-1.138 1.692-2.275 2.683-3.267l0.175-0.058c0.146 0 3.267 1.837 3.617 2.042 0.087 0.058 0.117 0.146 0.117 0.204 0 0.525-1.225 3.442-1.488 4.025 0.35 0.467 0.642 0.992 0.875 1.517 0.583 0.058 4.346 0.467 4.346 0.904z",
		dollar: "M42.565 37.031c0 6.375-4.563 11.406-11.187 12.5v5.469c0 0.563-0.438 1-1 1h-4.219c-0.531 0-1-0.438-1-1v-5.469c-7.312-1.031-11.312-5.406-11.469-5.594-0.312-0.375-0.344-0.906-0.063-1.281l3.219-4.219c0.156-0.219 0.438-0.344 0.719-0.375s0.563 0.063 0.75 0.281c0.063 0.031 4.438 4.219 9.969 4.219 3.063 0 6.375-1.625 6.375-5.156 0-3-3.688-4.469-7.906-6.156-5.625-2.219-12.625-5.031-12.625-12.875 0-5.75 4.5-10.5 11.031-11.75v-5.625c0-0.563 0.469-1 1-1h4.219c0.563 0 1 0.438 1 1v5.5c6.344 0.719 9.719 4.156 9.844 4.281 0.312 0.344 0.375 0.812 0.156 1.187l-2.531 4.563c-0.156 0.281-0.406 0.469-0.719 0.5-0.312 0.063-0.594-0.031-0.844-0.219-0.031-0.031-3.812-3.375-8.5-3.375-3.969 0-6.719 1.969-6.719 4.812 0 3.312 3.812 4.781 8.25 6.5 5.75 2.219 12.25 4.75 12.25 12.281z",
		envelope: "M56 20.188v24.812c0 2.75-2.25 5-5 5h-46c-2.75 0-5-2.25-5-5v-24.812c0.938 1.031 2 1.938 3.156 2.719 5.187 3.531 10.437 7.063 15.531 10.781 2.625 1.938 5.875 4.312 9.281 4.312h0.063c3.406 0 6.656-2.375 9.281-4.312 5.094-3.688 10.344-7.25 15.562-10.781 1.125-0.781 2.188-1.687 3.125-2.719zM56 11c0 3.5-2.594 6.656-5.344 8.562-4.875 3.375-9.781 6.75-14.625 10.156-2.031 1.406-5.469 4.281-8 4.281h-0.063c-2.531 0-5.969-2.875-8-4.281-4.844-3.406-9.75-6.781-14.594-10.156-2.219-1.5-5.375-5.031-5.375-7.875 0-3.063 1.656-5.688 5-5.688h46c2.719 0 5 2.25 5 5z",
		error: "M28 0c15.458 0 28 12.542 28 28s-12.542 28-28 28-28-12.542-28-28 12.542-28 28-28zM32.667 45.464v-6.927c0-0.656-0.51-1.203-1.13-1.203h-7c-0.656 0-1.203 0.547-1.203 1.203v6.927c0 0.656 0.547 1.203 1.203 1.203h7c0.62 0 1.13-0.547 1.13-1.203zM32.594 32.922l0.656-22.641c0-0.255-0.109-0.51-0.365-0.656-0.219-0.182-0.547-0.292-0.875-0.292h-8.021c-0.328 0-0.656 0.109-0.875 0.292-0.255 0.146-0.365 0.401-0.365 0.656l0.62 22.641c0 0.51 0.547 0.911 1.24 0.911h6.745c0.656 0 1.203-0.401 1.24-0.911z",
		eye: "M28 20.374q3.098 0 5.362 2.264t2.264 5.362-2.264 5.362-5.362 2.264-5.362-2.264-2.264-5.362 2.264-5.362 5.362-2.264zM28 40.749q5.243 0 8.996-3.753t3.753-8.996-3.753-8.996-8.996-3.753-8.996 3.753-3.753 8.996 3.753 8.996 8.996 3.753zM28 8.936q9.413 0 17.038 5.243t10.962 13.821q-3.336 8.579-10.962 13.821t-17.038 5.243-17.038-5.243-10.962-13.821q3.336-8.579 10.962-13.821t17.038-5.243z",
		"eye-thin": "M52 28c-2.969-4.594-7.031-8.531-11.906-11.031 1.25 2.125 1.906 4.563 1.906 7.031 0 7.719-6.281 14-14 14s-14-6.281-14-14c0-2.469 0.656-4.906 1.906-7.031-4.875 2.5-8.938 6.437-11.906 11.031 5.344 8.25 13.969 14 24 14s18.656-5.75 24-14zM29.5 16c0-0.812-0.687-1.5-1.5-1.5-5.219 0-9.5 4.281-9.5 9.5 0 0.812 0.687 1.5 1.5 1.5s1.5-0.687 1.5-1.5c0-3.563 2.937-6.5 6.5-6.5 0.812 0 1.5-0.687 1.5-1.5zM56 28c0 0.781-0.25 1.5-0.625 2.156-5.75 9.469-16.281 15.844-27.375 15.844s-21.625-6.406-27.375-15.844c-0.375-0.656-0.625-1.375-0.625-2.156s0.25-1.5 0.625-2.156c5.75-9.437 16.281-15.844 27.375-15.844s21.625 6.406 27.375 15.844c0.375 0.656 0.625 1.375 0.625 2.156z",
		filter: "M25.519 21.889c0 0-0.241-4.089-0.241-4.089s0-13.471 0-13.471c0.002-1.162-0.005-2.636 0.825-3.553 1.104-1.224 3.156-0.929 4.022 0.435 0.498 0.787 0.443 1.744 0.445 2.636 0 0 0 25.258 0 25.258s-5.052 0-5.052 0c0 0 0-7.217 0-7.217zM42.358 3.848c0.019-1.576 0.281-3.476 2.165-3.794 2.798-0.471 3.125 2.24 3.127 4.275 0 0 0 11.546 0 11.546s-2.646-0.233-2.646-0.233c0 0-2.646 0.233-2.646 0.233s0-12.028 0-12.028zM8.44 3.848c0.014-1.181 0.147-2.442 1.229-3.163 1.484-0.986 3.286-0.156 3.825 1.479 0.322 0.984 0.238 2.545 0.238 3.608 0 0 0 6.014 0 6.014s-2.646-0.197-2.646-0.197c0 0-2.646 0.197-2.646 0.197s0-7.938 0-7.938zM13.010 13.556c5.509 1.855 5.477 10.377-1.203 11.551-5.121 0.902-8.455-5.015-5.867-9.23 0.907-1.475 2.314-2.151 3.943-2.535 1.176-0.166 1.985-0.171 3.127 0.214zM46.207 28.993c-5.564 1.051-8.874-4.833-6.348-9.028 1.046-1.737 2.533-2.357 4.424-2.774 7.57-0.883 9.36 10.399 1.924 11.802zM13.732 26.46c0 0 0 24.536 0 24.536-0.002 1.215-0.067 3.079-0.844 4.063-1.066 1.352-3.094 1.222-3.984-0.226-0.496-0.808-0.462-1.958-0.464-2.875 0 0 0-25.499 0-25.499s5.292 0 5.292 0zM33.219 33.436c1.936 3.286-0.019 8.15-3.851 8.821-1.169 0.207-3.019 0.135-4.089-0.402-4.71-2.355-4.39-9.803 1.443-11.193 2.673-0.375 5.056 0.33 6.497 2.774zM45.004 30.77c0 0 2.646-0.221 2.646-0.221s0 21.409 0 21.409c-0.002 1.034 0.034 2.215-0.649 3.074-0.977 1.224-3.017 1.224-3.993 0-0.637-0.799-0.645-1.867-0.649-2.834 0 0 0-21.65 0-21.65s2.646 0.221 2.646 0.221zM27.684 43.998c0 0 2.887-0.219 2.887-0.219s0 8.66 0 8.66c-0.022 1.758-0.654 3.861-2.887 3.517-1.912-0.296-2.384-2.114-2.406-3.757 0 0 0-8.419 0-8.419s2.406 0.219 2.406 0.219z",
		filters: [
			{
				type: "path",
				attributes: {
					x1: "1",
					y1: "17",
					x2: "55",
					y2: "17",
					"stroke-width": "4",
					"stroke-linecap": "round",
					"stroke-linejoin": "round",
					stroke: "currentColor"
				}
			},
			{
				type: "line",
				attributes: {
					x1: "1",
					y1: "39",
					x2: "55",
					y2: "39",
					"stroke-width": "4",
					"stroke-linecap": "round",
					"stroke-linejoin": "round",
					stroke: "currentColor"
				}
			},
			{
				type: "circle",
				attributes: {
					cx: "18",
					cy: "17",
					r: "8",
					fill: "white",
					"stroke-width": "4",
					stroke: "currentColor"
				}
			},
			{
				type: "circle",
				attributes: {
					cx: "38",
					cy: "39",
					r: "8",
					fill: "white",
					stroke: "currentColor",
					"stroke-width": "4"
				}
			}
		],
		bullet: [{
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "20",
				"stroke-width": "3",
				fill: "white",
				stroke: "currentColor"
			}
		}, {
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "13",
				"stroke-width": "0"
			}
		}],
		"bullet-o": [{
			type: "circle",
			attributes: {
				cx: "28",
				cy: "28",
				r: "20",
				"stroke-width": "3",
				fill: "white",
				stroke: "currentColor"
			}
		}],
		heart: "M28 52c-0.5 0-1-0.188-1.375-0.563l-19.5-18.813c-0.25-0.219-7.125-6.5-7.125-14 0-9.156 5.594-14.625 14.938-14.625 5.469 0 10.594 4.312 13.062 6.75 2.469-2.437 7.594-6.75 13.062-6.75 9.344 0 14.938 5.469 14.938 14.625 0 7.5-6.875 13.781-7.156 14.063l-19.469 18.75c-0.375 0.375-0.875 0.563-1.375 0.563z",
		"heart-o": "M52 18.625c0-8.781-5.937-10.625-10.938-10.625-4.656 0-9.906 5.031-11.531 6.969-0.75 0.906-2.313 0.906-3.063 0-1.625-1.938-6.875-6.969-11.531-6.969-5 0-10.938 1.844-10.938 10.625 0 5.719 5.781 11.031 5.844 11.094l18.156 17.5 18.125-17.469c0.094-0.094 5.875-5.406 5.875-11.125zM56 18.625c0 7.5-6.875 13.781-7.156 14.063l-19.469 18.75c-0.375 0.375-0.875 0.563-1.375 0.563s-1-0.188-1.375-0.563l-19.5-18.813c-0.25-0.219-7.125-6.5-7.125-14 0-9.156 5.594-14.625 14.938-14.625 5.469 0 10.594 4.312 13.062 6.75 2.469-2.437 7.594-6.75 13.062-6.75 9.344 0 14.938 5.469 14.938 14.625z",
		info: "M56.1425 28.2143C56.1425 43.6783 43.6065 56.2143 28.1425 56.2143C12.6786 56.2143 0.142578 43.6783 0.142578 28.2143C0.142578 12.7504 12.6786 0.214325 28.1425 0.214325C43.6065 0.214325 56.1425 12.7504 56.1425 28.2143ZM32.2543 16.7406C33.1441 15.8361 33.587 14.7358 33.587 13.4469C33.587 12.1603 33.1441 11.0578 32.2543 10.1417C31.3665 9.22792 30.2961 8.76988 29.0452 8.76988C27.7901 8.76988 26.7156 9.22562 25.8194 10.1417C24.9232 11.0578 24.4741 12.1603 24.4741 13.4469C24.4741 14.7358 24.9232 15.8361 25.8194 16.7406C26.7177 17.6498 27.7901 18.1032 29.0452 18.1032C30.2961 18.1032 31.3665 17.6498 32.2543 16.7406ZM29.9419 45.5994C30.7373 45.2628 31.8057 44.7746 33.1417 44.1326C33.1417 44.1326 32.9859 42.1999 32.4746 42.3716C31.9633 42.5432 31.5033 42.6302 31.0983 42.6302C30.237 42.6302 29.6304 42.4585 29.2785 42.113C28.9285 41.7675 28.7544 41.1188 28.7544 40.1669C28.7544 39.7902 28.8076 39.2285 28.9175 38.4928C29.0238 37.7527 29.1466 37.0951 29.2822 36.52L30.9462 29.3555C31.1093 28.6979 31.2211 27.9756 31.2816 27.1865C31.342 26.3996 31.3714 25.849 31.3714 25.5369C31.3714 24.0255 30.9352 22.7995 30.0647 21.8543C29.1942 20.9091 27.9536 20.4365 26.3464 20.4365C25.4521 20.4365 24.5065 20.6305 23.5059 21.0161C22.5053 21.4018 21.4588 21.8654 20.3648 22.4071C20.3648 22.4071 20.6323 24.3198 21.0868 24.157C21.5395 23.9943 21.983 23.9096 22.4155 23.9096C23.2969 23.9096 23.8907 24.0924 24.2022 24.4535C24.5138 24.8146 24.6695 25.4566 24.6695 26.3751C24.6695 26.8833 24.6201 27.4473 24.5174 28.0603C24.4167 28.6778 24.2902 29.3309 24.1418 30.0198L22.4704 37.2111C22.322 37.9667 22.2139 38.6444 22.1461 39.2441C22.0783 39.8437 22.0453 40.4322 22.0453 41.0051C22.0453 42.483 22.4943 43.7024 23.3922 44.6632C24.2902 45.6217 25.5492 46.1032 27.1674 46.1032C28.2211 46.1032 29.1466 45.936 29.9419 45.5994Z",
		"layout-grid-4": "M11 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM11 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM11 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM26 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM41 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-5c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h5c1.656 0 3 1.344 3 3z",
		"layout-grid-3": kS.layoutGrid3,
		"layout-grid-2": kS.layoutGrid2,
		"layout-grid": kS.layoutGrid3,
		"layout-grid-1": "M56 9v38c0 1.656-1.344 3-3 3h-50c-1.656 0-3-1.344-3-3v-38c0-1.656 1.344-3 3-3h50c1.656 0 3 1.344 3 3z",
		"layout-large": kS.layoutGrid2,
		"layout-list": "M16 41v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM16 25v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 41v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3zM16 9v6c0 1.656-1.344 3-3 3h-10c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h10c1.656 0 3 1.344 3 3zM56 25v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3zM56 9v6c0 1.656-1.344 3-3 3h-30c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h30c1.656 0 3 1.344 3 3z",
		minus: "M56 24.182v7.636c0 2.108-1.71 3.818-3.818 3.818h-48.364c-2.108 0-3.818-1.71-3.818-3.818v-7.636c0-2.108 1.71-3.818 3.818-3.818h48.364c2.108 0 3.818 1.71 3.818 3.818z",
		"minus-thin": "M0 23.297h56v9.406h-56v-9.406z",
		plus: "M56 24.182v7.636c0 2.108-1.71 3.818-3.818 3.818h-16.545v16.545c0 2.108-1.71 3.818-3.818 3.818h-7.636c-2.108 0-3.818-1.71-3.818-3.818v-16.545h-16.545c-2.108 0-3.818-1.71-3.818-3.818v-7.636c0-2.108 1.71-3.818 3.818-3.818h16.545v-16.545c0-2.108 1.71-3.818 3.818-3.818h7.636c2.108 0 3.818 1.71 3.818 3.818v16.545h16.545c2.108 0 3.818 1.71 3.818 3.818z",
		"plus-thin": "M56 31.946h-24.054v24.054h-7.893v-24.054h-24.054v-7.893h24.054v-24.054h7.893v24.054h24.054v7.893z",
		"rotate-left": "M56 28c0 15.422-12.578 28-28 28-8.349 0-16.224-3.682-21.547-10.099-0.365-0.474-0.328-1.167 0.073-1.568l4.995-5.031c0.255-0.219 0.583-0.328 0.911-0.328 0.328 0.036 0.656 0.182 0.839 0.438 3.573 4.63 8.932 7.255 14.729 7.255 10.281 0 18.667-8.385 18.667-18.667s-8.385-18.667-18.667-18.667c-4.776 0-9.297 1.823-12.687 4.995l4.995 5.031c0.693 0.656 0.875 1.677 0.51 2.516-0.365 0.875-1.203 1.458-2.151 1.458h-16.333c-1.276 0-2.333-1.057-2.333-2.333v-16.333c0-0.948 0.583-1.786 1.458-2.151 0.839-0.365 1.859-0.182 2.516 0.51l4.74 4.703c5.141-4.849 12.104-7.729 19.286-7.729 15.422 0 28 12.578 28 28z",
		"rotate-right": "M56 4.667v16.333c0 1.276-1.057 2.333-2.333 2.333h-16.333c-0.948 0-1.786-0.583-2.151-1.458-0.365-0.839-0.182-1.859 0.51-2.516l5.031-5.031c-3.427-3.172-7.948-4.995-12.724-4.995-10.281 0-18.667 8.385-18.667 18.667s8.385 18.667 18.667 18.667c5.797 0 11.156-2.625 14.729-7.255 0.182-0.255 0.51-0.401 0.839-0.438 0.328 0 0.656 0.109 0.911 0.328l4.995 5.031c0.438 0.401 0.438 1.094 0.073 1.568-5.323 6.417-13.198 10.099-21.547 10.099-15.422 0-28-12.578-28-28s12.578-28 28-28c7.182 0 14.146 2.88 19.286 7.729l4.74-4.703c0.656-0.693 1.677-0.875 2.552-0.51 0.839 0.365 1.422 1.203 1.422 2.151z",
		search: "M35.385 23.692c0-6.457-5.235-11.692-11.693-11.692s-11.693 5.235-11.693 11.692 5.235 11.692 11.693 11.692 11.693-5.235 11.693-11.692zM54.243 45.757A6 6 0 0 1 45.757 54.243L35.656 44.141A23.692 23.692 0 1 1 44.141 35.656L54.243 45.757z",
		"search-thin": "M38.769 23.692c0-8.313-6.764-15.077-15.077-15.077s-15.077 6.764-15.077 15.077 6.764 15.077 15.077 15.077 15.077-6.764 15.077-15.077zM56 51.692c0 2.356-1.952 4.308-4.308 4.308-1.144 0-2.255-0.471-3.029-1.279l-11.543-11.51c-3.937 2.726-8.649 4.173-13.428 4.173-13.091 0-23.692-10.601-23.692-23.692s10.601-23.692 23.692-23.692 23.692 10.601 23.692 23.692c0 4.779-1.447 9.49-4.173 13.428l11.543 11.543c0.774 0.774 1.245 1.885 1.245 3.029z",
		sort: "M48.364 35.636c0 0.676-0.278 1.312-0.756 1.79l-17.818 17.818c-0.477 0.477-1.114 0.756-1.79 0.756s-1.312-0.278-1.79-0.756l-17.818-17.818c-0.477-0.477-0.756-1.114-0.756-1.79 0-1.392 1.153-2.545 2.545-2.545h35.636c1.392 0 2.545 1.153 2.545 2.545zM48.364 20.364c0 1.392-1.153 2.545-2.545 2.545h-35.636c-1.392 0-2.545-1.153-2.545-2.545 0-0.676 0.278-1.312 0.756-1.79l17.818-17.818c0.477-0.477 1.114-0.756 1.79-0.756s1.312 0.278 1.79 0.756l17.818 17.818c0.477 0.477 0.756 1.114 0.756 1.79z",
		spinner: "M16.009 45.176c0 2.268-1.847 4.148-4.148 4.148-2.268 0-4.148-1.88-4.148-4.148 0-2.301 1.88-4.148 4.148-4.148 2.301 0 4.148 1.847 4.148 4.148zM32.148 51.852c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM9.333 29.037c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM48.287 45.176c0 2.268-1.88 4.148-4.148 4.148-2.301 0-4.148-1.88-4.148-4.148 0-2.301 1.847-4.148 4.148-4.148 2.268 0 4.148 1.847 4.148 4.148zM17.046 12.898c0 2.852-2.333 5.185-5.185 5.185s-5.185-2.333-5.185-5.185 2.333-5.185 5.185-5.185 5.185 2.333 5.185 5.185zM54.963 29.037c0 2.301-1.847 4.148-4.148 4.148s-4.148-1.847-4.148-4.148 1.847-4.148 4.148-4.148 4.148 1.847 4.148 4.148zM34.222 6.222c0 3.435-2.787 6.222-6.222 6.222s-6.222-2.787-6.222-6.222 2.787-6.222 6.222-6.222 6.222 2.787 6.222 6.222zM51.398 12.898c0 4.018-3.273 7.259-7.259 7.259-4.018 0-7.259-3.241-7.259-7.259 0-3.986 3.241-7.259 7.259-7.259 3.986 0 7.259 3.273 7.259 7.259z",
		square: "M0 0h56v56h-56z",
		star: "M56 21.993c0 0.606-0.438 1.178-0.875 1.615l-12.216 11.913 2.894 16.827c0.034 0.236 0.034 0.438 0.034 0.673 0 0.875-0.404 1.683-1.38 1.683-0.471 0-0.942-0.168-1.346-0.404l-15.111-7.942-15.111 7.942c-0.438 0.236-0.875 0.404-1.346 0.404-0.976 0-1.413-0.808-1.413-1.683 0-0.236 0.034-0.438 0.067-0.673l2.894-16.827-12.25-11.913c-0.404-0.438-0.841-1.010-0.841-1.615 0-1.010 1.043-1.413 1.885-1.548l16.894-2.457 7.572-15.312c0.303-0.639 0.875-1.38 1.649-1.38s1.346 0.74 1.649 1.38l7.572 15.312 16.894 2.457c0.808 0.135 1.885 0.538 1.885 1.548z",
		"star-half": "M39.919 32.426l8.651-8.415-14.205-2.087-1.010-2.020-5.352-10.839v32.415l1.986 1.043 10.704 5.655-2.020-11.949-0.404-2.222zM55.134 23.607l-12.219 11.916 2.895 16.83c0.236 1.481-0.303 2.356-1.346 2.356-0.37 0-0.842-0.135-1.346-0.404l-15.113-7.944-15.113 7.944c-0.505 0.269-0.976 0.404-1.346 0.404-1.043 0-1.582-0.875-1.346-2.356l2.895-16.83-12.252-11.916c-1.447-1.447-0.976-2.861 1.043-3.164l16.897-2.457 7.574-15.315c0.438-0.909 1.043-1.38 1.649-1.38v0c0.606 0 1.178 0.471 1.649 1.38l7.574 15.315 16.897 2.457c2.020 0.303 2.491 1.717 1.010 3.164z",
		"star-o": "M38.264 34.007l10.298-9.995-14.202-2.087-6.361-12.856-6.361 12.856-14.202 2.087 10.298 9.995-2.457 14.168 12.721-6.697 12.688 6.697zM56 21.993c0 0.606-0.438 1.178-0.875 1.615l-12.216 11.913 2.894 16.827c0.034 0.236 0.034 0.438 0.034 0.673 0 0.909-0.404 1.683-1.38 1.683-0.471 0-0.942-0.168-1.346-0.404l-15.111-7.942-15.111 7.942c-0.438 0.236-0.875 0.404-1.346 0.404-0.976 0-1.413-0.808-1.413-1.683 0-0.236 0.034-0.438 0.067-0.673l2.894-16.827-12.25-11.913c-0.404-0.438-0.841-1.010-0.841-1.615 0-1.010 1.043-1.413 1.885-1.548l16.894-2.457 7.572-15.312c0.303-0.639 0.875-1.38 1.649-1.38s1.346 0.74 1.649 1.38l7.572 15.312 16.894 2.457c0.808 0.135 1.885 0.538 1.885 1.548z",
		"video-camera": "M56 11v34c0 0.812-0.5 1.531-1.219 1.844-0.25 0.094-0.531 0.156-0.781 0.156-0.531 0-1.031-0.188-1.406-0.594l-12.594-12.594v5.187c0 4.969-4.031 9-9 9h-22c-4.969 0-9-4.031-9-9v-22c0-4.969 4.031-9 9-9h22c4.969 0 9 4.031 9 9v5.156l12.594-12.562c0.375-0.406 0.875-0.594 1.406-0.594 0.25 0 0.531 0.063 0.781 0.156 0.719 0.312 1.219 1.031 1.219 1.844z",
		warn: "M31.2981 5.28228C29.8323 2.74341 26.1677 2.74341 24.7019 5.28228L0.515899 47.1737C-0.94992 49.7126 0.88235 52.8861 3.81399 52.8861H52.186C55.1176 52.8861 56.9499 49.7126 55.4841 47.1737L31.2981 5.28228ZM25.2229 35.0037L24.8264 18.837C24.8264 18.655 24.8923 18.4729 25.047 18.3686C25.1794 18.2387 25.3776 18.1601 25.5759 18.1601H30.4241C30.6223 18.1601 30.8206 18.238 30.953 18.3686C31.1071 18.4729 31.1736 18.655 31.1736 18.837L30.7988 35.0037C30.7988 35.3679 30.4682 35.6542 30.0493 35.6542H25.9724C25.5759 35.6542 25.2453 35.3679 25.2229 35.0037ZM25.1788 43.9593V39.0131C25.1788 38.5447 25.487 38.1541 25.8618 38.1541H30.0929C30.4894 38.1541 30.82 38.5447 30.82 39.0131V43.9593C30.82 44.4277 30.4894 44.8183 30.0929 44.8183H25.8618C25.487 44.8183 25.1788 44.4277 25.1788 43.9593Z",
		wrench: "M12.407 45.809c0-1.193-0.988-2.181-2.181-2.181s-2.181 0.988-2.181 2.181 0.988 2.181 2.181 2.181 2.181-0.988 2.181-2.181zM34.357 31.494l-23.245 23.245c-0.784 0.784-1.909 1.261-3.068 1.261s-2.284-0.477-3.102-1.261l-3.613-3.681c-0.818-0.784-1.295-1.909-1.295-3.068s0.477-2.284 1.295-3.102l23.211-23.211c1.772 4.465 5.351 8.044 9.816 9.816zM55.966 16.667c0 1.125-0.409 2.522-0.784 3.613-2.147 6.067-7.976 10.259-14.418 10.259-8.419 0-15.27-6.851-15.27-15.27s6.851-15.27 15.27-15.27c2.488 0 5.726 0.75 7.805 2.147 0.341 0.239 0.545 0.545 0.545 0.954 0 0.375-0.239 0.75-0.545 0.954l-9.987 5.76v7.635l6.578 3.647c1.125-0.648 9.032-5.624 9.714-5.624s1.091 0.511 1.091 1.193z"
	};
})), MS, NS, PS, FS = o((() => {
	Ai(), Jb(), MS = /* @__PURE__ */ u(Yb()), jx(), OS(), jS(), vS(), hS(), NS = ({ color: e, fill: t, stroke: n, theme: r, width: i, height: a, size: o }) => Kb({
		color: e || t || r?.variables?.colors?.primary,
		fill: t || e || r?.variables?.colors?.primary,
		stroke: n,
		width: isNaN(Number(i || o)) ? i || o : `${i || o}px`,
		height: isNaN(Number(a || o)) ? a || o : `${a || o}px`,
		position: "relative"
	}), PS = yx((e) => {
		let t = Wx("icon", xi(), {
			size: "16px",
			viewBox: "0 0 56 56",
			treePath: ES()
		}, e), { color: n, icon: r, fill: i, path: a, children: o, size: s, width: c, title: l, height: u, viewBox: d, svg: f, disableStyles: p, className: m, internalClassName: h, style: g, styleScript: _, themeStyleScript: v, name: y, treePath: b, ...ee } = t, { overrideElement: x, shouldRenderDefault: S } = fS("icon", t);
		if (!S) return x;
		let te = Xx(t, NS), ne = (0, MS.default)("ss__icon", r && !f ? `ss__icon--${r}` : null, m, h);
		if (f) {
			let e = f?.props?.className || f?.props?.class, t = {
				...te,
				className: (0, MS.default)(ne, e),
				...ee
			};
			return p && (t.width = c || s, t.height = u || s), N(Nx, { children: qb(f.type, {
				...f.props,
				...t,
				children: f.props.children
			}) });
		}
		let re = AS[r] || a, C = typeof re;
		return o || re && (C === "string" || C === "object" && Array.isArray(re)) ? N(Nx, { children: Oi("svg", {
			...te,
			className: ne,
			viewBox: d,
			xmlns: "http://www.w3.org/2000/svg",
			width: p ? c || s : void 0,
			height: p ? u || s : void 0,
			...ee,
			children: [l ? N("title", { children: l }) : null, (() => {
				if (o) return o;
				if (C === "string") return N("path", {
					fill: p && (i || n) || void 0,
					d: re
				});
				if (re && C === "object" && Array.isArray(re)) return re.map((e, t) => N(e.type, { ...e.attributes }, t));
			})()]
		}) }) : null;
	});
})), IS, LS, RS, zS, BS = o((() => {
	Ai(), Jb(), IS = /* @__PURE__ */ u(Yb()), k(), FS(), vS(), OS(), hS(), LS = ({ componentTheme: e }) => Kb({
		width: "360px",
		height: "120px",
		overflow: "hidden",
		fontSize: "14px",
		position: "fixed",
		zIndex: "9999",
		cursor: "auto",
		bottom: "50px",
		right: 0,
		padding: "0 5px",
		background: e.main.background,
		color: e.main.color,
		border: e.main.border,
		borderTopLeftRadius: "10px",
		borderBottomLeftRadius: "10px",
		boxShadow: e.main.boxShadow,
		transition: "height ease 0.2s, right ease 0.5s 0.2s",
		"&.ss__branch-override--collapsed": {
			transition: "height ease 0.5s 0.5s, right ease 0.5s",
			right: "-323px",
			height: "50px",
			cursor: "pointer"
		},
		".ss__branch-override__top": {
			padding: "10px 5px",
			background: e.top.background,
			borderBottom: e.top.border,
			".ss__branch-override__top__logo": {
				display: "inline-block",
				height: "30px",
				maxHeight: "30px",
				verticalAlign: "middle"
			},
			".ss__branch-override__top__collapse": {
				display: "inline-block",
				float: "right",
				paddingTop: "7px",
				cursor: "pointer"
			},
			".ss__branch-override__top__button": {
				borderRadius: "5px",
				padding: "6px",
				height: "100%",
				lineHeight: "14px",
				textAlign: "center",
				cursor: "pointer",
				fontSize: "10px",
				border: e.top.button.border,
				color: e.top.button.color,
				float: "right",
				marginRight: "14px"
			}
		},
		".ss__branch-override__bottom": {
			padding: "10px 15px",
			fontSize: "12px",
			".ss__branch-override__bottom__left": {
				fontWeight: "bold",
				fontStyle: e.bottom.branch.style,
				color: e.bottom.branch.color,
				fontSize: "14px",
				lineHeight: "20px",
				display: "inline-flex",
				alignItems: "center",
				maxWidth: "180px",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				svg: { marginRight: "10px" }
			},
			".ss__branch-override__bottom__right": {
				float: "right",
				fontStyle: "italic",
				color: e.bottom.additional.color,
				fontSize: "12px",
				lineHeight: "20px"
			},
			".ss__branch-override__bottom__content": { marginTop: "10px" }
		}
	}), RS = {
		darkTheme: {
			class: "ss__branch-override--dark",
			main: {
				border: "0",
				background: "rgba(26, 29, 36, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #454c5f",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "STOP PREVIEW"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Preview functionality may differ from production.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		},
		lightTheme: {
			class: "ss__branch-override--light",
			main: {
				border: "0",
				background: "rgba(29, 73, 144, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #3c78d7",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "STOP PREVIEW"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Preview functionality may differ from production.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		},
		failureTheme: {
			class: "ss__branch-override--error",
			main: {
				border: "0",
				background: "rgba(130, 6, 6, 0.9)",
				color: "#fff",
				boxShadow: ""
			},
			top: {
				border: "1px solid #e50b0b",
				logo: { src: "https://cdn.athoscommerce.net/snap/images/athos-logo-white.svg" },
				button: {
					border: "1px solid #fff",
					color: "#fff",
					content: "REMOVE"
				},
				close: { fill: "#fff" }
			},
			bottom: {
				content: "Incorrect branch name or branch no longer exists.",
				branch: {
					color: "#fff",
					style: "italic"
				},
				additional: { color: "#fff" }
			}
		}
	}, zS = (e) => {
		let t = Wx("branchOverride", xi(), { treePath: ES() }, e), { branch: n, details: r, error: i, className: a, internalClassName: o, darkMode: s, disableStyles: c, onRemoveClick: l, treePath: u } = t, { overrideElement: d, shouldRenderDefault: f } = fS("branchOverride", t);
		if (!f) return d;
		let p = { icon: {
			internalClassName: "ss__branch-override__bottom__left__icon",
			size: "12px",
			...zx({ disableStyles: c }),
			theme: t?.theme,
			treePath: u
		} }, [m, h] = Ve((typeof s == "boolean" ? s : window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) ? "darkTheme" : "lightTheme"), [g, _] = Ve(0);
		i && h("failureTheme");
		let v = Xx({
			...t,
			componentTheme: RS[m]
		}, LS);
		return (r || i) && n ? Oi("div", {
			className: (0, IS.default)("ss__branch-override", RS[m].class, { "ss__branch-override--collapsed": g }, a, o),
			...v,
			onClick: (e) => {
				e.preventDefault(), e.stopPropagation(), _(0);
			},
			children: [Oi("div", {
				className: "ss__branch-override__top",
				children: [
					N("img", {
						className: "ss__branch-override__top__logo",
						src: RS[m].top.logo.src
					}),
					N("div", {
						className: "ss__branch-override__top__collapse",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), _(1);
						},
						children: N(PS, {
							size: "18px",
							color: RS[m].top.close.fill,
							...p.icon,
							icon: "close-thin"
						})
					}),
					N("div", {
						className: "ss__branch-override__top__button",
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), l && l(e, n);
						},
						children: RS[m].top.button.content
					})
				]
			}), Oi("div", {
				className: "ss__branch-override__bottom",
				children: [
					N("span", {
						className: "ss__branch-override__bottom__left",
						children: i ? Oi(ki, { children: [N(PS, {
							size: "12px",
							color: RS[m].bottom.branch.color,
							...p.icon,
							icon: "warn"
						}), N("span", { children: i.message })] }) : n
					}),
					N("span", {
						className: "ss__branch-override__bottom__right",
						children: i ? n : r?.lastModified
					}),
					N("div", {
						className: "ss__branch-override__bottom__content",
						children: i?.description || RS[m].bottom.content
					})
				]
			})]
		}) : null;
	};
})), VS = /* @__PURE__ */ c({ BranchOverride: () => zS }), HS = o((() => {
	BS();
})), US = o((() => {
	Ib(), zb(), Hb(), Eb();
})), WS = /* @__PURE__ */ c({
	RecommendationInstantiator: () => ZS,
	defined: () => JS
});
async function GS(e, t, n, r, i, a, o, s, c) {
	let { profile: l, batchId: u, cart: d, tag: f } = o, p = l?.batched ?? o.batched ?? !0;
	if (!f) {
		e.logger.warn("'tag' is missing from <script> tag, skipping this profile", a);
		return;
	}
	Array.isArray(d) && e.tracker.cookies.cart.set(d);
	let m = YS.default.all([
		e.config.client?.globals || {},
		e.config.config?.globals || {},
		o
	]), h = {
		tag: f,
		batched: p ?? e.config.config?.batched ?? !0,
		realtime: !!(r.options?.realtime ?? r.profile?.options?.realtime ?? e.config.config?.realtime),
		batchId: u,
		middleware: e.config.config.middleware,
		plugins: e.config.config.plugins,
		branch: e.config.config?.branch || "production",
		limit: e.config.config?.limit,
		beacon: e.config.config?.beacon || { enabled: !0 },
		settings: { variants: e.config.config?.variants },
		globals: m
	};
	l?.branch && (h.branch = l?.branch), i[f] = i[f] + 1 || 1;
	let g = {
		id: `recommend_${f}_${i[f] - 1}`,
		...h
	}, _ = Vb({
		url: e.config.url,
		controller: g,
		context: r,
		mode: e.config.mode
	}, {
		client: e.client,
		tracker: e.tracker
	});
	n && n.setAttribute("ss-controller-id", _.id), e.uses.forEach((e) => _.use(e)), e.plugins.forEach((e) => _.plugin(e.func, ...e.args)), e.middleware.forEach((e) => _.on(e.event, ...e.func)), e.controller[_.config.id] = _, window.athos.controller = window.athos.controller || {}, window.athos.controller[_.config.id] = _, _.addTargeter(c), _.store.loading || await _.search();
	let v = _.store.profile.display?.templateParameters;
	if (!_.store.error) {
		if (!_.store.profile.display.template) {
			e.logger.error(`profile '${f}' found on the following element is missing a template!\n${a?.outerHTML}`);
			return;
		}
		if (!v) {
			e.logger.error(`profile '${f}' found on the following element is missing templateParameters!\n${a?.outerHTML}`);
			return;
		}
		return n && await KS(e, t, _, n, a, s), _;
	}
}
async function KS(e, t, n, r, i, a) {
	r && r.setAttribute("ss-controller-id", n.id);
	let o = n.config.tag, s = n.store.profile.display?.template?.component;
	if (!s) {
		e.logger.error(`profile '${o}' found on the following element is missing a component!\n${i?.outerHTML}`);
		return;
	}
	let c = {}, l;
	if (c.className = `ss__recommendation-${s.toLowerCase()}`, e.config.components[s]?.onTarget?.(a, i, r, n), e.config.components[s] && typeof e.config.components[s] == "function") l = await e.config.components[s]();
	else if (e.config.components[s] && typeof e.config.components[s] == "object") {
		c = e.config.components[s].props || {};
		let t = [];
		t.push(e.config.components[s].component()), l = (await Promise.all(t))[0];
	}
	if (!l) {
		e.logger.error(`profile '${o}' found on the following element is expecting component mapping for '${s}' - verify instantiator config.\n${i?.outerHTML}`);
		return;
	}
	setTimeout(() => {
		ge(N(l, {
			controller: n,
			snap: t?.snap,
			...c
		}), r);
	});
}
function qS(e) {
	if (typeof e == "function") try {
		let t = e();
		if (Array.isArray(t)) return t;
	} catch {}
	else if (Array.isArray(e)) return e;
	return [];
}
function JS(e) {
	let t = {};
	return Object.keys(e).map((n) => {
		e[n] !== void 0 && (t[n] = e[n]);
	}), t;
}
var YS, XS, ZS, QS = o((() => {
	Ai(), Le(), YS = /* @__PURE__ */ u(ji()), W(), vd(), Td(), c_(), US(), XS = "production", ZS = class {
		constructor(e, t, n) {
			if (this.mode = U.production, this.controller = {}, this.uses = [], this.plugins = [], this.middleware = [], this.config = e, !this.config) throw Error("Recommendation Instantiator config is required");
			if (this.config.config?.branch || (this.config.config = this.config.config || {}, this.config.config.branch = XS), !this.config.components || typeof this.config.components != "object" || !Object.keys(this.config.components).length) throw Error("Recommendation Instantiator config must contain 'components' mapping property");
			if ((!t?.client || !t?.tracker) && !this.config?.client?.globals?.siteId) throw Error("Recommendation Instantiator config must contain a valid config.client.globals.siteId value");
			this.config.mode && Object.values(U).includes(this.config.mode) && (this.mode = this.config.mode, this.config?.client?.globals?.siteId && (this.config.client.config = this.config.client.config || {}, this.config.client.config.mode = this.config.client.config.mode || this.mode)), window.athos = window.athos || {}, this.context = (0, YS.default)(n || {}, e.context || {}), this.client = t?.client || new gd(this.config.client.globals, this.config.client.config), this.tracker = t?.tracker || new a_(this.config.client.globals), this.logger = t?.logger || new Cd({
				prefix: "RecommendationInstantiator ",
				mode: this.mode
			});
			let r = {};
			this.targeter = new Il([{
				selector: `${this.config.selector || "script[type=\"searchspring/recommend\"], script[type=\"searchspring/personalized-recommendations\"], script[type=\"athos/recommend\"], script[type=\"athos/personalized-recommendations\"]"}, script[type="searchspring/recommend"][profile="email"], script[type="athos/recommend"][profile="email"]`,
				autoRetarget: !0,
				clickRetarget: !0,
				navigationRetarget: !0,
				emptyTarget: !1
			}, {
				selector: "script[type=\"searchspring/recommendations\"], script[type=\"athos/recommendations\"]",
				autoRetarget: !0,
				clickRetarget: !0,
				navigationRetarget: !0,
				emptyTarget: !1
			}], async (e, n) => {
				this.cleanupStaleControllers();
				let i = n, a = Yl([
					"shopperId",
					"shopper",
					"product",
					"products",
					"seed",
					"cart",
					"filters",
					"blockedItems",
					"options",
					"profile",
					"custom",
					"profiles",
					"globals"
				], i);
				if (a.profiles && a.profiles.length) {
					let e = a.profiles, n = a.globals, o = { ...JS({
						blockedItems: n?.blockedItems,
						filters: n?.filters,
						cart: n?.cart && qS(n.cart),
						products: n?.products,
						shopper: n?.shopper?.id,
						batchId: Math.floor(Math.random() * (2 ** 53 - 1))
					}) };
					e.forEach((e, s) => {
						if (e.selector) {
							let c = {
								selector: e.selector,
								autoRetarget: !0,
								profile: e,
								order: s
							}, l;
							new Il([c], async (e, s, c, u) => {
								if (i.isConnected === !1) {
									s && u?.releaseTargets([s]);
									return;
								}
								if (e.profile?.profile || e.profile?.tag) {
									let c = {
										...o,
										profile: {
											...e.profile?.options,
											order: e.order
										},
										tag: e.profile.tag || e.profile.profile
									}, d = (0, YS.default)(this.context, JS({
										globals: n,
										profile: e.profile
									}));
									if (a.custom && (d.custom = (0, YS.default)(d.custom, a.custom)), !l) l = GS(this, t || {}, s, d, r, i, c, e, u);
									else {
										let n = await l;
										n && s && KS(this, t || {}, n, s, i, e);
									}
								}
							});
						}
					});
				} else {
					let { profile: n, products: o, product: s, seed: c, filters: l, blockedItems: u, options: d, shopper: f, shopperId: p } = a, m = [].concat(o || s || c || []), h = [
						f,
						f?.id,
						p,
						p?.id
					].filter((e) => e && typeof e == "string").pop(), g = {
						tag: n,
						...JS({
							products: m.length ? m : void 0,
							cart: a.cart && qS(a.cart),
							shopper: h,
							filters: l,
							blockedItems: u,
							profile: d
						})
					}, _ = i.getAttribute("profile") || "", v = i.ownerDocument.createElement("div");
					v.setAttribute("searchspring-recommend", _), i.before(v);
					let y = (0, YS.default)(this.context, a);
					new Il([{
						selector: `[searchspring-recommend="${_}"]`,
						name: `legacy_${n}_${r[n || ""] || 0}`
					}], async (n, a, o, s) => {
						if (i.isConnected === !1) {
							a && s?.releaseTargets([a]);
							return;
						}
						GS(this, t || {}, a, y, r, i, g, e, s);
					});
				}
			});
		}
		plugin(e, ...t) {
			this.plugins.push({
				func: e,
				args: t
			});
		}
		on(e, ...t) {
			this.middleware.push({
				event: e,
				func: t
			});
		}
		use(e) {
			this.uses.push(e);
		}
		cleanupStaleControllers() {
			Object.keys(this.controller).forEach((e) => {
				let t = this.controller[e];
				Object.values(t.targeters).some((t) => t.getTargetedElems().some((t) => (t.isConnected !== !1 && t.getAttribute("ss-controller-id")) === e)) || (Object.keys(t.targeters).forEach((e) => t.targeters[e].destroy()), t.targeters = {}, delete this.controller[e], window.athos?.controller && delete window.athos.controller[e]);
			});
		}
	};
}));
Ai(), Le();
var $S = /* @__PURE__ */ u(ji());
Pi(), H(), vd(), Td(), c_(), W(), Ky(), Eb(), jb(), Yo({
	useProxies: "never",
	isolateGlobalState: !0,
	enforceActions: "never"
});
var eC = "athosBranch", tC = "athos-preview", nC = "athos-Dev", rC = "athos-snap-bundle-styles", iC = 3, aC = "Uncaught Error - Invalid value passed as the component.\nThis usually happens when you pass a JSX Element, and not a function that returns the component, in the snap config. \n		\n		instead of - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: <Content/>,\n		},\n	]\n\n		or - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: Content,\n		},\n	]\n\n		please try - \n\n	targeters: [\n		{\n			selector: '#athos-content',\n			hideTarget: true,\n			component: () => Content\n		},\n	]\n\nThe error above happened in the following targeter in the Snap Config", oC = class {
	constructor(e, t) {
		this.mode = U.production, this._instantiatorPromises = {}, this._controllerPromises = {}, this.controllers = {}, this.getInstantiator = (e) => this._instantiatorPromises[e] || Promise.reject(`getInstantiator could not find instantiator with id: ${e}`), this.getController = (e) => this._controllerPromises[e] || Promise.reject(`getController could not find controller with id: ${e}`), this.getControllers = (...e) => {
			let t = [];
			return e.forEach((e) => t.push(this.getController(e))), Promise.all(t);
		}, this.createController = async (e, t, n, r, i, a) => {
			if (this._controllerPromises[t.id] !== void 0) throw Error(`Controller with id '${t.id}' is already defined`);
			return this._controllerPromises[t.id] = new Promise((o) => this._createController(e, t, n, r, i, async (e) => {
				typeof a == "function" && await a(e), o(e);
			})), this._controllerPromises[t.id];
		}, this._createController = async (e, t, n, r, i, a) => {
			let o;
			switch (e) {
				case oy.autocomplete:
					o = Promise.resolve().then(() => (Ib(), Pb));
					break;
				case oy.finder:
					o = Promise.resolve().then(() => (zb(), Lb));
					break;
				case oy.recommendation:
					o = Promise.resolve().then(() => (Hb(), Bb));
					break;
				case oy.search:
				default: o = Promise.resolve().then(() => (Eb(), wb));
			}
			let s = (await o).default;
			return this.controllers[t.id] || (window.athos.controller = window.athos.controller || {}, window.athos.controller[t.id] = this.controllers[t.id] = s({
				mode: this.mode,
				url: (0, $S.default)(this.config.url || {}, r || {}),
				controller: t,
				context: (0, $S.default)(this.context || {}, i || {})
			}, {
				client: n?.client || this.client,
				store: n?.store,
				urlManager: n?.urlManager,
				eventManager: n?.eventManager,
				profiler: n?.profiler,
				logger: n?.logger,
				tracker: n?.tracker || this.tracker
			})), a && await a(this.controllers[t.id]), this.controllers[t.id];
		}, this.handlers = {
			attributes: (e) => {
				let t = this.tracker.config.id, n = [
					`ss-${t}-cart-add`,
					`ss-${t}-cart-remove`,
					`ss-${t}-cart-clear`,
					`ss-${t}-cart-view`,
					`ss-${t}-intellisuggest`,
					`ss-${t}-intellisuggest-signature`,
					"href"
				], r = {}, i = 0, a = null;
				for (a = e && e.target; Object.keys(r).length == 0 && a !== null && i <= iC;) a.attributes && Object.values(a.attributes).forEach((e) => {
					let t = e.nodeName;
					n.indexOf(t) != -1 && (r[t] = a && a.getAttribute(t));
				}), a = a.parentElement, i++;
				if (r[`ss-${t}-cart-add`]) {
					let e = r[`ss-${t}-cart-add`].split(",");
					this.tracker.cookies.cart.add(e), this.eventManager.fire("controller/recommendation/update");
				} else if (r[`ss-${t}-cart-remove`]) {
					let e = r[`ss-${t}-cart-remove`].split(",");
					this.tracker.cookies.cart.remove(e), this.eventManager.fire("controller/recommendation/update");
				} else `ss-${t}-cart-clear` in r ? (this.tracker.cookies.cart.clear(), this.eventManager.fire("controller/recommendation/update")) : `ss-${t}-cart-view` in r ? this.eventManager.fire("controller/recommendation/update") : r[`ss-${t}-intellisuggest`] && r[`ss-${t}-intellisuggest-signature`] && this.tracker.track.product.click();
			},
			error: (e) => {
				try {
					let { filename: t } = e;
					if ((t.includes("snapui.searchspring.io") || t.includes("snapui.athoscommerce.io")) && t.endsWith(".js") && this.tracker.track.error) {
						let { colno: n, lineno: r, error: { stack: i }, message: a, timeStamp: o } = e, s = {
							href: window.location.href,
							filename: t,
							stack: i,
							message: a,
							colno: n,
							lineno: r,
							errortimestamp: o
						};
						this.tracker.track.error(s);
					}
				} catch {}
			}
		}, window.removeEventListener("error", this.handlers.error), window.addEventListener("error", this.handlers.error), document.removeEventListener("click", this.handlers.attributes), document.addEventListener("click", this.handlers.attributes), this.config = e;
		let n = {};
		try {
			n = Yl([
				"shopper",
				"config",
				"custom",
				"merchandising",
				"siteId",
				"currency",
				"page",
				"backgroundFilters",
				"collection",
				"tags",
				"category",
				"brand"
			]);
		} catch {
			console.error("Snap failed to find global context");
		}
		if (this.config = (0, $S.default)(this.config || {}, n.config || {}, { isMergeableObject: Ni }), this.context = (0, $S.default)(this.config.context || {}, n || {}, { isMergeableObject: Ni }), !this.config?.client?.globals?.siteId && this.context.siteId) {
			let e = { globals: { siteId: this.context.siteId } };
			this.config.client = (0, $S.default)(e, this.config.client || {});
		}
		if ((!t?.client || !t?.tracker) && !this.config?.client?.globals?.siteId) throw t?.templatesStore ? Error("SnapTemplates: config provided must contain a valid config.siteId value") : Error("Snap: config provided must contain a valid config.client.globals.siteId value");
		this.config.client?.globals && this.context.merchandising?.segments && (this.config.client.globals?.merchandising ? this.config.client.globals.merchandising.segments = (0, $S.default)(this.config.client.globals.merchandising.segments, this.context.merchandising.segments) : this.config.client.globals.merchandising = { segments: this.context.merchandising.segments }), t?.templatesStore && (this.templates = t.templatesStore);
		try {
			let e = eu(window.location.href), n = e?.params?.query["athos-preview"] || Ul.get("athosBranch"), r = typeof window < "u" && window.location.hostname && "." + window.location.hostname.replace(/^www\./, "") || void 0;
			Object.values(U).includes("production") && (this.mode = "production"), this.config.mode && Object.values(U).includes(this.config.mode) && (this.mode = this.config.mode), (e?.params?.query && "dev" in e.params.query || Ul.get("athos-Dev")) && (e?.params.query?.dev == "false" || e?.params.query?.dev == "0" ? (Ul.unset(nC, r), this.mode = U.production) : (Ul.set(nC, "1", "Lax", 0, r), this.mode = U.development));
			let i = window?.athos?.managed ? "managed/" : "";
			this.config.client && (this.config.client.config = this.config.client.config || {}, this.config.client.config.initiator || (this.config.client.config.initiator = `athos/${i}snap/preact/${gu}`), this.config.client.config.mode = this.config.client.config.mode || this.mode), Db(this.config), this.client = t?.client || new gd(this.config.client.globals, this.config.client.config), this.logger = t?.logger || new Cd({
				prefix: `${this.config.tracker?.config?.framework == "snap/templates" ? "Snap Preact Templates " : this.config.tracker?.config?.framework == "snap/hybrid" ? "Snap Preact Hybrid " : "Snap Preact "}`,
				mode: this.mode
			});
			let a = this.config.tracker?.globals || this.config.client.globals;
			this.context.currency?.code && (a = (0, $S.default)(a || {}, { currency: this.context.currency })), this.context.shopper?.cart && (a = (0, $S.default)(a || {}, { cart: this.context.shopper.cart }));
			let o = (0, $S.default)(this.config.tracker?.config || {}, {
				framework: `${i}${this.config.tracker?.config?.framework || "snap"}/preact`,
				mode: this.mode
			});
			if (this.tracker = t?.tracker || new a_(a, o), this.logger.imageText({
				url: "https://snapui.athoscommerce.io/favicon.svg",
				text: `[${gu}]`,
				style: `color: ${this.logger.colors.indigo}; font-weight: bold;`
			}), n && !document.querySelector("script[athosBranch]")) {
				this.logger.warn(`:: loading branch override ~ '${n}' ...`), Vl.cookies ? Ul.set(eC, n, "Lax", 36e5, r) : this.logger.warn("Cookies are not supported/enabled by this browser, branch overrides will not persist!");
				let e = `https://snapui.athoscommerce.io/${this.config.client?.globals?.siteId}/`, t = document.querySelector("script[src*=\"//snapui.searchspring.io\"], script[src*=\"//snapui.athoscommerce.io\"]");
				if (t) {
					let n = t.getAttribute("src").match(/\/\/snapui.searchspring.io\/[a-zA-Z0-9]{6}\//);
					n ? e = n.toString() : (n = t.getAttribute("src").match(/\/\/snapui.athoscommerce.io\/[a-zA-Z0-9]{6}\//), n && (e = n.toString()));
				}
				let i = document.createElement("script"), a = `${e}${n}/bundle.js`;
				throw i.src = a, i.setAttribute(eC, n), new Il([{
					selector: "body",
					inject: {
						action: "append",
						element: () => {
							let e = document.createElement("div");
							return e.id = "athos-branch-override", e;
						}
					}
				}], async (e, t) => {
					let o = {};
					try {
						let e = (await Promise.resolve().then(() => (Gb(), Ub))).getBundleDetails;
						o.details = await e(a);
					} catch (e) {
						o.error = e;
					}
					let s = (await Promise.resolve().then(() => (HS(), VS))).BranchOverride;
					ge(N(s, {
						...o,
						branch: n,
						onRemoveClick: () => {
							Ul.unset(eC, r);
							let e = eu(window.location.href);
							delete e?.params.query[tC];
							let t = e?.url();
							t && t != window.location.href ? window.location.href = t : window.location.reload();
						}
					}), t);
					try {
						delete window.athos;
					} catch {
						window.athos = void 0;
					}
					document.head.appendChild(i);
				}), document.querySelectorAll(`.${rC}`).forEach((e) => e.remove()), "branch override";
			}
		} catch (e) {
			if (e == "branch override") throw `${this.logger.emoji.bang} Snap instantiation halted - using branch override.`;
			this.logger.error(e);
		}
		if (window.athos = window.athos || {}, window.athos.build = window.athos.build || "modern", window.athos.context = this.context, this.client && (window.athos.client = this.client), t?.templatesStore && (window.athos.templates = this.templates), this.eventManager = Mb(), this.eventManager && (window.athos.on = (e, ...t) => {
			this.eventManager.on(e, ...t);
		}, window.athos.fire = (e, ...t) => {
			this.eventManager.fire(e, ...t);
		}), this.context?.shopper?.id && this.tracker.track.shopper.login({ id: this.context.shopper.id }), Object.keys(this.config?.controllers || {}).forEach((e) => {
			switch (e) {
				case "search":
					this.config.controllers[e].forEach((t, n) => {
						try {
							if (this._controllerPromises[t.config.id] !== void 0) {
								this.logger.error(`Controller with id '${t.config.id}' is already defined`);
								return;
							}
							let e = Tb({
								mode: this.mode,
								url: (0, $S.default)(this.config.url || {}, t.url || {}),
								controller: t.config,
								context: (0, $S.default)(this.context || {}, t.context || {})
							}, {
								client: t.services?.client || this.client,
								store: t.services?.store,
								urlManager: t.services?.urlManager,
								eventManager: t.services?.eventManager,
								profiler: t.services?.profiler,
								logger: t.services?.logger,
								tracker: t.services?.tracker || this.tracker
							});
							window.athos.controller = window.athos.controller || {}, window.athos.controller[e.config.id] = this.controllers[e.config.id] = e, this._controllerPromises[e.config.id] = new Promise((t) => t(e));
							let n = null, r = async () => (n ||= (t.url?.initial && Yy(t.url.initial, e.urlManager).go({ history: "replace" }), this.controllers[t.config.id].search()), n), i = async (e, n, i) => {
								let a = [];
								e.renderAfterSearch ? a.push(r()) : (a.push(Promise.resolve()), r());
								let o = e.onTarget;
								o && await o(e, n, i);
								try {
									a.push(e.component());
									let [r, i] = await Promise.all(a);
									setTimeout(() => {
										ge(N(i, {
											controller: this.controllers[t.config.id],
											snap: this,
											...e.props
										}), n);
									});
								} catch (t) {
									this.logger.error(t), this.logger.error(aC, e);
								}
							};
							t?.targeters?.forEach((t, n) => {
								if (!t.selector) throw Error(`Targets at index ${n} missing selector value (string).`);
								if (!t.component) throw Error(`Targets at index ${n} missing component value (Component).`);
								let a = this.context.pageType && `${this.context.pageType}`.toLowerCase().trim();
								(t.prefetch || ["search", "category"].includes(a)) && (r(), t.component()), e.createTargeter({
									controller: e,
									...t
								}, async (e, t, n) => {
									if (e && e.skeleton && t) {
										let n = await e.skeleton();
										setTimeout(() => {
											ge(N(n, {}), t);
										});
									}
									await i(e, t, n);
								});
							});
						} catch (t) {
							this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
						}
					});
					break;
				case "autocomplete":
					this.config.controllers[e].forEach((t, n) => {
						if (this._controllerPromises[t.config.id] !== void 0) {
							this.logger.error(`Controller with id '${t.config.id}' is already defined`);
							return;
						}
						this._controllerPromises[t.config.id] = new Promise(async (r) => {
							try {
								let e = !1, n = () => {
									e || (e = !0, setTimeout(() => {
										this.controllers[t.config.id].bind();
									}));
								}, i = async (e, n, r) => {
									let i = e.onTarget;
									i && await i(e, n, r);
									try {
										let i = [];
										i.push(e.component());
										let a = (await Promise.all(i))[0];
										setTimeout(() => {
											ge(N(a, {
												controller: this.controllers[t.config.id],
												input: r,
												snap: this,
												...e.props
											}), n);
										});
									} catch (t) {
										this.logger.error(t), this.logger.error(aC, e);
									}
								};
								(!t?.targeters || t?.targeters.length === 0) && (await this._createController(oy.autocomplete, t.config, t.services, t.url, t.context, (e) => {
									e && r(e);
								}), n()), t?.targeters?.forEach((e, a) => {
									if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
									if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
									let o = new Il([{
										inject: {
											action: "after",
											element: () => {
												let e = document.createElement("div");
												return e.className = "ss__autocomplete--target", e.addEventListener("click", (e) => {
													e.stopPropagation();
												}), e;
											}
										},
										...e
									}], async (e, a, s) => {
										let c = await this._createController(oy.autocomplete, t.config, t.services, t.url, t.context, (e) => {
											e && r(e);
										});
										n(), i({
											controller: c,
											...e
										}, a, s), c.addTargeter(o);
									});
								});
							} catch (t) {
								this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
							}
						});
					});
					break;
				case "finder":
					this.config.controllers[e].forEach((t, n) => {
						if (this._controllerPromises[t.config.id] !== void 0) {
							this.logger.error(`Controller with id '${t.config.id}' is already defined`);
							return;
						}
						this._controllerPromises[t.config.id] = new Promise((r) => {
							try {
								let e = !1, n = () => {
									e ||= (this.controllers[t.config.id].search(), !0);
								}, i = async (e, n, r) => {
									let i = e.onTarget;
									i && await i(e, n, r);
									try {
										let r = await e.component();
										setTimeout(() => {
											ge(N(r, {
												controller: this.controllers[t.config.id],
												snap: this,
												...e.props
											}), n);
										});
									} catch (t) {
										this.logger.error(t), this.logger.error(aC, e);
									}
								};
								(!t?.targeters || t?.targeters.length === 0) && this._createController(oy.finder, t.config, t.services, t.url, t.context, (e) => {
									e && r(e);
								}), t?.targeters?.forEach((e, a) => {
									if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
									if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
									let o = new Il([{ ...e }], async (e, a, s) => {
										let c = await this._createController(oy.finder, t.config, t.services, t.url, t.context, (e) => {
											e && r(e);
										});
										n(), i({
											controller: c,
											...e
										}, a, s), c.addTargeter(o);
									});
								});
							} catch (t) {
								this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
							}
						});
					});
					break;
				case "recommendation": this.config.controllers[e].forEach((t, n) => {
					if (this._controllerPromises[t.config.id] !== void 0) {
						this.logger.error(`Controller with id '${t.config.id}' is already defined`);
						return;
					}
					this._controllerPromises[t.config.id] = new Promise((r) => {
						try {
							let e = !1, n = () => {
								e ||= (this.controllers[t.config.id].search(), !0);
							}, i = async (e, n, r) => {
								let i = e.onTarget;
								i && await i(e, n, r);
								try {
									let r = await e.component();
									setTimeout(() => {
										ge(N(r, {
											controller: this.controllers[t.config.id],
											snap: this,
											...e.props
										}), n);
									});
								} catch (t) {
									this.logger.error(t), this.logger.error(aC, e);
								}
							};
							(!t?.targeters || t?.targeters.length === 0) && this._createController(oy.recommendation, t.config, t.services, t.url, t.context, (e) => {
								e && r(e);
							}), t?.targeters?.forEach((e, a) => {
								if (!e.selector) throw Error(`Targets at index ${a} missing selector value (string).`);
								if (!e.component) throw Error(`Targets at index ${a} missing component value (Component).`);
								let o = new Il([{ ...e }], async (e, a, s) => {
									let c = await this._createController(oy.recommendation, t.config, t.services, t.url, t.context, (e) => {
										e && r(e);
									});
									n(), i({
										controller: c,
										...e
									}, a, s), c.addTargeter(o);
								});
							});
						} catch (t) {
							this.logger.error(`Failed to instantiate ${e} controller at index ${n}.`, t);
						}
					});
				});
			}
		}), this.config?.instantiators?.recommendation) try {
			this._instantiatorPromises.recommendation = Promise.resolve().then(() => (QS(), WS)).then(({ RecommendationInstantiator: e }) => (this.config.instantiators.recommendation.mode = this.config.instantiators.recommendation.mode || this.mode, new e(this.config.instantiators.recommendation, {
				client: this.client,
				tracker: this.tracker,
				logger: this.logger,
				snap: this
			}, this.context)));
		} catch (e) {
			this.logger.error("Failed to create Recommendations Instantiator.", e);
		}
	}
}, sC = (e, t = "https://www.stemma.fi") => {
	if (typeof e != "string") return null;
	let n = e.trim();
	if (!n) return null;
	try {
		let e = new URL(n, t);
		return e.protocol !== "http:" && e.protocol !== "https:" ? null : e;
	} catch {
		return null;
	}
}, cC = (e) => {
	let t = sC(e);
	return t ? t.href : "";
}, lC = (e) => /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(e), uC = (e) => {
	if (!e) return e || "";
	try {
		let t = new URL(e, "https://example.invalid");
		if (!t.searchParams.has("variant")) return e;
		t.searchParams.delete("variant");
		let n = t.searchParams.toString(), r = `${t.pathname}${n ? `?${n}` : ""}${t.hash}`;
		return lC(e) ? `${t.origin}${r}` : r;
	} catch {
		return e;
	}
}, dC = 12, fC = (e) => {
	let t = e?.display?.mappings?.core || e?.mappings?.core || {}, n = e?.display?.mappings?.core?.url || "";
	return {
		coreUrl: t.url || "",
		displayUrl: n
	};
}, pC = (e, t) => !e || !t ? !1 : e.includes(t), mC = (e, t) => {
	if (!e || !t) return !1;
	let n = uC(t);
	if (!n) return !1;
	if (e === n || e.startsWith(`${n}?`)) return !0;
	try {
		return new URL(e, "https://example.invalid").pathname === new URL(n, "https://example.invalid").pathname;
	} catch {
		return !1;
	}
}, hC = (e, t) => {
	let { coreUrl: n, displayUrl: r } = fC(t), i = (e.composedPath ? e.composedPath() : [e.target]).slice(0, dC);
	for (let e of i) {
		if (!(e instanceof Element)) continue;
		let t = e.getAttribute("href");
		if (t && (pC(t, n) || pC(t, r))) return !0;
	}
	return !1;
}, gC = (e, t, n) => {
	if (!t?.track?.product || !n || hC(e, n)) return;
	let { coreUrl: r, displayUrl: i } = fC(n), a = e.composedPath ? e.composedPath() : [e.target];
	for (let o of a.slice(0, dC)) {
		if (!(o instanceof Element)) continue;
		let a = o.getAttribute("href");
		if (a && (mC(a, r) || mC(a, i))) {
			t.track.product.clickThrough(e, n);
			return;
		}
	}
}, _C = (e, t, { panelOpen: n = !0 } = {}) => {
	!n || !e?.track?.product || !t?.length || t.forEach((t) => {
		t?.result && e.track.product.impression(t.result);
	});
};
k(), ze();
var vC = (e) => `predictive-search-option-${e}`, yC = (e, t) => {
	let n = String(e).match(/(\d+)$/);
	return `search-recommendation-list-item-${n ? n[1] : t + 1}`;
}, bC = (e = {}) => {
	let t = [
		...(e.suggestions || []).map((e) => vC(e.id)),
		...(e.collections || []).map((e) => vC(e.id)),
		...(e.pages || []).map((e) => vC(e.id)),
		...(e.products || []).map((e) => vC(e.id))
	];
	return e.searchFor && t.push("predictive-search-option-search-keywords"), t;
}, xC = () => /* @__PURE__ */ E("svg", {
	role: "presentation",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	width: "24",
	height: "24",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	"stroke-width": "2",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	className: "feather feather-chevron-right",
	children: /* @__PURE__ */ E("polyline", { points: "9 18 15 12 9 6" })
}), SC = () => /* @__PURE__ */ E("div", {
	className: "predictive-search__loading-state",
	children: /* @__PURE__ */ E("svg", {
		"aria-hidden": "true",
		focusable: "false",
		className: "spinner",
		viewBox: "0 0 66 66",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ E("circle", {
			className: "path",
			fill: "none",
			"stroke-width": "6",
			cx: "33",
			cy: "33",
			r: "30"
		})
	})
}), CC = ({ item: e, selected: t }) => /* @__PURE__ */ E("li", {
	id: vC(e.id),
	className: "predictive-search__list-item",
	role: "option",
	"aria-selected": t ? "true" : "false",
	children: /* @__PURE__ */ E("a", {
		href: e.href,
		className: "predictive-search__item link",
		tabindex: "-1",
		children: /* @__PURE__ */ E("div", {
			className: "predictive-search__item-content predictive-search__item-content--centered",
			children: /* @__PURE__ */ E("p", {
				className: "predictive-search__item-heading predictive-search__item-query-result",
				children: e.label
			})
		})
	})
}), wC = ({ item: e, selected: t, controller: n }) => {
	let r = (t) => {
		e.result && gC(t, n, e.result);
	}, i = cC(e.imageUrl);
	return /* @__PURE__ */ E("li", {
		id: vC(e.id),
		className: "predictive-search__list-item",
		role: "option",
		"aria-selected": t ? "true" : "false",
		children: /* @__PURE__ */ E("a", {
			href: e.href,
			className: "predictive-search__item predictive-search__item--link-with-thumbnail",
			tabindex: "-1",
			onClick: r,
			children: [i ? /* @__PURE__ */ E("img", {
				className: "predictive-search__image",
				src: i,
				alt: e.imageAlt || "",
				width: "50",
				height: "50"
			}) : null, /* @__PURE__ */ E("div", {
				className: "predictive-search__item-content",
				children: /* @__PURE__ */ E("p", { children: e.title })
			})]
		})
	});
}, TC = ({ groups: e = {}, labels: t = {}, input: n, statusElement: r, host: i, loading: a = !1, controller: o }) => {
	let s = Ge(null), c = Ge(""), [l, u] = Ve(""), d = e.suggestions || [], f = e.collections || [], p = e.products || [], m = e.pages || [], h = e.idleSuggestions || [], g = bC(e), _ = g.length > 0, v = !_ && h.length > 0;
	return c.current = l, Ue(() => {
		u("");
	}, [g.join("|")]), Ue(() => {
		n && (n.setAttribute("aria-expanded", _ ? "true" : "false"), _ || n.setAttribute("aria-activedescendant", ""));
	}, [n, _]), Ue(() => {
		if (!r) return;
		let n = e.liveRegionText || (a ? t.loading : "");
		r.textContent = n || "", r.setAttribute("aria-hidden", n ? "false" : "true");
	}, [
		r,
		e.liveRegionText,
		a,
		t.loading
	]), Ue(() => {
		i && (_ ? i.setAttribute("open", "") : i.removeAttribute("open"), a ? i.setAttribute("loading", "") : i.removeAttribute("loading"));
	}, [
		i,
		_,
		a
	]), Ue(() => {
		if (!n || !_) return;
		let e = (e) => {
			let t = g.indexOf(c.current);
			if (e < 0 && t === -1) return;
			let r = t + e;
			t === -1 && (r = 0), r < 0 && (r = g.length - 1), r >= g.length && (r = 0), u(g[r]), n.setAttribute("aria-activedescendant", g[r]);
		}, t = () => {
			let e = s.current?.querySelector("[aria-selected=\"true\"]");
			(e?.matches("button, a") ? e : e?.querySelector("a, button"))?.click();
		}, r = (e) => {
			(e.code === "ArrowUp" || e.code === "ArrowDown") && e.preventDefault(), e.code === "Enter" && c.current && e.preventDefault();
		}, i = (n) => {
			n.code === "ArrowDown" && e(1), n.code === "ArrowUp" && e(-1), n.code === "Enter" && t();
		};
		return n.addEventListener("keydown", r), n.addEventListener("keyup", i), () => {
			n.removeEventListener("keydown", r), n.removeEventListener("keyup", i);
		};
	}, [
		n,
		_,
		g.join("|")
	]), /* @__PURE__ */ E("div", {
		ref: s,
		children: [v ? /* @__PURE__ */ E("div", {
			className: "search-recommendations",
			children: [/* @__PURE__ */ E("h2", {
				id: "search-recommendation-heading",
				className: "predictive-search__heading h6",
				children: t.commonlySearched
			}), /* @__PURE__ */ E("ul", {
				id: "search-recommendation-list",
				className: "search-recommendation-list",
				role: "group",
				"aria-labelledby": "search-recommendation-heading",
				children: h.map((e, t) => /* @__PURE__ */ E("li", {
					id: yC(e.id, t),
					className: "search-recommendation__list-item",
					role: "option",
					"aria-selected": "false",
					children: /* @__PURE__ */ E("a", {
						href: e.href,
						className: "predictive-search__item",
						tabindex: "-1",
						children: e.label
					})
				}, e.id))
			})]
		}) : null, /* @__PURE__ */ E("div", {
			className: "predictive-search predictive-search--header",
			tabindex: "-1",
			"data-predictive-search": !0,
			children: [/* @__PURE__ */ E(SC, {}), _ ? /* @__PURE__ */ E("div", {
				id: "predictive-search-results",
				role: "listbox",
				children: [d.length || f.length || p.length || m.length ? /* @__PURE__ */ E("div", {
					className: "predictive-search__result-group",
					children: [
						d.length || f.length ? /* @__PURE__ */ E("div", { children: [/* @__PURE__ */ E("h4", {
							id: "predictive-search-queries",
							className: "predictive-search__heading h6",
							children: t.suggestions
						}), /* @__PURE__ */ E("ul", {
							id: "predictive-search-results-queries-list",
							className: "predictive-search__results-list",
							role: "group",
							"aria-labelledby": "predictive-search-queries",
							children: [d.map((e) => /* @__PURE__ */ E(CC, {
								item: e,
								selected: l === vC(e.id)
							}, e.id)), f.map((e) => /* @__PURE__ */ E(CC, {
								item: e,
								selected: l === vC(e.id)
							}, e.id))]
						})] }) : null,
						m.length ? /* @__PURE__ */ E("div", {
							className: "predictive-search__pages-wrapper",
							children: [/* @__PURE__ */ E("h4", {
								id: "predictive-search-pages",
								className: "predictive-search__heading h6",
								children: t.pages
							}), /* @__PURE__ */ E("ul", {
								className: "predictive-search__results-list",
								role: "group",
								"aria-labelledby": "predictive-search-pages",
								children: m.map((e) => /* @__PURE__ */ E(CC, {
									item: e,
									selected: l === vC(e.id)
								}, e.id))
							})]
						}) : null,
						p.length ? /* @__PURE__ */ E("div", { children: [/* @__PURE__ */ E("h4", {
							id: "predictive-search-products",
							className: "predictive-search__heading h6",
							children: t.products
						}), /* @__PURE__ */ E("ul", {
							id: "predictive-search-results-products-list",
							className: "predictive-search__results-list",
							role: "group",
							"aria-labelledby": "predictive-search-products",
							children: p.map((e) => /* @__PURE__ */ E(wC, {
								item: e,
								selected: l === vC(e.id),
								controller: o
							}, e.id))
						})] }) : null
					]
				}) : null, e.searchFor ? /* @__PURE__ */ E("div", {
					className: "predictive-search__search-for-button",
					children: /* @__PURE__ */ E("button", {
						id: "predictive-search-option-search-keywords",
						type: "submit",
						className: "predictive-search__item predictive-search__item--term btn btn--with-icon btn--with-icon-last",
						tabindex: "-1",
						role: "option",
						"aria-selected": l === "predictive-search-option-search-keywords" ? "true" : "false",
						children: [/* @__PURE__ */ E("span", {
							"data-predictive-search-search-for-text": "",
							children: e.searchFor.label
						}), /* @__PURE__ */ E(xC, {})]
					})
				}) : null]
			}) : null]
		})]
	});
}, EC = "at22v8", DC = (e) => e?.display?.mappings?.core || e?.mappings?.core || e || {}, OC = (e) => {
	let t = String(DC(e).url || ""), n = t;
	try {
		n = new URL(t, "https://example.invalid").pathname;
	} catch {
		n = t;
	}
	return n.includes("/blogs/") || n.includes("/articles/") ? "blog" : n.includes("/pages/") ? "page" : n.includes("/collections/") ? "collection" : "product";
}, kC = (e, t, n) => {
	let r = DC(e), i = String(r.name || "").trim(), a = String(r.url || "").trim();
	return !i || !a || OC(e) !== n ? null : {
		id: `${n}-${t + 1}`,
		href: a,
		title: i
	};
}, AC = (e = []) => {
	let t = [], n = [], r = /* @__PURE__ */ new Set();
	return e.forEach((e) => {
		let i = OC(e);
		if (i !== "collection" && i !== "page") return;
		let a = kC(e, i === "collection" ? t.length : n.length, i);
		!a || r.has(a.href) || (r.add(a.href), i === "collection" ? t.push(a) : n.push(a));
	}), {
		collections: t,
		pages: n
	};
}, jC = /* @__PURE__ */ new WeakMap(), MC = (e) => {
	if (jC.has(e)) return jC.get(e);
	let t = e(`https://${EC}.a.athoscommerce.net/v1/search?siteId=${EC}&q=*&resultsPerPage=50`).then((e) => e?.ok ? e.json() : { results: [] }).then((e) => Array.isArray(e?.results) ? e.results : []).catch(() => []);
	return jC.set(e, t), t;
}, NC = async (e, t = globalThis.fetch) => {
	let n = String(e ?? "").trim().toLowerCase();
	return !n || typeof t != "function" ? [] : (await MC(t)).filter((e) => String(e?.name || "").toLowerCase().includes(n));
}, PC = (e) => Array.isArray(e) || typeof e == "object" && !!e && typeof e.length == "number", FC = (e) => PC(e) ? Array.from(e) : [], IC = (e) => String(e ?? "").trim(), LC = (e) => typeof e == "string" ? e.trim() : String(e?.value ?? e?.searchQuery ?? e?.query ?? e?.text ?? "").trim(), RC = (e, t) => {
	let n = e || "/search";
	return `${n}${n.includes("?") ? "&" : "?"}q=${encodeURIComponent(t)}`;
}, zC = (e) => String(e ?? "").replaceAll("&quot;", "\"").replaceAll("&#34;", "\"").replaceAll("&#39;", "'").replaceAll("&apos;", "'").replaceAll("&lt;", "<").replaceAll("&gt;", ">").replaceAll("&amp;", "&"), BC = (e, t) => {
	if (!e) return "";
	let n = zC(e);
	return Object.entries(t).reduce((e, [t, n]) => e.replaceAll(t, String(n)), n);
}, VC = (e, t, n) => BC(e === 1 ? t : n, { __COUNT__: e }), HC = (e, { searchUrl: t, idPrefix: n, exclude: r }) => {
	let i = String(r ?? "").toLowerCase(), a = [];
	return FC(e).forEach((e) => {
		let r = LC(e);
		!r || r.toLowerCase() === i || a.push({
			id: `${n}-${a.length + 1}`,
			href: RC(t, r),
			label: r
		});
	}), a;
}, UC = (e) => e?.display?.mappings?.core || e?.mappings?.core || {}, WC = (e) => {
	let t = [];
	return FC(e).forEach((e) => {
		if (OC(e) !== "product") return;
		let n = UC(e), r = String(n.name ?? "").trim(), i = uC(n.url);
		!r || !i || t.push({
			id: `product-${t.length + 1}`,
			href: i,
			title: r,
			imageUrl: n.imageUrl || "",
			imageAlt: r,
			result: e
		});
	}), t;
}, GC = ({ query: e, suggestions: t, products: n, collections: r, pages: i, labels: a }) => {
	let o = t.length, s = n.length, c = r.length, l = i.length, u = o + s + c + l;
	if (!e) return "";
	if (u === 0) return BC(a.noResults, { __TERMS__: e });
	let d = [];
	o && d.push(VC(o, a.suggestionsWithCountOne, a.suggestionsWithCountOther)), c && a.collections && d.push(VC(c, a.collectionsWithCountOne, a.collectionsWithCountOther)), s && d.push(VC(s, a.productsWithCountOne, a.productsWithCountOther)), l && a.pages && d.push(`${l} ${a.pages}`);
	let f = VC(u, a.resultsWithCountOne, a.resultsWithCountOther);
	return d.length ? `${f}: ${d.join(", ")}` : f;
}, KC = ({ terms: e = [], results: t = [], contentResults: n = [], query: r = "", labels: i = {}, trending: a = [] } = {}) => {
	let o = IC(r), s = i.searchUrl || "/search";
	if (!o) return {
		suggestions: [],
		collections: [],
		products: [],
		pages: [],
		searchFor: null,
		idleSuggestions: HC(a, {
			searchUrl: s,
			idPrefix: "idle"
		}),
		liveRegionText: ""
	};
	let c = HC(e, {
		searchUrl: s,
		idPrefix: "query",
		exclude: o
	}), l = WC(t), u = AC([...FC(t), ...FC(n)]), d = (e) => ({
		...e,
		label: e.title
	});
	return {
		suggestions: c,
		collections: u.collections.map(d),
		products: l,
		pages: u.pages.map(d),
		searchFor: {
			href: RC(s, o),
			label: BC(i.searchFor, { __TERMS__: o })
		},
		idleSuggestions: [],
		liveRegionText: GC({
			query: o,
			suggestions: c,
			products: l,
			collections: u.collections,
			pages: u.pages,
			labels: i
		})
	};
};
k(), jx(), ze();
var qC = yx(({ controller: e, labels: t = {}, input: n, statusElement: r, host: i }) => {
	let a = e?.store || {}, o = typeof a.state?.input == "string" ? a.state.input : n?.value ?? "", [s, c] = Ve([]);
	Ue(() => {
		let e = String(o ?? "").trim();
		if (!e) {
			c([]);
			return;
		}
		let t = !1;
		return NC(e).then((e) => {
			t || c(e);
		}).catch(() => {
			t || c([]);
		}), () => {
			t = !0;
		};
	}, [o]);
	let l = KC({
		terms: a.terms,
		results: a.results,
		contentResults: s,
		query: o,
		labels: t,
		trending: a.trending
	}), u = l.products || [];
	return Ue(() => {
		let t = String(o ?? "").trim();
		if (!e?.track?.product || a.loading || !t || !i?.hasAttribute("open") || !u.length) return;
		let n = !1, r = requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				n || _C(e, u, { panelOpen: !0 });
			});
		});
		return () => {
			n = !0, cancelAnimationFrame(r);
		};
	}, [
		e,
		i,
		qe(() => `${a.search?.tracking?.responseId || u[0]?.result?.responseId || ""}:${u.map((e) => e.id).join(",")}`, [u, a.search?.tracking?.responseId]),
		u,
		o,
		a.loading
	]), /* @__PURE__ */ E(TC, {
		groups: l,
		labels: t,
		input: n,
		statusElement: r,
		host: i,
		loading: !!a.loading,
		controller: e
	});
}), JC = "atg0mj", YC = { beacon: !0 };
Le(), W(), ze();
var XC = (e = document) => {
	let t = e.getElementById("athos-autocomplete-config");
	if (t?.textContent) try {
		return JSON.parse(t.textContent);
	} catch {
		return {};
	}
	return {};
}, ZC = () => {
	try {
		return Yl(["siteId"])?.siteId || "atg0mj";
	} catch {
		return JC;
	}
}, QC = (e, t) => {
	t && t.classList.toggle("hidden", !e.value);
}, $C = (e) => {
	if (!e) return !1;
	let t = document.getElementById("drawerSearchInput"), n = document.getElementById("athos-predictive-root");
	if (!t || !n) return !1;
	let { labels: r = {} } = XC(), i = e.querySelector("predictive-search") || e, a = e.querySelector(".predictive-search-status"), o = e.querySelector("button[type=\"reset\"]"), s = new oC({
		mode: "production",
		client: {
			globals: { siteId: ZC() },
			config: {
				search: { globals: YC },
				cache: { enabled: !1 }
			}
		},
		controllers: { autocomplete: [{ config: {
			id: "autocomplete",
			selector: "#drawerSearchInput",
			globals: { pagination: { pageSize: 6 } },
			settings: {
				initializeFromUrl: !1,
				syncInputs: !1,
				serializeForm: !1,
				disableClickOutside: !0,
				trending: { limit: 6 },
				redirects: {
					merchandising: !0,
					singleResult: !1
				},
				bind: {
					input: !0,
					submit: !0
				}
			}
		} }] }
	}), c = (e) => {
		e && ge(/* @__PURE__ */ E(qC, {
			controller: e,
			labels: r,
			input: t,
			statusElement: a,
			host: i
		}), n);
	}, l = s.getController?.("autocomplete");
	return l?.then && l.then(c), QC(t, o), t.addEventListener("input", () => QC(t, o)), t.form?.addEventListener("reset", () => {
		window.setTimeout(() => {
			s.controllers?.autocomplete?.reset?.(), QC(t, o);
		}, 0);
	}), window.athosSnapAutocomplete = s, !0;
};
typeof document < "u" && $C(document.getElementById("athos-autocomplete"));
//#endregion
export { $C as mountAthosAutocomplete };
